/* This file is generated by scripts/build-entry.mjs. Do not edit directly. */
import React from "react";
import { createRoot } from "react-dom/client";

window.React = React;
window.ReactDOM = { createRoot };


/* ---- app/icons.js ---- */
/* ============================================================
   DEALWONDR · STORYBOOK — icon set
   Stroke-based, 24×24, 1.7 weight (set in atoms.css .dw-icon).
   Usage in markup:  dwIcon('search')  →  <span class="dw-icon">…</span>
   ============================================================ */
window.DWIcons = {
  search:    '<circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/>',
  bell:      '<path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.7 21a2 2 0 0 1-3.4 0"/>',
  check:     '<path d="M5 12l4.5 4.5L19 7"/>',
  x:         '<path d="M6 6l12 12M18 6L6 18"/>',
  chevdown:  '<path d="M5 9l7 7 7-7"/>',
  chevright: '<path d="M9 5l7 7-7 7"/>',
  arrowright:'<path d="M4 12h15M13 6l6 6-6 6"/>',
  plus:      '<path d="M12 5v14M5 12h14"/>',
  comment:   '<path d="M21 11.5a8.5 8.5 0 0 1-12.2 7.7L3 21l1.8-5.8A8.5 8.5 0 1 1 21 11.5z"/>',
  upload:    '<path d="M12 16V4M7 9l5-5 5 5"/><path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"/>',
  download:  '<path d="M12 4v12M7 11l5 5 5-5"/><path d="M4 20h16"/>',
  play:      '<path d="M7 4.5v15l13-7.5z"/>',
  users:     '<circle cx="9" cy="8" r="3.2"/><path d="M3.5 20a5.5 5.5 0 0 1 11 0"/><path d="M16 5.2a3.2 3.2 0 0 1 0 6.1M17 14.5a5.5 5.5 0 0 1 3.5 5.1"/>',
  user:      '<circle cx="12" cy="8" r="3.4"/><path d="M5 20a7 7 0 0 1 14 0"/>',
  file:      '<path d="M14 3H7a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7z"/><path d="M14 3v4h4"/>',
  settings:  '<circle cx="12" cy="12" r="3"/><path d="M12 2.5l1.4 2.8 3 .3-1.5 2.7 1.5 2.7-3 .3L12 14l-1.4-2.8-3-.3L9.1 8.3 7.6 5.6l3-.3z" transform="translate(0 4) scale(1 0.0)"/><path d="M19.4 13a7.5 7.5 0 0 0 0-2l2-1.5-2-3.4-2.3 1a7.5 7.5 0 0 0-1.7-1l-.3-2.5h-4l-.3 2.5a7.5 7.5 0 0 0-1.7 1l-2.3-1-2 3.4L4.6 11a7.5 7.5 0 0 0 0 2l-2 1.5 2 3.4 2.3-1a7.5 7.5 0 0 0 1.7 1l.3 2.5h4l.3-2.5a7.5 7.5 0 0 0 1.7-1l2.3 1 2-3.4z"/>',
  home:      '<path d="M4 11l8-7 8 7"/><path d="M6 10v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-9"/>',
  grid:      '<rect x="4" y="4" width="6.5" height="6.5" rx="1"/><rect x="13.5" y="4" width="6.5" height="6.5" rx="1"/><rect x="4" y="13.5" width="6.5" height="6.5" rx="1"/><rect x="13.5" y="13.5" width="6.5" height="6.5" rx="1"/>',
  inbox:     '<path d="M3 13l3-8h12l3 8v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"/><path d="M3 13h5l1.5 2.5h5L16 13h5"/>',
  eye:       '<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"/><circle cx="12" cy="12" r="3"/>',
  lock:      '<rect x="5" y="11" width="14" height="9" rx="1.5"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>',
  mail:      '<rect x="3" y="5" width="18" height="14" rx="1.5"/><path d="M3.5 6.5L12 13l8.5-6.5"/>',
  clock:     '<circle cx="12" cy="12" r="8.5"/><path d="M12 7v5l3.5 2"/>',
  more:      '<circle cx="5" cy="12" r="1.4"/><circle cx="12" cy="12" r="1.4"/><circle cx="19" cy="12" r="1.4"/>',
  trash:     '<path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13"/>',
  edit:      '<path d="M4 20h4L19 9l-4-4L4 16z"/><path d="M14 6l4 4"/>',
  filter:    '<path d="M3 5h18l-7 8v6l-4-2v-4z"/>',
  link:      '<path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1.5 1.5"/><path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1.5-1.5"/>',
  sparkle:   '<path d="M12 3l1.8 6.2L20 11l-6.2 1.8L12 19l-1.8-6.2L4 11l6.2-1.8z"/>',
  bolt:      '<path d="M13 3L5 13h6l-1 8 8-10h-6z"/>',
  info:      '<circle cx="12" cy="12" r="8.5"/><path d="M12 11v5M12 8h.01"/>',
  alert:     '<path d="M12 3l9.5 16.5H2.5z"/><path d="M12 9v5M12 17h.01"/>',
  chart:     '<path d="M4 20V4M4 20h16"/><path d="M8 16v-4M12 16V8M16 16v-6"/>',
  layers:    '<path d="M12 3l9 5-9 5-9-5z"/><path d="M3 13l9 5 9-5"/>',
  quote:     '<path d="M9 7H5v5h3v2a3 3 0 0 1-3 3M19 7h-4v5h3v2a3 3 0 0 1-3 3"/>',
  highlight: '<path d="M14 4l6 6-9 9-6 1 1-6z"/><path d="M3 21h7"/>',
  send:      '<path d="M4 12L20 4l-6 16-3-7z"/><path d="M11 13l9-9"/>',
  shield:    '<path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z"/>',
  refresh:   '<path d="M4 12a8 8 0 0 1 13.7-5.7L20 8M20 4v4h-4"/><path d="M20 12a8 8 0 0 1-13.7 5.7L4 16M4 20v-4h4"/>',
  pencil:    '<path d="M4 20h4L18 10l-4-4L4 16z"/>',
};
window.dwIcon = function (name, cls) {
  var inner = window.DWIcons[name] || '';
  return '<span class="dw-icon' + (cls ? ' ' + cls : '') + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">' + inner + '</svg></span>';
};


/* ---- app/data.js ---- */
/* ============================================================
   DEALWONDR APP — seed data (window.DW_SEED)
   The functional content backbone: people, the Redux room, its
   document, comments, activity and insights. Mirrors the app.
   ============================================================ */
window.DW_SEED = {
  org: { name: 'Fragmatic', domain: 'fragmatic.io' },
  me: { email: 'vid@fragmatic.io', name: 'Vid', initials: 'V', role: 'admin', team: true },

  people: {
    'vid@fragmatic.io':     { name: 'Vid', initials: 'V', cls: 'dw-ava--accent', team: true },
    'maria.t@redux.com':    { name: 'Maria T.', initials: 'MT', cls: '', dealRole: 'approver' },
    'james.d@redux.com':    { name: 'James D.', initials: 'JD', cls: 'dw-ava--ink', dealRole: 'champion' },
    'reuben.z@redux.com':   { name: 'Reuben Z.', initials: 'RZ', cls: '', dealRole: 'senior' },
  },

  /* rooms shown in the pine nav */
  rooms: [
    { id: 'redux', apiId: 'redux-y1', title: 'Redux — Master Growth Proposal', sub: 'Active', status: 'live', version: 'V8', temp: 'Warm', tempScore: 70, readers: '12 / 16', comments: '5 · 2 open', readTime: '6h 41m', last: '18m ago' },
    { id: 'meridian', title: 'Meridian Health — AEO Pilot',     sub: 'Active', status: 'live', version: 'V3', temp: 'Hot', tempScore: 82, readers: '2 / 3', comments: '5 · 1 open', readTime: '1h 12m', last: '2d ago' },
    { id: 'bryon',    title: 'Bryon Labs — Pre-engagement',     sub: 'Questionnaire', status: 'quest', version: '', temp: '', tempScore: 0, readers: '1 / 4', comments: '—', readTime: '—', last: '1d ago' },
    { id: 'northwind',title: 'Northwind Audio — Brand Sprint',  sub: 'Draft', status: 'draft', version: '', temp: '', tempScore: 0, readers: '—', comments: '—', readTime: '—', last: 'edited 4h' },
  ],

  /* upload wizard — import formats, templates, detected sections */
  importFormats: [
    { id: 'pdf', label: 'PDF', glyph: '▤', note: 'Paged → auto-sectioned by headings' },
    { id: 'pptx', label: 'PowerPoint', glyph: '◫', note: 'One section per slide' },
    { id: 'docx', label: 'Word', glyph: '▦', note: 'Sectioned by heading styles' },
    { id: 'html', label: 'HTML', glyph: '❮❯', note: 'Interactive elements preserved' },
    { id: 'md', label: 'Markdown', glyph: '↓', note: 'Sectioned by #/## headings' },
  ],
  importDemo: { file: 'growth-proposal.pdf', pages: 44, sections: 9, title: 'Growth Proposal', steps: ['Reading 44 pages', 'Detecting section breaks', 'Extracting title & cover', 'Building the reader'] },
  roomTemplates: [],
  detectedSections: [
    { page: '01', label: 'Cover — Win Before the Click', src: 'label', on: true },
    { page: '03', label: '§01 · The answer', src: 'label', on: true },
    { page: '04', label: '§01 · What $190k pays back', src: 'label', on: true },
    { page: '09', label: '§04 · Plan A — sprint', src: 'label', on: true },
    { page: '15', label: '§06 · Dependency map — Plan A', src: 'h2', on: true },
    { page: '35', label: '§11 · Investment & guarantee', src: 'label', on: true },
    { page: '38', label: 'Appendix A · Future possibilities', src: 'h2', on: true },
    { page: '—', label: 'Tweaks panel (hidden chrome)', src: 'inferred', on: false },
  ],

  room: {
    id: 'redux', apiId: 'redux-y1', title: 'Redux — Master Growth Proposal', ref: 'IP-2026-RDX1',
    version: 'V8', documents: 2, status: 'live', since: '12 Jun',
    versions: [
      { id: 'V8', label: 'V8', issued: '12 Jun 2026', note: 'Pricing revised after the security call', latest: true },
      { id: 'V7', label: 'V7', issued: '28 May 2026', note: 'Added a security & compliance section' },
      { id: 'V6', label: 'V6', issued: '14 May 2026', note: 'Reworked the pricing table' },
    ],
  },

  /* the document the reader reads — sections with highlightable prose */
  doc: [
    { id: 's1', label: '§01 · The answer', heading: 'Master Growth Proposal',
      paras: [
        'Redux is scaling fast, and the next phase is about turning that momentum into durable, qualified pipeline rather than one-off spikes.',
        'Our engagement is designed around a 20% lift in qualified pipeline within one quarter, measured against your current baseline and reviewed weekly.',
        '20% of our fees are earned only on results, so our incentives are aligned with the outcome you actually care about.',
      ] },
    { id: 's2', label: '§02 · How it works', heading: 'How the engagement works',
      paras: [
        'We embed with your revenue team for the first month to map the funnel, agree definitions, and lock a shared baseline before any targets are set.',
        'Implementation is rolled out in under two weeks, including data migration and team onboarding, so you see signal early.',
      ] },
    { id: 's3', label: '§03 · Pricing & terms', heading: 'Pricing & terms',
      paras: [
        'A fixed monthly platform fee covers the work; the results-based component is billed only when the agreed pipeline lift is verified.',
        'Either party can pause the engagement with 30 days notice — no long lock-in, because the results should make the case each month.',
      ] },
  ],

  /* multiple documents in this room — the reader loads them in sequence */
  docs: [
    { id: 'd1', title: 'Master Growth Proposal', kind: 'proposal', sections: 'doc' },
    { id: 'd2', title: 'Security & Compliance', kind: 'addendum', sections: [
      { id: 'd2s1', label: '§01 · Data handling', heading: 'How we handle your data',
        paras: [
          'Every room is isolated per client, encrypted at rest and in transit, and access is gated to the exact email addresses you invite — nothing is public or guessable.',
          'We never sell, share, or train on your proposal content or your readers’ activity; it stays between you and the people invited to the room.',
        ] },
      { id: 'd2s2', label: '§02 · Compliance', heading: 'Compliance & retention',
        paras: [
          'We are SOC 2 Type II aligned, with annual penetration testing and a documented incident-response process available on request.',
          'You control retention: archive or delete a room at any time and its analytics, comments and replay history are removed within 30 days.',
        ] },
    ] },
  ],
  /* a post-reading questionnaire shown after the final document */
  postQuestionnaire: { id: 'pq', title: 'Two quick questions before we talk', fields: [
    { id: 'pq1', type: 'single', label: 'After reading, how do you feel about moving forward?', options: ['Ready to talk terms', 'A few open questions', 'Need more time'] },
    { id: 'pq2', type: 'long', label: 'Anything you’d like us to prioritise on the call?', help: 'Optional — but it helps us prepare.' },
  ] },

  /* seeded comment threads, pinned to a section + version */
  comments: [
    { id: 'c1', author: 'maria.t@redux.com', sectionId: 's1', section: '§01 · The answer', version: 'V8',
      quote: '20% of our fees are earned only on results.', created: '2d',
      body: 'This is the part the board will like. Can we get the exact measurement definition early?',
      needsReply: true, resolved: false,
      replies: [ { author: 'vid@fragmatic.io', created: '1d', body: 'Yes — definitions live in §11, and we lock the baseline together in month 1.' } ] },
    { id: 'c2', author: 'james.d@redux.com', sectionId: 's2', section: '§02 · How it works', version: 'V8',
      quote: 'rolled out in under two weeks', created: '5d',
      body: 'Two weeks including data migration? What do you need from our side to hit that?',
      needsReply: false, resolved: true, replies: [] },
    { id: 'c3', author: 'maria.t@redux.com', sectionId: 's3', section: '§03 · Pricing & terms', version: 'V8',
      quote: 'A fixed monthly platform fee', created: '6d',
      body: 'Can you share the platform fee range before the call so I can socialise it internally?',
      needsReply: true, resolved: false, replies: [] },
    { id: 'c4', author: 'james.d@redux.com', sectionId: 's2', section: '§02 · How it works', version: 'V7',
      quote: 'map the funnel, agree definitions', created: '8d',
      body: 'Love that this starts with definitions — that has tripped us up before.',
      needsReply: false, resolved: false, replies: [] },
  ],

  /* reader-side activity feed (Activity panel) */
  activity: {
    tagged:  [ { who: 'Maria T.', email: 'maria.t@redux.com', body: 'can we get the exact measurement definition?', when: '2d ago', unread: true } ],
    replies: [ { who: 'Vid', email: 'vid@fragmatic.io', body: 'replied on §01 · The answer', when: '1d ago', unread: true } ],
    around:  [ { who: 'James D.', email: 'james.d@redux.com', body: 'commented on the rollout', when: '5d ago' } ],
  },

  /* cross-room dashboard feed */
  feed: [
    { initials: 'MT', who: 'Maria T.', action: 'completed the questionnaire', room: 'Redux', status: 'Completed', quote: 'Before our call — 5 quick questions' },
    { initials: 'JD', who: 'James D.', action: 'started — left midway', room: 'Redux', status: 'In progress', quote: 'Before our call — 5 quick questions' },
    { initials: 'MT', who: 'Maria T.', action: 'left a comment', room: 'Redux', status: '', quote: '20% of our fees are earned only on results.' },
  ],

  /* access list for the Access tab */
  access: [
    { email: 'maria.t@redux.com', access: 'opened', role: 'Final approver', opened: '2d ago', time: '18m' },
    { email: 'james.d@redux.com', access: 'opened', role: 'Champion', opened: '5d ago', time: '7m' },
    { email: 'reuben.z@redux.com', access: 'invited', role: 'Senior', opened: '—', time: '—' },
  ],

  /* insights synthesis */
  insights: {
    temperature: { interest: 71, friction: 34, label: 'Warm', confidence: 'high' },
    lifting: [ '12 of 16 invited readers opened', 'Median completion ~51% · deepest reach Appendix A', 'Most-highlighted: the results-based fee line' ],
    holding: [ 'Pricing section re-read 3× · one direct question', 'An approver has been quiet for 6 days' ],
    objections: [
      { cat: 'Pricing & terms', sev: 'crit', sevLabel: 'Critical', score: 82, ev: 5 },
      { cat: 'Security review', sev: 'high', sevLabel: 'High', score: 64, ev: 3 },
      { cat: 'Timeline',        sev: 'med',  sevLabel: 'Medium', score: 48, ev: 2 },
    ],
    actions: [
      { id: 'a1', verb: 'Reassure', temp: 'hot', impact: 'High impact', title: 'Answer Maria’s pricing question', why: 'She re-read the pricing section and asked for the exact measurement definition — the strongest friction signal on this version.', best: true },
      { id: 'a2', verb: 'Re-engage', temp: 'risk', impact: 'Medium', title: 'Follow up with Reuben — quiet 6 days', why: 'Senior stakeholder invited but not yet active. A light nudge keeps momentum.', best: false },
    ],

    /* archived pre-call notes, pinned to the version they were written on */
    pastNotes: [
      { id: 'pn-v8', version: 'V8', label: 'Warm', temperature: 76, tone: 'warm', date: '12 Jun 2026', by: 'Vid',
        summary: 'Pricing is the swing factor — lead with the measurement definition.',
        parts: [
          { title: 'Where the deal stands', body: 'Maria has read V8 end-to-end twice; James is active on timeline. Reuben is invited but quiet.' },
          { title: 'Open questions', items: ['Measurement definition for the 20% lift', 'Platform-fee band before the call'] },
          { title: 'Biggest risk', body: 'Pricing — re-read three times with a direct question.' },
        ] },
      { id: 'pn-v2', version: 'V2', label: 'Cooling', temperature: 48, tone: 'steady', date: '4 Jun 2026', by: 'Vid',
        summary: 'Multilingual priced separately drew a pricing challenge — fold it into the fee.',
        parts: [
          { title: 'Where the deal stands', body: 'Maria challenged the separate multilingual line on V2; this drove the V8 repricing.' },
          { title: 'Open questions', items: ['Is multilingual in or out of the fixed fee?'] },
          { title: 'Biggest risk', body: 'Sticker shock from the separate line item — addressed in V8.' },
        ] },
    ],
  },

  /* multiple questionnaires per room — intro · post-read · standalone (builder + responses) */
  questionnaires: [
  { id: 'q1', title: 'Before our call — 5 quick questions', status: 'live', placement: 'intro', mode: 'single', lastActivity: '2h ago',
    sent: 16, completed: 6, inProgress: 2,
    fields: [
      { id: 'goal', type: 'long', label: 'What’s the headline goal for this engagement?', required: true, help: 'One sentence is plenty.' },
      { id: 'team', type: 'single', label: 'Which best describes your team?', options: ['Startup', 'Scale-up', 'Enterprise'] },
      { id: 'urgency', type: 'rating', label: 'How urgent is this?', help: '1 = exploring · 5 = need it now' },
      { id: 'matters', type: 'multi', label: 'What matters most? (pick any)', options: ['Speed', 'Quality', 'Price', 'Support'] },
      { id: 'budget', type: 'short', label: 'Target budget range' },
      { id: 'consent', type: 'consent', label: 'I agree my answers may be used to prepare for our call.' },
    ],
    responses: [
      { email: 'maria.t@redux.com', status: 'Completed', when: '2d ago', dur: '4m 10s', answers: { goal: 'Predictable, qualified pipeline before our Series B raise.', team: 'Scale-up', urgency: 4, matters: ['Quality', 'Speed'], budget: '$8–12k / mo', consent: 'yes' } },
      { email: 'reuben.z@redux.com', status: 'Completed', when: '1d ago', dur: '6m 02s', answers: { goal: 'De-risk the guarantee and prove ROI to the board.', team: 'Scale-up', urgency: 5, matters: ['Quality', 'Support'], budget: '$10–15k / mo', consent: 'yes' } },
      { email: 'anita.rao@redux.com', status: 'Completed', when: '3h ago', dur: '3m 48s', answers: { goal: 'A repeatable demand engine, not one-off campaigns.', team: 'Scale-up', urgency: 4, matters: ['Quality', 'Speed'], budget: '$8–12k / mo', consent: 'yes' } },
      { email: 'daniel.okafor@redux.com', status: 'Completed', when: '5h ago', dur: '5m 21s', answers: { goal: 'Clean attribution and a defensible budget line.', team: 'Enterprise', urgency: 3, matters: ['Price', 'Quality'], budget: '$6–10k / mo', consent: 'yes' } },
      { email: 'lucy.chen@redux.com', status: 'Completed', when: '6h ago', dur: '4m 33s', answers: { goal: 'Faster pipeline without adding headcount.', team: 'Scale-up', urgency: 4, matters: ['Speed', 'Support'], budget: '$8–12k / mo', consent: 'yes' } },
      { email: 'priya.n@redux.com', status: 'Completed', when: '1d ago', dur: '3m 12s', answers: { goal: 'Stand up paid + lifecycle in one quarter.', team: 'Startup', urgency: 5, matters: ['Speed', 'Quality'], budget: '$5–8k / mo', consent: 'yes' } },
      { email: 'james.d@redux.com', status: 'In progress', when: '1d ago', dur: '1m 40s', answers: { goal: 'Tighten the funnel and forecasting.', team: 'Scale-up', urgency: 3 } },
      { email: 'tom.becker@redux.com', status: 'In progress', when: '4h ago', dur: '0m 52s', answers: { team: 'Enterprise', urgency: 2 } },
    ] },
  { id: 'q2', title: 'After reading — are we aligned?', status: 'live', placement: 'post', mode: 'single', lastActivity: '5h ago',
    sent: 16, completed: 3, inProgress: 1,
    fields: [
      { id: 'feel', type: 'single', label: 'After reading, how do you feel about moving forward?', options: ['Ready to talk terms', 'A few open questions', 'Need more time'] },
      { id: 'pri', type: 'long', label: 'Anything you’d like us to prioritise on the call?', help: 'Optional — but it helps us prepare.' },
      { id: 'meet', type: 'yesno', label: 'Shall we get time on the calendar this week?' },
    ],
    responses: [
      { email: 'maria.t@redux.com', status: 'Completed', when: '4h ago', dur: '1m 20s', answers: { feel: 'Ready to talk terms', pri: 'The measurement definition and the fee band.', meet: 'yes' } },
      { email: 'anita.rao@redux.com', status: 'Completed', when: '6h ago', dur: '0m 58s', answers: { feel: 'A few open questions', pri: 'Rollout dependencies in weeks 5–6.', meet: 'yes' } },
      { email: 'daniel.okafor@redux.com', status: 'Completed', when: '1d ago', dur: '1m 12s', answers: { feel: 'Need more time', pri: 'Budget approval is still internal.', meet: 'no' } },
      { email: 'james.d@redux.com', status: 'In progress', when: '2h ago', dur: '0m 24s', answers: { feel: 'Ready to talk terms' } },
    ] },
  { id: 'q3', title: 'Security & compliance intake', status: 'draft', placement: 'standalone', mode: 'multi', lastActivity: 'edited 1d ago',
    sent: 0, completed: 0, inProgress: 0,
    fields: [
      { id: 'contact', type: 'email', label: 'Best security contact for this review?' },
      { id: 'framework', type: 'multi', label: 'Which frameworks do you require?', options: ['SOC 2', 'ISO 27001', 'GDPR', 'HIPAA'] },
      { id: 'pentest', type: 'yesno', label: 'Do you need a recent penetration-test report?' },
      { id: 'notes', type: 'long', label: 'Anything specific your security team needs from us?' },
    ],
    responses: [] },
  ],

  /* reusable questionnaire templates (Settings → Templates) */
  questionnaireTemplates: [
    { id: 'tpl-precall', name: 'Pre-call discovery', tags: ['Discovery', 'Sales'], questions: 6, steps: 2, version: 3, by: 'Vid', usage: 12, lastUsed: '2d ago' },
    { id: 'tpl-intake', name: 'New-client intake', tags: ['Onboarding'], questions: 9, steps: 3, version: 2, by: 'Marcus Reed', usage: 7, lastUsed: '1w ago' },
    { id: 'tpl-budget', name: 'Budget & authority', tags: ['Qualification', 'Sales'], questions: 5, steps: 1, version: 4, by: 'Vid', usage: 21, lastUsed: 'yesterday' },
    { id: 'tpl-feedback', name: 'Proposal feedback', tags: ['Feedback'], questions: 4, steps: 1, version: 1, by: 'Sana Okafor', usage: 3, lastUsed: '3w ago' },
  ],

  /* the 14 field types the builder offers */
  fieldTypes: [
    { type: 'short', label: 'Short text', icon: 'edit' },
    { type: 'long', label: 'Long text', icon: 'quote' },
    { type: 'email', label: 'Email', icon: 'mail' },
    { type: 'url', label: 'URL', icon: 'link' },
    { type: 'number', label: 'Number', icon: 'chart' },
    { type: 'currency', label: 'Currency', icon: 'chart' },
    { type: 'date', label: 'Date', icon: 'clock' },
    { type: 'single', label: 'Single choice', icon: 'check' },
    { type: 'multi', label: 'Multi choice', icon: 'grid' },
    { type: 'yesno', label: 'Yes / No', icon: 'check' },
    { type: 'rating', label: 'Rating', icon: 'sparkle' },
    { type: 'ranking', label: 'Ranking', icon: 'layers' },
    { type: 'file', label: 'File upload', icon: 'upload' },
    { type: 'consent', label: 'Consent', icon: 'shield' },
  ],

  /* super console — org/account admin */
  superConsole: {
    orgs: [
      { name: 'Fragmatic', plan: 'Studio', seats: 3, rooms: 4, status: 'active', created: 'Jan 2026' },
      { name: 'Northstar Advisory', plan: 'Agency', seats: 9, rooms: 22, status: 'active', created: 'Nov 2025' },
      { name: 'Lumen Studio', plan: 'Trial', seats: 1, rooms: 2, status: 'trial', created: 'Jun 2026' },
      { name: 'Cobalt Partners', plan: 'Studio', seats: 4, rooms: 7, status: 'past_due', created: 'Mar 2026' },
    ],
    metrics: { orgs: 38, mrr: '$11.4k', activeRooms: 142, signups7d: 6 },
  },

  /* the notification → action loop (Roadmap #2) — every alert is one-tap actionable */
  notifications: [
    { id: 'n1', verb: 'Hot reader', temp: 'hot', tempLabel: 'Hot', hot: true, actionable: true, room: 'Redux · Master Growth', reader: 'reuben.z@redux.com',
      title: 'Reuben re-read the guarantee 3× this morning', body: 'Three visits to §11 in one session — the guarantee is his decision point. Reach out while it’s top of mind.',
      actions: [{ id: 'reply', label: 'Reply in room', primary: true, doneLabel: 'Replied', toast: 'Opening the room…' }, { id: 'copy', label: 'Copy email' }, { id: 'snooze', label: 'Snooze', kind: 'snooze' }] },
    { id: 'n2', verb: 'Approver silent', temp: 'risk', tempLabel: 'At risk', actionable: true, room: 'Redux · Master Growth', reader: 'maria.t@redux.com',
      title: 'Maria asked for the measurement definition — unanswered 2 days', body: 'Your final approver is waiting on the exact definition for the 20% lift. An open question on pricing cools fast.',
      actions: [{ id: 'reply', label: 'Answer now', primary: true, doneLabel: 'Answered' }, { id: 'draft', label: 'Draft email' }, { id: 'snooze', label: 'Snooze', kind: 'snooze' }] },
    { id: 'n3', verb: 'New objection', temp: 'hot', tempLabel: 'High', hot: true, actionable: true, room: 'Redux · Master Growth',
      title: 'Pricing surfaced as a high-severity objection', body: 'Insights scored Pricing & terms at 82 from five signals across two readers. Address the fee band proactively.',
      actions: [{ id: 'view', label: 'View evidence', primary: true, doneLabel: 'Reviewed' }, { id: 'snooze', label: 'Snooze', kind: 'snooze' }] },
    { id: 'n4', verb: 'Champion active', temp: 'warm', tempLabel: 'Warm', actionable: true, room: 'Redux · Master Growth', reader: 'james.d@redux.com',
      title: 'James opened the security section twice', body: 'Your champion is doing pre-work on security. A short walkthrough offer keeps momentum.',
      actions: [{ id: 'reply', label: 'Offer a walkthrough', primary: true, doneLabel: 'Offered' }, { id: 'snooze', label: 'Snooze', kind: 'snooze' }] },
    { id: 'n5', verb: 'Deep read', temp: 'warm', tempLabel: 'Warm', actionable: true, room: 'Meridian Health · AEO Pilot', reader: 'anita.rao@redux.com',
      title: 'Anita read Meridian end-to-end', body: 'Full completion on V3 — a strong internal advocate forming. Worth a thank-you note.',
      actions: [{ id: 'thank', label: 'Send a note', primary: true, doneLabel: 'Sent' }, { id: 'snooze', label: 'Snooze', kind: 'snooze' }] },
    { id: 'n6', verb: 'Approver silent', temp: 'risk', tempLabel: 'At risk', actionable: true, snoozed: true, room: 'Redux · Master Growth', reader: 'reuben.z@redux.com',
      title: 'Reuben hasn’t opened V8 yet', body: 'Snoozed yesterday — back in your queue tomorrow.',
      actions: [{ id: 'nudge', label: 'Nudge now', primary: true, doneLabel: 'Nudged' }, { id: 'snooze', label: 'Snooze again', kind: 'snooze' }] },
    { id: 'n7', verb: 'Replied', temp: 'warm', tempLabel: 'Warm', actionable: false, room: 'Redux · Master Growth', done: { label: 'Replied' },
      title: 'You answered James’s rollout question', body: '', actions: [] },
  ],
};


/* ---- app/analytics-data.js ---- */
/* ============================================================
   DEALWONDR APP — analytics dummy data (window.DW_ANALYTICS)
   Lifted from the original Reading Room app, per version, never
   merged. Drives the Engagement / Sections / Journeys tabs.
   ============================================================ */
window.DW_ANALYTICS = {
  v8: {
    totalReadTime: '6h 41m', delta: '+38m today',
    readersOpened: '12 / 16', completion: '78%', deepest: 'Appendix A',
    neverOpened: ['lucy.chen@redux.com (invited 12 Jun)', 'fred.mortensen@redux.com (invited 12 Jun)', 'nina.petrova@redux.com (invited 12 Jun)', 'ops@redux.com (invited 12 Jun)'],
    insight: 'Reuben read §11 (the guarantee) four times — lead with it on the call.',
    mostHighlighted: '“20% of our fees are earned only on results.” · 3 readers',
    sectionTime: [
      { label: '§01 · The answer + payback', pct: 96, time: '14m 20s', hot: true },
      { label: '§11 · Investment & guarantee', pct: 78, time: '11m 36s', hot: true },
      { label: '§04 · Plan A', pct: 64, time: '9m 02s' },
      { label: '§06 · Dependency maps', pct: 52, time: '7m 44s' },
      { label: '§07 · Head-to-head', pct: 38, time: '5m 10s' },
      { label: '§10 · Budgets', pct: 30, time: '4m 28s' },
      { label: '§14 · Working terms', pct: 22, time: '3m 05s' },
      { label: 'Appendix A · Future possibilities', pct: 12, time: '1m 40s' },
    ],
    sectionStats: [
      { doc: 'Master Proposal', label: '§01 · The answer + payback', readers: '12/16', avg: '4m 40s', revisits: 9, questions: 1, highlights: 3, skips: 0, hot: true, insight: 'Strongest commercial attention — the most-highlighted line lives here.' },
      { doc: 'Master Proposal', label: '§11 · Investment & guarantee', readers: '7/16', avg: '3m 50s', revisits: 6, questions: 2, highlights: 1, skips: 0, hot: true, insight: 'Reuben re-read the guarantee clause repeatedly — the decision point.' },
      { doc: 'Master Proposal', label: '§10 · Budgets', readers: '5/16', avg: '2m 05s', revisits: 4, questions: 1, highlights: 1, skips: 1, hot: true, insight: 'Finance lead spent the most time of anyone here.' },
      { doc: 'Master Proposal', label: '§04 · Plan A', readers: '9/16', avg: '2m 10s', revisits: 3, questions: 0, highlights: 0, skips: 1, insight: 'Steady read; a couple stalled here before pricing.' },
      { doc: 'Master Proposal', label: '§06 · Dependency maps', readers: '6/16', avg: '1m 55s', revisits: 2, questions: 0, highlights: 0, skips: 1, insight: 'Technical readers lingered; others skimmed.' },
      { doc: 'Master Proposal', label: '§07 · Head-to-head', readers: '4/16', avg: '0m 25s', revisits: 0, questions: 0, highlights: 0, skips: 7, insight: 'Proof / case-study section under-read — likely skipped.' },
      { doc: 'Appendix B · Rollout phasing', label: 'Dependencies', readers: '4/16', avg: '1m 10s', revisits: 1, questions: 1, highlights: 0, skips: 1, insight: 'Daniel flagged the week-6 content dependency.' },
    ],
    readers: [
      { email: 'reuben.zielinski@redux.com', time: '2h 58m', last: '18m ago' },
      { email: 'anita.rao@redux.com', time: '1h 22m', last: '3h ago' },
      { email: 'daniel.okafor@redux.com', time: '1h 06m', last: '5h ago' },
      { email: 'maria.t@redux.com', time: '1h 51m', last: '2d ago' },
      { email: 'james.d@redux.com', time: '44m', last: '1d ago' },
    ],
    perReader: {
      'reuben.zielinski@redux.com': { time: '2h 58m', completion: '100%', comments: 1, last: '18m ago', insight: 'Read §11 four times across two sessions — the guarantee is his decision point.', sectionTime: [{ label: '§11 · Investment & guarantee', pct: 96, time: '8m 40s', hot: true }, { label: '§01 · The answer + payback', pct: 80, time: '7m 10s', hot: true }, { label: '§06 · Dependency maps', pct: 52, time: '4m 40s' }, { label: '§04 · Plan A', pct: 44, time: '3m 58s' }] },
      'maria.t@redux.com': { time: '1h 51m', completion: '86%', comments: 2, last: '2d ago', insight: 'Spent longest on the payback math — and tagged Reuben on the ARPPU figure.', sectionTime: [{ label: '§01 · The answer + payback', pct: 96, time: '9m 05s', hot: true }, { label: '§10 · Budgets', pct: 64, time: '6m 02s', hot: true }, { label: '§11 · Investment & guarantee', pct: 48, time: '4m 30s' }] },
      'daniel.okafor@redux.com': { time: '1h 06m', completion: '72%', comments: 0, last: '5h ago', insight: 'Finance lead — lingered on the budget tables and the guarantee math.', sectionTime: [{ label: '§10 · Budgets', pct: 84, time: '6m 10s', hot: true }, { label: '§11 · Investment & guarantee', pct: 70, time: '5m 02s' }] },
      'anita.rao@redux.com': { time: '1h 22m', completion: '81%', comments: 0, last: '3h ago', insight: 'Read end-to-end — deepest reach after Reuben. A strong internal advocate.', sectionTime: [{ label: '§01 · The answer + payback', pct: 92, time: '7m 40s', hot: true }, { label: '§06 · Dependency maps', pct: 66, time: '5m 01s' }] },
      'james.d@redux.com': { time: '44m', completion: '43%', comments: 1, last: '1d ago', insight: 'Stopped at §04 · Plan A — hasn’t reached the guarantee yet.', sectionTime: [{ label: '§01 · The answer + payback', pct: 90, time: '6m 12s', hot: true }, { label: '§04 · Plan A', pct: 58, time: '4m 01s' }] },
    },
  },
  v2: {
    totalReadTime: '3h 12m', delta: 'superseded by V8 on 12 Jun',
    readersOpened: '3 / 5', completion: '61%', deepest: '§10 · Budgets',
    neverOpened: ['priya.n@redux.com (invited 4 Jun)'],
    insight: 'Maria challenged the separate multilingual pricing on this version — V8 folded it into the fixed fee.',
    mostHighlighted: '“$180,000, with the multilingual rollout priced separately.” · 2 readers',
    sectionTime: [
      { label: '§01 · The answer', pct: 92, time: '8m 44s', hot: true },
      { label: '§11 · Guarantee (first cut)', pct: 50, time: '4m 41s' },
      { label: '§04 · Plan A', pct: 38, time: '3m 30s' },
      { label: '§10 · Budgets', pct: 24, time: '2m 12s' },
    ],
    sectionStats: [
      { doc: 'Master Proposal', label: '§01 · The answer', readers: '3/5', avg: '6m 10s', revisits: 4, questions: 1, highlights: 2, skips: 0, hot: true, insight: 'Maria’s pricing challenge lives here.' },
      { doc: 'Master Proposal', label: '§10 · Budgets', readers: '2/5', avg: '2m 12s', revisits: 1, questions: 1, highlights: 0, skips: 1, insight: 'Separate multilingual pricing questioned.' },
    ],
    readers: [
      { email: 'maria.t@redux.com', time: '1h 51m', last: '8d ago' },
      { email: 'reuben.zielinski@redux.com', time: '58m', last: '9d ago' },
    ],
    perReader: {
      'maria.t@redux.com': { time: '1h 51m', completion: '86%', comments: 1, last: '8d ago', insight: 'Maria’s pricing question on this version drove the V8 repricing.', sectionTime: [{ label: '§01 · The answer', pct: 95, time: '6m 30s', hot: true }, { label: '§10 · Budgets', pct: 60, time: '4m 05s' }] },
      'reuben.zielinski@redux.com': { time: '58m', completion: '55%', comments: 0, last: '9d ago', insight: 'Skimmed V2 once — his deep reading started on V8.', sectionTime: [{ label: '§01 · The answer', pct: 88, time: '4m 50s', hot: true }] },
    },
  },

  /* questionnaire analytics (Sections tab) */
  questionnaireStats: { invited: 16, started: 2, completed: 1, avg: 64, inProgress: 1,
    rows: [
      { email: 'maria.t@redux.com', status: 'submitted', completion: 100, submitted: '2d ago' },
      { email: 'james.d@redux.com', status: 'partial', completion: 28, submitted: '—' },
    ] },

  /* recorded sessions for replay (Journeys tab) */
  sessions: [
    { id: 'sess1', reader: 'reuben.zielinski@redux.com', when: 'Today 09:41', version: 'v8', duration: '52m 10s',
      events: [
        { t: '00:00', label: 'Opened §01 · The answer', kind: 'section' },
        { t: '02:00', label: 'Hovered the 4× scenario row', kind: 'click' },
        { t: '07:00', label: 'Idle 4m (tab hidden)', kind: 'idle' },
        { t: '11:40', label: 'Opened §11 · The performance guarantee', kind: 'section' },
        { t: '16:20', label: 'Highlighted “Targets pause-adjust…”', kind: 'highlight' },
        { t: '16:50', label: 'Posted a question on §11', kind: 'comment' },
        { t: '40:00', label: 'Returned to §11 (third visit)', kind: 'section' },
        { t: '51:40', label: 'Re-read the payout ladder', kind: 'click' },
      ] },
    { id: 'sess4', reader: 'james.d@redux.com', when: '13 Jun 11:30', version: 'v8', duration: '44m',
      events: [
        { t: '00:00', label: 'Opened §01 · The answer', kind: 'section' },
        { t: '10:00', label: 'Highlighted “$190,000, fixed.”', kind: 'highlight' },
        { t: '10:40', label: 'Asked about multilingual scope', kind: 'comment' },
        { t: '30:00', label: 'Opened §04 · Plan A', kind: 'section' },
      ] },
  ],
};


/* ---- app/perf.js ---- */
/* ============================================================
   DEALWONDR APP — small performance marks for smoke tests and
   field debugging. No network beacons; browser-local only.
   ============================================================ */
(function () {
  var rows = [];

  function now() {
    return performance && performance.now ? performance.now() : Date.now();
  }

  function mark(name) {
    if (!name) return;
    rows.push({ name: String(name), at: now() });
    if (performance && performance.mark) {
      try { performance.mark("dw:" + name); } catch (error) {}
    }
  }

  function measure(name, startName, endName) {
    if (!name) return null;
    var start = rows.slice().reverse().find(function (row) { return row.name === startName; });
    var end = rows.slice().reverse().find(function (row) { return row.name === endName; });
    if (!start || !end) return null;
    var duration = Math.max(0, end.at - start.at);
    rows.push({ name: String(name), at: end.at, duration: duration, start: startName, end: endName });
    if (performance && performance.measure) {
      try { performance.measure("dw:" + name, "dw:" + startName, "dw:" + endName); } catch (error) {}
    }
    return duration;
  }

  function time(name, fn) {
    mark(name + ":start");
    return Promise.resolve()
      .then(fn)
      .finally(function () {
        mark(name + ":end");
        measure(name, name + ":start", name + ":end");
      });
  }

  window.DWPerf = {
    mark: mark,
    measure: measure,
    time: time,
    entries: function () { return rows.slice(); },
    clear: function () { rows = []; }
  };
})();


/* ---- app/client-analyzers.js ---- */
/* ============================================================
   DEALWONDR APP — browser-side document analyzers
   Fast preview extraction for supported upload types. The upload
   flow persists this preview immediately, then the backend parser
   validates/replaces it from the queued R2 object.
   ============================================================ */
(function () {
  var htmlDocumentMarker = '<dealwondr-html-document data-frame="1"></dealwondr-html-document>';
  function ext(name) {
    return String(name || "").toLowerCase().split(".").pop() || "";
  }

  function firstLine(text, fallback) {
    return String(text || "")
      .split(/\r?\n/)
      .map(function (line) { return line.trim(); })
      .find(Boolean) || fallback;
  }

  function decodeXmlText(value) {
    return String(value || "")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, '"')
      .replace(/&apos;/g, "'")
      .replace(/&amp;/g, "&");
  }

  function textNodes(xml) {
    return Array.from(String(xml || "").matchAll(/<[^:>]*:?t\b[^>]*>([\s\S]*?)<\/[^:>]*:?t>/g))
      .map(function (match) { return decodeXmlText(match[1] || "").trim(); })
      .filter(Boolean);
  }

  function htmlText(element) {
    var clone = element.cloneNode(true);
    Array.from(clone.querySelectorAll("script,style,noscript")).forEach(function (node) { node.remove(); });
    return (clone.textContent || "").replace(/\s+/g, " ").trim();
  }

  function bundledTemplateHtml(doc) {
    var templateEl = doc.querySelector('script[type="__bundler/template"]');
    if (!templateEl) return "";
    try {
      return JSON.parse(templateEl.textContent || '""');
    } catch (error) {
      throw new Error("Bundled HTML template could not be parsed.");
    }
  }

  function pageLabel(page, index) {
    var screen = (page.getAttribute("data-screen-label") || "").trim();
    if (screen) return screen;
    var heading = page.querySelector("h1,h2,h3,.kicker,.eyebrow");
    var headingText = (heading && (heading.textContent || "").trim()) || "";
    if (headingText) return headingText;
    var marker = (page.getAttribute("data-section") || page.getAttribute("data-page") || page.getAttribute("data-sec") || page.id || "").trim();
    return marker || "Section " + (index + 1);
  }

  function cleanHtmlAnchorLabel(value, fallback) {
    var label = String(value || "").replace(/\s+/g, " ").trim();
    label = label.replace(/^§?\s*\d+(?:[a-z](?=\s|[—-]|$))?\s*/i, "").replace(/[—-]\s*$/, "").trim();
    return label || fallback;
  }

  function htmlAnchorSections(doc) {
    var anchors = Array.from(doc.querySelectorAll("[data-screen-label],[data-sec],[data-section],[data-page],.page,section,article"));
    var seen = new Set();
    return anchors.map(function (anchor, index) {
      var key = anchor.getAttribute("data-sec") || anchor.getAttribute("data-section") || anchor.getAttribute("data-screen-label") || anchor.getAttribute("data-page") || anchor.id || String(index + 1);
      var source = htmlText(anchor);
      var label = pageLabel(anchor, index);
      if (/^\d+[a-z]?$/i.test(label) && source) label = cleanHtmlAnchorLabel(firstLine(source, label), label);
      var dedupe = key + "|" + label;
      if (seen.has(dedupe) || !label || !source) return null;
      seen.add(dedupe);
      return {
        page: String(index + 1).padStart(2, "0"),
        label: label,
        src: anchor.getAttribute("data-screen-label") ? "label" : anchor.getAttribute("data-sec") ? "data-sec" : anchor.tagName.toLowerCase(),
        source: source,
        on: true,
        reviewOnly: true
      };
    }).filter(Boolean);
  }

  function paragraphText(xml) {
    var paragraphs = Array.from(String(xml || "").matchAll(/<w:p\b[^>]*>([\s\S]*?)<\/w:p>/g))
      .map(function (match) { return textNodes(match[1] || "").join(""); })
      .map(function (line) { return line.trim(); })
      .filter(Boolean);
    return paragraphs.length ? paragraphs : textNodes(xml);
  }

  async function htmlSections(text, fileName) {
    var doc = new DOMParser().parseFromString(text, "text/html");
    var bundled = bundledTemplateHtml(doc);
    var html = bundled || text;
    if (bundled) doc = new DOMParser().parseFromString(bundled, "text/html");
    var title = (doc.querySelector("title") && doc.querySelector("title").textContent || "").trim();
    var bodyText = (doc.body && doc.body.textContent || "").trim();
    if (/<!doctype\s+html\b|<html\b/i.test(html)) {
      return [{
        page: "—",
        label: title || firstLine(bodyText, fileName),
        src: "html-document",
        source: bodyText,
        bodyHtml: htmlDocumentMarker,
        on: true
      }].concat(htmlAnchorSections(doc));
    }
    var pages = Array.from(doc.querySelectorAll(".page"));
    if (!pages.length) pages = Array.from(doc.querySelectorAll("[data-screen-label]"));
    var pageSections = pages.map(function (page, index) {
      return {
        page: String(index + 1).padStart(2, "0"),
        label: pageLabel(page, index),
        src: page.getAttribute("data-screen-label") ? "label" : page.getAttribute("data-sec") ? "data-sec" : "html",
        source: htmlText(page),
        on: true
      };
    }).filter(function (section) { return section.label && section.source; });
    if (pageSections.length) return pageSections;
    var headings = Array.from(doc.querySelectorAll("h1,h2,h3")).map(function (heading, index) {
      return {
        page: "—",
        label: (heading.textContent || "").trim() || "Section " + (index + 1),
        src: heading.tagName.toLowerCase(),
        source: bodyText || (heading.textContent || "").trim(),
        on: true
      };
    });
    if (headings.length) return headings;
    return [{ page: "—", label: title || firstLine(bodyText, fileName), src: "html", source: bodyText, on: true }];
  }

  function markdownSections(text, fileName) {
    var lines = String(text || "").split(/\r?\n/);
    var headingIndexes = [];
    lines.forEach(function (line, index) {
      if (/^#{1,6}\s+.+$/.test(line.trim())) headingIndexes.push(index);
    });
    var headings = headingIndexes.map(function (lineIndex, index) {
      var match = /^#{1,6}\s+(.+)$/.exec(lines[lineIndex].trim());
      var nextIndex = headingIndexes[index + 1] === undefined ? lines.length : headingIndexes[index + 1];
      var source = lines.slice(lineIndex + 1, nextIndex).join("\n").trim() || (match && match[1] || "");
      return { page: "—", label: match && match[1] ? match[1].trim() : "Section " + (index + 1), src: "heading", source: source, on: true };
    });
    return headings.length ? headings : [{ page: "—", label: firstLine(text, fileName), src: "text", source: String(text || "").trim(), on: true }];
  }

  async function zipFromFile(file) {
    var mod = await import("jszip");
    var JSZip = mod.default || mod;
    return JSZip.loadAsync(await file.arrayBuffer());
  }

  async function docxSections(file) {
    var zip = await zipFromFile(file);
    var files = Object.values(zip.files)
      .filter(function (entry) { return !entry.dir && /^word\/(document|header\d*|footer\d*)\.xml$/.test(entry.name); })
      .sort(function (a, b) { return a.name.localeCompare(b.name); });
    var sections = [];
    for (var i = 0; i < files.length; i += 1) {
      var xml = await files[i].async("text");
      var text = paragraphText(xml).join("\n\n").trim();
      if (text) sections.push({ page: String(i + 1).padStart(2, "0"), label: firstLine(text, files[i].name), src: "docx", source: text, on: true });
    }
    return sections;
  }

  async function pptxSections(file) {
    var zip = await zipFromFile(file);
    var files = Object.values(zip.files)
      .filter(function (entry) { return !entry.dir && /^ppt\/slides\/slide\d+\.xml$/.test(entry.name); })
      .sort(function (a, b) { return slideNumber(a.name) - slideNumber(b.name); });
    var sections = [];
    for (var i = 0; i < files.length; i += 1) {
      var xml = await files[i].async("text");
      var lines = textNodes(xml);
      if (lines.length) {
        var n = slideNumber(files[i].name);
        sections.push({ page: String(n).padStart(2, "0"), label: firstLine(lines.join("\n"), "Slide " + n), src: "pptx", source: lines.join("\n"), on: true });
      }
    }
    return sections;
  }

  function slideNumber(path) {
    return Number((String(path || "").match(/slide(\d+)\.xml$/) || [])[1] || 0);
  }

  async function pdfSections(file) {
    var parser = await import("unpdf");
    var pdf = await parser.getDocumentProxy(new Uint8Array(await file.arrayBuffer()));
    var result = await parser.extractText(pdf, { mergePages: false });
    return result.text
      .map(function (pageText, index) {
        return { page: String(index + 1).padStart(2, "0"), label: firstLine(pageText, "Page " + (index + 1)), src: "pdf", source: String(pageText || "").trim(), on: true };
      })
      .filter(function (section) { return section.label; });
  }

  async function analyzeFile(file) {
    var fileExt = ext(file && file.name);
    var sections = [];
    if (fileExt === "pdf") sections = await pdfSections(file);
    else if (fileExt === "docx") sections = await docxSections(file);
    else if (fileExt === "pptx") sections = await pptxSections(file);
    else if (fileExt === "html" || fileExt === "htm") sections = await htmlSections(await file.text(), file.name);
    else if (fileExt === "md" || fileExt === "markdown" || fileExt === "txt") sections = markdownSections(await file.text(), file.name);
    else throw new Error("Client preview is not available for this file type.");
    return { fileName: file.name, sections: sections.slice(0, 40) };
  }

  window.DWClientAnalyzers = { analyzeFile: analyzeFile };
})();


/* ---- app/api.js ---- */
/* ============================================================
   DEALWONDR APP — backend API client
   Production default points at api.dealwondr.com. Tests/dev can
   override with VITE_DEALWONDR_API_BASE or window.DW_API_BASE.
   ============================================================ */
(function () {
  var envBase =
    typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_DEALWONDR_API_BASE
      ? import.meta.env.VITE_DEALWONDR_API_BASE
      : "";
  var baseUrl = (window.DW_API_BASE || envBase || "https://api.dealwondr.com").replace(/\/+$/, "");
  var sessionKey = "dw-api-session-v1";
  var readerSessionsKey = "dw-api-reader-sessions-v1";

  function readActiveSession() {
    try {
      return JSON.parse(localStorage.getItem(sessionKey) || "null");
    } catch (error) {
      return null;
    }
  }

  function getSession() {
    var session = readActiveSession();
    var roomId = window.DW_API_ROOM_ID || "";
    if ((!session || session.kind === "reader") && roomId) {
      return getReaderSession(roomId) || session;
    }
    return session;
  }

  function readReaderSessions() {
    try {
      var parsed = JSON.parse(localStorage.getItem(readerSessionsKey) || "{}");
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function writeReaderSessions(sessions) {
    try {
      localStorage.setItem(readerSessionsKey, JSON.stringify(sessions || {}));
    } catch (error) {}
  }

  function rememberReaderSession(session) {
    if (!session || session.kind !== "reader" || !session.roomId || !session.sessionToken) return;
    var sessions = readReaderSessions();
    sessions[session.roomId] = session;
    writeReaderSessions(sessions);
  }

  function getReaderSession(roomId) {
    if (!roomId) return null;
    var session = readReaderSessions()[roomId] || null;
    return session && session.sessionToken ? session : null;
  }

  function roomIdFromPath(path) {
    var match = /^\/rooms\/([^/?#]+)/.exec(path || "");
    return match ? decodeURIComponent(match[1]) : "";
  }

  function sessionForPath(path) {
    var session = readActiveSession();
    if (session && session.kind === "team") return session;
    var roomId = roomIdFromPath(path);
    if (roomId) {
      var readerSession = getReaderSession(roomId);
      if (readerSession) return readerSession;
    }
    return session;
  }

  function setSession(session) {
    try {
      if (session) {
        localStorage.setItem(sessionKey, JSON.stringify(session));
        rememberReaderSession(session);
      } else {
        localStorage.removeItem(sessionKey);
        localStorage.removeItem(readerSessionsKey);
      }
    } catch (error) {}
  }

  function headers(extra, path) {
    var h = Object.assign({ accept: "application/json" }, extra || {});
    var session = sessionForPath(path);
    if (session && session.sessionToken) h.authorization = "Bearer " + session.sessionToken;
    return h;
  }

  async function request(path, options) {
    var method = (options && options.method) || "GET";
    var init = options || {};
    var response = await fetch(baseUrl + path, Object.assign({}, init, { headers: headers(init.headers, path) }));
    var body = null;
    var type = response.headers.get("content-type") || "";
    if (type.indexOf("application/json") >= 0) body = await response.json();
    if (!response.ok || (body && body.ok === false)) {
      var message = body && body.error && body.error.message ? body.error.message : "Request failed";
      var err = new Error(message);
      err.status = response.status;
      err.body = body;
      err.path = path;
      err.method = method;
      throw err;
    }
    return body && Object.prototype.hasOwnProperty.call(body, "data") ? body.data : body;
  }

  function json(path, method, body) {
    return request(path, {
      method: method || "GET",
      headers: body ? { "content-type": "application/json" } : undefined,
      body: body ? JSON.stringify(body) : undefined
    });
  }

  async function artifact(path, fallbackName) {
    var response = await fetch(baseUrl + path, { headers: headers(undefined, path) });
    if (!response.ok) {
      var message = "Download failed";
      try {
        var body = await response.json();
        if (body && body.error && body.error.message) message = body.error.message;
      } catch (error) {}
      var err = new Error(message);
      err.status = response.status;
      throw err;
    }
    var blob = await response.blob();
    var disposition = response.headers.get("content-disposition") || "";
    var match = /filename="?([^"]+)"?/i.exec(disposition);
    return {
      filename: match ? match[1] : fallbackName,
      contentType: blob.type || response.headers.get("content-type") || "application/octet-stream",
      content: blob
    };
  }

  async function text(path) {
    var response = await fetch(baseUrl + path, { headers: headers({ accept: "text/html" }, path) });
    if (!response.ok) {
      var message = "Request failed";
      try {
        var body = await response.json();
        if (body && body.error && body.error.message) message = body.error.message;
      } catch (error) {}
      var err = new Error(message);
      err.status = response.status;
      throw err;
    }
    return await response.text();
  }

  function qs(params) {
    var search = new URLSearchParams();
    Object.keys(params || {}).forEach(function (key) {
      if (params[key] !== undefined && params[key] !== null && params[key] !== "") search.set(key, params[key]);
    });
    var text = search.toString();
    return text ? "?" + text : "";
  }

  window.DWApi = {
    baseUrl: baseUrl,
    getSession: getSession,
    getReaderSession: getReaderSession,
    setSession: setSession,
    request: request,
    health: function () { return json("/health"); },
    requestTeamMagicLink: function (input) { return json("/auth/team/magic-link", "POST", input); },
    completeTeamMagicLink: function (token) { return json("/auth/team/complete-magic-link", "POST", { token: token }); },
    teamWorkspaces: function () { return json("/auth/team/workspaces"); },
    switchTeamWorkspace: function (workspaceId) { return json("/auth/team/switch-workspace", "POST", { workspaceId: workspaceId }); },
    logoutTeam: function () { return json("/auth/team/logout", "POST", {}); },
    completeReaderMagicLink: function (token) { return json("/auth/reader/complete-magic-link", "POST", { token: token }); },
    logoutReader: function () { return json("/auth/reader/logout", "POST", {}); },
    verifyReaderEmail: function (roomId, email) { return json("/rooms/" + encodeURIComponent(roomId) + "/reader/verify-email", "POST", { email: email }); },
    rooms: function (workspaceId) { return json("/rooms" + qs({ workspaceId: workspaceId })); },
    workspaceBootstrap: function (workspaceId) { return json("/workspaces/" + encodeURIComponent(workspaceId) + "/bootstrap"); },
    createRoom: function (input) { return json("/rooms", "POST", input); },
    roomBootstrap: function (roomId) { return json("/rooms/" + encodeURIComponent(roomId) + "/bootstrap"); },
    room: function (roomId) { return json("/rooms/" + encodeURIComponent(roomId)); },
    renameRoom: function (roomId, title) { return json("/rooms/" + encodeURIComponent(roomId), "PATCH", { title: title }); },
    publishRoom: function (roomId) { return json("/rooms/" + encodeURIComponent(roomId) + "/publish", "POST"); },
    archiveRoom: function (roomId) { return json("/rooms/" + encodeURIComponent(roomId) + "/archive", "PATCH"); },
    deleteRoom: function (roomId) { return json("/rooms/" + encodeURIComponent(roomId), "DELETE"); },
    unarchiveRoom: function (roomId) { return json("/rooms/" + encodeURIComponent(roomId) + "/unarchive", "PATCH"); },
    versions: function (roomId) { return json("/rooms/" + encodeURIComponent(roomId) + "/versions"); },
    addVersion: function (roomId, input) { return json("/rooms/" + encodeURIComponent(roomId) + "/versions", "POST", input); },
    setVersionVisible: function (roomId, versionId, visible) {
      return json("/rooms/" + encodeURIComponent(roomId) + "/versions/" + encodeURIComponent(versionId) + "/visible", "PATCH", { visible: visible });
    },
    documents: function (roomId, versionId) { return json("/rooms/" + encodeURIComponent(roomId) + "/documents" + qs({ versionId: versionId })); },
    addDocument: function (roomId, input) { return json("/rooms/" + encodeURIComponent(roomId) + "/documents", "POST", input); },
    renameDocument: function (roomId, documentId, title) {
      return json("/rooms/" + encodeURIComponent(roomId) + "/documents/" + encodeURIComponent(documentId), "PATCH", { title: title });
    },
    removeDocument: function (roomId, documentId) {
      return json("/rooms/" + encodeURIComponent(roomId) + "/documents/" + encodeURIComponent(documentId), "DELETE");
    },
    moveDocument: function (roomId, documentId, direction) {
      return json("/rooms/" + encodeURIComponent(roomId) + "/documents/" + encodeURIComponent(documentId) + "/move", "POST", { direction: direction });
    },
    documentContent: function (roomId, documentId, versionId) {
      return json("/rooms/" + encodeURIComponent(roomId) + "/documents/" + encodeURIComponent(documentId) + "/content" + qs({ versionId: versionId }));
    },
    documentFrameHtml: function (roomId, documentId, versionId) {
      return text("/rooms/" + encodeURIComponent(roomId) + "/documents/" + encodeURIComponent(documentId) + "/frame-html" + qs({ versionId: versionId }));
    },
    saveDocumentPreviewSections: function (roomId, documentId, input) {
      return json("/rooms/" + encodeURIComponent(roomId) + "/documents/" + encodeURIComponent(documentId) + "/preview-sections", "POST", input);
    },
    prototypes: function (roomId, versionId) { return json("/rooms/" + encodeURIComponent(roomId) + "/prototypes" + qs({ versionId: versionId })); },
    documentPrototype: function (roomId, documentId, versionId) {
      return json("/rooms/" + encodeURIComponent(roomId) + "/documents/" + encodeURIComponent(documentId) + "/prototype" + qs({ versionId: versionId }));
    },
    prototypeFrameHtml: function (roomId, prototypeId) {
      return text("/rooms/" + encodeURIComponent(roomId) + "/prototypes/" + encodeURIComponent(prototypeId) + "/frame-html");
    },
    contentDraft: function (roomId) { return json("/rooms/" + encodeURIComponent(roomId) + "/content-draft"); },
    ensureContentDraft: function (roomId) { return json("/rooms/" + encodeURIComponent(roomId) + "/content-draft", "POST"); },
    addDraftDocument: function (roomId, input) { return json("/rooms/" + encodeURIComponent(roomId) + "/content-draft/documents", "POST", input); },
    uploadDraftDocument: function (roomId, input) {
      return request("/rooms/" + encodeURIComponent(roomId) + "/content-draft/uploads" + qs({ fileName: input.fileName, title: input.title, role: input.role || "appendix" }), {
        method: "POST",
        headers: { "content-type": input.contentType || "application/octet-stream" },
        body: input.body
      });
    },
    renameDraftDocument: function (roomId, draftDocumentId, title) {
      return json("/rooms/" + encodeURIComponent(roomId) + "/content-draft/documents/" + encodeURIComponent(draftDocumentId), "PATCH", { title: title });
    },
    replaceDraftDocument: function (roomId, draftDocumentId, input) {
      return json("/rooms/" + encodeURIComponent(roomId) + "/content-draft/documents/" + encodeURIComponent(draftDocumentId) + "/replace", "POST", input || {});
    },
    uploadExistingDraftDocument: function (roomId, draftDocumentId, input) {
      return request("/rooms/" + encodeURIComponent(roomId) + "/content-draft/documents/" + encodeURIComponent(draftDocumentId) + "/upload" + qs({ fileName: input.fileName, title: input.title }), {
        method: "POST",
        headers: { "content-type": input.contentType || "application/octet-stream" },
        body: input.body
      });
    },
    addDraftPrototypeLink: function (roomId, input) {
      return json("/rooms/" + encodeURIComponent(roomId) + "/content-draft/prototypes/link", "POST", input || {});
    },
    uploadDraftPrototypeHtml: function (roomId, input) {
      return request("/rooms/" + encodeURIComponent(roomId) + "/content-draft/prototypes/html" + qs({ fileName: input.fileName, title: input.title }), {
        method: "POST",
        headers: { "content-type": input.contentType || "text/html" },
        body: input.body
      });
    },
    removeDraftDocument: function (roomId, draftDocumentId) {
      return json("/rooms/" + encodeURIComponent(roomId) + "/content-draft/documents/" + encodeURIComponent(draftDocumentId), "DELETE");
    },
    moveDraftDocument: function (roomId, draftDocumentId, direction) {
      return json("/rooms/" + encodeURIComponent(roomId) + "/content-draft/documents/" + encodeURIComponent(draftDocumentId) + "/move", "POST", { direction: direction });
    },
    publishContentDraft: function (roomId, input) { return json("/rooms/" + encodeURIComponent(roomId) + "/content-draft/publish", "POST", input || {}); },
    discardContentDraft: function (roomId) { return json("/rooms/" + encodeURIComponent(roomId) + "/content-draft/discard", "POST"); },
    comments: function (roomId, versionId) { return json("/rooms/" + encodeURIComponent(roomId) + "/comments" + qs({ versionId: versionId })); },
    addComment: function (roomId, input) { return json("/rooms/" + encodeURIComponent(roomId) + "/comments", "POST", input); },
    addReply: function (commentId, body) { return json("/comments/" + encodeURIComponent(commentId) + "/replies", "POST", { body: body }); },
    setResolved: function (commentId, resolved) { return json("/comments/" + encodeURIComponent(commentId) + "/resolved", "PATCH", { resolved: resolved }); },
    access: function (roomId) { return json("/rooms/" + encodeURIComponent(roomId) + "/access"); },
    inviteAccess: function (roomId, input) { return json("/rooms/" + encodeURIComponent(roomId) + "/access", "POST", input); },
    updateAccess: function (roomId, emailOrDomain, input) {
      return json("/rooms/" + encodeURIComponent(roomId) + "/access/" + encodeURIComponent(emailOrDomain), "PATCH", input);
    },
    removeAccess: function (roomId, emailOrDomain) {
      return json("/rooms/" + encodeURIComponent(roomId) + "/access/" + encodeURIComponent(emailOrDomain), "DELETE");
    },
    mentionables: function (roomId) { return json("/rooms/" + encodeURIComponent(roomId) + "/mentionables"); },
    activity: function (roomId, readerEmail) { return json("/rooms/" + encodeURIComponent(roomId) + "/activity" + qs({ readerEmail: readerEmail })); },
    analytics: function (roomId, versionId) { return json("/rooms/" + encodeURIComponent(roomId) + "/analytics" + qs({ versionId: versionId })); },
    recordAnalytics: function (roomId, events) { return json("/rooms/" + encodeURIComponent(roomId) + "/analytics", "POST", { events: events }); },
    exportComments: function (roomId, versionId, format) {
      return json("/rooms/" + encodeURIComponent(roomId) + "/exports/comments" + qs({ versionId: versionId, format: format || "csv" }));
    },
    exportSubmissions: function (roomId) { return json("/rooms/" + encodeURIComponent(roomId) + "/exports/submissions"); },
    exportObjections: function (roomId, versionId) {
      return json("/rooms/" + encodeURIComponent(roomId) + "/exports/objections" + qs({ versionId: versionId }));
    },
    exportPrecall: function (roomId, versionId) {
      return json("/rooms/" + encodeURIComponent(roomId) + "/exports/precall" + qs({ versionId: versionId }));
    },
    exportAnalytics: function (roomId, versionId) {
      return json("/rooms/" + encodeURIComponent(roomId) + "/exports/analytics" + qs({ versionId: versionId }));
    },
    exportProposalPdf: function (roomId, versionId) {
      return json("/rooms/" + encodeURIComponent(roomId) + "/exports/proposal-pdf" + qs({ versionId: versionId }));
    },
    exportAllVersions: function (roomId) {
      return json("/rooms/" + encodeURIComponent(roomId) + "/exports/all-versions");
    },
    insights: function (roomId, versionId) { return json("/rooms/" + encodeURIComponent(roomId) + "/insights" + qs({ versionId: versionId })); },
    setObjectionStatus: function (roomId, category, input) {
      return json("/rooms/" + encodeURIComponent(roomId) + "/objections/" + encodeURIComponent(category) + "/status", "POST", input);
    },
    nextActions: function (roomId, versionId) { return json("/rooms/" + encodeURIComponent(roomId) + "/next-actions" + qs({ versionId: versionId })); },
    actOnNextAction: function (roomId, actionKey, input) {
      return json("/rooms/" + encodeURIComponent(roomId) + "/next-actions/" + encodeURIComponent(actionKey) + "/actions", "POST", input);
    },
    undoNextAction: function (roomId, actionKey, versionId) {
      return json("/rooms/" + encodeURIComponent(roomId) + "/next-actions/" + encodeURIComponent(actionKey) + "/undo", "POST", { versionId: versionId });
    },
    precallNotes: function (roomId, versionId) { return json("/rooms/" + encodeURIComponent(roomId) + "/precall-notes" + qs({ versionId: versionId })); },
    createPrecallNote: function (roomId, versionId) { return json("/rooms/" + encodeURIComponent(roomId) + "/precall-notes", "POST", { versionId: versionId }); },
    sessions: function (roomId, versionId) { return json("/rooms/" + encodeURIComponent(roomId) + "/sessions" + qs({ versionId: versionId })); },
    startSession: function (roomId, input) { return json("/rooms/" + encodeURIComponent(roomId) + "/sessions", "POST", input || {}); },
    session: function (sessionId) { return json("/sessions/" + encodeURIComponent(sessionId)); },
    recordSessionEvents: function (sessionId, events) { return json("/sessions/" + encodeURIComponent(sessionId) + "/events", "POST", { events: events || [] }); },
    finishSession: function (sessionId, input) { return json("/sessions/" + encodeURIComponent(sessionId), "PATCH", input || {}); },
    tracking: function (roomId) { return json("/rooms/" + encodeURIComponent(roomId) + "/tracking"); },
    setTracking: function (roomId, patch) { return json("/rooms/" + encodeURIComponent(roomId) + "/tracking", "PATCH", patch); },
    readerTracking: function (roomId) { return json("/rooms/" + encodeURIComponent(roomId) + "/reader/tracking"); },
    setReaderTrackingPaused: function (roomId, paused) { return json("/rooms/" + encodeURIComponent(roomId) + "/reader/tracking-paused", "PATCH", { paused: paused }); },
    questionnaires: function (roomId) { return json("/rooms/" + encodeURIComponent(roomId) + "/questionnaires"); },
    liveQuestionnaires: function (roomId) { return json("/rooms/" + encodeURIComponent(roomId) + "/questionnaires/live"); },
    saveQuestionnaire: function (roomId, input) { return json("/rooms/" + encodeURIComponent(roomId) + "/questionnaires", "POST", input); },
    generateQuestionnaire: function (roomId, prompt) { return json("/rooms/" + encodeURIComponent(roomId) + "/questionnaires/generate", "POST", { prompt: prompt }); },
    improveQuestionnaire: function (input) { return json("/questionnaires/improve", "POST", input); },
    questionnaire: function (questionnaireId) { return json("/questionnaires/" + encodeURIComponent(questionnaireId)); },
    publishQuestionnaire: function (questionnaireId) { return json("/questionnaires/" + encodeURIComponent(questionnaireId) + "/publish", "POST"); },
    deleteQuestionnaire: function (questionnaireId) { return json("/questionnaires/" + encodeURIComponent(questionnaireId), "DELETE"); },
    uploadQuestionnaireAttachment: function (questionnaireId, input) {
      return request("/questionnaires/" + encodeURIComponent(questionnaireId) + "/attachments" + qs({ roomId: input.roomId, questionId: input.questionId, fileName: input.fileName }), {
        method: "POST",
        headers: { "content-type": input.contentType || "application/octet-stream" },
        body: input.body
      });
    },
    downloadQuestionnaireAttachment: function (questionnaireId, input) {
      return artifact(
        "/questionnaires/" + encodeURIComponent(questionnaireId) + "/attachments" + qs({ key: input.key }),
        input.fileName || "questionnaire-attachment"
      );
    },
    submitQuestionnaire: function (questionnaireId, input) { return json("/questionnaires/" + encodeURIComponent(questionnaireId) + "/submissions", "POST", input); },
    questionnaireSubmissions: function (questionnaireId) { return json("/questionnaires/" + encodeURIComponent(questionnaireId) + "/submissions"); },
    readerQuestionnaireSubmission: function (questionnaireId, readerEmail) {
      return json("/questionnaires/" + encodeURIComponent(questionnaireId) + "/submissions/" + encodeURIComponent(readerEmail));
    },
    workspace: function (workspaceId) { return json("/workspaces/" + encodeURIComponent(workspaceId)); },
    brand: function (workspaceId) { return json("/workspaces/" + encodeURIComponent(workspaceId) + "/brand"); },
    updateBrand: function (workspaceId, patch) { return json("/workspaces/" + encodeURIComponent(workspaceId) + "/brand", "PATCH", patch); },
    workspaceDomains: function (workspaceId) { return json("/workspaces/" + encodeURIComponent(workspaceId) + "/domains"); },
    createWorkspaceDomain: function (workspaceId, input) { return json("/workspaces/" + encodeURIComponent(workspaceId) + "/domains", "POST", input); },
    verifyWorkspaceDomain: function (workspaceId, domainId) {
      return json("/workspaces/" + encodeURIComponent(workspaceId) + "/domains/" + encodeURIComponent(domainId) + "/verify", "POST");
    },
    deleteWorkspaceDomain: function (workspaceId, domainId) {
      return json("/workspaces/" + encodeURIComponent(workspaceId) + "/domains/" + encodeURIComponent(domainId), "DELETE");
    },
    testWorkspaceDomainEmail: function (workspaceId, domainId) {
      return json("/workspaces/" + encodeURIComponent(workspaceId) + "/domains/" + encodeURIComponent(domainId) + "/test-email", "POST");
    },
    members: function (workspaceId) { return json("/workspaces/" + encodeURIComponent(workspaceId) + "/members"); },
    inviteMember: function (workspaceId, input) { return json("/workspaces/" + encodeURIComponent(workspaceId) + "/members", "POST", input); },
    setMemberRole: function (workspaceId, email, role) {
      return json("/workspaces/" + encodeURIComponent(workspaceId) + "/members/" + encodeURIComponent(email) + "/role", "PATCH", { role: role });
    },
    removeMember: function (workspaceId, email) { return json("/workspaces/" + encodeURIComponent(workspaceId) + "/members/" + encodeURIComponent(email), "DELETE"); },
    joinRequests: function (workspaceId) { return json("/workspaces/" + encodeURIComponent(workspaceId) + "/join-requests"); },
    approveJoinRequest: function (workspaceId, requestId) {
      return json("/workspaces/" + encodeURIComponent(workspaceId) + "/join-requests/" + encodeURIComponent(requestId) + "/approve", "POST");
    },
    rejectJoinRequest: function (workspaceId, requestId, note) {
      return json("/workspaces/" + encodeURIComponent(workspaceId) + "/join-requests/" + encodeURIComponent(requestId) + "/reject", "POST", { note: note });
    },
    emailSmoke: function (workspaceId) {
      return json("/workspaces/" + encodeURIComponent(workspaceId) + "/email-smoke", "POST");
    },
    questionnaireTemplates: function (workspaceId) { return json("/workspaces/" + encodeURIComponent(workspaceId) + "/questionnaire-templates"); },
    saveQuestionnaireTemplate: function (workspaceId, input) { return json("/workspaces/" + encodeURIComponent(workspaceId) + "/questionnaire-templates", "POST", input); },
    duplicateQuestionnaireTemplate: function (workspaceId, templateId) {
      return json("/workspaces/" + encodeURIComponent(workspaceId) + "/questionnaire-templates/" + encodeURIComponent(templateId) + "/duplicate", "POST");
    },
    archiveQuestionnaireTemplate: function (workspaceId, templateId) {
      return json("/workspaces/" + encodeURIComponent(workspaceId) + "/questionnaire-templates/" + encodeURIComponent(templateId) + "/archive", "POST");
    },
    renameQuestionnaireTemplate: function (workspaceId, templateId, name) {
      return json("/workspaces/" + encodeURIComponent(workspaceId) + "/questionnaire-templates/" + encodeURIComponent(templateId) + "/rename", "PATCH", { name: name });
    },
    useQuestionnaireTemplate: function (roomId, templateId) {
      return json("/rooms/" + encodeURIComponent(roomId) + "/questionnaire-templates/" + encodeURIComponent(templateId) + "/use", "POST");
    },
    roomTemplates: function (workspaceId) { return json("/workspaces/" + encodeURIComponent(workspaceId) + "/room-templates"); },
    roomTemplateSections: function (workspaceId, templateId) {
      return json("/workspaces/" + encodeURIComponent(workspaceId) + "/room-templates/" + encodeURIComponent(templateId) + "/sections");
    },
    useRoomTemplate: function (workspaceId, templateId, input) {
      return json("/workspaces/" + encodeURIComponent(workspaceId) + "/room-templates/" + encodeURIComponent(templateId) + "/use", "POST", input || {});
    },
    importLink: function (workspaceId, input) {
      return json("/workspaces/" + encodeURIComponent(workspaceId) + "/imports/link", "POST", input || {});
    },
    createPrototypeLink: function (workspaceId, input) {
      return json("/workspaces/" + encodeURIComponent(workspaceId) + "/prototypes/link", "POST", input || {});
    },
    uploadPrototypeHtml: function (workspaceId, input) {
      return request("/workspaces/" + encodeURIComponent(workspaceId) + "/prototypes/html" + qs({ fileName: input.fileName, title: input.title, preparedFor: input.preparedFor, gateDescription: input.gateDescription }), {
        method: "POST",
        headers: { "content-type": input.contentType || "text/html" },
        body: input.body
      });
    },
    platformOverview: function () { return json("/platform/overview"); },
    setPlatformWorkspacePlan: function (workspaceId, plan) { return json("/platform/workspaces/" + encodeURIComponent(workspaceId) + "/plan", "PATCH", { plan: plan }); },
    deletePlatformWorkspace: function (workspaceId) { return json("/platform/workspaces/" + encodeURIComponent(workspaceId), "DELETE"); },
    notifications: function (workspaceId, recipient) { return json("/workspaces/" + encodeURIComponent(workspaceId) + "/notifications" + qs({ recipient: recipient })); },
    notificationPrefs: function (workspaceId) { return json("/workspaces/" + encodeURIComponent(workspaceId) + "/notification-prefs"); },
    updateNotificationPrefs: function (workspaceId, patch) { return json("/workspaces/" + encodeURIComponent(workspaceId) + "/notification-prefs", "PATCH", patch); },
    createNotification: function (workspaceId, input) { return json("/workspaces/" + encodeURIComponent(workspaceId) + "/notifications", "POST", input); },
    actOnNotification: function (notificationId, actionId) { return json("/notifications/" + encodeURIComponent(notificationId) + "/actions", "POST", { actionId: actionId }); },
    setNotificationRead: function (notificationId, read) { return json("/notifications/" + encodeURIComponent(notificationId) + "/read", "PATCH", { read: read }); },
    markAllNotificationsRead: function (workspaceId, recipientEmail) {
      return json("/workspaces/" + encodeURIComponent(workspaceId) + "/notifications/read-all", "POST", { recipientEmail: recipientEmail });
    },
    snoozeNotification: function (notificationId, snoozedUntil) { return json("/notifications/" + encodeURIComponent(notificationId) + "/snooze", "POST", { snoozedUntil: snoozedUntil }); },
    unsnoozeNotification: function (notificationId) { return json("/notifications/" + encodeURIComponent(notificationId) + "/unsnooze", "POST"); },
    undoNotification: function (notificationId) { return json("/notifications/" + encodeURIComponent(notificationId) + "/undo", "POST"); },
    costs: function (workspaceId) { return json("/workspaces/" + encodeURIComponent(workspaceId) + "/costs"); },
    llmRuns: function (workspaceId, params) { return json("/workspaces/" + encodeURIComponent(workspaceId) + "/llm-runs" + qs(params || {})); },
    sectionAnalysis: function (roomId, versionId) { return json("/rooms/" + encodeURIComponent(roomId) + "/ai/section-analysis" + qs({ versionId: versionId })); },
    upload: function (roomId, input) {
      return request("/rooms/" + encodeURIComponent(roomId) + "/uploads" + qs({ versionId: input.versionId, documentId: input.documentId, fileName: input.fileName }), {
        method: "POST",
        headers: { "content-type": input.contentType || "application/octet-stream" },
        body: input.body
      });
    }
  };
})();


/* ---- app/adapters.js ---- */
/* ============================================================
   DEALWONDR APP — backend-to-UI data adapters
   Keeps API response mapping out of screens and store actions.
   ============================================================ */
(function () {
  function titleCase(value) {
    return String(value || "")
      .replace(/[-_]+/g, " ")
      .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function statusLabel(value) {
    var status = String(value || "").toLowerCase();
    if (status === "live") return "Active";
    if (status === "quest") return "Questionnaire";
    return titleCase(status || "room");
  }

  function initials(name, email) {
    var source = String(name || email || "NA").trim();
    var parts = source.split(/\s+/).filter(Boolean);
    return ((parts[0] || "N")[0] + (parts[1] || parts[0] || "A")[0]).toUpperCase();
  }

  function defaultNotificationRules() {
    return [
      { id: "hot_reader", name: "Hot reader", desc: "A buyer returns 3+ times in a day", threshold: ">= 3 visits", on: true },
      { id: "approver_silent", name: "Approver goes silent", desc: "No activity from an approver", threshold: ">= 5 days", on: true },
      { id: "new_objection", name: "New objection", desc: "Insights surfaces a high-severity concern", threshold: "High+", on: false }
    ];
  }

  function normalizeNotificationPrefs(prefs) {
    var current = prefs || {};
    var digest = current.digest || {};
    return {
      workspaceId: current.workspaceId || null,
      channels: Object.assign({ inApp: true, email: true, slack: false }, current.channels || {}),
      rules: Array.isArray(current.rules) && current.rules.length ? current.rules : defaultNotificationRules(),
      digest: Object.assign({ on: true, cadence: "daily", time: "09:00" }, digest),
      updatedAt: current.updatedAt || null
    };
  }

  function teamRoleLabel(role) {
    if (role === "admin") return "Admin";
    if (role === "manager" || role === "editor") return "Editor";
    return "Viewer";
  }

  function teamRoleValue(label) {
    var value = String(label || "").toLowerCase();
    if (value === "admin") return "admin";
    if (value === "editor" || value === "manager") return "manager";
    return "viewer";
  }

  function mapMember(row, options) {
    var email = row.email || "";
    var name = row.name || titleCase(email.split("@")[0].replace(/[._]/g, " "));
    var label = teamRoleLabel(row.role);
    var meEmail = options && options.meEmail ? String(options.meEmail).toLowerCase() : "";
    var me = meEmail ? meEmail === email.toLowerCase() : !!row.isMe;
    return [name, email, initials(name, email), label.toLowerCase(), label, me];
  }

  function mapJoinRequest(row) {
    var email = row.email || "";
    var name = row.name || titleCase(email.split("@")[0].replace(/[._]/g, " "));
    return {
      id: row.id,
      workspaceId: row.workspaceId,
      email: email,
      name: name,
      initials: initials(name, email),
      status: row.status || "pending",
      requestedAt: row.requestedAt || null,
      decidedBy: row.decidedBy || null,
      decidedAt: row.decidedAt || null,
      decisionNote: row.decisionNote || ""
    };
  }

  function mapTemplate(row) {
    var schema = row.schema || {};
    var steps = Array.isArray(schema.steps) ? schema.steps : [];
    var questions = steps.reduce(function (sum, step) { return sum + ((step.questions || []).length); }, 0);
    return {
      id: row.id,
      name: row.name,
      tags: row.tags || [],
      questions: row.questions !== undefined ? row.questions : questions,
      steps: row.steps !== undefined ? row.steps : steps.length,
      version: row.version || 1,
      by: row.by || "Team",
      usage: row.usage !== undefined ? row.usage : (row.usageCount || 0),
      lastUsed: row.lastUsed || "—",
      schema: schema
    };
  }

  function mapPrecallNote(row, options) {
    var label = row.label || row.temperatureLabel || "Brief";
    var temperature = row.temperature !== undefined ? row.temperature : (row.temperatureScore || 0);
    return {
      id: row.id,
      version: String(row.versionId || row.version || "").toUpperCase(),
      versionId: row.versionId || row.version || ((options && options.fallbackVersionId) || null),
      label: label,
      temperature: temperature,
      tone: temperature >= 85 ? "hot" : (temperature >= 65 ? "warm" : (temperature >= 45 ? "steady" : "cold")),
      date: shortDate(row.createdAt),
      by: row.createdBy || row.by || "",
      summary: row.summary || "",
      parts: row.parts || row.sections || [],
      markdown: row.markdown || ""
    };
  }

  function mapRoomSummary(row) {
    var status = row.status || "draft";
    var live = status === "live";
    return {
      id: row.id,
      apiId: row.id,
      title: row.title,
      sub: statusLabel(status),
      status: status,
      version: "",
      temp: "",
      tempScore: 0,
      readers: "—",
      comments: "—",
      readTime: "—",
      last: row.liveSince ? "active" : "—",
      ref: row.ref,
      liveSince: row.liveSince,
      preparedFor: row.preparedFor || "",
      gateDescription: row.gateDescription || "",
      canOpen: live || status === "draft" || status === "archived"
    };
  }

  var CONTENT_TODAY = "14 Jun 2026";
  var QUESTIONNAIRE_PLACEMENTS = {
    intro: ["Intro", "Sent with the room invite — answered before the proposal."],
    post: ["Post-read", "Appears as a CTA after the reader finishes the documents."],
    standalone: ["Standalone", "Has its own link — sent on its own, no proposal needed."]
  };

  function mapContentDoc(doc) {
    return {
      id: doc.id,
      roomId: doc.roomId,
      draftDocumentId: doc.draftDocumentId || null,
      sourceDocumentId: doc.sourceDocumentId || null,
      title: doc.title,
      role: doc.role || "appendix",
      pages: doc.pages || 0,
      sortOrder: doc.sortOrder || 0,
      stagedAction: doc.stagedAction || "unchanged",
      prototype: doc.prototype || null
    };
  }

  function titleFromFileName(fileName) {
    return String(fileName || "Appendix")
      .replace(/\.[^.]+$/, "")
      .replace(/[-_]+/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .replace(/\b\w/g, function (c) { return c.toUpperCase(); }) || "Appendix";
  }

  function shortContentDate(value) {
    if (!value) return CONTENT_TODAY;
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return CONTENT_TODAY;
    return date.toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" });
  }

  function mapContentVersion(version, docs, fallbackNote, keepOld) {
    var total = (docs || []).reduce(function (n, d) { return n + (d.pages || 0); }, 0);
    var label = String(version.label || version.id || "v1").toUpperCase();
    return {
      id: version.id || label,
      label: label,
      issued: shortContentDate(version.issuedAt),
      note: version.note || fallbackNote || "",
      latest: version.current !== false,
      docs: docs.length,
      pages: total,
      comments: 0,
      clientVisible: version.clientVisible !== false,
      keepOld: keepOld !== false
    };
  }

  function versionNumber(row) {
    return parseInt(String((row && (row.label || row.id)) || "").replace(/\D/g, ""), 10) || 0;
  }

  function sortVersionsCurrentFirst(versions) {
    return (versions || []).slice().sort(compareVersionsCurrentFirst);
  }

  function compareVersionsCurrentFirst(a, b) {
      if (!!(a.current || a.latest) !== !!(b.current || b.latest)) return (a.current || a.latest) ? -1 : 1;
      var bn = versionNumber(b);
      var an = versionNumber(a);
      if (bn !== an) return bn - an;
      return String(b.issuedAt || b.issued || "").localeCompare(String(a.issuedAt || a.issued || ""));
  }

  function mapContentVersions(versions, docs) {
    var total = (docs || []).reduce(function (n, d) { return n + (d.pages || 0); }, 0);
    return (versions || []).map(function (v) {
      return Object.assign({}, v, {
        id: v.id || v.label,
        label: String(v.label || v.id || "").toUpperCase(),
        issued: v.issued || shortContentDate(v.issuedAt),
        latest: v.latest !== undefined ? v.latest : !!v.current,
        docs: docs.length,
        pages: total,
        comments: 0,
        clientVisible: v.clientVisible !== false
      });
    }).sort(compareVersionsCurrentFirst);
  }

  function syncPublishedContent(roomId, result, liveDocs, mappedVersion) {
    var seed = window.DW_SEED || {};
    var version = mappedVersion || mapContentVersion(result.version || {}, liveDocs || [], "", true);
    var docs = liveDocs || [];
    seed.documents = docs.map(function (doc, index) {
      return { id: doc.sourceDocumentId || doc.id, roomId: roomId, title: doc.title, role: doc.role, pages: doc.pages, sortOrder: index + 1, prototype: doc.prototype || null };
    });
    seed.room = Object.assign({}, seed.room || {}, {
      version: version.label,
      documents: docs.length,
      versions: [version].concat(((seed.room && seed.room.versions) || []).map(function (row) { return Object.assign({}, row, { latest: false }); }))
    });
    seed.versions = [Object.assign({}, result.version || {}, {
      id: (result.version && result.version.id) || version.id,
      label: (result.version && result.version.label) || version.label,
      roomId: roomId,
      latest: true,
      current: true,
      clientVisible: version.clientVisible !== false
    })].concat((seed.versions || []).map(function (row) { return Object.assign({}, row, { latest: false, current: false }); }));
    seed.rooms = (seed.rooms || []).map(function (row) {
      var rowId = row.apiId || row.id;
      var status = statusLabel(row.status || "live");
      return rowId === roomId ? Object.assign({}, row, { version: version.label, sub: status + " · " + version.label }) : row;
    });
    window.DW_SEED = seed;
    return seed;
  }

  function shortDate(value) {
    if (!value) return "—";
    var d = new Date(value);
    if (Number.isNaN(d.getTime())) return "—";
    return d.toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" });
  }

  function relative(value) {
    if (!value) return "—";
    var ms = Date.now() - new Date(value).getTime();
    if (!Number.isFinite(ms)) return "—";
    var mins = Math.max(0, Math.round(ms / 60000));
    if (mins < 60) return mins ? mins + "m ago" : "just now";
    var hours = Math.round(mins / 60);
    if (hours < 48) return hours + "h ago";
    return Math.round(hours / 24) + "d ago";
  }

  function formatDuration(ms) {
    var sec = Math.max(0, Math.round((ms || 0) / 1000));
    var h = Math.floor(sec / 3600);
    var m = Math.floor((sec % 3600) / 60);
    if (h) return h + "h " + m + "m";
    return m ? m + "m" : sec + "s";
  }

  function textFromHtml(html) {
    if (!html) return "";
    var div = document.createElement("div");
    div.innerHTML = html;
    return (div.textContent || div.innerText || "").trim();
  }

  function hasRichHtml(html) {
    return /<(style|div|section|article|main|header|footer|figure|table|ul|ol|svg)\b/i.test(String(html || "")) || /\s(class|style)=["']/i.test(String(html || ""));
  }

  function isStandaloneHtmlDocument(html) {
    return /(?:<!doctype\s+html\b|<html\b)/i.test(String(html || ""));
  }

  function isHtmlDocumentFrameMarker(html) {
    return /<dealwondr-html-document\b/i.test(String(html || ""));
  }

  function dealRoleLabel(role) {
    var map = { approver: "Final approver", champion: "Champion", senior: "Senior", junior: "Junior", unknown: "Unknown" };
    return map[role] || titleCase(role || "unknown");
  }

  function schemaFields(schema) {
    var steps = schema && Array.isArray(schema.steps) ? schema.steps : [];
    return steps.flatMap(function (step) {
      return (step.questions || []).map(function (q) {
        return {
          id: q.id,
          type: q.type === "long_text" ? "long" : q.type === "short_text" ? "short" : q.type === "single_select" ? "single" : q.type === "multi_select" ? "multi" : q.type,
          label: q.label,
          required: !!q.required,
          req: !!q.required,
          help: q.help || "",
          options: q.options || q.opts || [],
          opts: q.options || q.opts || []
        };
      });
    });
  }

  function latestVersion(versions) {
    return sortVersionsCurrentFirst(versions)[0] || null;
  }

  function mapRoom(room, versions, access, comments, analytics, insights) {
    var latest = latestVersion(versions);
    var invited = (access || []).filter(function (a) { return a.role === "client" && String(a.emailOrDomain || "").charAt(0) !== "@"; }).length;
    var opened = analytics && analytics.openedReaders ? analytics.openedReaders : 0;
    var openComments = (comments || []).filter(function (c) { return c.needsReply && !c.resolved; }).length;
    var score = insights && insights.temperature ? insights.temperature.temperature || insights.temperature.score || insights.temperature.temp || null : null;
    var tempScore = score || 0;
    return {
      id: room.id,
      title: room.title,
      sub: titleCase(room.status) + (latest ? " · " + latest.label.toUpperCase() : ""),
      status: room.status,
      version: latest ? latest.label.toUpperCase() : "",
      temp: tempScore >= 80 ? "Hot" : tempScore >= 60 ? "Warm" : tempScore ? "Steady" : "",
      tempScore: tempScore,
      readers: opened + " / " + invited,
      comments: String((comments || []).length) + (openComments ? " · " + openComments + " open" : ""),
      readTime: formatDuration(Object.keys((analytics && analytics.perReader) || {}).reduce(function (sum, email) {
        return sum + (((analytics.perReader || {})[email] || {}).durationMs || 0);
      }, 0)),
      last: room.liveSince ? relative(room.liveSince) : "—",
      apiId: room.id
    };
  }

  function mapComment(row) {
    return {
      id: row.id,
      author: row.authorEmail || row.author || "",
      sectionId: row.sectionId,
      section: row.sectionId || "Section",
      version: (row.versionId || "").toUpperCase(),
      quote: row.quote || "",
      created: relative(row.createdAt),
      body: row.body,
      needsReply: !!row.needsReply,
      resolved: !!row.resolved,
      replies: (row.replies || []).map(function (reply) {
        return { author: reply.authorEmail || reply.author, created: relative(reply.createdAt), body: reply.body };
      })
    };
  }

  function mapAccess(row) {
    return {
      id: row.id,
      email: row.emailOrDomain,
      access: row.revokedAt ? "revoked" : "opened",
      role: dealRoleLabel(row.dealRole),
      opened: row.revokedAt ? "—" : "active",
      time: "—"
    };
  }

  function applyMentionables(rows) {
    window.DW_SEED.people = Object.assign({}, window.DW_SEED.people || {});
    (rows || []).forEach(function (row) {
      var email = row.email || row.emailOrDomain || row.email_or_domain;
      if (!email) return;
      var name = row.name || titleCase(String(email).split("@")[0].replace(/[._]/g, " "));
      window.DW_SEED.people[email] = {
        name: name,
        initials: row.initials || initials(name, email),
        cls: "",
        role: row.role || "",
        dealRole: row.dealRole || row.displayRole || row.display_role || row.role || ""
      };
    });
  }

  function mapQuestionnaire(q, submissions) {
    var rows = submissions || [];
    return {
      id: q.id,
      roomId: q.roomId,
      versionId: q.versionId || null,
      title: q.title,
      introText: q.introText || "",
      outroText: q.outroText || "",
      status: q.status,
      placement: q.placement || (q.versionId ? "post" : "standalone"),
      mode: q.mode === "single_step" ? "single" : "multi",
      lastActivity: q.publishedAt ? relative(q.publishedAt) : "draft",
      schema: q.schema || {},
      sent: rows.length,
      completed: rows.filter(function (s) { return s.status === "submitted"; }).length,
      inProgress: rows.filter(function (s) { return s.status === "partial" || s.status === "started"; }).length,
      fields: schemaFields(q.schema),
      responses: rows.map(function (s) {
        return { email: s.readerEmail, status: s.status === "submitted" ? "Completed" : "In progress", when: relative(s.updatedAt), dur: "—", answers: s.answers || {} };
      })
    };
  }

  function mapNotification(n) {
    var payload = n.payload || {};
    return {
      id: n.id,
      verb: titleCase(n.type),
      temp: /hot|objection/i.test(n.type) ? "hot" : "warm",
      tempLabel: /hot|objection/i.test(n.type) ? "Hot" : "Warm",
      hot: /hot|objection/i.test(n.type),
      actionable: true,
      read: !!n.readAt,
      readAt: n.readAt,
      snoozed: !!n.snoozedUntil,
      snoozedUntil: n.snoozedUntil,
      done: n.done ? { label: titleCase(n.done.action || "Done") } : null,
      roomId: n.roomId || n.room_id || payload.roomId || payload.room_id || null,
      room: payload.room || "Room",
      reader: payload.reader || payload.readerEmail || "",
      title: payload.message || titleCase(n.type),
      body: payload.section ? "Section: " + payload.section : "",
      actions: [
        { id: payload.commentId ? "resolve" : "section", label: payload.commentId ? "Resolve" : "Open", primary: true, doneLabel: payload.commentId ? "Resolved" : "Opened" },
        { id: "snooze", label: "Snooze", kind: "snooze" }
      ]
    };
  }

  function mapNextAction(action, index) {
    return {
      id: action.id || action.key || "a" + index,
      verb: action.verb || "Act",
      temp: action.temp || (index === 0 ? "hot" : "risk"),
      impact: action.impactLabel || action.impact || "Recommended",
      title: action.title || "Recommended action",
      why: action.why || action.reason || "",
      meta: action.meta || "",
      best: index === 0,
      commentId: action.commentId || null,
      done: action.done || null,
      actions: (action.actions || []).map(function (item) {
        return { id: item.id, label: item.label || item.id, kind: item.kind || item.id, primary: !!item.primary };
      }).filter(function (item) { return !!item.id; })
    };
  }

  function mapNextActions(result) {
    return ((result && result.actions) || []).map(mapNextAction);
  }

  function mapAnalytics(versionId, analytics, access, comments, sessions) {
    var readers = Object.keys((analytics && analytics.perReader) || {});
    var invited = (access || []).filter(function (a) { return a.role === "client" && String(a.emailOrDomain || "").charAt(0) !== "@"; }).map(function (a) { return a.emailOrDomain; });
    var perReader = {};
    readers.forEach(function (email) {
      var row = analytics.perReader[email] || {};
      perReader[email] = {
        time: formatDuration(row.durationMs),
        completion: row.eventCount ? "100%" : "0%",
        comments: (comments || []).filter(function (c) { return c.authorEmail === email; }).length,
        last: "active",
        insight: row.eventCount + " tracked events",
        sectionTime: (analytics.sectionTime || []).slice(0, 4).map(function (s) {
          return { label: s.label || s.sectionId || "Section", pct: Math.min(100, Math.round((s.durationMs || 0) / 6000)), time: formatDuration(s.durationMs), hot: (s.durationMs || 0) > 300000 };
        })
      };
    });
    return {
      totalReadTime: formatDuration(Object.keys(analytics.perReader || {}).reduce(function (sum, email) { return sum + ((analytics.perReader[email] || {}).durationMs || 0); }, 0)),
      delta: "live API",
      readersOpened: (analytics.openedReaders || 0) + " / " + invited.length,
      completion: invited.length ? Math.round(((analytics.openedReaders || 0) / invited.length) * 100) + "%" : "0%",
      deepest: (analytics.sectionTime || [])[0] ? (analytics.sectionTime || [])[0].label : "—",
      neverOpened: invited.filter(function (email) { return readers.indexOf(email) < 0; }).map(function (email) { return email + " (invited)"; }),
      insight: (analytics.sectionTime || [])[0] ? "Highest attention: " + analytics.sectionTime[0].label : "No reader analytics recorded yet.",
      mostHighlighted: "Highlights are recorded as analytics events.",
      sectionTime: (analytics.sectionTime || []).map(function (s) {
        return { label: s.label || s.sectionId || "Section", pct: Math.min(100, Math.round((s.durationMs || 0) / 6000)), time: formatDuration(s.durationMs), hot: (s.durationMs || 0) > 300000 };
      }),
      sectionStats: (analytics.sectionTime || []).map(function (s) {
        var q = (comments || []).filter(function (c) { return c.sectionId === s.sectionId; }).length;
        return { doc: "Proposal", label: s.label || s.sectionId || "Section", readers: String(analytics.openedReaders || 0), avg: formatDuration(s.durationMs), revisits: 0, questions: q, highlights: 0, skips: 0, hot: (s.durationMs || 0) > 300000, insight: q ? q + " question(s) attached." : "Tracked via reader events." };
      }),
      readers: readers.map(function (email) { return { email: email, time: perReader[email].time, last: perReader[email].last }; }),
      perReader: perReader
    };
  }

  function mapSessions(summaries, details) {
    return (summaries || []).map(function (s) {
      var detail = (details || []).find(function (d) { return d && d.id === s.id; }) || s;
      return {
        id: s.id,
        reader: s.readerEmail,
        when: shortDate(s.startedAt),
        version: s.versionId,
        duration: formatDuration((s.durationSec || 0) * 1000),
        events: (detail.events || []).map(function (event) {
          var isScroll = event.type === "scroll_progress" || event.type === "prototype_scroll" || event.type === "html_document_scroll";
          var kind = isScroll ? "scroll" : event.type.indexOf("prototype_") === 0 ? "prototype" : event.type.indexOf("html_document_") === 0 ? "prototype" : event.type === "section_dwell" || event.type === "open" ? "section" : event.type === "highlight" || event.type === "html_document_selection" ? "highlight" : event.type === "comment" ? "comment" : event.type === "idle" ? "idle" : "click";
          var payload = event.payload || {};
          return {
            t: Math.floor(event.atSec / 60) + ":" + String(event.atSec % 60).padStart(2, "0"),
            label: isScroll && payload.percent !== undefined ? "Scrolled to " + payload.percent + "%" : event.label || event.type,
            kind: kind,
            type: event.type,
            sectionId: event.sectionId || null,
            payload: payload,
            scrollPercent: isScroll && payload.percent !== undefined ? Math.max(0, Math.min(100, Number(payload.percent) || 0)) : null
          };
        })
      };
    });
  }

  function replayDocSections(docs, fallbackTitle) {
    var rows = [];
    (docs || []).forEach(function (doc) {
      readerDocSections(window.DW_SEED || {}, doc).forEach(function (section) {
        if (rows.length < 5) rows.push({ doc: doc, section: section });
      });
    });
    if (!rows.length) {
      return [{ id: "s1", eyebrow: "§01", h: fallbackTitle || "Room", paras: ["Replay content appears here after reader events are recorded for this room."] }];
    }
    return rows.map(function (row, i) {
      return {
        id: "s" + (i + 1),
        eyebrow: row.section.label || "§" + String(i + 1).padStart(2, "0"),
        h: row.section.heading || row.section.label || row.doc.title || fallbackTitle || "Room",
        paras: row.section.paras && row.section.paras.length ? row.section.paras.slice(0, 3) : ["This section was loaded from the document parser."]
      };
    });
  }

  function replaySectionLabels(doc) {
    return (doc || []).reduce(function (labels, section) {
      labels[section.id] = section.eyebrow;
      return labels;
    }, {});
  }

  function replayEventSection(label) {
    if (/§11|guarantee|payout|ladder|targets|pause/i.test(label)) return "s4";
    if (/dependency|week-?6/i.test(label)) return "s3";
    if (/§04|plan a|\$190|scenario|multilingual/i.test(label)) return "s2";
    if (/appendix|future/i.test(label)) return "s5";
    return "s1";
  }

  function replayEventSeconds(t) {
    var p = String(t || "0:0").split(":").map(Number);
    return p.length === 2 ? p[0] * 60 + p[1] : (p[0] || 0);
  }

  function mapReplayEvents(events) {
    var rows = events && events.length ? events : [{ t: "0:00", label: "Session opened", kind: "section" }];
    return rows.map(function (event) {
      return Object.assign({}, event, {
        sec: replayEventSeconds(event.t),
        section: event.sectionId || replayEventSection(event.label),
        scrollPercent: event.scrollPercent !== undefined && event.scrollPercent !== null ? event.scrollPercent : null
      });
    });
  }

  function replayFrameTarget(events, docs, versionId) {
    var rows = events || [];
    var source = window.DW_SEED || {};
    var room = source.room || {};
    var roomId = room.apiId || room.id || window.DW_API_ROOM_ID || "";
    var htmlEvent = rows.find(function (event) {
      return event && event.type && event.type.indexOf("html_document_") === 0 && event.payload && event.payload.documentId;
    });
    if (htmlEvent) {
      var htmlPayload = htmlEvent.payload || {};
      return {
        kind: "html_document",
        roomId: roomId,
        documentId: htmlPayload.documentId,
        versionId: htmlPayload.versionId || versionId,
        title: htmlEvent.label || htmlPayload.internalLabel || "Hosted document"
      };
    }
    var prototypeEvent = rows.find(function (event) {
      return event && event.type && event.type.indexOf("prototype_") === 0 && event.payload && event.payload.prototypeId;
    });
    if (!prototypeEvent) return null;
    var prototypeId = prototypeEvent.payload.prototypeId;
    var doc = (docs || []).find(function (row) {
      return row && row.prototype && row.prototype.id === prototypeId;
    });
    var prototype = doc && doc.prototype;
    if ((prototype && prototype.kind === "external_url") || prototypeEvent.payload.kind === "external_url") return null;
    return {
      kind: "prototype_html",
      roomId: prototype && prototype.roomId || roomId,
      prototypeId: prototypeId,
      title: prototype && prototype.title || doc && doc.title || prototypeEvent.label || "Hosted prototype"
    };
  }

  function usageQuantity(value) {
    var n = Number(value || 0);
    return Number.isFinite(n) ? n : 0;
  }

  function formatUsageMoney(value) {
    if (value === null || value === undefined || value === "") return "—";
    var n = Number(value);
    if (!Number.isFinite(n)) return "—";
    return "$" + n.toFixed(n > 0 && n < 0.01 ? 6 : 4);
  }

  function formatUsageDate(value) {
    if (!value) return "—";
    var d = new Date(value);
    if (Number.isNaN(d.getTime())) return "—";
    return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
  }

  function mapUsageServiceRows(costs) {
    var map = {};
    (costs || []).forEach(function (row) {
      var service = row.service || "unknown";
      if (!map[service]) map[service] = { service: service, quantity: 0, cost: 0, hasCost: false, entries: 0 };
      map[service].quantity += usageQuantity(row.quantity);
      map[service].entries += 1;
      if (row.totalCostUsd !== null && row.totalCostUsd !== undefined) {
        map[service].cost += Number(row.totalCostUsd) || 0;
        map[service].hasCost = true;
      }
    });
    return Object.values(map).sort(function (a, b) { return b.entries - a.entries || a.service.localeCompare(b.service); });
  }

  function usageTokenTotals(runs) {
    return (runs || []).reduce(function (acc, run) {
      acc.input += usageQuantity(run.inputTokens !== undefined && run.inputTokens !== null ? run.inputTokens : run.promptTokens);
      acc.output += usageQuantity(run.outputTokens !== undefined && run.outputTokens !== null ? run.outputTokens : run.completionTokens);
      acc.cost += Number(run.costUsd || 0);
      if (run.costUsd !== null && run.costUsd !== undefined) acc.hasCost = true;
      return acc;
    }, { input: 0, output: 0, cost: 0, hasCost: false });
  }

  function mapLlmRunRow(run) {
    var input = usageQuantity(run.inputTokens !== undefined && run.inputTokens !== null ? run.inputTokens : run.promptTokens);
    var output = usageQuantity(run.outputTokens !== undefined && run.outputTokens !== null ? run.outputTokens : run.completionTokens);
    return {
      id: run.id,
      task: run.task || "LLM task",
      promptVersion: run.promptVersion || run.id,
      roomId: run.roomId || "workspace",
      status: run.status || "unknown",
      model: run.model || "—",
      tokens: input + output,
      cost: formatUsageMoney(run.costUsd),
      created: formatUsageDate(run.createdAt)
    };
  }

  function usageSummary(costs, runs) {
    var rows = costs || [];
    var services = mapUsageServiceRows(rows);
    var tokenTotals = usageTokenTotals(runs);
    var totalCost = rows.reduce(function (sum, row) { return sum + (Number(row.totalCostUsd || 0) || 0); }, 0);
    var hasLedgerAiCost = rows.some(function (row) {
      return /workers[-_ ]?ai|llm|ai/i.test(row.service || "") && row.totalCostUsd !== null && row.totalCostUsd !== undefined;
    });
    if (!hasLedgerAiCost && tokenTotals.hasCost) totalCost += tokenTotals.cost;
    var hasAnyCost = rows.some(function (row) { return row.totalCostUsd !== null && row.totalCostUsd !== undefined; });
    hasAnyCost = hasAnyCost || tokenTotals.hasCost;
    return {
      ledgerRows: rows.length,
      serviceCount: services.length,
      llmRunCount: (runs || []).length,
      knownCost: hasAnyCost ? formatUsageMoney(totalCost) : "—",
      services: services,
      tokenTotals: tokenTotals,
      tokenTotal: tokenTotals.input + tokenTotals.output,
      llmRuns: (runs || []).map(mapLlmRunRow)
    };
  }

  function platformWorkspaceRows(overview) {
    return ((overview && overview.workspaceRows) || []).map(function (row) {
      return {
        id: row.id || row.workspaceId || row.name,
        name: row.name || row.workspaceName || "Workspace",
        plan: row.plan || "Trial",
        seats: usageQuantity(row.seats),
        rooms: usageQuantity(row.rooms || row.liveRooms),
        status: row.status || "active",
        created: row.created || formatUsageDate(row.createdAt)
      };
    });
  }

  function emptyAnalytics() {
    return {
      totalReadTime: "0m",
      delta: "No reader events yet",
      readersOpened: 0,
      completion: "0%",
      deepest: "—",
      insight: "No reading signals have been recorded for this version yet.",
      mostHighlighted: "Highlights appear here once readers select text.",
      readers: [],
      neverOpened: [],
      perReader: {},
      sectionStats: []
    };
  }

  function emptyInsights() {
    return {
      temperature: { interest: 0, friction: 0, label: "No signal", confidence: "Low" },
      lifting: [],
      holding: [],
      objections: [],
      actions: [],
      pastNotes: []
    };
  }

  function markAnalyticsHydrated(versionKey, options) {
    window.DW_ANALYTICS = window.DW_ANALYTICS || {};
    var key = String(versionKey || "").toLowerCase();
    window.DW_ANALYTICS.__hydratedVersions = window.DW_ANALYTICS.__hydratedVersions || {};
    window.DW_ANALYTICS.__sessionsHydrated = window.DW_ANALYTICS.__sessionsHydrated || {};
    if (key) {
      window.DW_ANALYTICS.__hydratedVersions[key] = true;
      window.DW_ANALYTICS.__sessionsHydrated[key] = true;
    }
    if (options && options.questionnaires) window.DW_ANALYTICS.__questionnaireStatsHydrated = true;
  }

  function hydrateInsightCache(insights, actions, precall, versionId) {
    return {
      __hydrated: true,
      __loadedFromApi: true,
      temperature: { interest: insights.temperature ? insights.temperature.interest : 0, friction: insights.temperature ? insights.temperature.friction : 0, label: insights.temperature ? insights.temperature.label : "No signal", confidence: insights.temperature ? insights.temperature.confidence : "Low" },
      lifting: insights.temperature && insights.temperature.up ? insights.temperature.up : [],
      holding: insights.temperature && insights.temperature.down ? insights.temperature.down : [],
      objections: (insights.objections || []).map(function (o) { return { cat: o.category || o.cat, sev: o.severity || o.sev || "med", sevLabel: titleCase(o.severity || o.sev || "medium"), score: o.score || 0, ev: o.evidenceCount || (o.evidence || []).length || 0, evidence: o.evidence || [], status: o.status || "open" }; }),
      actions: mapNextActions(actions || []),
      pastNotes: (precall || []).map(function (note) { return { id: note.id, version: (note.versionId || "").toUpperCase(), versionId: note.versionId || versionId, label: note.temperatureLabel || "Brief", temperature: note.temperatureScore || 0, tone: "warm", date: shortDate(note.createdAt), by: note.createdBy || "", summary: note.summary || "", parts: note.sections || [], markdown: note.markdown || "" }; })
    };
  }

  function clearRoomSeed() {
    window.DW_API_ROOM_ID = null;
    window.DW_SEED.room = null;
    window.DW_SEED.versions = [];
    window.DW_SEED.documents = [];
    window.DW_SEED.docs = [];
    window.DW_SEED.doc = [];
    window.DW_SEED.comments = [];
    window.DW_SEED.access = [];
    window.DW_SEED.activity = { tagged: [], replies: [], around: [] };
    window.DW_SEED.questionnaires = [];
    window.DW_SEED.postQuestionnaire = null;
    window.DW_SEED.roomTracking = null;
    window.DW_SEED.insights = Object.assign({ __hydrated: true }, emptyInsights());
    window.DW_ANALYTICS = {
      __hydratedVersions: {},
      __sessionsHydrated: {},
      __sessionDetailsHydrated: {},
      questionnaireStats: { invited: 0, started: 0, completed: 0, avg: 0, inProgress: 0, rows: [] },
      sessions: []
    };
  }

  function analyticsForVersion(analyticsOrVersion, maybeVersion) {
    var source = maybeVersion === undefined ? (window.DW_ANALYTICS || {}) : (analyticsOrVersion || {});
    var value = String(maybeVersion === undefined ? analyticsOrVersion : maybeVersion || "");
    var key = value.toLowerCase();
    if (maybeVersion === undefined && !(source.__hydratedVersions && source.__hydratedVersions[key])) return emptyAnalytics();
    return source[key] || source[value.toUpperCase()] || emptyAnalytics();
  }

  function questionnaireStats(analytics) {
    var source = analytics || window.DW_ANALYTICS || {};
    if (!analytics && !source.__questionnaireStatsHydrated) return { invited: 0, started: 0, completed: 0, avg: 0, inProgress: 0, rows: [] };
    return (source && source.questionnaireStats) || { invited: 0, started: 0, completed: 0, avg: 0, inProgress: 0, rows: [] };
  }

  function sessionsForVersion(analyticsOrVersion, maybeVersion) {
    var source = maybeVersion === undefined ? (window.DW_ANALYTICS || {}) : (analyticsOrVersion || {});
    var version = maybeVersion === undefined ? analyticsOrVersion : maybeVersion;
    if (maybeVersion === undefined && !(source.__sessionsHydrated && source.__sessionsHydrated[String(version || "").toLowerCase()])) return [];
    return ((source && source.sessions) || []).filter(function (session) { return session.version === version; });
  }

  function readerRoomModel(seed) {
    var source = seed || window.DW_SEED || {};
    var people = source.people || {};
    return {
      docs: source.docs || [],
      room: source.room || {},
      postQuestionnaire: source.postQuestionnaire || null,
      readers: Object.keys(people).filter(function (email) { return people[email] && !people[email].team; })
    };
  }

  function readerDocSections(seedOrDoc, maybeDoc) {
    var seed = maybeDoc === undefined ? (window.DW_SEED || {}) : (seedOrDoc || window.DW_SEED || {});
    var doc = maybeDoc === undefined ? seedOrDoc : maybeDoc;
    if (!doc) return [];
    return doc.sections === "doc" ? ((seed && seed.doc) || []) : (doc.sections || []);
  }

  function dashboardNumber(value) {
    var n = parseInt(String(value || "").replace(/[^\d]/g, ""), 10);
    return Number.isFinite(n) ? n : 0;
  }

  function dashboardOpenNotifications(notifications) {
    return (notifications || []).filter(function (n) { return !n.read && !n.done && !n.snoozed; });
  }

  function personForEmail(seed, email) {
    var people = (seed && seed.people) || {};
    var person = email ? people[email] || people[String(email).toLowerCase()] : null;
    if (person) return person;
    if (!email) return null;
    var name = titleCase(String(email).split("@")[0].replace(/[._]/g, " "));
    return { name: name, initials: initials(name, email) };
  }

  function dashboardPerson(email, fallbackName, seed) {
    var person = personForEmail(seed || window.DW_SEED, email);
    return person || { name: fallbackName || "Someone", initials: initials(fallbackName || "Someone", email) };
  }

  function dashboardFeed(notifications, state, seedOrRoomTitle, roomTitle) {
    var seed = typeof seedOrRoomTitle === "string" ? window.DW_SEED : (seedOrRoomTitle || window.DW_SEED);
    var title = typeof seedOrRoomTitle === "string" ? seedOrRoomTitle : roomTitle;
    var rows = notifications || [];
    if (rows.length) {
      return rows.slice(0, 8).map(function (n) {
        var person = n.reader ? personForEmail(seed, n.reader) : null;
        return {
          initials: person ? person.initials : "DW",
          who: person ? person.name : n.verb,
          action: n.title || n.verb,
          roomId: n.roomId || null,
          room: n.room || title || "Room",
          status: n.done ? n.done.label : n.snoozed ? "Snoozed" : n.read ? "" : "Needs action",
          quote: n.body || n.title || n.verb
        };
      });
    }
    return [];
  }

  function dashboardQuestionnaires(stateQuestionnaires, seed) {
    var source = seed || window.DW_SEED || {};
    return stateQuestionnaires || (source.questionnaires || []);
  }

  function dashboardStats(rooms, notifications, questionnaires) {
    var roomRows = rooms || [];
    var qRows = questionnaires || [];
    var live = roomRows.filter(function (r) { return r.status === "live"; }).length;
    var needs = dashboardOpenNotifications(notifications).length;
    var liveQuestionnaires = qRows.filter(function (q) { return q.status === "live"; }).length;
    var inProgress = qRows.reduce(function (sum, q) {
      return sum + dashboardNumber(q.inProgress || ((q.responses || []).filter(function (r) { return r.status === "In progress"; }).length));
    }, 0);
    var comments = roomRows.reduce(function (sum, r) { return sum + dashboardNumber(r.comments); }, 0);
    return [
      ["Active rooms", live, "of " + roomRows.length + " total"],
      ["Needs you", needs, needs === 1 ? "1 alert open" : needs + " alerts open"],
      ["Questionnaires", liveQuestionnaires, inProgress + " in progress"],
      ["Comments", comments, "across your rooms"]
    ];
  }

  function currentRoomId(seed, apiRoomId) {
    var source = seed || window.DW_SEED || {};
    var room = source.room || {};
    return apiRoomId || window.DW_API_ROOM_ID || room.apiId || room.id || null;
  }

  function roomContext(room, seed) {
    if (room) return room;
    var source = seed || window.DW_SEED || {};
    var target = source.room || {};
    var activeId = currentRoomId(seed);
    var targetId = target && (target.apiId || target.id);
    if (activeId && targetId && activeId !== targetId) return { id: activeId, apiId: activeId };
    if (activeId && !targetId) return Object.assign({}, target, { id: activeId, apiId: activeId });
    return target;
  }

  function shareRoomId(room, seed, apiRoomId) {
    var target = roomContext(room, seed);
    var id = (target && (target.apiId || target.id)) || currentRoomId(seed, apiRoomId);
    if (!id) throw new Error("Room context is required to create a room link.");
    return id;
  }

  function hasRoomContext(apiRoomId) {
    return !!(apiRoomId || window.DW_API_ROOM_ID);
  }

  function dashboardSideModel(rooms, notifications, questionnaires, seed, apiRoomId) {
    var source = seed || window.DW_SEED || {};
    var liveRooms = (rooms || []).filter(function (r) { return r.status === "live"; });
    var qRows = questionnaires || [];
    var liveQuestionnaires = qRows.filter(function (q) { return q.status === "live"; });
    var completed = qRows.reduce(function (sum, q) {
      return sum + dashboardNumber(q.completed || ((q.responses || []).filter(function (r) { return r.status === "Completed"; }).length));
    }, 0);
    var inProgress = qRows.reduce(function (sum, q) {
      return sum + dashboardNumber(q.inProgress || ((q.responses || []).filter(function (r) { return r.status === "In progress"; }).length));
    }, 0);
    var needs = dashboardOpenNotifications(notifications);
    var roomId = currentRoomId(source, apiRoomId);
    var currentRoom = roomId ? liveRooms.find(function (r) { return (r.apiId || r.id) === roomId; }) || { id: roomId } : null;
    var questionnaireRoomId = liveQuestionnaires[0] && liveQuestionnaires[0].roomId;
    var questionnaireRoom = questionnaireRoomId ? liveRooms.find(function (r) { return (r.apiId || r.id) === questionnaireRoomId; }) || { id: questionnaireRoomId } : (currentRoom || liveRooms[0] || null);
    var commentsRoom = liveRooms.find(function (r) { return dashboardNumber(r.comments) > 0; }) || liveRooms[0] || null;
    return {
      liveRooms: liveRooms,
      liveQuestionnaires: liveQuestionnaires,
      completed: completed,
      inProgress: inProgress,
      needs: needs,
      currentRoom: currentRoom,
      questionnaireRoom: questionnaireRoom,
      commentsRoom: commentsRoom
    };
  }

  function shellRoleMeta(role, fallbackLabel) {
    var value = String(role || "").toLowerCase();
    if (value === "super") return { value: "admin", label: "Super" };
    if (value === "admin") return { value: "admin", label: "Admin" };
    if (value === "manager" || value === "editor") return { value: "editor", label: "Editor" };
    return { value: "viewer", label: fallbackLabel || "Viewer" };
  }

  function shellAccount(state, session, members, seed) {
    var source = seed || window.DW_SEED || {};
    var seedMe = source.me || {};
    var email = String((session && session.email) || (state && state.teamUser && state.teamUser.email) || seedMe.email || "").toLowerCase();
    var member = (members || []).find(function (m) { return String(m[1] || "").toLowerCase() === email; });
    var person = email && source.people ? source.people[email] : null;
    var rawName = member ? member[0] : (person && person.name) || (state && state.teamUser && state.teamUser.name) || seedMe.name || email.split("@")[0] || "Account";
    var role = shellRoleMeta((session && session.role) || (state && state.teamUser && state.teamUser.role) || (person && person.role) || seedMe.role || (member && member[3]), member && member[4]);
    return {
      email: email || "account",
      name: titleCase(rawName),
      role: role
    };
  }

  function shellOrgModel(seed, apiRoomId) {
    var source = seed || window.DW_SEED || {};
    var org = source.org || {};
    return {
      currentRoomId: currentRoomId(source, apiRoomId),
      orgId: org.id || "",
      orgName: org.name || "Workspace",
      orgs: org.id || org.name ? [{ id: org.id || org.name, name: org.name || "Workspace", plan: org.plan || "" }] : [],
      isCurrentOrg: function (row) { return !!row && (row.id ? row.id === org.id : row.name === org.name); }
    };
  }

  function commentPerson(email, seed) {
    var person = personForEmail(seed || window.DW_SEED, email);
    return person || { name: titleCase(String(email || "Someone").split("@")[0].replace(/[._]/g, " ")), initials: initials("", email), team: false };
  }

  function person(email, seed) {
    return commentPerson(email, seed);
  }

  function commentMentionables(seed) {
    var source = seed || window.DW_SEED || {};
    return Object.keys(source.people || {});
  }

  function fieldTypes(seed) {
    var source = seed || window.DW_SEED || {};
    return source.fieldTypes || [];
  }

  function importFormats(seed) {
    var source = seed || window.DW_SEED || {};
    return source.importFormats || [];
  }

  function roomTemplates(seed) {
    var source = seed || window.DW_SEED || {};
    return source.roomTemplates || [];
  }

  function workspacePlan(seed) {
    var source = seed || window.DW_SEED || {};
    return source.org && source.org.plan ? source.org.plan : "Studio";
  }

  function mapWorkspaceDomain(row) {
    return {
      id: row.id,
      workspaceId: row.workspaceId,
      kind: row.kind,
      hostname: row.hostname,
      status: row.status || "pending_dns",
      provider: row.provider,
      providerId: row.providerId || null,
      senderLocalPart: row.senderLocalPart || "proposals",
      dnsRecords: Array.isArray(row.dnsRecords) ? row.dnsRecords : [],
      errorMessage: row.errorMessage || "",
      verifiedAt: row.verifiedAt || null,
      updatedAt: row.updatedAt || row.createdAt || null
    };
  }

  function domainStatusLabel(status) {
    var value = String(status || "").toLowerCase();
    if (value === "active") return "Verified";
    if (value === "failed") return "Needs attention";
    if (value === "verifying") return "Checking";
    return "Waiting for DNS";
  }

  function roomDocuments(seed) {
    var source = seed || window.DW_SEED || {};
    if (Array.isArray(source.documents) && source.documents.length) return source.documents;
    var docs = Array.isArray(source.docs) ? source.docs : [];
    return docs.map(function (doc, index) {
      var sectionSource = doc.sections === "doc" ? source.doc : doc.sections;
      var pages = Array.isArray(sectionSource) ? Math.max(1, sectionSource.length) : 1;
      return {
        id: doc.id,
        roomId: (source.room && (source.room.apiId || source.room.id)) || "",
        title: doc.title,
        role: index === 0 ? "main" : "appendix",
        pages: pages,
        sortOrder: index + 1
      };
    });
  }

  function roomVersions(seed) {
    var source = seed || window.DW_SEED || {};
    var rows = Array.isArray(source.versions) && source.versions.length ? source.versions : (((source.room || {}).versions) || []);
    return sortVersionsCurrentFirst(rows);
  }

  function readerVersions(seed) {
    var source = seed || window.DW_SEED || {};
    var roomRows = (source.room || {}).versions || [];
    return roomRows.length ? sortVersionsCurrentFirst(roomRows) : roomVersions(source);
  }

  function roomInsights(seed) {
    var source = seed || window.DW_SEED || {};
    return source.insights && source.insights.__hydrated ? source.insights : emptyInsights();
  }

  function replayDocs(seed) {
    var source = seed || window.DW_SEED || {};
    return source.docs || [];
  }

  async function hydrateVersionSignals(roomId, versionId) {
    var api = window.DWApi;
    if (!roomId || !versionId) throw new Error("roomId and versionId are required to load version analytics.");
    window.DW_API_ROOM_ID = roomId;
    var parallel = await Promise.all([
      api.comments(roomId, versionId),
      api.access(roomId),
      api.analytics(roomId, versionId),
      api.insights(roomId, versionId),
      api.nextActions(roomId, versionId),
      api.precallNotes(roomId, versionId),
      api.sessions(roomId, versionId)
    ]);
    var comments = parallel[0];
    var access = parallel[1];
    var analytics = parallel[2];
    var insights = parallel[3];
    var actions = parallel[4];
    var precall = parallel[5];
    var sessionSummaries = parallel[6];
    var sessionDetails = await Promise.all(sessionSummaries.map(function (s) { return api.session(s.id); }));
    var versionKey = String(versionId).toLowerCase();
    var uiComments = comments.map(mapComment);
    var uiAccess = access.map(mapAccess);
    window.DW_SEED.comments = uiComments;
    window.DW_SEED.access = uiAccess;
    window.DW_ANALYTICS[versionKey] = mapAnalytics(versionKey, analytics, access, comments, sessionSummaries);
    window.DW_ANALYTICS.sessions = mapSessions(sessionSummaries, sessionDetails);
    markAnalyticsHydrated(versionKey);
    window.DW_SEED.insights = hydrateInsightCache(insights, actions, precall, versionId);
    return { comments: uiComments, access: uiAccess, analytics: window.DW_ANALYTICS[versionKey], insights: window.DW_SEED.insights, sessions: window.DW_ANALYTICS.sessions };
  }

  function prototypeForDoc(prototypes, docId) {
    return (prototypes || []).find(function (prototype) { return prototype.documentId === docId; }) || null;
  }

  function mapDocumentSeed(doc, prototypes) {
    var prototype = prototypeForDoc(prototypes, doc.id);
    return {
      id: doc.id,
      roomId: doc.roomId,
      title: doc.title,
      role: doc.role,
      pages: doc.pages,
      sortOrder: doc.sortOrder,
      prototype: prototype ? {
        id: prototype.id,
        kind: prototype.kind,
        title: prototype.title || doc.title,
        sourceUrl: prototype.sourceUrl || "",
        roomId: prototype.roomId,
        versionId: prototype.versionId,
        documentId: prototype.documentId
      } : null
    };
  }

  function mapPrototypeDoc(doc, prototype) {
    return {
      id: doc.id,
      title: doc.title,
      kind: "prototype",
      renderMode: "prototype",
      role: doc.role || "main",
      prototype: {
        id: prototype.id,
        kind: prototype.kind,
        title: prototype.title || doc.title,
        sourceUrl: prototype.sourceUrl || "",
        roomId: prototype.roomId,
        versionId: prototype.versionId,
        documentId: prototype.documentId
      },
      sections: []
    };
  }

  function mapContentRows(rows, prototypes) {
    return rows.map(function (row) {
      var prototype = prototypeForDoc(prototypes, row.doc.id);
      if (prototype) return mapPrototypeDoc(row.doc, prototype);
      return {
        id: row.doc.id,
        title: row.doc.title,
        kind: row.doc.role === "main" ? "proposal" : "addendum",
        sections: row.content ? row.content.sections.map(function (section) {
          var htmlDocument = isStandaloneHtmlDocument(section.bodyHtml) ? section.bodyHtml : "";
          var htmlDocumentPath = !htmlDocument && isHtmlDocumentFrameMarker(section.bodyHtml)
            ? { roomId: row.doc.roomId, documentId: row.doc.id, versionId: row.content.versionId }
            : null;
          var html = !htmlDocument && !htmlDocumentPath && hasRichHtml(section.bodyHtml) ? section.bodyHtml : "";
          return {
            id: section.id,
            label: section.label,
            heading: section.label,
            html: html,
            htmlDocument: htmlDocument,
            htmlDocumentPath: htmlDocumentPath,
            paras: [textFromHtml(section.bodyHtml) || section.label]
          };
        }) : [{ id: row.doc.id + "-content-missing", label: "Content unavailable", heading: "Content unavailable", paras: [row.issue] }]
      };
    });
  }

  async function hydrateSessionDetails(roomId, versionId) {
    var api = window.DWApi;
    var key = String(versionId || "").toLowerCase();
    window.DW_ANALYTICS = window.DW_ANALYTICS || {};
    window.DW_ANALYTICS.__sessionDetailsHydrated = window.DW_ANALYTICS.__sessionDetailsHydrated || {};
    if (key && window.DW_ANALYTICS.__sessionDetailsHydrated[key]) return window.DW_ANALYTICS.sessions || [];
    var summaries = await api.sessions(roomId, versionId);
    var details = await Promise.all(summaries.map(function (s) { return api.session(s.id); }));
    window.DW_ANALYTICS.sessions = mapSessions(summaries, details);
    if (key) window.DW_ANALYTICS.__sessionDetailsHydrated[key] = true;
    markAnalyticsHydrated(versionId);
    return window.DW_ANALYTICS.sessions;
  }

  async function hydrateInsightOverview(roomId, versionId) {
    var api = window.DWApi;
    var targetVersion = versionId || (latestVersion(window.DW_SEED.versions || []) || {}).id;
    if (!roomId || !targetVersion) throw new Error("roomId and versionId are required to load insights.");
    var parallel = await Promise.all([
      api.insights(roomId, targetVersion),
      api.nextActions(roomId, targetVersion),
      api.precallNotes(roomId, targetVersion)
    ]);
    window.DW_SEED.insights = hydrateInsightCache(parallel[0], parallel[1], parallel[2], targetVersion);
    return window.DW_SEED.insights;
  }

  async function hydrateAnalyticsSummary(roomId, versionId) {
    var api = window.DWApi;
    var targetVersion = versionId || (latestVersion(window.DW_SEED.versions || []) || {}).id;
    if (!roomId || !targetVersion) throw new Error("roomId and versionId are required to load analytics.");
    window.DW_ANALYTICS = window.DW_ANALYTICS || {};
    var key = String(targetVersion || "").toLowerCase();
    if (key && window.DW_ANALYTICS.__hydratedVersions && window.DW_ANALYTICS.__hydratedVersions[key]) return window.DW_ANALYTICS[key];
    var analytics = await api.analytics(roomId, targetVersion);
    window.DW_ANALYTICS[key] = mapAnalytics(key, analytics, window.DW_SEED.access || [], window.DW_SEED.comments || [], []);
    markAnalyticsHydrated(key);
    return window.DW_ANALYTICS[key];
  }

  async function hydrateQuestionnaireStats(roomId, versionId, invitedCount) {
    var api = window.DWApi;
    window.DW_ANALYTICS = window.DW_ANALYTICS || {};
    if (window.DW_ANALYTICS.__questionnaireStatsHydrated) return window.DW_ANALYTICS.questionnaireStats;
    var questionnaires = await api.questionnaires(roomId);
    var submissions = await Promise.all(questionnaires.map(function (q) { return api.questionnaireSubmissions(q.id); }));
    var flat = submissions.flat();
    window.DW_ANALYTICS.questionnaireStats = {
      invited: invitedCount || ((window.DW_SEED.access || []).length),
      started: flat.length,
      completed: flat.filter(function (s) { return s.status === "submitted"; }).length,
      avg: flat.length ? Math.round(flat.reduce(function (sum, s) { return sum + (s.completion || 0); }, 0) / flat.length) : 0,
      inProgress: flat.filter(function (s) { return s.status !== "submitted"; }).length,
      rows: flat.map(function (s) { return { email: s.readerEmail, status: s.status, completion: s.completion, submitted: s.submittedAt ? relative(s.submittedAt) : "—" }; })
    };
    window.DW_SEED.questionnaires = questionnaires.map(function (q, i) { return mapQuestionnaire(q, submissions[i]); });
    window.DW_SEED.postQuestionnaire = window.DW_SEED.questionnaires.find(function (q) { return q.placement === "post" && q.status === "live"; }) || null;
    markAnalyticsHydrated(String(versionId || "").toLowerCase(), { questionnaires: true });
    return window.DW_ANALYTICS.questionnaireStats;
  }

  function mapActivityRows(activity) {
    return {
      tagged: (activity || []).filter(function (a) { return a.kind === "mention"; }).map(function (a) { return { who: a.who || "Someone", email: a.who, body: a.body || "mentioned you", when: "new", unread: !!a.unread }; }),
      replies: (activity || []).filter(function (a) { return a.kind === "reply"; }).map(function (a) { return { who: a.who || "Someone", email: a.who, body: a.body || "replied", when: "new", unread: !!a.unread }; }),
      around: (activity || []).filter(function (a) { return a.kind !== "mention" && a.kind !== "reply"; }).map(function (a) { return { who: a.who || "Someone", email: a.who, body: a.body || a.kind, when: "new" }; })
    };
  }

  function resolveVersionId(input) {
    var key = String(input || "").toLowerCase();
    var match = ((window.DW_SEED && window.DW_SEED.versions) || []).find(function (v) {
      return String(v.id || "").toLowerCase() === key || String(v.label || "").toLowerCase() === key;
    });
    return match ? match.id : input;
  }

  async function hydrateReaderVersion(roomId, versionId) {
    var api = window.DWApi;
    if (!roomId || !versionId) throw new Error("roomId and versionId are required to load reader version content.");
    window.DW_API_ROOM_ID = roomId;
    var targetVersionId = resolveVersionId(versionId);
    var parallel = await Promise.all([
      api.documents(roomId, targetVersionId),
      api.comments(roomId, targetVersionId),
      api.activity(roomId),
      api.prototypes(roomId, targetVersionId)
    ]);
    var docs = parallel[0];
    var comments = parallel[1];
    var activity = parallel[2];
    var prototypes = parallel[3];
    var content = await Promise.all(docs.map(function (doc) {
      if (prototypeForDoc(prototypes, doc.id)) return Promise.resolve({ doc: doc, content: null, issue: null });
      return api.documentContent(roomId, doc.id, targetVersionId).then(function (c) {
        return { doc: doc, content: c, issue: null };
      }).catch(function (error) {
        return { doc: doc, content: null, issue: error.message || "Document content unavailable." };
      });
    }));
    var uiDocs = mapContentRows(content, prototypes);
    var uiComments = comments.map(mapComment);
    var selectedVersion = ((window.DW_SEED && window.DW_SEED.versions) || []).find(function (v) { return v.id === targetVersionId; });
    window.DW_SEED.documents = docs.map(function (doc) { return mapDocumentSeed(doc, prototypes); });
    window.DW_SEED.docs = uiDocs;
    window.DW_SEED.doc = uiDocs[0] ? uiDocs[0].sections : [];
    window.DW_SEED.comments = uiComments;
    window.DW_SEED.activity = mapActivityRows(activity);
    window.DW_SEED.room.version = selectedVersion && selectedVersion.label ? String(selectedVersion.label).toUpperCase() : String(versionId).toUpperCase();
    return { versionId: targetVersionId, documents: docs, docs: uiDocs, comments: uiComments, activity: window.DW_SEED.activity };
  }

  async function hydrateReaderRoom(roomId) {
    var loaded = await window.DWApi.roomBootstrap(roomId);
    return applyRoomBootstrap(loaded, { reader: true });
  }

  function applyRoomBootstrap(loaded, options) {
    var roomId = loaded && loaded.room && loaded.room.id;
    if (!roomId) throw new Error("Room bootstrap did not include a room.");
    window.DW_API_ROOM_ID = roomId;
    var room = loaded.room;
    var versions = loaded.versions || [];
    var version = loaded.currentVersion || latestVersion(versions);
    var versionId = version ? version.id : undefined;
    var docs = loaded.documents || [];
    var comments = loaded.comments || [];
    var activity = loaded.activity || [];
    var questionnaires = loaded.questionnaires || [];
    var mentionables = loaded.mentionables || [];
    var prototypes = loaded.prototypes || [];
    var content = loaded.content || [];
    var uiDocs = mapContentRows(content, prototypes);
    var uiComments = comments.map(mapComment);
    window.DW_SEED.room = {
      id: room.id,
      workspaceId: room.workspaceId,
      workspaceName: room.workspaceName || "",
      title: room.title,
      ref: room.ref,
      version: version ? version.label.toUpperCase() : "",
      documents: docs.length,
      status: room.status,
      since: shortDate(room.liveSince),
      preparedFor: room.preparedFor || "",
      gateDescription: room.gateDescription || "",
      versions: versions.map(function (v) { return { id: v.id.toUpperCase(), label: v.label.toUpperCase(), issued: shortDate(v.issuedAt), note: v.note || "", latest: !!v.current }; })
    };
    if (room.workspaceName) window.DW_SEED.org = Object.assign({}, window.DW_SEED.org || {}, { id: room.workspaceId, name: room.workspaceName });
    window.DW_SEED.versions = versions.map(function (v) {
      return { id: v.id, roomId: v.roomId, label: v.label, issuedAt: v.issuedAt, note: v.note || "", latest: !!v.current, current: !!v.current, clientVisible: v.clientVisible !== false };
    });
    window.DW_SEED.rooms = [mapRoom(room, versions, [], comments, null, null)];
    window.DW_SEED.documents = docs.map(function (doc) { return mapDocumentSeed(doc, prototypes); });
    window.DW_SEED.docs = uiDocs;
    window.DW_SEED.doc = uiDocs[0] ? uiDocs[0].sections : [];
    window.DW_SEED.comments = uiComments;
    window.DW_SEED.access = (loaded.access || []).map(mapAccess);
    window.DW_SEED.people = {};
    var session = window.DWApi && window.DWApi.getSession ? window.DWApi.getSession() : null;
    if (session && session.email) window.DW_SEED.people[session.email] = { name: titleCase(session.email.split("@")[0].replace(/[._]/g, " ")), initials: initials("", session.email), cls: "" };
    comments.forEach(function (comment) {
      if (comment.authorEmail) window.DW_SEED.people[comment.authorEmail] = { name: titleCase(comment.authorEmail.split("@")[0].replace(/[._]/g, " ")), initials: initials("", comment.authorEmail), cls: "" };
    });
    (loaded.access || []).forEach(function (grant) {
      if (String(grant.emailOrDomain || "").charAt(0) === "@") return;
      window.DW_SEED.people[grant.emailOrDomain] = { name: titleCase(grant.emailOrDomain.split("@")[0].replace(/[._]/g, " ")), initials: initials("", grant.emailOrDomain), cls: "", dealRole: grant.dealRole };
    });
    applyMentionables(mentionables);
    window.DW_SEED.activity = mapActivityRows(activity);
    window.DW_SEED.questionnaires = questionnaires.map(function (q) { return mapQuestionnaire(q, []); });
    window.DW_SEED.postQuestionnaire = window.DW_SEED.questionnaires.find(function (q) { return q.placement === "post" && q.status === "live"; }) || null;
    if (!(options && options.keepInsights)) {
      window.DW_SEED.insights = Object.assign({ __hydrated: true }, emptyInsights());
      window.DW_ANALYTICS = {
        __hydratedVersions: {},
        __sessionsHydrated: {},
        __sessionDetailsHydrated: {},
        questionnaireStats: { invited: 0, started: 0, completed: 0, avg: 0, inProgress: 0, rows: [] },
        sessions: []
      };
    }
    return { room: room, versions: versions, documents: docs, comments: uiComments, access: window.DW_SEED.access, activity: window.DW_SEED.activity };
  }

  function insightsLoadedFromApi(seed) {
    var source = seed || window.DW_SEED || {};
    return !!(source.insights && source.insights.__loadedFromApi);
  }

  async function hydrateRoom(roomId) {
    var loaded = await window.DWApi.roomBootstrap(roomId);
    return applyRoomBootstrap(loaded);
  }

  async function hydrateWorkspace(session) {
    if (!session || !session.workspaceId) throw new Error("Workspace session is missing workspaceId.");
    var loaded = await window.DWApi.workspaceBootstrap(session.workspaceId);
    var workspace = loaded.workspace;
    var members = loaded.members || [];
    var brand = loaded.brand || {};
    var rooms = loaded.rooms || [];
    var templates = loaded.questionnaireTemplates || [];
    var roomTemplates = loaded.roomTemplates || [];
    var notifications = loaded.notifications || [];
    var notificationPrefs = loaded.notificationPrefs || null;
    var joinRequests = loaded.joinRequests || [];
    var workspaceDomains = loaded.workspaceDomains || [];
    window.DW_SEED.org = { id: workspace.id, name: workspace.name, domain: workspace.domain, plan: workspace.plan };
    window.DW_SEED.me = { email: session.email, name: session.email.split("@")[0], initials: initials("", session.email), role: session.role, team: true };
    window.DW_SEED.people = {};
    members.forEach(function (m) {
      window.DW_SEED.people[m.email] = { name: m.name || titleCase(m.email.split("@")[0]), initials: initials(m.name, m.email), cls: m.email === session.email ? "dw-ava--accent" : "", team: true, role: m.role };
    });
    window.DW_SEED.brand = brand;
    window.DW_SEED.questionnaireTemplates = templates.map(function (t) {
      var fields = schemaFields(t.schema);
      var steps = t.schema && Array.isArray(t.schema.steps) ? t.schema.steps.length : 0;
      return { id: t.id, name: t.name, tags: t.tags || [], questions: fields.length, steps: steps, version: t.version, by: "Team", usage: t.usageCount || 0, lastUsed: "—", schema: t.schema };
    });
    window.DW_SEED.roomTemplates = roomTemplates.map(function (t) { return { id: t.id, name: t.name, tagline: t.description || "", sections: ((t.sections || t.sectionTemplates || [])).length || 1 }; });
    window.DW_SEED.notifications = notifications.map(mapNotification);
    window.DW_SEED.notificationPrefs = notificationPrefs;
    window.DW_SEED.joinRequests = joinRequests || [];
    window.DW_SEED.workspaceDomains = (workspaceDomains || []).map(mapWorkspaceDomain);
    clearRoomSeed();
    return { workspace: workspace, members: members, rooms: rooms, costs: loaded.costs || [], llmRuns: loaded.llmRuns || [], joinRequests: joinRequests, workspaceDomains: workspaceDomains };
  }

  window.DWAdapters = {
    hydrateRoom: hydrateRoom,
    hydrateInsightOverview: hydrateInsightOverview,
    hydrateAnalyticsSummary: hydrateAnalyticsSummary,
    hydrateSessionDetails: hydrateSessionDetails,
    hydrateQuestionnaireStats: hydrateQuestionnaireStats,
    hydrateVersionSignals: hydrateVersionSignals,
    hydrateReaderRoom: hydrateReaderRoom,
    hydrateReaderVersion: hydrateReaderVersion,
    hydrateWorkspace: hydrateWorkspace,
    insightsLoadedFromApi: insightsLoadedFromApi,
    clearRoomSeed: clearRoomSeed,
    initials: initials,
    teamRoleValue: teamRoleValue,
    normalizeNotificationPrefs: normalizeNotificationPrefs,
    mapMember: mapMember,
    mapJoinRequest: mapJoinRequest,
    mapTemplate: mapTemplate,
    mapPrecallNote: mapPrecallNote,
    mapRoomSummary: mapRoomSummary,
    mapContentDoc: mapContentDoc,
    mapContentVersion: mapContentVersion,
    mapContentVersions: mapContentVersions,
    syncPublishedContent: syncPublishedContent,
    questionnairePlacements: function () { return QUESTIONNAIRE_PLACEMENTS; },
    titleFromFileName: titleFromFileName,
    replayDocSections: replayDocSections,
    replaySectionLabels: replaySectionLabels,
    replayFrameTarget: replayFrameTarget,
    mapReplayEvents: mapReplayEvents,
    formatUsageMoney: formatUsageMoney,
    usageSummary: usageSummary,
    analyticsForVersion: analyticsForVersion,
    statusLabel: statusLabel,
    questionnaireStats: questionnaireStats,
    sessionsForVersion: sessionsForVersion,
    readerRoomModel: readerRoomModel,
    readerDocSections: readerDocSections,
    dashboardFeed: dashboardFeed,
    dashboardPerson: dashboardPerson,
    dashboardOpenNotifications: dashboardOpenNotifications,
    dashboardQuestionnaires: dashboardQuestionnaires,
    dashboardStats: dashboardStats,
    dashboardSideModel: dashboardSideModel,
    currentRoomId: currentRoomId,
    roomContext: roomContext,
    shareRoomId: shareRoomId,
    hasRoomContext: hasRoomContext,
    shellAccount: shellAccount,
    shellOrgModel: shellOrgModel,
    platformWorkspaceRows: platformWorkspaceRows,
    person: person,
    commentPerson: commentPerson,
    commentMentionables: commentMentionables,
    fieldTypes: fieldTypes,
    importFormats: importFormats,
    roomTemplates: roomTemplates,
    workspacePlan: workspacePlan,
    mapWorkspaceDomain: mapWorkspaceDomain,
    domainStatusLabel: domainStatusLabel,
    roomDocuments: roomDocuments,
    roomVersions: roomVersions,
    readerVersions: readerVersions,
    roomInsights: roomInsights,
    replayDocs: replayDocs,
    mapComment: mapComment,
    mapAccess: mapAccess,
    mapNextActions: mapNextActions,
    schemaFields: schemaFields,
    mapNotification: mapNotification,
    mapQuestionnaire: mapQuestionnaire
  };
})();


/* ---- app/display.js ---- */
/* ============================================================
   DEALWONDR APP — display adapters
   Converts backend/seed room data into UI-safe display labels.
   ============================================================ */
(function () {
  function seed() {
    return window.DW_SEED || {};
  }

  function splitRoomTitle(title) {
    var text = String(title || "").trim();
    var parts = text.split(/\s+[—-]\s+/);
    return parts.length > 1 ? { client: parts[0], title: parts.slice(1).join(" — ") } : { client: "", title: text };
  }

  function activeRoomMatchesSeed() {
    var data = seed();
    var room = data.room || {};
    var activeId = window.DW_API_ROOM_ID;
    if (!activeId) return true;
    return String(activeId) === String(room.apiId || room.id || "");
  }

  function roomSeed() {
    return activeRoomMatchesSeed() ? (seed().room || {}) : {};
  }

  function orgName() {
    return activeRoomMatchesSeed() ? ((seed().org && seed().org.name) || "Workspace") : "Dealwondr";
  }

  function roomTitle() {
    var room = roomSeed();
    var split = splitRoomTitle(room.title);
    return split.title || room.title || "Proposal";
  }

  function clientName() {
    var room = roomSeed();
    var split = splitRoomTitle(room.title);
    return room.preparedFor || split.client || "Client";
  }

  function preparedForLabel() {
    return "Prepared for " + clientName();
  }

  function roomShortTitle() {
    return clientName() + " — " + roomTitle().replace(/\s+Proposal$/i, "");
  }

  function versions() {
    var data = seed();
    if (!activeRoomMatchesSeed()) return [];
    return (data && (data.versions || (data.room && data.room.versions))) || [];
  }

  function currentVersion() {
    var rows = versions();
    var selected = window.DWStore && window.DWStore.get && window.DWStore.get().selectedVersionId;
    if (selected) {
      var selectedKey = String(selected).toLowerCase();
      var match = rows.find(function (v) {
        return String(v.id || "").toLowerCase() === selectedKey || String(v.label || "").toLowerCase() === selectedKey;
      });
      if (match) return match;
    }
    return rows.slice().reverse().find(function (v) { return v.current || v.latest; }) || rows[rows.length - 1] || rows[0] || null;
  }

  function versionId() {
    var version = currentVersion();
    return version && version.id ? String(version.id).toLowerCase() : "current";
  }

  function versionLabel() {
    var version = currentVersion();
    var raw = version && (version.label || version.id) ? String(version.label || version.id) : "Current";
    return /^v\d+/i.test(raw) ? raw.toUpperCase() : raw;
  }

  function versionSummary() {
    var rows = versions();
    var version = currentVersion();
    var label = versionLabel();
    var state = version && (version.current || version.latest) ? "latest" : "historical";
    return label + " · " + state + (rows.length > 1 ? " · " + rows.length + " versions" : "");
  }

  function workspaceEmailExample() {
    var data = seed();
    if (!activeRoomMatchesSeed()) return "name@company.com";
    var domain = data && data.org && data.org.domain;
    return "name@" + (domain || "company.com");
  }

  function clientEmailExample() {
    if (!activeRoomMatchesSeed()) return "name@company.com";
    var access = (seed() && seed().access) || [];
    var client = access.find(function (row) { return row && row.email && row.email.indexOf("@") > -1; });
    var domain = client ? client.email.split("@")[1] : "";
    return domain ? "name@" + domain : workspaceEmailExample();
  }

  function readerVersionId() {
    return versionId();
  }

  function enableReaderReset() {
    return window.DW_ENABLE_READER_RESET === true;
  }

  window.DWDisplay = {
    orgName: orgName,
    roomTitle: roomTitle,
    clientName: clientName,
    preparedForLabel: preparedForLabel,
    roomShortTitle: roomShortTitle,
    currentVersion: currentVersion,
    versionId: versionId,
    versionLabel: versionLabel,
    versionSummary: versionSummary,
    workspaceEmailExample: workspaceEmailExample,
    clientEmailExample: clientEmailExample,
    readerVersionId: readerVersionId,
    enableReaderReset: enableReaderReset
  };

  Object.assign(window, {
    dwOrgName: orgName,
    dwRoomTitle: roomTitle,
    dwClientName: clientName,
    dwPreparedForLabel: preparedForLabel,
    dwRoomShortTitle: roomShortTitle,
    dwCurrentVersion: currentVersion,
    dwVersionId: versionId,
    dwVersionLabel: versionLabel,
    dwVersionSummary: versionSummary,
    dwWorkspaceEmailExample: workspaceEmailExample,
    dwClientEmailExample: clientEmailExample,
    dwReaderVersionId: readerVersionId,
    dwEnableReaderReset: enableReaderReset
  });
})();


/* ---- app/share.js ---- */
/* ============================================================
   DEALWONDR APP — share/copy helpers
   Clipboard writes are fail-closed: no hidden execCommand fallback.
   ============================================================ */
(function () {
  function envAppBase() {
    return typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_DEALWONDR_APP_BASE
      ? import.meta.env.VITE_DEALWONDR_APP_BASE
      : "";
  }

  function appBaseUrl() {
    return String(window.DW_APP_BASE_URL || envAppBase() || window.location.origin).replace(/\/+$/, "");
  }

  function appPath() {
    return window.DW_APP_PATH || window.location.pathname || "/";
  }

  function roomId(room) {
    if (typeof room === "string") return room;
    return window.DWAdapters.shareRoomId(room);
  }

  function readerHash(room, options) {
    var params = new URLSearchParams();
    params.set("roomId", roomId(room));
    if (options && options.preview) params.set("preview", "1");
    if (options && options.versionId) params.set("versionId", options.versionId);
    return "#/room?" + params.toString();
  }

  function readerPreviewHash(room) {
    return readerHash(room, { preview: true });
  }

  function questionnaireHash(questionnaire, room) {
    var qid = questionnaire && questionnaire.id;
    if (!qid) throw new Error("Questionnaire id is required to create a form link.");
    return "#/form?roomId=" + encodeURIComponent((questionnaire && questionnaire.roomId) || roomId(room)) + "&questionnaireId=" + encodeURIComponent(qid);
  }

  function roomUrl(room) {
    return new URL(appPath() + readerHash(room), appBaseUrl() + "/").toString();
  }

  function readerPreviewUrl(room) {
    return new URL(appPath() + readerPreviewHash(room), appBaseUrl() + "/").toString();
  }

  function questionnaireUrl(questionnaire, room) {
    return new URL(appPath() + questionnaireHash(questionnaire, room), appBaseUrl() + "/").toString();
  }

  function applyRoomIdFromLocation() {
    var hash = window.location.hash || "";
    var queryStart = hash.indexOf("?");
    var params = queryStart >= 0 ? new URLSearchParams(hash.slice(queryStart + 1)) : new URLSearchParams(window.location.search || "");
    var id = params.get("roomId");
    if (id) window.DW_API_ROOM_ID = id;
    return id;
  }

  async function copyText(text) {
    if (!navigator.clipboard || typeof navigator.clipboard.writeText !== "function") {
      throw new Error("Clipboard API is unavailable. Open Dealwondr over HTTPS or localhost, then try again.");
    }
    await navigator.clipboard.writeText(text);
    return text;
  }

  function updateEmail(room, input) {
    var targetRoom = window.DWAdapters.roomContext(room);
    var version = input && input.versionLabel ? input.versionLabel : (targetRoom.version || "the latest version");
    return [
      "Hi,",
      "",
      "I just published " + version + " of " + (targetRoom.title || "the proposal") + ".",
      "The room link is unchanged:",
      roomUrl(targetRoom),
      "",
      "Open it when you have a moment and highlight anything you want me to answer in context.",
      "",
      "Best,"
    ].join("\n");
  }

  function inviteEmail(email, room) {
    var targetRoom = window.DWAdapters.roomContext(room);
    return [
      "Hi" + (email ? " " + email.split("@")[0].replace(/[._]/g, " ") : "") + ",",
      "",
      "Here is " + (targetRoom.title || "the proposal") + " as a private Dealwondr room:",
      roomUrl(targetRoom),
      "",
      "Enter your work email there and Dealwondr will send you a one-time magic link to open the room.",
      "",
      "Once inside, you can highlight any sentence to ask a question and I will answer in context.",
      "",
      "Best,"
    ].join("\n");
  }

  async function copyRoomLink(room) {
    return copyText(roomUrl(room));
  }

  async function copyUpdateEmail(room, input) {
    return copyText(updateEmail(room, input));
  }

  async function copyInviteEmail(email, room) {
    return copyText(inviteEmail(email, room));
  }

  async function copyQuestionnaireLink(questionnaire, room) {
    return copyText(questionnaireUrl(questionnaire, room));
  }

  window.DWShare = {
    appBaseUrl: appBaseUrl,
    roomId: roomId,
    readerHash: readerHash,
    readerPreviewHash: readerPreviewHash,
    questionnaireHash: questionnaireHash,
    roomUrl: roomUrl,
    readerPreviewUrl: readerPreviewUrl,
    questionnaireUrl: questionnaireUrl,
    applyRoomIdFromLocation: applyRoomIdFromLocation,
    copyText: copyText,
    updateEmail: updateEmail,
    inviteEmail: inviteEmail,
    copyRoomLink: copyRoomLink,
    copyUpdateEmail: copyUpdateEmail,
    copyInviteEmail: copyInviteEmail,
    copyQuestionnaireLink: copyQuestionnaireLink
  };
})();


/* ---- app/download.js ---- */
/* ============================================================
   DEALWONDR APP — download helpers
   Exports must return explicit artifacts; no client fallback.
   ============================================================ */
(function () {
  function artifact(input) {
    if (!input || !input.filename || ((input.content === undefined || input.content === null) && !input.contentBase64)) {
      throw new Error("Export did not return an artifact.");
    }
    var body = input.content;
    if (input.encoding === "base64" || input.contentBase64) {
      var binary = atob(input.contentBase64 || "");
      var bytes = new Uint8Array(binary.length);
      for (var i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
      body = bytes;
    }
    var blob = new Blob([body], { type: input.contentType || "text/plain;charset=utf-8" });
    var url = URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.href = url;
    link.download = input.filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
    return input.filename;
  }

  window.DWDownload = {
    artifact: artifact
  };
})();


/* ---- app/store-session.js ---- */
/* ============================================================
   DEALWONDR APP — session store domain
   Auth, session restore, workspace/room hydration, and version
   selection for team and reader sessions.
   ============================================================ */
(function () {
  function create(ctx) {
    function state() { return ctx.state(); }
    function requireSession(message) {
      if (!window.DWApi.getSession()) throw new Error(message);
      return state();
    }
    async function activateReaderSession(result) {
      var s = state();
      if (!result || !result.sessionToken) throw new Error('Reader session token is required.');
      ctx.clearBackendState(s);
      s.teamUser = null;
      s.teamSession = null;
      if (result.roomId) window.DW_API_ROOM_ID = result.roomId;
      s.clientEmail = String(result.email || (result.user && result.user.email) || '').trim().toLowerCase();
      s.readerSession = result;
      s.apiError = null;
      window.DWApi.setSession({ sessionToken: result.sessionToken, kind: 'reader', roomId: result.roomId || ctx.apiRoomId(), email: s.clientEmail });
      await api.refreshReaderRoom();
      ctx.emit();
      return result;
    }
    var prefsKey = 'dw-ui-prefs-v1';
    function readPrefs() {
      try {
        var parsed = JSON.parse(localStorage.getItem(prefsKey) || '{}');
        return parsed && typeof parsed === 'object' ? parsed : {};
      } catch (error) {
        return {};
      }
    }
    function writePrefs(prefs) {
      try { localStorage.setItem(prefsKey, JSON.stringify(prefs || {})); } catch (error) {}
    }
    function selectedWorkspaceKey(email) {
      return 'selectedWorkspace:' + String(email || '').trim().toLowerCase();
    }
    function selectedWorkspaceId(email) {
      return readPrefs()[selectedWorkspaceKey(email)] || '';
    }
    function rememberWorkspace(email, workspaceId) {
      if (!email || !workspaceId) return;
      var prefs = readPrefs();
      prefs[selectedWorkspaceKey(email)] = workspaceId;
      writePrefs(prefs);
    }
    function mapWorkspace(row) {
      return {
        id: row.id,
        name: row.name || 'Workspace',
        domain: row.domain || '',
        plan: row.plan || '',
        role: row.role || ''
      };
    }
    function perfTime(name, fn) {
      return window.DWPerf && window.DWPerf.time ? window.DWPerf.time(name, fn) : Promise.resolve().then(fn);
    }
    async function refreshTeamWorkspaces(s) {
      var rows = await window.DWApi.teamWorkspaces();
      s.teamWorkspaces = (rows || []).map(mapWorkspace);
      return s.teamWorkspaces;
    }
    function setTeamSessionState(s, session) {
      s.clientEmail = null;
      s.readerSession = null;
      s.teamUser = {
        email: session.email,
        name: String(session.email || '').split('@')[0],
        initials: window.DWAdapters.initials('', session.email),
        role: session.role,
        workspaceId: session.workspaceId || null
      };
      s.teamSession = session;
      window.DWApi.setSession(session);
    }
    async function resolveWorkspaceSession(api, s, session) {
      var workspaces = await refreshTeamWorkspaces(s);
      if (!workspaces.length) return session;
      var remembered = selectedWorkspaceId(session.email);
      var selected = remembered ? workspaces.find(function (workspace) { return workspace.id === remembered; }) : null;
      if (selected && selected.id !== session.workspaceId) {
        var switched = await window.DWApi.switchTeamWorkspace(selected.id);
        setTeamSessionState(s, switched);
        rememberWorkspace(switched.email, switched.workspaceId);
        return switched;
      }
      var current = session.workspaceId ? workspaces.find(function (workspace) { return workspace.id === session.workspaceId; }) : null;
      if (current) {
        rememberWorkspace(session.email, current.id);
        return session;
      }
      if (!selected && workspaces.length === 1) selected = workspaces[0];
      if (!selected) return session;
      var switched = await window.DWApi.switchTeamWorkspace(selected.id);
      setTeamSessionState(s, switched);
      rememberWorkspace(switched.email, switched.workspaceId);
      return switched;
    }

    var api = {
      activeSession: function () {
        return window.DWApi && window.DWApi.getSession ? window.DWApi.getSession() : null;
      },
      hasTeamApiSession: function () {
        return !!(this.activeSession() && state().teamSession);
      },
      hasReaderApiSession: function () {
        var session = this.activeSession();
        return !!(session && session.kind === 'reader' && state().readerSession);
      },
      signInClient: async function (email) {
        var s = state();
        try {
          var result = await window.DWApi.verifyReaderEmail(ctx.apiRoomId(), email);
          if (!result || !result.ok) throw new Error('This email is not on the invite list for this room.');
          if (result.sessionToken) return activateReaderSession(Object.assign({ email: email.trim().toLowerCase(), roomId: ctx.apiRoomId() }, result));
          if (result.token && result.emailQueued === false) return this.completeReaderMagicLink(result.token);
          s.clientEmail = null;
          s.readerSession = null;
          s.apiError = null;
          ctx.emit();
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      signOutClient: async function () {
        var s = state();
        try {
          if (window.DWApi.getSession()) await window.DWApi.logoutReader();
          ctx.clearBackendState(s);
          window.DWApi.setSession(null);
          ctx.replaceState(ctx.seedState());
          ctx.emit();
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      completeReaderMagicLink: async function (token) {
        try {
          var result = await window.DWApi.completeReaderMagicLink(token);
          return activateReaderSession(result);
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      requestTeamMagicLink: async function (email, mode, profile) {
        var s = state();
        try {
          var result = await window.DWApi.requestTeamMagicLink(Object.assign({ email: email, mode: mode || 'login' }, profile || {}));
          s.apiError = null;
          ctx.emit();
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      completeTeamMagicLink: async function (token) {
        var s = state();
        try {
          var result = await window.DWApi.completeTeamMagicLink(token);
          ctx.clearBackendState(s);
          setTeamSessionState(s, result);
          s.apiError = null;
          result = await resolveWorkspaceSession(api, s, result);
          if (result.workspaceId) await this.refreshWorkspace();
          else ctx.emit();
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      signInTeam: async function (email) {
        var result = await this.requestTeamMagicLink(email, 'login');
        if (result.token) return this.completeTeamMagicLink(result.token);
        return result;
      },
      signOutTeam: async function () {
        var s = state();
        try {
          if (window.DWApi.getSession()) await window.DWApi.logoutTeam();
          ctx.clearBackendState(s);
          window.DWApi.setSession(null);
          ctx.replaceState(ctx.seedState());
          ctx.emit();
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      reset: function () {
        ctx.replaceState(ctx.seedState());
        ctx.emit();
      },
      restoreSession: async function () {
        var s = state();
        var requestedRoomId = window.DW_API_ROOM_ID || null;
        var session = window.DWApi.getSession();
        var routeRoomSession = null;
        try {
          routeRoomSession = window.DWApi.getReaderSession && window.DWApi.getReaderSession(ctx.apiRoomId());
        } catch (error) {
          routeRoomSession = null;
        }
        if ((!session || session.kind === 'reader') && routeRoomSession) session = routeRoomSession;
        if (!session || !session.sessionToken) return null;
        ctx.clearBackendState(s);
        if (requestedRoomId) window.DW_API_ROOM_ID = requestedRoomId;
        try {
          if (session.kind === 'reader') {
            s.clientEmail = session.email;
            s.readerSession = session;
            if (session.roomId) window.DW_API_ROOM_ID = session.roomId;
            window.DWApi.setSession(session);
            await this.refreshReaderRoom();
          } else {
            setTeamSessionState(s, session);
            session = await resolveWorkspaceSession(api, s, session);
            if (session.workspaceId) {
              await this.refreshWorkspace();
              if (requestedRoomId) {
                window.DW_API_ROOM_ID = requestedRoomId;
                await this.refreshRoom();
              }
            }
            else s.backendLoaded = true;
          }
          s.apiError = null;
          ctx.emit();
          return session;
        } catch (error) {
          if (!session.kind && [401, 403, 404].indexOf(error.status) > -1) {
            window.DWApi.setSession(null);
            ctx.replaceState(ctx.seedState());
            ctx.emit();
          }
          ctx.setApiError(error);
          throw error;
        }
      },
      teamWorkspaces: function () {
        return state().teamWorkspaces || [];
      },
      switchWorkspace: async function (workspaceId) {
        var s = requireSession('Team session is required before switching workspaces.');
        if (!s.teamSession) throw new Error('Team session is required before switching workspaces.');
        try {
          var result = await window.DWApi.switchTeamWorkspace(workspaceId);
          ctx.clearBackendState(s);
          setTeamSessionState(s, result);
          rememberWorkspace(result.email, result.workspaceId);
          s.apiError = null;
          await this.refreshWorkspace();
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      refreshWorkspace: async function () {
        var s = state();
        if (!s.teamSession) throw new Error('Team session is required before loading workspace data.');
        ctx.clearBackendState(s);
        ctx.emit();
        try {
          var loaded = await perfTime('refreshWorkspace', function () { return window.DWAdapters.hydrateWorkspace(s.teamSession); });
          s.rooms = ((loaded && loaded.rooms) || []).map(window.DWAdapters.mapRoomSummary);
          window.DW_SEED.rooms = ctx.clone(s.rooms);
          s.comments = ctx.clone(window.DW_SEED.comments);
          s.access = ctx.clone(window.DW_SEED.access);
          s.activity = ctx.clone(window.DW_SEED.activity || { tagged: [], replies: [], around: [] });
          s.members = ctx.seedMembers();
          s.joinRequests = ((loaded && loaded.joinRequests) || []).map(window.DWAdapters.mapJoinRequest);
          window.DW_SEED.joinRequests = ctx.clone(s.joinRequests);
          s.workspaceDomains = ((loaded && loaded.workspaceDomains) || []).map(window.DWAdapters.mapWorkspaceDomain);
          window.DW_SEED.workspaceDomains = ctx.clone(s.workspaceDomains);
          s.questionnaires = [];
          window.DW_SEED.questionnaires = [];
          window.DW_SEED.postQuestionnaire = null;
          s.questionnaireTemplates = ctx.clone(window.DW_SEED.questionnaireTemplates || []);
          s.brand = ctx.clone(window.DW_SEED.brand || s.brand);
          s.notifications = ctx.clone(window.DW_SEED.notifications || []);
          s.notificationPrefs = window.DWAdapters.normalizeNotificationPrefs(window.DW_SEED.notificationPrefs);
          s.costs = ctx.clone((loaded && loaded.costs) || []);
          s.llmRuns = ctx.clone((loaded && loaded.llmRuns) || []);
          window.DW_SEED.costs = ctx.clone(s.costs);
          window.DW_SEED.llmRuns = ctx.clone(s.llmRuns);
          s.selectedVersionId = null;
          s.backendLoaded = true;
          s.apiError = null;
          ctx.emit();
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      refreshRoom: async function () {
        var s = requireSession('Signed-in session is required before loading room data.');
        try {
          await perfTime('refreshRoom', function () { return window.DWAdapters.hydrateRoom(ctx.apiRoomId()); });
          s.comments = ctx.clone(window.DW_SEED.comments);
          s.access = ctx.clone(window.DW_SEED.access);
          s.activity = ctx.clone(window.DW_SEED.activity || { tagged: [], replies: [], around: [] });
          s.questionnaires = ctx.clone(window.DW_SEED.questionnaires || []);
          s.roomTracking = ctx.clone(window.DW_SEED.roomTracking || null);
          s.readerTracking = null;
          s.questionnaireSubmission = null;
          s.focusedQuestionnaire = null;
          s.selectedVersionId = null;
          s.backendLoaded = true;
          s.apiError = null;
          ctx.emit();
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      refreshReaderRoom: async function () {
        var s = state();
        if (!window.DWApi.getSession() || !s.readerSession) throw new Error('Reader session is required before loading room data.');
        try {
          await perfTime('refreshReaderRoom', function () { return window.DWAdapters.hydrateReaderRoom(ctx.apiRoomId()); });
          s.comments = ctx.clone(window.DW_SEED.comments);
          s.access = ctx.clone(window.DW_SEED.access);
          s.activity = ctx.clone(window.DW_SEED.activity || { tagged: [], replies: [], around: [] });
          s.questionnaires = ctx.clone(window.DW_SEED.questionnaires || []);
          s.readerTracking = null;
          s.questionnaireSubmission = null;
          s.focusedQuestionnaire = null;
          s.selectedVersionId = null;
          s.backendLoaded = true;
          s.apiError = null;
          ctx.emit();
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      selectVersionSignals: async function (roomId, versionId) {
        var s = state();
        if (!window.DWApi.getSession() || !s.teamSession) throw new Error('Team session is required to load version analytics.');
        if (!versionId) throw new Error('Choose a version before opening analytics.');
        try {
          var loaded = await window.DWAdapters.hydrateVersionSignals(roomId || ctx.apiRoomId(), versionId);
          s.selectedVersionId = versionId;
          s.comments = ctx.clone(window.DW_SEED.comments);
          s.access = ctx.clone(window.DW_SEED.access);
          s.activity = ctx.clone(window.DW_SEED.activity || { tagged: [], replies: [], around: [] });
          s.apiError = null;
          ctx.emit();
          return loaded;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      selectReaderVersion: async function (roomId, versionId) {
        var s = state();
        if (!window.DWApi.getSession() || !s.readerSession) throw new Error('Reader session is required to load version content.');
        if (!versionId) throw new Error('Choose a version before opening it.');
        try {
          var loaded = await window.DWAdapters.hydrateReaderVersion(roomId || ctx.apiRoomId(), versionId);
          s.selectedVersionId = loaded.versionId || versionId;
          s.comments = ctx.clone(window.DW_SEED.comments);
          s.activity = ctx.clone(window.DW_SEED.activity || { tagged: [], replies: [], around: [] });
          s.questionnaireSubmission = null;
          s.apiError = null;
          ctx.emit();
          return loaded;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      selectPreviewVersion: async function (roomId, versionId) {
        var s = state();
        if (!window.DWApi.getSession() || !s.teamSession) throw new Error('Team session is required to preview version content.');
        if (!versionId) throw new Error('Choose a version before previewing it.');
        try {
          var loaded = await window.DWAdapters.hydrateReaderVersion(roomId || ctx.apiRoomId(), versionId);
          s.selectedVersionId = loaded.versionId || versionId;
          s.comments = ctx.clone(window.DW_SEED.comments);
          s.activity = ctx.clone(window.DW_SEED.activity || { tagged: [], replies: [], around: [] });
          s.questionnaireSubmission = null;
          s.apiError = null;
          ctx.emit();
          return loaded;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      }
    };
    return api;
  }

  window.DWStoreSession = { create: create };
})();


/* ---- app/store-rooms.js ---- */
/* ============================================================
   DEALWONDR APP — rooms/content store domain
   Backend-backed room lifecycle, new-room creation, documents,
   versions, uploads, and content draft actions.
   ============================================================ */
(function () {
  function create(ctx) {
    function state() { return ctx.state(); }
    function requireTeam(message) {
      var s = state();
      if (!window.DWApi.getSession() || !s.teamSession) throw new Error(message);
      return s;
    }
    function targetRoomId(roomId) {
      return roomId || ctx.apiRoomId();
    }

    return {
      rooms: function () {
        var s = state();
        if (s.teamSession || s.backendLoaded) return s.rooms || [];
        return s.rooms || window.DW_SEED.rooms || [];
      },
      refreshRooms: async function () {
        var s = requireTeam('Team session is required to load rooms.');
        try {
          var rows = await window.DWApi.rooms(ctx.workspaceId());
          s.rooms = rows.map(window.DWAdapters.mapRoomSummary);
          window.DW_SEED.rooms = ctx.clone(s.rooms);
          s.apiError = null;
          ctx.emit();
          return s.rooms;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      selectRoom: async function (roomId) {
        if (!roomId) throw new Error('Choose a room to open.');
        window.DW_API_ROOM_ID = roomId;
        await this.refreshRoom();
        return roomId;
      },
      archiveRoom: async function (roomId) {
        requireTeam('Team session is required to archive rooms.');
        if (!roomId) throw new Error('Choose a room to archive.');
        try {
          await window.DWApi.archiveRoom(roomId);
          await this.refreshRooms();
          return { archived: true };
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      deleteRoom: async function (roomId) {
        requireTeam('Team session is required to delete rooms.');
        if (!roomId) throw new Error('Choose a room to delete.');
        try {
          await window.DWApi.deleteRoom(roomId);
          await this.refreshRooms();
          return { deleted: true };
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      unarchiveRoom: async function (roomId) {
        requireTeam('Team session is required to restore rooms.');
        if (!roomId) throw new Error('Choose a room to restore.');
        try {
          await window.DWApi.unarchiveRoom(roomId);
          await this.refreshRooms();
          return { archived: false };
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      renameRoom: async function (roomId, title) {
        requireTeam('Team session is required to rename rooms.');
        if (!roomId) throw new Error('Choose a room to rename.');
        if (!title || !title.trim()) throw new Error('Room title is required.');
        try {
          var room = await window.DWApi.renameRoom(roomId, title.trim());
          await this.refreshRoom();
          await this.refreshRooms();
          return room;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      createUploadedRoom: async function (input) {
        var s = requireTeam('Team session is required to create a room.');
        if (!input || !input.file) throw new Error('Choose a file before creating the room.');
        try {
          var file = input.file;
          var title = input.title || file.name.replace(/\.[^.]+$/, '').replace(/[-_]+/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
          var room = await window.DWApi.createRoom({
            title: title,
            preparedFor: input.preparedFor || '',
            gateDescription: input.gateDescription || ''
          });
          var version = await window.DWApi.addVersion(room.id, {
            fileName: file.name,
            pages: input.pages || 0,
            note: input.note || 'Initial proposal upload',
            clientsCanViewOld: true
          });
          var documents = await window.DWApi.addDocument(room.id, { title: title, role: 'main', pages: input.pages || 0 });
          var document = Array.isArray(documents) ? documents.find(function (doc) { return doc.role === 'main'; }) || documents[0] : documents;
          if (!document || !document.id) throw new Error('Upload did not return a document.');
          var upload = await window.DWApi.upload(room.id, {
            versionId: version.id,
            documentId: document.id,
            fileName: file.name,
            contentType: file.type || 'application/octet-stream',
            body: file
          });
          var preview = null;
          if (input.preview && input.preview.sections && input.preview.sections.length) {
            var persistSections = input.preview.sections.filter(function (section) { return !section.reviewOnly; });
            if (!persistSections.length) throw new Error('Client preview did not include reader content to save.');
            preview = await window.DWApi.saveDocumentPreviewSections(room.id, document.id, {
              versionId: version.id,
              sections: persistSections
            });
          }
          window.DW_API_ROOM_ID = room.id;
          s.apiError = null;
          ctx.emit();
          return { room: room, version: version, document: document, upload: upload, preview: preview };
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      createTemplateRoom: async function (templateId, input) {
        var s = requireTeam('Team session is required to create a room from a template.');
        if (!s.teamSession.workspaceId) throw new Error('Team session is required to create a room from a template.');
        if (!templateId) throw new Error('Choose a template before creating the room.');
        try {
          var result = await window.DWApi.useRoomTemplate(s.teamSession.workspaceId, templateId, input || {});
          if (!result || !result.room || !result.room.id) throw new Error('Template did not return a room.');
          window.DW_API_ROOM_ID = result.room.id;
          s.apiError = null;
          ctx.emit();
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      createLinkedRoom: async function (input) {
        var s = requireTeam('Team session is required to import a link.');
        if (!s.teamSession.workspaceId) throw new Error('Team session is required to import a link.');
        if (!input || !input.url) throw new Error('Paste a link before importing.');
        try {
          var result = await window.DWApi.importLink(s.teamSession.workspaceId, input);
          if (!result || !result.room || !result.room.id) throw new Error('Import did not return a room.');
          window.DW_API_ROOM_ID = result.room.id;
          s.apiError = null;
          ctx.emit();
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      createPrototypeLinkRoom: async function (input) {
        var s = requireTeam('Team session is required to share a prototype link.');
        if (!s.teamSession.workspaceId) throw new Error('Team session is required to share a prototype link.');
        if (!input || !input.url) throw new Error('Paste a prototype link before creating the room.');
        try {
          var result = await window.DWApi.createPrototypeLink(s.teamSession.workspaceId, input);
          if (!result || !result.room || !result.room.id) throw new Error('Prototype link did not return a room.');
          window.DW_API_ROOM_ID = result.room.id;
          s.apiError = null;
          ctx.emit();
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      createUploadedPrototypeRoom: async function (input) {
        var s = requireTeam('Team session is required to upload a prototype.');
        if (!s.teamSession.workspaceId) throw new Error('Team session is required to upload a prototype.');
        if (!input || !input.file) throw new Error('Choose an HTML file before creating the prototype room.');
        try {
          var file = input.file;
          var result = await window.DWApi.uploadPrototypeHtml(s.teamSession.workspaceId, {
            title: input.title || window.DWAdapters.titleFromFileName(file.name),
            fileName: file.name,
            contentType: file.type || 'text/html',
            body: file
          });
          if (!result || !result.room || !result.room.id) throw new Error('Prototype upload did not return a room.');
          window.DW_API_ROOM_ID = result.room.id;
          s.apiError = null;
          ctx.emit();
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      publishRoom: async function (roomId) {
        requireTeam('Team session is required to publish a room.');
        try {
          var room = await window.DWApi.publishRoom(targetRoomId(roomId));
          window.DW_API_ROOM_ID = room.id;
          await this.refreshWorkspace();
          return room;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      addDocument: async function (roomId, input) {
        requireTeam('Team session is required to add a document.');
        try {
          return await window.DWApi.addDocument(targetRoomId(roomId), input);
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      uploadDocument: async function (roomId, input) {
        requireTeam('Team session is required to upload a document.');
        try {
          return await window.DWApi.upload(targetRoomId(roomId), input);
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      addVersion: async function (roomId, input) {
        requireTeam('Team session is required to publish versions.');
        try {
          return await window.DWApi.addVersion(targetRoomId(roomId), input);
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      setVersionVisible: async function (roomId, versionId, visible) {
        requireTeam('Team session is required to update version visibility.');
        try {
          return await window.DWApi.setVersionVisible(targetRoomId(roomId), versionId, visible);
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      renameDocument: async function (roomId, documentId, title) {
        requireTeam('Team session is required to rename a document.');
        try {
          return await window.DWApi.renameDocument(targetRoomId(roomId), documentId, title);
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      removeDocument: async function (roomId, documentId) {
        requireTeam('Team session is required to remove a document.');
        try {
          return await window.DWApi.removeDocument(targetRoomId(roomId), documentId);
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      moveDocument: async function (roomId, documentId, direction) {
        requireTeam('Team session is required to reorder documents.');
        try {
          return await window.DWApi.moveDocument(targetRoomId(roomId), documentId, direction);
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      ensureContentDraft: async function (roomId) {
        requireTeam('Team session is required to edit proposal content.');
        try {
          return await window.DWApi.ensureContentDraft(targetRoomId(roomId));
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      contentDraft: async function (roomId) {
        requireTeam('Team session is required to read proposal content drafts.');
        try {
          return await window.DWApi.contentDraft(targetRoomId(roomId));
        } catch (error) {
          if (error && error.status === 404) return null;
          ctx.setApiError(error);
          throw error;
        }
      },
      addDraftDocument: async function (roomId, input) {
        requireTeam('Team session is required to add proposal content.');
        try {
          return await window.DWApi.addDraftDocument(targetRoomId(roomId), input);
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      uploadDraftDocument: async function (roomId, input) {
        requireTeam('Team session is required to upload proposal content.');
        try {
          return await window.DWApi.uploadDraftDocument(targetRoomId(roomId), input);
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      renameDraftDocument: async function (roomId, draftDocumentId, title) {
        requireTeam('Team session is required to rename proposal content.');
        try {
          return await window.DWApi.renameDraftDocument(targetRoomId(roomId), draftDocumentId, title);
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      replaceDraftDocument: async function (roomId, draftDocumentId, input) {
        requireTeam('Team session is required to replace proposal content.');
        try {
          return await window.DWApi.replaceDraftDocument(targetRoomId(roomId), draftDocumentId, input);
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      uploadExistingDraftDocument: async function (roomId, draftDocumentId, input) {
        requireTeam('Team session is required to upload proposal content.');
        try {
          return await window.DWApi.uploadExistingDraftDocument(targetRoomId(roomId), draftDocumentId, input);
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      addDraftPrototypeLink: async function (roomId, input) {
        requireTeam('Team session is required to add a prototype.');
        try {
          return await window.DWApi.addDraftPrototypeLink(targetRoomId(roomId), input);
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      uploadDraftPrototypeHtml: async function (roomId, input) {
        requireTeam('Team session is required to upload a prototype.');
        try {
          return await window.DWApi.uploadDraftPrototypeHtml(targetRoomId(roomId), input);
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      documentFrameHtml: async function (roomId, documentId, versionId) {
        try {
          return await window.DWApi.documentFrameHtml(targetRoomId(roomId), documentId, versionId);
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      removeDraftDocument: async function (roomId, draftDocumentId) {
        requireTeam('Team session is required to remove proposal content.');
        try {
          return await window.DWApi.removeDraftDocument(targetRoomId(roomId), draftDocumentId);
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      moveDraftDocument: async function (roomId, draftDocumentId, direction) {
        requireTeam('Team session is required to reorder proposal content.');
        try {
          return await window.DWApi.moveDraftDocument(targetRoomId(roomId), draftDocumentId, direction);
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      publishContentDraft: async function (roomId, input) {
        requireTeam('Team session is required to publish proposal content.');
        try {
          return await window.DWApi.publishContentDraft(targetRoomId(roomId), input);
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      discardContentDraft: async function (roomId) {
        requireTeam('Team session is required to discard proposal content changes.');
        try {
          return await window.DWApi.discardContentDraft(targetRoomId(roomId));
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      }
    };
  }

  window.DWStoreRooms = { create: create };
})();


/* ---- app/store-collaboration.js ---- */
/* ============================================================
   DEALWONDR APP — collaboration store domain
   Room-scoped comments, activity, access, tracking, and exports.
   ============================================================ */
(function () {
  function roleToDealRole(role) {
    var value = String(role || '').toLowerCase();
    if (value.indexOf('approver') >= 0) return 'approver';
    if (value.indexOf('champion') >= 0) return 'champion';
    if (value.indexOf('senior') >= 0) return 'senior';
    if (value.indexOf('junior') >= 0) return 'junior';
    return 'unknown';
  }

  function create(ctx) {
    function state() { return ctx.state(); }
    function requireSession(message) {
      if (!window.DWApi.getSession()) throw new Error(message);
      return state();
    }
    function requireTeam(message) {
      var s = state();
      if (!window.DWApi.getSession() || !s.teamSession) throw new Error(message);
      return s;
    }
    function targetRoomId(roomId) {
      return roomId || ctx.apiRoomId();
    }

    return {
      comments: function () {
        return state().comments;
      },
      activity: function () {
        return state().activity || { tagged: [], replies: [], around: [] };
      },
      activityUnreadCount: function () {
        var activity = this.activity();
        return (activity.tagged || []).filter(function (a) { return !!a.unread; }).length + (activity.replies || []).filter(function (a) { return !!a.unread; }).length;
      },
      refreshComments: async function () {
        var s = state();
        try {
          s.comments = (await window.DWApi.comments(ctx.apiRoomId(), ctx.currentVersionId())).map(window.DWAdapters.mapComment);
          s.apiError = null;
          ctx.emit();
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      addComment: async function (sectionId, section, quote, body, needsReply) {
        var s = requireSession('Signed-in session is required to add a comment.');
        try {
          var saved = await window.DWApi.addComment(ctx.apiRoomId(), { versionId: ctx.currentVersionId(), sectionId: sectionId, quote: quote, body: body, needsReply: !!needsReply });
          s.comments = [window.DWAdapters.mapComment(saved)].concat(s.comments);
          s.apiError = null;
          ctx.emit();
          return saved;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      addReply: async function (id, body) {
        requireSession('Signed-in session is required to add a reply.');
        try {
          await window.DWApi.addReply(id, body);
          await this.refreshComments();
          return;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      setResolved: async function (id, val) {
        requireSession('Signed-in session is required to resolve comments.');
        try {
          await window.DWApi.setResolved(id, val);
          await this.refreshComments();
          return;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },

      access: function () {
        return state().access;
      },
      refreshAccess: async function () {
        var s = state();
        try {
          s.access = (await window.DWApi.access(ctx.apiRoomId())).map(window.DWAdapters.mapAccess);
          s.apiError = null;
          ctx.emit();
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      invite: async function (email, role) {
        requireSession('Team session is required to invite client access.');
        try {
          await window.DWApi.inviteAccess(ctx.apiRoomId(), { emailOrDomain: email.trim().toLowerCase(), role: 'client', dealRole: roleToDealRole(role) });
          await this.refreshAccess();
          return;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      removeAccess: async function (email) {
        requireSession('Team session is required to remove client access.');
        try {
          await window.DWApi.removeAccess(ctx.apiRoomId(), email);
          await this.refreshAccess();
          return;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      setAccessRole: async function (email, role) {
        requireSession('Team session is required to update client access.');
        try {
          await window.DWApi.updateAccess(ctx.apiRoomId(), email, { dealRole: roleToDealRole(role) });
          await this.refreshAccess();
          return;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },

      roomTracking: function () {
        return state().roomTracking;
      },
      loadRoomTracking: async function (roomId) {
        var s = requireTeam('Team session is required to load room tracking settings.');
        try {
          s.roomTracking = await window.DWApi.tracking(targetRoomId(roomId));
          window.DW_SEED.roomTracking = ctx.clone(s.roomTracking);
          s.apiError = null;
          ctx.emit();
          return s.roomTracking;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      setRoomTracking: async function (patch, roomId) {
        var s = requireTeam('Team session is required to update room tracking settings.');
        try {
          s.roomTracking = await window.DWApi.setTracking(targetRoomId(roomId), patch || {});
          window.DW_SEED.roomTracking = ctx.clone(s.roomTracking);
          s.apiError = null;
          ctx.emit();
          return s.roomTracking;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },

      exportRoomArtifact: async function (kind, input) {
        requireTeam('Team session is required to export room artifacts.');
        var options = input || {};
        var roomId = options.roomId || ctx.apiRoomId();
        var versionId = options.versionId || ctx.currentVersionId();
        try {
          if (kind === 'comments') return await window.DWApi.exportComments(roomId, versionId, options.format || 'csv');
          if (kind === 'submissions') return await window.DWApi.exportSubmissions(roomId);
          if (!versionId) throw new Error('A current room version is required for this export.');
          if (kind === 'objections') return await window.DWApi.exportObjections(roomId, versionId);
          if (kind === 'precall') return await window.DWApi.exportPrecall(roomId, versionId);
          if (kind === 'analytics') return await window.DWApi.exportAnalytics(roomId, versionId);
          if (kind === 'proposal-pdf') return await window.DWApi.exportProposalPdf(roomId, versionId);
          if (kind === 'all-versions') return await window.DWApi.exportAllVersions(roomId);
          throw new Error('Unsupported export type: ' + kind);
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      }
    };
  }

  window.DWStoreCollaboration = { create: create };
})();


/* ---- app/store-insights.js ---- */
/* ============================================================
   DEALWONDR APP — insights store domain
   Pre-call notes, next actions, and objection state mutations.
   ============================================================ */
(function () {
  function create(ctx) {
    function requireTeam(message) {
      var s = ctx.state();
      if (!window.DWApi.getSession() || !s.teamSession) throw new Error(message);
      return s;
    }
    function targetRoomId(roomId) {
      return roomId || ctx.apiRoomId();
    }
    function targetVersionId(message) {
      var versionId = ctx.currentVersionId();
      if (!versionId) throw new Error(message);
      return versionId;
    }

    return {
      precallNotes: function () {
        return (window.DW_SEED.insights && window.DW_SEED.insights.__hydrated && window.DW_SEED.insights.pastNotes) || [];
      },
      generatePrecallNote: async function () {
        requireTeam('Team session is required to generate pre-call notes.');
        var versionId = targetVersionId('A current room version is required to generate a pre-call note.');
        try {
          var note = window.DWAdapters.mapPrecallNote(await window.DWApi.createPrecallNote(ctx.apiRoomId(), versionId), { fallbackVersionId: ctx.currentVersionId() });
          window.DW_SEED.insights = window.DW_SEED.insights || {};
          window.DW_SEED.insights.__hydrated = true;
          var existing = (window.DW_SEED.insights.pastNotes || []).filter(function (row) { return row.id !== note.id; });
          window.DW_SEED.insights.pastNotes = [note].concat(existing);
          ctx.state().apiError = null;
          ctx.emit();
          return note;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      refreshNextActions: async function (roomId) {
        requireTeam('Team session is required to load next actions.');
        var targetId = targetRoomId(roomId);
        var versionId = targetVersionId('A current room version is required to load next actions.');
        try {
          var result = await window.DWApi.nextActions(targetId, versionId);
          window.DW_SEED.insights = window.DW_SEED.insights || {};
          window.DW_SEED.insights.__hydrated = true;
          window.DW_SEED.insights.actions = window.DWAdapters.mapNextActions(result);
          ctx.state().apiError = null;
          ctx.emit();
          return window.DW_SEED.insights.actions;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      refreshInsightOverview: async function (roomId, versionId) {
        requireTeam('Team session is required to load insights.');
        var targetId = targetRoomId(roomId);
        var targetVersion = versionId || targetVersionId('A current room version is required to load insights.');
        try {
          var result = await window.DWAdapters.hydrateInsightOverview(targetId, targetVersion);
          ctx.state().apiError = null;
          ctx.emit();
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      refreshAnalyticsSummary: async function (roomId, versionId) {
        requireTeam('Team session is required to load analytics.');
        var targetId = targetRoomId(roomId);
        var targetVersion = versionId || targetVersionId('A current room version is required to load analytics.');
        try {
          var result = await window.DWAdapters.hydrateAnalyticsSummary(targetId, targetVersion);
          ctx.state().apiError = null;
          ctx.emit();
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      refreshReplaySessions: async function (roomId, versionId) {
        requireTeam('Team session is required to load replay sessions.');
        var targetId = targetRoomId(roomId);
        var targetVersion = versionId || targetVersionId('A current room version is required to load replay sessions.');
        try {
          var result = await window.DWAdapters.hydrateSessionDetails(targetId, targetVersion);
          ctx.state().apiError = null;
          ctx.emit();
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      refreshQuestionnaireStats: async function (roomId, versionId) {
        requireTeam('Team session is required to load questionnaire analytics.');
        var targetId = targetRoomId(roomId);
        var targetVersion = versionId || targetVersionId('A current room version is required to load questionnaire analytics.');
        try {
          var result = await window.DWAdapters.hydrateQuestionnaireStats(targetId, targetVersion, (window.DW_SEED.access || []).length);
          ctx.state().questionnaires = ctx.state().questionnaires || [];
          ctx.state().questionnaires = JSON.parse(JSON.stringify(window.DW_SEED.questionnaires || []));
          ctx.state().apiError = null;
          ctx.emit();
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      actOnNextAction: async function (action, actionId) {
        requireTeam('Team session is required to act on insights.');
        if (!action || !action.id) throw new Error('Choose a next action before marking it done.');
        if (!actionId) throw new Error('Choose how this action was handled.');
        var versionId = targetVersionId('A current room version is required to act on insights.');
        try {
          var result = await window.DWApi.actOnNextAction(ctx.apiRoomId(), action.id, { versionId: versionId, actionId: actionId, commentId: action.commentId || undefined });
          await this.refreshNextActions(ctx.apiRoomId());
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      undoNextAction: async function (action) {
        requireTeam('Team session is required to undo insight actions.');
        if (!action || !action.id) throw new Error('Choose a next action before undoing it.');
        var versionId = targetVersionId('A current room version is required to undo insight actions.');
        try {
          var result = await window.DWApi.undoNextAction(ctx.apiRoomId(), action.id, versionId);
          await this.refreshNextActions(ctx.apiRoomId());
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      setObjectionStatus: async function (objection, status) {
        requireTeam('Team session is required to update objections.');
        if (!objection || !objection.cat) throw new Error('Choose an objection before updating it.');
        if (['open', 'resolved', 'dismissed'].indexOf(status) === -1) throw new Error('Choose a supported objection status.');
        var versionId = targetVersionId('A current room version is required to update objections.');
        try {
          await window.DWApi.setObjectionStatus(ctx.apiRoomId(), objection.cat, { versionId: versionId, status: status });
          var refreshed = await window.DWApi.insights(ctx.apiRoomId(), versionId);
          window.DW_SEED.insights = window.DW_SEED.insights || {};
          window.DW_SEED.insights.__hydrated = true;
          window.DW_SEED.insights.temperature = {
            interest: refreshed.temperature ? refreshed.temperature.interest : 0,
            friction: refreshed.temperature ? refreshed.temperature.friction : 0,
            label: refreshed.temperature ? refreshed.temperature.label : 'No signal',
            confidence: refreshed.temperature ? refreshed.temperature.confidence : 'Low'
          };
          window.DW_SEED.insights.lifting = refreshed.temperature && refreshed.temperature.up ? refreshed.temperature.up : [];
          window.DW_SEED.insights.holding = refreshed.temperature && refreshed.temperature.down ? refreshed.temperature.down : [];
          window.DW_SEED.insights.objections = (refreshed.objections || []).map(function (o) {
            return { cat: o.category || o.cat, sev: o.severity || o.sev || 'med', sevLabel: o.severity || o.sev || 'Medium', score: o.score || 0, ev: o.evidenceCount || (o.evidence || []).length || 0, evidence: o.evidence || [], status: o.status || 'open' };
          });
          await this.refreshNextActions(ctx.apiRoomId());
          ctx.emit();
          return { status: status };
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      }
    };
  }

  window.DWStoreInsights = { create: create };
})();


/* ---- app/store-workspace.js ---- */
/* ============================================================
   DEALWONDR APP — workspace store domain
   Backend-backed workspace, team, brand, templates, usage, and
   platform overview actions.
   ============================================================ */
(function () {
  function create(ctx) {
    function state() { return ctx.state(); }
    function requireTeam(message) {
      var s = state();
      if (!window.DWApi.getSession() || !s.teamSession) throw new Error(message);
      return s;
    }
    function workspaceId() {
      var s = state();
      var id = s.teamSession && s.teamSession.workspaceId ? s.teamSession.workspaceId : (window.DW_SEED.org && window.DW_SEED.org.id);
      if (!id) throw new Error('Workspace context is required.');
      return id;
    }

    return {
      workspaceId: workspaceId,
      isSuper: function () {
        return !!(state().teamSession && state().teamSession.role === 'super');
      },
      platformOverview: function () {
        return state().platformOverview;
      },
      loadPlatformOverview: async function () {
        var s = requireTeam('Platform staff session is required.');
        if (s.teamSession.role !== 'super') throw new Error('Platform staff session is required.');
        try {
          s.platformOverview = await window.DWApi.platformOverview();
          s.apiError = null;
          ctx.emit();
          return s.platformOverview;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      deletePlatformWorkspace: async function (workspaceId) {
        var s = requireTeam('Platform staff session is required.');
        if (s.teamSession.role !== 'super') throw new Error('Platform staff session is required.');
        if (!workspaceId) throw new Error('Choose a workspace before deleting it.');
        try {
          var result = await window.DWApi.deletePlatformWorkspace(workspaceId);
          s.platformOverview = await window.DWApi.platformOverview();
          s.apiError = null;
          ctx.emit();
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      setPlatformWorkspacePlan: async function (workspaceId, plan) {
        var s = requireTeam('Platform staff session is required.');
        if (s.teamSession.role !== 'super') throw new Error('Platform staff session is required.');
        if (!workspaceId) throw new Error('Choose a workspace before changing its plan.');
        try {
          var result = await window.DWApi.setPlatformWorkspacePlan(workspaceId, plan);
          s.platformOverview = await window.DWApi.platformOverview();
          s.apiError = null;
          ctx.emit();
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      members: function () {
        return state().members || [];
      },
      joinRequests: function () {
        return state().joinRequests || [];
      },
      refreshJoinRequests: async function () {
        var s = requireTeam('Team session is required to load workspace requests.');
        try {
          var rows = await window.DWApi.joinRequests(workspaceId());
          s.joinRequests = rows.map(window.DWAdapters.mapJoinRequest);
          window.DW_SEED.joinRequests = ctx.clone(s.joinRequests);
          s.apiError = null;
          ctx.emit();
          return s.joinRequests;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      approveJoinRequest: async function (requestId) {
        var s = requireTeam('Team session is required to approve workspace requests.');
        if (!requestId) throw new Error('Choose a workspace request before approving it.');
        try {
          var result = await window.DWApi.approveJoinRequest(workspaceId(), requestId);
          var members = await window.DWApi.members(workspaceId());
          s.members = ctx.mapMembers(members);
          await this.refreshJoinRequests();
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      rejectJoinRequest: async function (requestId, note) {
        requireTeam('Team session is required to reject workspace requests.');
        if (!requestId) throw new Error('Choose a workspace request before rejecting it.');
        try {
          var result = await window.DWApi.rejectJoinRequest(workspaceId(), requestId, note || '');
          await this.refreshJoinRequests();
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      sendEmailSmoke: async function () {
        var s = requireTeam('Team session is required to send an email check.');
        try {
          var result = await window.DWApi.emailSmoke(workspaceId());
          s.apiError = null;
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      inviteMember: async function (email, roleLabel) {
        var s = requireTeam('Team session is required to invite teammates.');
        try {
          var result = await window.DWApi.inviteMember(workspaceId(), { email: email.trim().toLowerCase(), role: window.DWAdapters.teamRoleValue(roleLabel) });
          var rows = Array.isArray(result) ? result : result.members || [];
          s.members = ctx.mapMembers(rows);
          s.apiError = null;
          ctx.emit();
          return s.members;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      setMemberRole: async function (email, roleLabel) {
        var s = requireTeam('Team session is required to update teammate roles.');
        try {
          var rows = await window.DWApi.setMemberRole(workspaceId(), email, window.DWAdapters.teamRoleValue(roleLabel));
          s.members = ctx.mapMembers(rows);
          s.apiError = null;
          ctx.emit();
          return s.members;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      removeMember: async function (email) {
        var s = requireTeam('Team session is required to remove teammates.');
        try {
          var rows = await window.DWApi.removeMember(workspaceId(), email);
          s.members = ctx.mapMembers(rows);
          s.apiError = null;
          ctx.emit();
          return s.members;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      brand: function () {
        return state().brand || {};
      },
      workspaceDomains: function () {
        return state().workspaceDomains || [];
      },
      refreshWorkspaceDomains: async function () {
        var s = requireTeam('Team session is required to load workspace domains.');
        try {
          var rows = await window.DWApi.workspaceDomains(workspaceId());
          s.workspaceDomains = rows.map(window.DWAdapters.mapWorkspaceDomain);
          s.apiError = null;
          ctx.emit();
          return s.workspaceDomains;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      createWorkspaceDomain: async function (input) {
        var s = requireTeam('Team session is required to configure workspace domains.');
        try {
          var row = await window.DWApi.createWorkspaceDomain(workspaceId(), input);
          var mapped = window.DWAdapters.mapWorkspaceDomain(row);
          s.workspaceDomains = (s.workspaceDomains || []).filter(function (domain) { return domain.id !== mapped.id && domain.kind !== mapped.kind; }).concat(mapped);
          s.apiError = null;
          ctx.emit();
          return mapped;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      verifyWorkspaceDomain: async function (domainId) {
        var s = requireTeam('Team session is required to verify workspace domains.');
        try {
          var row = await window.DWApi.verifyWorkspaceDomain(workspaceId(), domainId);
          var mapped = window.DWAdapters.mapWorkspaceDomain(row);
          s.workspaceDomains = (s.workspaceDomains || []).map(function (domain) { return domain.id === mapped.id ? mapped : domain; });
          s.apiError = null;
          ctx.emit();
          return mapped;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      deleteWorkspaceDomain: async function (domainId) {
        var s = requireTeam('Team session is required to remove workspace domains.');
        try {
          await window.DWApi.deleteWorkspaceDomain(workspaceId(), domainId);
          s.workspaceDomains = (s.workspaceDomains || []).filter(function (domain) { return domain.id !== domainId; });
          s.apiError = null;
          ctx.emit();
          return { deleted: true };
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      testWorkspaceDomainEmail: async function (domainId) {
        var s = requireTeam('Team session is required to test workspace email domains.');
        try {
          var result = await window.DWApi.testWorkspaceDomainEmail(workspaceId(), domainId);
          s.apiError = null;
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      saveBrand: async function (patch) {
        var s = requireTeam('Team session is required to update workspace brand.');
        try {
          var saved = await window.DWApi.updateBrand(workspaceId(), patch);
          s.brand = saved;
          window.DW_SEED.brand = saved;
          s.apiError = null;
          ctx.emit();
          return saved;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      costs: function () {
        return state().costs || [];
      },
      llmRuns: function () {
        return state().llmRuns || [];
      },
      questionnaireTemplates: function () {
        return state().questionnaireTemplates || [];
      },
      refreshQuestionnaireTemplates: async function () {
        var s = requireTeam('Team session is required to load questionnaire templates.');
        try {
          var rows = await window.DWApi.questionnaireTemplates(workspaceId());
          s.questionnaireTemplates = rows.map(window.DWAdapters.mapTemplate);
          window.DW_SEED.questionnaireTemplates = ctx.clone(s.questionnaireTemplates);
          s.apiError = null;
          ctx.emit();
          return s.questionnaireTemplates;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      duplicateQuestionnaireTemplate: async function (templateId) {
        requireTeam('Team session is required to duplicate questionnaire templates.');
        try {
          await window.DWApi.duplicateQuestionnaireTemplate(workspaceId(), templateId);
          return await this.refreshQuestionnaireTemplates();
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      archiveQuestionnaireTemplate: async function (templateId) {
        requireTeam('Team session is required to archive questionnaire templates.');
        try {
          await window.DWApi.archiveQuestionnaireTemplate(workspaceId(), templateId);
          return await this.refreshQuestionnaireTemplates();
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      renameQuestionnaireTemplate: async function (templateId, name) {
        requireTeam('Team session is required to rename questionnaire templates.');
        try {
          await window.DWApi.renameQuestionnaireTemplate(workspaceId(), templateId, name);
          return await this.refreshQuestionnaireTemplates();
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      saveQuestionnaireTemplate: async function (input) {
        requireTeam('Team session is required to save questionnaire templates.');
        try {
          await window.DWApi.saveQuestionnaireTemplate(workspaceId(), input);
          return await this.refreshQuestionnaireTemplates();
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      }
    };
  }

  window.DWStoreWorkspace = { create: create };
})();


/* ---- app/store-questionnaires.js ---- */
/* ============================================================
   DEALWONDR APP — questionnaire store domain
   Backend-backed questionnaire actions used by builder, reader forms,
   and result downloads.
   ============================================================ */
(function () {
  function create(ctx) {
    function state() { return ctx.state(); }
    function requireTeam(message) {
      var s = state();
      if (!window.DWApi.getSession() || !s.teamSession) throw new Error(message);
      return s;
    }
    function requireReader(message) {
      var s = state();
      if (!window.DWApi.getSession() || !s.readerSession) throw new Error(message);
      return s;
    }
    function readerRoomId(s) {
      return s.readerSession.roomId || (window.DW_SEED.room && window.DW_SEED.room.id) || ctx.apiRoomId();
    }

    return {
      questionnaires: function () {
        return state().questionnaires || [];
      },
      refreshQuestionnaires: async function (roomId) {
        var s = requireTeam('Team session is required to load questionnaires.');
        try {
          var targetRoomId = roomId || ctx.apiRoomId();
          var rows = await window.DWApi.questionnaires(targetRoomId);
          var submissions = await Promise.all(rows.map(function (q) { return window.DWApi.questionnaireSubmissions(q.id); }));
          s.questionnaires = rows.map(function (q, i) { return window.DWAdapters.mapQuestionnaire(q, submissions[i]); });
          window.DW_SEED.questionnaires = ctx.clone(s.questionnaires);
          window.DW_SEED.postQuestionnaire = s.questionnaires.find(function (q) { return q.placement === 'post' && q.status === 'live'; }) || null;
          s.apiError = null;
          ctx.emit();
          return s.questionnaires;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      loadQuestionnaire: async function (questionnaireId) {
        var s = state();
        if (!window.DWApi.getSession()) throw new Error('Signed-in session is required to load a questionnaire.');
        if (!questionnaireId) throw new Error('Choose a questionnaire before opening the form.');
        try {
          var questionnaire = window.DWAdapters.mapQuestionnaire(await window.DWApi.questionnaire(questionnaireId), []);
          s.focusedQuestionnaire = questionnaire;
          s.questionnaires = [questionnaire].concat((s.questionnaires || []).filter(function (row) { return row.id !== questionnaire.id; }));
          window.DW_SEED.questionnaires = ctx.clone(s.questionnaires);
          s.apiError = null;
          ctx.emit();
          return questionnaire;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      activeQuestionnaire: function (questionnaireId) {
        var s = state();
        if (questionnaireId) {
          if (s.focusedQuestionnaire && s.focusedQuestionnaire.id === questionnaireId) return s.focusedQuestionnaire;
          return (s.questionnaires || []).find(function (q) { return q.id === questionnaireId; }) || null;
        }
        return (s.questionnaires || []).find(function (q) { return q.placement === 'post' && q.status === 'live'; }) || null;
      },
      downloadQuestionnaireAttachment: async function (questionnaireId, value) {
        requireTeam('Team session is required to download questionnaire files.');
        if (!questionnaireId || !value || !value.key) throw new Error('Questionnaire attachment is missing.');
        try {
          return await window.DWApi.downloadQuestionnaireAttachment(questionnaireId, value);
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      saveQuestionnaire: async function (roomId, input) {
        requireTeam('Team session is required to save questionnaires.');
        try {
          var targetRoomId = roomId || ctx.apiRoomId();
          var version = (window.DW_SEED.versions || []).find(function (v) { return v.current || v.latest; }) || (window.DW_SEED.versions || [])[0] || null;
          var placement = input.placement || 'post';
          await window.DWApi.saveQuestionnaire(targetRoomId, {
            id: input.id,
            title: input.title || input.name || 'Untitled questionnaire',
            introText: input.introText || '',
            outroText: input.outroText || '',
            schema: input.schema,
            mode: input.mode === 'single' || input.mode === 'single_step' ? 'single_step' : 'multi_step',
            status: input.status || 'draft',
            placement: placement,
            versionId: placement === 'standalone' ? null : (input.versionId || (version && version.id) || null)
          });
          return await this.refreshQuestionnaires(targetRoomId);
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      publishQuestionnaire: async function (roomId, questionnaireId) {
        requireTeam('Team session is required to publish questionnaires.');
        try {
          await window.DWApi.publishQuestionnaire(questionnaireId);
          return await this.refreshQuestionnaires(roomId || ctx.apiRoomId());
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      archiveQuestionnaire: async function (roomId, questionnaireId) {
        requireTeam('Team session is required to archive questionnaires.');
        try {
          await window.DWApi.deleteQuestionnaire(questionnaireId);
          return await this.refreshQuestionnaires(roomId || ctx.apiRoomId());
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      generateQuestionnaire: async function (roomId, prompt) {
        var s = requireTeam('Team session is required to generate questionnaires.');
        try {
          var draft = await window.DWApi.generateQuestionnaire(roomId || ctx.apiRoomId(), prompt);
          s.apiError = null;
          ctx.emit();
          return {
            title: draft.title || 'Generated questionnaire',
            introText: draft.intro || '',
            outroText: draft.outro || '',
            mode: draft.mode === 'single_step' ? 'single' : 'multi',
            placement: 'post',
            schema: draft.schema || { steps: [] },
            fields: window.DWAdapters.schemaFields(draft.schema || { steps: [] })
          };
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      useQuestionnaireTemplate: async function (roomId, templateId) {
        requireTeam('Team session is required to create questionnaire drafts from templates.');
        if (!templateId) throw new Error('Choose a questionnaire template before creating a draft.');
        try {
          var saved = await window.DWApi.useQuestionnaireTemplate(roomId || ctx.apiRoomId(), templateId);
          await this.refreshQuestionnaireTemplates();
          await this.refreshQuestionnaires(roomId || ctx.apiRoomId());
          return saved;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      uploadQuestionnaireAttachment: async function (questionnaireId, questionId, file) {
        var s = requireReader('Reader session is required to upload a questionnaire file.');
        if (!file) throw new Error('Choose a file before uploading.');
        try {
          return await window.DWApi.uploadQuestionnaireAttachment(questionnaireId, {
            roomId: readerRoomId(s),
            questionId: questionId,
            fileName: file.name || 'attachment',
            contentType: file.type || 'application/octet-stream',
            body: file
          });
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      submitQuestionnaire: async function (questionnaireId, answers, finalize) {
        var s = requireReader('Reader session is required to submit a questionnaire.');
        try {
          var saved = await window.DWApi.submitQuestionnaire(questionnaireId, { roomId: readerRoomId(s), answers: answers || {}, finalize: !!finalize });
          s.questionnaireSubmission = saved;
          s.apiError = null;
          ctx.emit();
          return saved;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      }
    };
  }

  window.DWStoreQuestionnaires = { create: create };
})();


/* ---- app/store-notifications.js ---- */
/* ============================================================
   DEALWONDR APP — notification store domain
   Backend-backed alerts, bell triage, and notification preferences.
   ============================================================ */
(function () {
  function create(ctx) {
    function state() { return ctx.state(); }
    function requireTeam(message) {
      var s = state();
      if (!window.DWApi.getSession() || !s.teamSession) throw new Error(message);
      return s;
    }

    return {
      notifications: function () {
        return state().notifications || [];
      },
      notificationPrefs: function () {
        return window.DWAdapters.normalizeNotificationPrefs(state().notificationPrefs);
      },
      refreshNotifications: async function () {
        var s = requireTeam('Team session is required to load notifications.');
        try {
          var rows = await window.DWApi.notifications(ctx.workspaceId(), s.teamSession.email);
          s.notifications = rows.map(window.DWAdapters.mapNotification);
          window.DW_SEED.notifications = ctx.clone(s.notifications);
          s.apiError = null;
          ctx.emit();
          return s.notifications;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      actOnNotification: async function (notificationId, actionId) {
        requireTeam('Team session is required to act on notifications.');
        try {
          var result = await window.DWApi.actOnNotification(notificationId, actionId);
          await this.refreshNotifications();
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      snoozeNotification: async function (notificationId) {
        requireTeam('Team session is required to snooze notifications.');
        try {
          var result = await window.DWApi.snoozeNotification(notificationId);
          await this.refreshNotifications();
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      unsnoozeNotification: async function (notificationId) {
        requireTeam('Team session is required to unsnooze notifications.');
        try {
          var result = await window.DWApi.unsnoozeNotification(notificationId);
          await this.refreshNotifications();
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      undoNotification: async function (notificationId) {
        requireTeam('Team session is required to undo notification actions.');
        try {
          var result = await window.DWApi.undoNotification(notificationId);
          await this.refreshNotifications();
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      markAllNotificationsRead: async function () {
        var s = requireTeam('Team session is required to mark notifications read.');
        try {
          var result = await window.DWApi.markAllNotificationsRead(ctx.workspaceId(), s.teamSession.email);
          await this.refreshNotifications();
          return result;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      saveNotificationPrefs: async function (patch) {
        var s = requireTeam('Team session is required to update notification preferences.');
        try {
          var saved = await window.DWApi.updateNotificationPrefs(ctx.workspaceId(), patch);
          s.notificationPrefs = window.DWAdapters.normalizeNotificationPrefs(saved);
          window.DW_SEED.notificationPrefs = ctx.clone(s.notificationPrefs);
          s.apiError = null;
          ctx.emit();
          return s.notificationPrefs;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      }
    };
  }

  window.DWStoreNotifications = { create: create };
})();


/* ---- app/store-reader.js ---- */
/* ============================================================
   DEALWONDR APP — reader store domain
   Reader sharing controls and local read-progress state.
   ============================================================ */
(function () {
  function create(ctx) {
    function state() { return ctx.state(); }
    function readerRoomId() {
      var s = state();
      return s.readerSession.roomId || (window.DW_SEED.room && window.DW_SEED.room.id) || ctx.apiRoomId();
    }
    function requireReader(message) {
      var s = state();
      if (!window.DWApi.getSession() || !s.readerSession) throw new Error(message);
      return s;
    }
    function requireReaderOrTeam(message) {
      var s = state();
      if (!window.DWApi.getSession() || (!s.readerSession && !s.teamSession)) throw new Error(message);
      return s;
    }

    return {
      readerTracking: function () {
        return state().readerTracking;
      },
      refreshReaderTracking: async function () {
        var s = requireReader('Reader session is required to load sharing details.');
        try {
          s.readerTracking = await window.DWApi.readerTracking(readerRoomId());
          s.apiError = null;
          ctx.emit();
          return s.readerTracking;
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      setReaderTrackingPaused: async function (paused) {
        requireReader('Reader session is required to update sharing details.');
        try {
          await window.DWApi.setReaderTrackingPaused(readerRoomId(), !!paused);
          return await this.refreshReaderTracking();
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      prototypeFrameHtml: async function (roomId, prototypeId) {
        requireReaderOrTeam('Signed-in session is required to load this prototype.');
        if (!roomId || !prototypeId) throw new Error('Prototype context is required.');
        try {
          return await window.DWApi.prototypeFrameHtml(roomId, prototypeId);
        } catch (error) {
          ctx.setApiError(error);
          throw error;
        }
      },
      setProgress: function (p) {
        state().readProgress = Math.round(p);
        ctx.emit();
      }
    };
  }

  window.DWStoreReader = { create: create };
})();


/* ---- app/store.js ---- */
/* ============================================================
   DEALWONDR APP — store (window.DWStore)
   In-memory app store. Backend-owned data is hydrated from the API
   per session; only the API client owns durable session persistence.
   Subscribers re-render on change.
   ============================================================ */
(function () {
  var subs = [];

  function clone(o) { return JSON.parse(JSON.stringify(o)); }
  function defaultBrand() {
    return { primary: '#123A33', secondary: '#FF4A1C', logo: '', logoMode: 'none', website: '' };
  }
  function resetBackendSeed() {
    if (!window.DW_SEED) window.DW_SEED = {};
    window.DW_API_ROOM_ID = null;
    window.DW_SEED.org = {};
    window.DW_SEED.me = null;
    window.DW_SEED.people = {};
    window.DW_SEED.rooms = [];
    window.DW_SEED.comments = [];
    window.DW_SEED.access = [];
    window.DW_SEED.activity = { tagged: [], replies: [], around: [] };
    window.DW_SEED.questionnaires = [];
    window.DW_SEED.questionnaireTemplates = [];
    window.DW_SEED.roomTemplates = [];
    window.DW_SEED.workspaceDomains = [];
    window.DW_SEED.notifications = [];
    window.DW_SEED.notificationPrefs = null;
    window.DW_SEED.costs = [];
    window.DW_SEED.llmRuns = [];
    window.DW_SEED.brand = defaultBrand();
    if (window.DWAdapters && window.DWAdapters.clearRoomSeed) window.DWAdapters.clearRoomSeed();
  }
  function clearBackendState(target) {
    resetBackendSeed();
    target.rooms = [];
    target.comments = [];
    target.access = [];
    target.activity = { tagged: [], replies: [], around: [] };
    target.members = [];
    target.joinRequests = [];
    target.workspaceDomains = [];
    target.questionnaires = [];
    target.questionnaireTemplates = [];
    target.brand = defaultBrand();
    target.notifications = [];
    target.notificationPrefs = window.DWAdapters.normalizeNotificationPrefs(null);
    target.costs = [];
    target.llmRuns = [];
    target.platformOverview = null;
    target.questionnaireSubmission = null;
    target.roomTracking = null;
    target.readerTracking = null;
    target.focusedQuestionnaire = null;
    target.selectedVersionId = null;
    target.backendLoaded = false;
  }

  function seedState() {
    return {
      clientEmail: null,           // signed-in reader (client gate)
      teamUser: null,              // signed-in team member (admin)
      readerSession: null,
      teamSession: window.DWApi ? window.DWApi.getSession() : null,
      apiError: null,
      apiErrorStatus: null,
      apiErrorPath: null,
      apiErrorMethod: null,
      rooms: [],
      comments: [],
      access: [],
      activity: { tagged: [], replies: [], around: [] },
      members: seedMembers(),
      teamWorkspaces: [],
      joinRequests: [],
      workspaceDomains: [],
      questionnaires: [],
      questionnaireTemplates: [],
      brand: clone(window.DW_SEED.brand || defaultBrand()),
      notifications: [],
      notificationPrefs: window.DWAdapters.normalizeNotificationPrefs(window.DW_SEED.notificationPrefs),
      costs: [],
      llmRuns: [],
      platformOverview: null,
      questionnaireSubmission: null,
      roomTracking: null,
      readerTracking: null,
      focusedQuestionnaire: null,
      selectedVersionId: null,
      readProgress: 0,
      backendLoaded: false,
    };
  }

  var state = seedState();
  try { localStorage.removeItem('dw-app-state-v1'); } catch (e) {}

  function emit() { subs.forEach(function (f) { f(); }); }
  function apiRoomId() {
    var id = window.DW_API_ROOM_ID || (window.DW_SEED.room && (window.DW_SEED.room.apiId || window.DW_SEED.room.id));
    if (!id) throw new Error('Room context is required.');
    return id;
  }
  function currentVersionId() {
    if (state && state.selectedVersionId) return state.selectedVersionId;
    var versions = window.DW_SEED.versions || (window.DW_SEED.room && window.DW_SEED.room.versions) || [];
    var version = versions.find(function (v) { return v.current || v.latest; }) || versions[0] || null;
    return version && version.id ? version.id : null;
  }
  function shortDate(value) {
    if (!value) return '—';
    return new Date(value).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  }
  function setApiError(error) {
    state.apiError = error ? (error.message || String(error)) : null;
    state.apiErrorStatus = error && error.status ? error.status : null;
    state.apiErrorPath = error && error.path ? error.path : null;
    state.apiErrorMethod = error && error.method ? error.method : null;
    emit();
  }
  function clearApiError() {
    state.apiError = null;
    state.apiErrorStatus = null;
    state.apiErrorPath = null;
    state.apiErrorMethod = null;
    emit();
  }
  function currentTeamEmail() { return state && state.teamSession && state.teamSession.email ? state.teamSession.email : ''; }
  function mapMembers(rows, meEmail) {
    return (rows || []).map(function (row) { return window.DWAdapters.mapMember(row, { meEmail: meEmail || currentTeamEmail() }); });
  }
  function seedMembers() {
    var people = window.DW_SEED.people || {};
    var me = window.DW_SEED.me;
    var rows = Object.keys(people).filter(function (email) { return people[email] && people[email].team; }).map(function (email) {
      return { email: email, name: people[email].name, role: people[email].role || (me && me.email === email ? me.role : 'viewer'), isMe: me && me.email === email };
    });
    return rows.length ? mapMembers(rows, me && me.email) : [];
  }

  window.DWStore = {
    get: function () { return state; },
    subscribe: function (fn) { subs.push(fn); return function () { subs = subs.filter(function (f) { return f !== fn; }); }; },
    apiRoomId: apiRoomId,
    clearApiError: clearApiError,
    clearSelectedVersion: function () {
      state.selectedVersionId = null;
      emit();
    },
    /* ---- sessions ---- */
    ...window.DWStoreSession.create({
      state: function () { return state; },
      replaceState: function (nextState) { state = nextState; },
      seedState: seedState,
      seedMembers: seedMembers,
      apiRoomId: apiRoomId,
      clone: clone,
      clearBackendState: clearBackendState,
      emit: emit,
      setApiError: setApiError
    }),

    /* ---- rooms + documents ---- */
    ...window.DWStoreRooms.create({
      state: function () { return state; },
      apiRoomId: apiRoomId,
      workspaceId: function () {
        var workspaceId = state.teamSession && state.teamSession.workspaceId ? state.teamSession.workspaceId : (window.DW_SEED.org && window.DW_SEED.org.id);
        if (!workspaceId) throw new Error('Workspace context is required.');
        return workspaceId;
      },
      clone: clone,
      emit: emit,
      setApiError: setApiError
    }),

    /* ---- people ---- */
    person: function (email) {
      var p = window.DW_SEED.people[email];
      if (p) return p;
      var nm = (email || '').split('@')[0].replace(/[._]/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
      return { name: nm || email, initials: (nm || 'NA').slice(0, 2).toUpperCase(), cls: '' };
    },

    /* ---- collaboration ---- */
    ...window.DWStoreCollaboration.create({
      state: function () { return state; },
      apiRoomId: apiRoomId,
      currentVersionId: currentVersionId,
      clone: clone,
      emit: emit,
      setApiError: setApiError
    }),

    currentVersionId: currentVersionId,
    /* ---- insights ---- */
    ...window.DWStoreInsights.create({
      state: function () { return state; },
      apiRoomId: apiRoomId,
      currentVersionId: currentVersionId,
      emit: emit,
      setApiError: setApiError
    }),

    ...window.DWStoreWorkspace.create({
      state: function () { return state; },
      clone: clone,
      emit: emit,
      setApiError: setApiError,
      mapMembers: mapMembers
    }),

    ...window.DWStoreQuestionnaires.create({
      state: function () { return state; },
      apiRoomId: apiRoomId,
      currentVersionId: currentVersionId,
      clone: clone,
      emit: emit,
      setApiError: setApiError
    }),

    ...window.DWStoreNotifications.create({
      state: function () { return state; },
      workspaceId: function () { return window.DWStore.workspaceId(); },
      clone: clone,
      emit: emit,
      setApiError: setApiError
    }),

    /* ---- reader ---- */
    ...window.DWStoreReader.create({
      state: function () { return state; },
      apiRoomId: apiRoomId,
      emit: emit,
      setApiError: setApiError
    }),
  };

  window.addEventListener('storage', function (event) {
    if (event.key !== 'dw-api-session-v1') return;
    state = seedState();
    clearBackendState(state);
    emit();
    if (event.newValue && window.DWStore && window.DWStore.restoreSession) {
      window.DWStore.restoreSession().catch(function (error) { setApiError(error); });
    }
  });

})();


/* ---- app/ui.jsx ---- */
/* ============================================================
   DEALWONDR APP — shared components (DS-bound, prop-driven)
   Every component renders design-system .dw-* classes only.
   Exposed on window for the screen modules.
   ============================================================ */
const { useState, useEffect, useRef } = React;

/* ---- Icon ---- */
function Icon({ name, size }) {
  const cls = size === 'sm' ? 'dw-icon--sm' : size === 'lg' ? 'dw-icon--lg' : size === 'xl' ? 'dw-icon--xl' : '';
  return <span className={'dw-icon ' + cls} dangerouslySetInnerHTML={{ __html: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">' + (window.DWIcons[name] || '') + '</svg>' }} />;
}

/* ---- Button — variant · size · icon · block · loading ---- */
function Btn({ variant, size, icon, iconRight, block, loading, disabled, onClick, children, title, type }) {
  const cls = ['dw-btn'];
  if (variant) cls.push('dw-btn--' + variant);
  if (size) cls.push('dw-btn--' + size);
  if (block) cls.push('dw-btn--block');
  if (loading) cls.push('dw-btn--loading');
  if (!children && (icon || iconRight)) cls.push('dw-btn--icon');
  return (
    <button type={type || 'button'} className={cls.join(' ')} disabled={disabled} onClick={onClick} title={title}>
      {icon ? <Icon name={icon} size="sm" /> : null}
      {children}
      {iconRight ? <Icon name={iconRight} size="sm" /> : null}
    </button>
  );
}

/* ---- Avatar ---- */
function Avatar({ email, size }) {
  const p = window.DWAdapters.person(email);
  const cls = ['dw-ava', p.cls, size === 'sm' ? 'dw-ava--sm' : size === 'lg' ? 'dw-ava--lg' : ''];
  return <span className={cls.filter(Boolean).join(' ')}>{p.initials}</span>;
}

/* ---- Badge ---- */
function Badge({ variant, children }) { return <span className={'dw-badge dw-badge--' + (variant || 'outline')}>{children}</span>; }

/* ---- Brand logo / lockup ---- */
function Logo({ reversed }) {
  return <span className={'dw-logo' + (reversed ? ' dw-logo--reversed' : '')} aria-label="dealwondr">dealw<i className="dw-logo__mark" aria-hidden="true"></i>ndr</span>;
}
function Lockup({ reversed }) {
  return (
    <span className={'dw-lockup' + (reversed ? ' dw-lockup--reversed' : '')}>
      <Logo reversed={reversed} /><span className="dw-lockup__by">by Intent Pop</span>
    </span>
  );
}

/* ---- Eyebrow / label ---- */
function Eyebrow({ children }) { return <span className="dw-eyebrow">{children}</span>; }
function Field({ label, optional, hint, error, children }) {
  return (
    <div className="dw-field">
      <div className="dw-field__row"><label className="dw-label">{label}</label>{optional ? <span className="dw-field__optional">Optional</span> : null}</div>
      {children}
      {hint && !error ? <div className="dw-hint">{hint}</div> : null}
      {error ? <div className="dw-error">{error}</div> : null}
    </div>
  );
}

/* ---- Toast host ---- */
function useToast() {
  const [msg, setMsg] = useState(null);
  const show = (m, ok) => { setMsg({ m, ok }); setTimeout(() => setMsg(null), 2600); };
  const node = msg ? (
    <div style={{ position: 'fixed', left: '50%', bottom: 26, transform: 'translateX(-50%)', zIndex: 600 }}>
      <div className={'dw-toast' + (msg.ok ? ' dw-toast--ok' : '')}>{msg.ok ? <i className="dw-burst dw-burst--pop" data-animate style={{ width: 15, height: 15, background: '#5FC98C' }}></i> : <Icon name="bell" size="sm" />}{msg.m}</div>
    </div>
  ) : null;
  return [show, node];
}

/* ---- Modal ---- */
/* ---- focus trap + restore for overlays ---- */
function useFocusTrap(open, onClose) {
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    const prev = document.activeElement;
    const root = ref.current;
    const sel = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
    const first = root && root.querySelector(sel);
    if (first) setTimeout(() => first.focus(), 30);
    const onKey = (e) => {
      if (e.key === 'Escape') { onClose && onClose(); return; }
      if (e.key !== 'Tab' || !root) return;
      const items = [...root.querySelectorAll(sel)].filter((el) => el.offsetParent !== null);
      if (!items.length) return;
      const a = items[0], z = items[items.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    };
    window.addEventListener('keydown', onKey);
    return () => { window.removeEventListener('keydown', onKey); if (prev && prev.focus) try { prev.focus(); } catch (e) {} };
  }, [open]);
  return ref;
}

/* ---- Modal ---- */
function Modal({ open, title, sub, onClose, footer, wide, children }) {
  const ref = useFocusTrap(open, onClose);
  if (!open) return null;
  return (
    <div className="dw-modal-scrim" style={{ position: 'fixed' }} onMouseDown={(e) => { if (e.target === e.currentTarget) onClose && onClose(); }}>
      <div ref={ref} className={'dw-modal' + (wide ? ' dw-modal--wide' : '')} role="dialog" aria-modal="true" aria-label={title}>
        <div className="dw-modal__head"><div><h3 className="dw-modal__title">{title}</h3>{sub ? <span className="dw-modal__sub">{sub}</span> : null}</div>
          <button className="dw-modal__x" onClick={onClose} aria-label="Close"><Icon name="x" size="sm" /></button></div>
        <div className="dw-modal__body">{children}</div>
        {footer ? <div className="dw-modal__foot">{footer}</div> : null}
      </div>
    </div>
  );
}

/* ---- Drawer (right context) ---- */
function Drawer({ open, title, sub, onClose, footer, children }) {
  const ref = useFocusTrap(open, onClose);
  if (!open) return null;
  return (
    <div className="dw-drawer-scrim" style={{ position: 'fixed' }} onMouseDown={(e) => { if (e.target === e.currentTarget) onClose && onClose(); }}>
      <div ref={ref} className="dw-drawer" role="dialog" aria-modal="true" aria-label={title}>
        <div className="dw-drawer__head"><div><h4 className="dw-drawer__title">{title}</h4>{sub ? <span className="dw-drawer__sub">{sub}</span> : null}</div>
          <button className="dw-drawer__x" onClick={onClose} aria-label="Close"><Icon name="x" size="sm" /></button></div>
        <div className="dw-drawer__body">{children}</div>
        {footer ? <div className="dw-drawer__foot">{footer}</div> : null}
      </div>
    </div>
  );
}

/* ---- Bottom sheet (mobile) ---- */
function Sheet({ open, title, onClose, footer, children, action }) {
  const ref = useFocusTrap(open, onClose);
  if (!open) return null;
  return (
    <div className="dw-sheet-scrim" style={{ position: 'fixed' }} onMouseDown={(e) => { if (e.target === e.currentTarget) onClose && onClose(); }}>
      <div ref={ref} className="dw-sheet" role="dialog" aria-modal="true">
        <div className="dw-sheet__grip"></div>
        {action ? <div className="dw-action-sheet">{children}</div> : (
          <React.Fragment>
            {title ? <div className="dw-sheet__head"><h4 className="dw-sheet__title">{title}</h4><button className="dw-sheet__x" onClick={onClose} aria-label="Close"><Icon name="x" size="sm" /></button></div> : null}
            <div className="dw-sheet__body">{children}</div>
            {footer ? <div className="dw-sheet__foot">{footer}</div> : null}
          </React.Fragment>
        )}
      </div>
    </div>
  );
}

/* ---- Section rule ---- */
function SectionRule({ children, hint }) {
  return <div className="dw-section-rule">{children}{hint ? <span style={{ textTransform: 'none', letterSpacing: '.02em', color: 'var(--dw-text-muted)' }}>· {hint}</span> : null}</div>;
}

/* ---- PageHead — reusable page heading: title · description/data slot · CTAs ----
   props: title, sub (description), data (React node placeholder for stats/meta),
   primary {label,onClick,icon}, secondary {label,onClick,icon}, tabs (React node),
   children (anything extra in the heading, e.g. a version chip)               */
function PageHead({ title, sub, data, primary, secondary, tabs, children }) {
  return (
    <div className="dw-main__head">
      <div className="dw-main__hrow">
        <div className="dw-main__titleblock">
          <h2 className="dw-main__title">{title}</h2>
          {sub ? <span className="dw-main__sub">{sub}</span> : null}
          {data ? <div className="dw-main__data">{data}</div> : null}
        </div>
        {children}
        {secondary ? <Btn variant="ghost" size="sm" icon={secondary.icon} onClick={secondary.onClick}>{secondary.label}</Btn> : null}
        {primary ? <Btn variant="pine" size="sm" icon={primary.icon} onClick={primary.onClick}>{primary.label}</Btn> : null}
      </div>
      {tabs ? <div className="dw-tabs dw-main__tabs">{tabs}</div> : null}
    </div>
  );
}
/* a compact inline data stat for the PageHead data slot */
function HeadStat({ k, v }) {
  return <span className="dw-headstat"><span className="dw-headstat__k">{k}</span><span className="dw-headstat__v">{v}</span></span>;
}

/* ---- responsive hook ---- */
function useIsMobile() {
  const [m, setM] = useState(window.innerWidth <= 768);
  useEffect(() => {
    let raf = 0;
    const fn = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => setM(window.innerWidth <= 768)); };
    window.addEventListener('resize', fn);
    return () => { cancelAnimationFrame(raf); window.removeEventListener('resize', fn); };
  }, []);
  return m;
}

/* ---- store subscription hook ---- */
function useStore() {
  const [, force] = useState(0);
  useEffect(() => window.DWStore.subscribe(() => force((n) => n + 1)), []);
  return window.DWStore;
}

Object.assign(window, { Icon, Btn, Avatar, Badge, Logo, Lockup, Eyebrow, Field, useToast, Modal, Drawer, Sheet, SectionRule, PageHead, HeadStat, useIsMobile, useStore });


/* ---- app/brand.jsx ---- */
/* ============================================================
   DEALWONDR APP — brand & motion components
   Rotating stamp, app footer, marquee, burst.
   ============================================================ */

/* Rotating stamp — circular mono text around the burst (gate showpiece) */
function Stamp({ text, size }) {
  const s = size || 110;
  const label = (text || '· DEALWONDR · PRIVATE ROOM · CONFIDENTIAL ').toUpperCase();
  return (
    <span className="dw-stamp" style={{ width: s, height: s, color: 'var(--dw-poppy-300)' }}>
      <svg viewBox="0 0 110 110">
        <defs><path id={'stamp-' + s} d="M55,55 m-39,0 a39,39 0 1,1 78,0 a39,39 0 1,1 -78,0" /></defs>
        <text><textPath href={'#stamp-' + s} startOffset="0">{label}</textPath></text>
      </svg>
      <i className="dw-burst"></i>
    </span>
  );
}

/* Burst that pops when it enters (key moments) */
function Burst({ size, animate }) {
  const ref = useRef(null);
  useEffect(() => { if (animate && ref.current) { ref.current.setAttribute('data-animate', ''); } }, [animate]);
  return <i ref={ref} className="dw-burst dw-burst--pop" style={{ width: size || 18, height: size || 18 }}></i>;
}

/* App footer — dealwondr · by Intent Pop, marks on either side */
function AppFooter({ reversed, onPoweredBy }) {
  return (
    <div className={'dw-appfoot' + (reversed ? ' dw-appfoot--reversed' : '')}>
      <Logo reversed={reversed} />
      <span className="dw-appfoot__line"></span>
      {onPoweredBy
        ? <button className="dw-action" style={{ textTransform: 'none', letterSpacing: 0 }} onClick={onPoweredBy}>Powered by <em style={{ fontFamily: 'var(--dw-font-serif)', fontStyle: 'italic' }}>Dealwondr</em> · what’s this?</button>
        : <span className="dw-appfoot__text">Dealwondr · by Intent Pop</span>}
      <span className="dw-appfoot__line"></span>
      <span className="dw-appfoot__text">Confidential</span>
    </div>
  );
}

/* Marquee ticker */
function Marquee({ phrases }) {
  const items = phrases || ['Highlight to ask', 'answer in context', 'a private room'];
  const run = (k) => (
    <div className="dw-marquee__track" key={k}>
      {items.map((p, i) => <React.Fragment key={i}><span>{p}</span><i className="dw-burst"></i></React.Fragment>)}
    </div>
  );
  return <div className="dw-marquee">{run(0)}{run(1)}</div>;
}

Object.assign(window, { Stamp, Burst, AppFooter, Marquee });


/* ---- app/ux.jsx ---- */
/* ============================================================
   DEALWONDR APP — P1 UX components
   Skeleton loaders · first-open trust banner · highlight-to-ask
   margin cue · version-diff "what changed" popover.
   Token-driven, design-system classes only.
   ============================================================ */

const { dwOrgName, dwRoomTitle, dwClientName, dwPreparedForLabel, dwRoomShortTitle, dwCurrentVersion, dwVersionId, dwVersionLabel, dwVersionSummary, dwWorkspaceEmailExample, dwClientEmailExample, dwReaderVersionId, dwEnableReaderReset } = window;

/* ---- Skeleton list (loading state for comment / activity panels) ---- */
function SkeletonList({ rows }) {
  const n = rows || 3;
  return (
    <div style={{ padding: 'var(--dw-space-4)' }}>
      {Array.from({ length: n }).map((_, i) => (
        <div key={i} style={{ display: 'flex', gap: 'var(--dw-space-3)', padding: 'var(--dw-space-3) 0' }}>
          <div className="dw-skeleton" style={{ width: 24, height: 24, borderRadius: '50%', flex: 'none' }}></div>
          <div style={{ flex: 1 }}>
            <div className="dw-skeleton" style={{ height: 10, width: '52%', marginBottom: 8 }}></div>
            <div className="dw-skeleton" style={{ height: 10, width: '90%', marginBottom: 6 }}></div>
            <div className="dw-skeleton" style={{ height: 10, width: '70%' }}></div>
          </div>
        </div>
      ))}
    </div>
  );
}

/* ---- a one-shot loading gate: shows skeleton briefly, then children ---- */
function useBriefLoad(ms) {
  const [loading, setLoading] = useState(true);
  useEffect(() => { const t = setTimeout(() => setLoading(false), ms || 550); return () => clearTimeout(t); }, []);
  return loading;
}

/* ---- First-open trust banner (reciprocal visibility) — one-time ---- */
function TrustBanner({ onDetails, onDismiss }) {
  return (
    <div style={{ display: 'flex', gap: 'var(--dw-space-3)', alignItems: 'flex-start', padding: 'var(--dw-space-4) var(--dw-space-5)', background: 'var(--dw-pine-tint)', borderBottom: '1px solid var(--dw-border-default)', borderLeft: '3px solid var(--dw-pine-500)' }}>
      <span style={{ color: 'var(--dw-pine-500)', flex: 'none', marginTop: 1 }}><Icon name="shield" size="sm" /></span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div className="dw-body-sm" style={{ fontWeight: 600, color: 'var(--dw-pine-500)' }}>This is a private, two-way room</div>
        <div className="dw-body-sm dw-secondary" style={{ marginTop: 2, lineHeight: 1.5 }}>{dwOrgName()} can see which sections you open and the questions you ask — and you can see everything they’ve shared and answered. Nothing is sold or shared outside this room.</div>
        <div className="dw-cluster-2" style={{ marginTop: 'var(--dw-space-2)' }}>
          <button className="dw-jump" onClick={onDetails}>See exactly what’s shared →</button>
        </div>
      </div>
      <button className="dw-action dw-fixed" onClick={onDismiss} aria-label="Dismiss" style={{ marginTop: 1 }}><Icon name="x" size="sm" /></button>
    </div>
  );
}

/* ---- Highlight-to-ask margin cue — first session only ---- */
function HighlightCue({ onDismiss }) {
  return (
    <div className="dw-hl-cue" role="note">
      <span className="dw-hl-cue__dot"></span>
      <span className="dw-hl-cue__bubble">
        <b>Highlight any sentence</b> to ask a question — we’ll answer right here.
        <button className="dw-action dw-mt-2" style={{ display: 'block' }} onClick={onDismiss}>Got it</button>
      </span>
    </div>
  );
}

/* ---- Version-diff "what changed" popover ---- */
function VersionDiff({ from, to, onClose }) {
  const list = ['Updated proposal content', 'Preserved existing comments on their original version', 'Kept the room link unchanged'];
  return (
    <div className="dw-pop dw-pop--version" onClick={(e) => e.stopPropagation()}>
      <div className="dw-pop__title">What changed in {to}</div>
      <div className="dw-mono-xs dw-muted" style={{ marginBottom: 'var(--dw-space-2)' }}>{from} → {to} · you’re now reading the latest</div>
      <ul className="dw-note__list" style={{ marginBottom: 'var(--dw-space-3)' }}>{list.map((d, i) => <li key={i}>{d}</li>)}</ul>
      <div className="dw-cluster-2" style={{ justifyContent: 'space-between' }}>
        <span className="dw-mono-xs dw-muted">Comments stay pinned to their version</span>
        <button className="dw-jump" onClick={onClose}>Dismiss</button>
      </div>
    </div>
  );
}

/* ---- Theme (light / dark) — applies data-theme to <html>, persists ---- */
function dwGetTheme() { try { return localStorage.getItem('dw-theme') || 'light'; } catch (e) { return 'light'; } }
function dwApplyTheme(t) { document.documentElement.setAttribute('data-theme', t); try { localStorage.setItem('dw-theme', t); } catch (e) {} }
function useTheme() {
  const [theme, setTheme] = useState(dwGetTheme());
  useEffect(() => { dwApplyTheme(theme); }, [theme]);
  return [theme, (t) => setTheme(t), () => setTheme(theme === 'dark' ? 'light' : 'dark')];
}
/* apply persisted theme immediately on load */
dwApplyTheme(dwGetTheme());

Object.assign(window, { SkeletonList, useBriefLoad, TrustBanner, HighlightCue, VersionDiff, dwGetTheme, dwApplyTheme, useTheme, dwOrgName, dwRoomTitle, dwClientName, dwPreparedForLabel, dwRoomShortTitle, dwCurrentVersion, dwVersionId, dwVersionLabel, dwVersionSummary, dwWorkspaceEmailExample, dwClientEmailExample, dwReaderVersionId, dwEnableReaderReset });


/* ---- app/not-found.jsx ---- */
/* ============================================================
   DEALWONDR APP — route/API not found state
   Design-system only 404 surface for unknown routes and missing
   API-backed rooms.
   ============================================================ */

function NotFoundPage({ kind, detail, onPrimary, primaryLabel, onSecondary, secondaryLabel }) {
  const isMobile = useIsMobile();
  const roomCopy = kind === 'room';
  return (
    <div className="dw-app">
      <div className="dw-gate" style={{ flexDirection: isMobile ? 'column' : 'row', height: '100%' }}>
        <div className="dw-gate__brand" style={{ position: 'relative', flex: isMobile ? 'none' : '1.05', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: 30, right: 26 }}><Stamp text="· DEALWONDR · PAGE NOT FOUND · " size={isMobile ? 76 : 104} /></div>
          <Lockup reversed />
          <h1 className="dw-gate__h1" style={isMobile ? { paddingRight: 88, margin: '24px 0 16px' } : null}>{roomCopy ? 'This room link is not available.' : 'We could not open this page.'}</h1>
          <p className="dw-gate__sub">{roomCopy ? 'The room may have been removed, unpublished, or shared with a different link.' : 'The address may be mistyped, out of date, or no longer part of this workspace.'}</p>
          <div style={{ marginTop: 'auto', paddingTop: 28, display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ fontFamily: 'var(--dw-font-mono)', fontSize: 'var(--dw-text-2xs)', letterSpacing: '0.12em', textTransform: 'uppercase', color: 'color-mix(in srgb, var(--dw-cream-100) 60%, transparent)' }}>404 · nothing to open</span>
            <span style={{ flex: 1, height: 1, background: 'color-mix(in srgb, var(--dw-cream-100) 16%, transparent)' }}></span>
            <i className="dw-burst" style={{ width: 18, height: 18, background: 'var(--dw-poppy-300)' }}></i>
          </div>
        </div>
        <div className="dw-gate__entry" style={{ flex: isMobile ? 'none' : '1', overflowY: 'auto' }}>
          <div style={{ width: '100%', maxWidth: 440, margin: '0 auto' }}>
            <Eyebrow>{roomCopy ? 'Room unavailable' : 'Page not found'}</Eyebrow>
            <div className="dw-mono-xs dw-muted dw-mt-2">ERROR 404</div>
            <h2 className="dw-h1" style={{ marginTop: 10 }}>{roomCopy ? 'We could not find a room for this link.' : 'This address does not match a Dealwondr page.'}</h2>
            <p className="dw-body-sm dw-secondary dw-mt-2">{detail || (roomCopy ? 'Check the link with the person who shared it. If you are part of the team, sign in and open the room from your workspace.' : 'Check the address, or return to the Dealwondr home screen and continue from there.')}</p>
            <div className="dw-card dw-card--sunken dw-mt-4">
              <div className="dw-cluster-2" style={{ color: 'var(--dw-accent-text)' }}><Icon name="sparkle" size="sm" /><span className="dw-body-sm">{roomCopy ? 'Ask for a fresh room link, or sign in to open rooms available to your workspace.' : 'Use the home screen or dashboard to get back to a known workspace page.'}</span></div>
            </div>
            <div className="dw-cluster-2 dw-mt-4">
              <Btn variant="accent" size="lg" iconRight="arrowright" onClick={onPrimary}>{primaryLabel || 'Go to sign in'}</Btn>
              {onSecondary ? <Btn variant="ghost" size="lg" onClick={onSecondary}>{secondaryLabel || 'Open dashboard'}</Btn> : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

Object.assign(window, { NotFoundPage });


/* ---- app/gate.jsx ---- */
/* ============================================================
   DEALWONDR APP — client gate
   The signed-out entry: pine brand panel + cream entry form.
   ============================================================ */

function ClientGate({ onEnter, onAdmin }) {
  const [email, setEmail] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(null);
  const submit = async () => {
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.trim())) { setErr('That doesn’t look like a full email — add the domain.'); return; }
    setBusy(true);
    try {
      const result = await window.DWStore.signInClient(email);
      if (result && result.sessionToken) onEnter();
      else setSent({ email: (result && result.email) || email.trim().toLowerCase(), expiresAt: result && result.expiresAt, emailQueued: result && result.emailQueued });
    } catch (error) {
      setErr(error.message || 'This email could not open the room.');
    } finally {
      setBusy(false);
    }
  };
  const isMobile = useIsMobile();
  const orgName = window.DWDisplay.orgName();
  const preparedFor = window.DWDisplay.preparedForLabel();
  const roomTitle = window.DWDisplay.roomTitle();
  const exampleEmail = window.DWDisplay.clientEmailExample();
  const divider = <hr style={{ border: 'none', borderTop: '1px solid var(--dw-border-default)', margin: '20px 0' }} />;
  return (
    <div className="dw-app">
      <div className="dw-gate" style={{ flexDirection: isMobile ? 'column' : 'row', height: '100%' }}>
        {/* LEFT — pine brand panel */}
        <div className="dw-gate__brand" style={{ position: 'relative', flex: isMobile ? 'none' : '1.1', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: 32, right: 28 }}><Stamp size={isMobile ? 80 : 104} /></div>
          <Lockup reversed />
          <h1 className="dw-gate__h1" style={isMobile ? { paddingRight: 90, margin: '24px 0 16px' } : null}>A proposal with a place to <span className="dw-mark" style={{ whiteSpace: 'nowrap' }}>talk back.</span></h1>
          <p className="dw-gate__sub">This is a private room. Inside: an active, interactive proposal prepared for you — highlight any sentence to ask a question, and we’ll answer right where you asked it.</p>
          <details className="dw-disclosure" style={{ marginTop: 22, background: 'color-mix(in srgb, var(--dw-cream-100) 7%, transparent)', borderColor: 'color-mix(in srgb, var(--dw-cream-100) 18%, transparent)', maxWidth: 380 }}>
            <summary className="dw-disclosure__head" style={{ color: 'var(--dw-cream-100)' }}><Icon name="shield" size="sm" /> A private room — here’s the deal on your privacy <span style={{ marginLeft: 'auto' }}><Icon name="chevdown" size="sm" /></span></summary>
            <div className="dw-disclosure__body" style={{ color: 'color-mix(in srgb, var(--dw-cream-100) 70%, transparent)' }}>Only people on the invite list can open this room. Your highlights and questions are visible to the sender so they can answer in context — and you can see what they’ve shared with you, too.</div>
          </details>
          <div style={{ marginTop: 'auto', paddingTop: 28, display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ fontFamily: 'var(--dw-font-mono)', fontSize: 'var(--dw-text-2xs)', letterSpacing: '0.12em', textTransform: 'uppercase', color: 'color-mix(in srgb, var(--dw-cream-100) 60%, transparent)' }}>{orgName}</span>
            <span style={{ flex: 1, height: 1, background: 'color-mix(in srgb, var(--dw-cream-100) 16%, transparent)' }}></span>
            <button className="dw-action" style={{ color: 'var(--dw-poppy-300)', textTransform: 'uppercase', fontSize: 'var(--dw-text-2xs)', letterSpacing: '0.12em' }} onClick={onAdmin}>Admin console →</button>
          </div>
        </div>
        {/* RIGHT — cream entry panel, vertically centered */}
        <div className="dw-gate__entry" style={{ flex: isMobile ? 'none' : '1', overflowY: 'auto' }}>
          <div style={{ width: '100%', maxWidth: 380, margin: '0 auto' }}>
            <Eyebrow>{preparedFor}</Eyebrow>
            <h2 className="dw-h1" style={{ marginTop: 10 }}>{roomTitle}</h2>
            <div className="dw-body-sm dw-secondary" style={{ marginTop: 8 }}>{orgName} shared this private room with invited readers.</div>
            {divider}
            <div className="dw-cluster-2" style={{ color: 'var(--dw-accent-text)' }}><Icon name="sparkle" size="sm" /><span className="dw-body-sm">Includes a short questionnaire before your call.</span></div>
            {divider}
            <label className="dw-label">Your work email</label>
            <input className={'dw-input' + (err ? ' is-error' : '')} style={{ marginTop: 7 }} placeholder={exampleEmail} value={email}
              onChange={(e) => { setEmail(e.target.value); setErr(''); setSent(null); }} onKeyDown={(e) => e.key === 'Enter' && submit()} />
            {err ? <div className="dw-error">{err}</div> : null}
            {sent ? (
              <div className="dw-callout dw-mt-4">
                <div className="dw-callout__title"><Icon name="mail" size="sm" /> Check your inbox</div>
                <div className="dw-body-sm dw-secondary">We sent a one-time room link to <b>{sent.email}</b>. It expires shortly and opens this private reading room.</div>
              </div>
            ) : null}
            <div style={{ marginTop: 14 }}><Btn variant="accent" size="lg" block iconRight="arrowright" loading={busy} disabled={busy || !!err} onClick={submit}>{sent ? 'Send link again' : 'Email me the room link'}</Btn></div>
            <div className="dw-hint" style={{ marginTop: 14 }}>If your email is on the invite list, we’ll send a one-time magic link — no password, no account.</div>
          </div>
        </div>
      </div>
    </div>
  );
}

Object.assign(window, { ClientGate });


/* ---- app/comment.jsx ---- */
/* ============================================================
   DEALWONDR APP — comment card + composer
   The two reusable conversation pieces shared by the reader
   panel and the admin comments desk.
   ============================================================ */

/* ---------- Comment card ---------- */
function CommentCard({ c, active, onJump, onResolve, onReply }) {
  const [replying, setReplying] = useState(false);
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  const p = window.DWAdapters.commentPerson(c.author);
  const orgName = window.DWDisplay.orgName();
  const renderBody = (b) => b.split(/(@[\w.]+)/g).map((t, i) => t[0] === '@' ? <span key={i} className="dw-mention">{t}</span> : t);
  return (
    <div className={'dw-comment' + (active ? ' is-active' : '')}>
      <div className="dw-comment__head" style={{ flexWrap: 'nowrap' }}>
        <Avatar email={c.author} size="sm" />
        <span className="dw-comment__who" style={{ whiteSpace: 'nowrap', flex: 'none' }}>{p.name}{p.team ? <span className="dw-orgbadge">{orgName}</span> : null}</span>
        <span className="dw-comment__when" style={{ flex: 'none' }}>{c.created}</span>
        <span className="dw-grow"></span>
        <span style={{ flex: 'none', whiteSpace: 'nowrap' }}>{c.resolved ? <Badge variant="resolved">Resolved</Badge> : (c.needsReply ? <Badge variant="accent">Needs reply</Badge> : null)}</span>
      </div>
      <blockquote className="dw-comment__quote">{c.quote}</blockquote>
      <p className="dw-comment__body">{renderBody(c.body)}</p>
      <div className="dw-comment__foot">
        <a className="dw-jump" onClick={() => onJump && onJump(c)}>→ {c.section}</a>
        <button className="dw-action" onClick={() => setReplying(!replying)}>Reply</button>
        <button className="dw-action" disabled={busy} onClick={async () => { setBusy(true); try { await onResolve(c, !c.resolved); } finally { setBusy(false); } }}>{c.resolved ? 'Reopen' : 'Resolve'}</button>
      </div>
      {c.replies.map((r, i) => {
        const rp = window.DWAdapters.commentPerson(r.author);
        return (
          <div className="dw-reply" key={i}>
            <div className="dw-comment__head"><Avatar email={r.author} size="sm" /><span className="dw-comment__who">{rp.name}{rp.team ? <span className="dw-orgbadge">{orgName}</span> : null}</span><span className="dw-comment__when">{r.created}</span></div>
            <p className="dw-comment__body" style={{ margin: 0 }}>{renderBody(r.body)}</p>
          </div>
        );
      })}
      {replying ? (
        <div style={{ marginTop: 9 }}>
          <textarea className="dw-textarea" style={{ minHeight: 52 }} autoFocus value={text} onChange={(e) => setText(e.target.value)} placeholder="Reply… (@ to tag)" />
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 6 }}>
            <Btn variant="ghost" size="sm" onClick={() => setReplying(false)}>Cancel</Btn>
            <Btn variant="pine" size="sm" disabled={!text.trim() || busy} loading={busy} onClick={async () => { setBusy(true); try { await onReply(c, text); setText(''); setReplying(false); } finally { setBusy(false); } }}>Reply</Btn>
          </div>
        </div>
      ) : null}
    </div>
  );
}

/* ---------- Composer (shared by bubble + sheet) ---------- */
function Composer({ quote, onPost, onCancel, autoFocus }) {
  const [text, setText] = useState('');
  const [needsReply, setNeedsReply] = useState(true);
  const [busy, setBusy] = useState(false);
  const [ac, setAc] = useState(null);   // {query} when typing @
  const people = window.DWAdapters.commentMentionables();
  const matches = ac ? people.filter((e) => { const p = window.DWAdapters.commentPerson(e); return p.name.toLowerCase().includes(ac.query) || e.includes(ac.query); }) : [];
  function onChange(e) {
    const v = e.target.value; setText(v);
    const m = v.slice(0, e.target.selectionStart).match(/@([\w.]*)$/);
    setAc(m ? { query: m[1].toLowerCase() } : null);
  }
  function pick(email) { const p = window.DWAdapters.commentPerson(email); setText(text.replace(/@([\w.]*)$/, '@' + p.name.replace(/\s/g, '') + ' ')); setAc(null); }
  return (
    <React.Fragment>
      <blockquote className="dw-bubble__quote">{quote.length > 110 ? quote.slice(0, 110) + '…' : quote}</blockquote>
      <div className="dw-composer-box" style={{ position: 'relative' }}>
        <textarea autoFocus={autoFocus} value={text} onChange={onChange} placeholder="Leave a comment…" />
        <div className="dw-composer-box__bar">
          <label className="dw-choice"><input type="checkbox" className="dw-check" checked={needsReply} onChange={() => setNeedsReply(!needsReply)} /> I’d like a reply</label>
        </div>
        {ac && matches.length ? (
          <div className="dw-menu" style={{ position: 'absolute', left: 10, top: '100%', marginTop: -4, zIndex: 10, width: 250 }}>
            {matches.slice(0, 4).map((e, i) => { const p = window.DWAdapters.commentPerson(e); return (
              <div key={e} className={'dw-menu__opt' + (i === 0 ? ' is-on' : '')} onMouseDown={(ev) => { ev.preventDefault(); pick(e); }}>
                <Avatar email={e} size="sm" /> {p.name}{p.team ? <span className="dw-orgbadge">{window.DWDisplay.orgName()}</span> : null}<span className="em">{e}</span>
              </div>
            ); })}
            <div className="dw-menu__foot">Only people invited to this proposal can be tagged.</div>
          </div>
        ) : null}
      </div>
      <p className="dw-hint" style={{ fontSize: 'var(--dw-text-2xs)' }}><b style={{ color: 'var(--dw-accent-text)' }}>@</b> mention to tag anyone invited · visible to everyone invited to this proposal</p>
      <div className="dw-bubble__foot" style={{ justifyContent: 'flex-end' }}>
        <button className="dw-action" onClick={onCancel}>Cancel</button>
        <Btn variant="pine" size="sm" disabled={!text.trim() || busy} loading={busy} onClick={async () => { setBusy(true); try { await onPost(text, needsReply); } finally { setBusy(false); } }}>Post comment</Btn>
      </div>
    </React.Fragment>
  );
}

Object.assign(window, { CommentCard, Composer });


/* ---- app/reader-doc.jsx ---- */
/* ============================================================
   DEALWONDR APP — reader document area
   Multi-document tabs + progressive load (next doc unlocks at the
   end of the previous, behind a separator) + post-reading
   questionnaire + focus mode. Keeps Reader lean.
   ============================================================ */

function getDocSections(d) { return window.DWAdapters.readerDocSections(d); }

function DocSeparator({ eyebrow, title, onContinue, cta }) {
  return (
    <div className="dw-doc-sep">
      <div className="dw-divider"><i className="dw-burst"></i><i className="dw-burst"></i><i className="dw-burst"></i></div>
      <div className="dw-doc-sep__eyebrow">{eyebrow}</div>
      <div className="dw-doc-sep__title">{title}</div>
      {onContinue ? <Btn variant="pine" size="sm" iconRight="arrowright" onClick={onContinue}>{cta}</Btn> : null}
    </div>
  );
}

function HtmlDocumentFrame({ section, title, replayTracker, onHtmlDocumentSelect, onHtmlDocumentClearSelection }) {
  const store = useStore();
  const path = section && section.htmlDocumentPath;
  const frameRef = useRef(null);
  const [srcDoc, setSrcDoc] = useState(section && section.htmlDocument ? section.htmlDocument : '');
  const [status, setStatus] = useState(section && section.htmlDocument ? 'ready' : 'loading');
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    if (!path || srcDoc) return undefined;
    setStatus('loading');
    setError('');
    store.documentFrameHtml(path.roomId, path.documentId, path.versionId).then((html) => {
      if (cancelled) return;
      setSrcDoc(html);
      setStatus('ready');
    }).catch((err) => {
      if (cancelled) return;
      setError(err.message || 'HTML document is unavailable.');
      setStatus('error');
    });
    return () => { cancelled = true; };
  }, [path && path.roomId, path && path.documentId, path && path.versionId]);

  useEffect(() => {
    if (!path) return undefined;
    const onMessage = (event) => {
      const data = event.data || {};
      if (!data || data.source !== 'dealwondr-html-document' || data.documentId !== path.documentId || data.versionId !== path.versionId) return;
      const payload = Object.assign({}, data.payload || {}, {
        documentId: path.documentId,
        versionId: path.versionId,
        path: data.path || ''
      });
      const internalId = payload.internalSectionId ? String(payload.internalSectionId).slice(0, 72) : '';
      const sectionId = internalId ? (section.id + ':' + internalId).slice(0, 128) : section.id;
      const internalLabel = payload.internalLabel ? String(payload.internalLabel).slice(0, 120) : '';
      if (data.type === 'html_document_selection' && onHtmlDocumentSelect) {
        const frameRect = frameRef.current ? frameRef.current.getBoundingClientRect() : { left: 0, top: 0 };
        const rect = payload.rect || {};
        onHtmlDocumentSelect({
          quote: String(payload.quote || '').trim(),
          sectionId: sectionId,
          section: internalLabel ? ((section.label || title || 'HTML document') + ' · ' + internalLabel).slice(0, 160) : (section.label || title || 'HTML document')
        }, {
          clientX: frameRect.left + Number(rect.left || 0),
          clientY: frameRect.top + Number(rect.top || 0)
        });
      }
      if (data.type === 'html_document_click' && onHtmlDocumentClearSelection && !payload.selectedText) onHtmlDocumentClearSelection();
      if (replayTracker && replayTracker.current) {
        replayTracker.current.track(data.type || 'html_document_click', {
          sectionId: sectionId,
          label: internalLabel ? ((section.label || title || 'HTML document') + ' · ' + internalLabel).slice(0, 160) : ((data.payload && data.payload.label) || data.title || section.label || title || 'HTML document'),
          payload: payload
        });
      }
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [path && path.documentId, path && path.versionId, replayTracker, section && section.id, section && section.label, title, onHtmlDocumentSelect, onHtmlDocumentClearSelection]);

  if (status === 'error') {
    return <div className="dw-empty"><Icon name="file" size="xl" /><div className="dw-empty__title">Document unavailable</div><div className="dw-empty__body">{error}</div></div>;
  }
  if (status === 'loading') {
    return <div className="dw-empty"><span className="dw-spinner"></span><div className="dw-empty__title">Loading document</div></div>;
  }
  return <iframe ref={frameRef} className="dw-html-doc-frame" title={section.label || title} sandbox="allow-scripts allow-forms allow-popups allow-downloads" srcDoc={srcDoc} />;
}

function PrototypeDocument({ doc, roomId, replayTracker, previewMode, onPrototypeComment }) {
  const store = useStore();
  const prototype = doc && doc.prototype;
  const [srcDoc, setSrcDoc] = useState('');
  const [status, setStatus] = useState(prototype && prototype.kind === 'uploaded_html' ? 'loading' : 'ready');
  const [error, setError] = useState('');
  const [full, setFull] = useState(false);
  const [commentOpen, setCommentOpen] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!prototype || prototype.kind !== 'uploaded_html') return undefined;
    setStatus('loading');
    setError('');
    store.prototypeFrameHtml(roomId, prototype.id).then((html) => {
      if (cancelled) return;
      setSrcDoc(html);
      setStatus('ready');
    }).catch((err) => {
      if (cancelled) return;
      setError(err.message || 'Prototype HTML is unavailable.');
      setStatus('error');
    });
    return () => { cancelled = true; };
  }, [roomId, prototype && prototype.id]);

  useEffect(() => {
    if (!prototype || prototype.kind !== 'uploaded_html') return undefined;
    const onMessage = (event) => {
      const data = event.data || {};
      if (!data || data.source !== 'dealwondr-prototype' || data.prototypeId !== prototype.id) return;
      const payload = Object.assign({}, data.payload || {}, { prototypeId: prototype.id, path: data.path || '' });
      if (replayTracker && replayTracker.current) {
        replayTracker.current.track(data.type || 'prototype_click', {
          label: (payload.label || data.title || prototype.title || doc.title || 'Prototype').slice(0, 160),
          payload: payload
        });
      }
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [prototype && prototype.id, replayTracker]);

  useEffect(() => {
    if (!full) return undefined;
    const onKey = (event) => {
      if (event.key === 'Escape') setFull(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [full]);

  if (!prototype) return null;
  const external = prototype.kind === 'external_url';
  const src = external ? prototype.sourceUrl : undefined;
  const sandbox = external
    ? 'allow-scripts allow-forms allow-popups allow-downloads allow-same-origin'
    : 'allow-scripts allow-forms allow-popups allow-downloads';
  const track = (type, payload) => {
    if (replayTracker && replayTracker.current) {
      replayTracker.current.track(type, { label: prototype.title || doc.title || 'Prototype', payload: Object.assign({ prototypeId: prototype.id }, payload || {}) });
    }
  };
  const anchor = {
    sectionId: 'prototype:' + prototype.id,
    section: 'Prototype · ' + (prototype.title || doc.title || 'Untitled'),
    quote: (prototype.title || doc.title || 'Prototype') + ' screen'
  };
  const toggleFull = () => {
    const next = !full;
    setFull(next);
    track('prototype_fullscreen', { state: next ? 'entered' : 'exited', kind: prototype.kind });
  };
  const postPrototypeComment = async (text, needsReply) => {
    await onPrototypeComment(anchor, text, needsReply, prototype);
    setCommentOpen(false);
  };

  return (
    <div className={'dw-prototype' + (full ? ' is-fullscreen' : '')} data-prototype={prototype.id} data-doc={doc.id} data-sec={anchor.sectionId} data-seclabel={anchor.section}>
      <div className="dw-row" style={{ alignItems: 'center', gap: 12 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <Eyebrow>{external ? 'Linked prototype' : 'Hosted prototype'}</Eyebrow>
          <h2 className="dw-h3" style={{ margin: '4px 0 0' }}>{prototype.title || doc.title}</h2>
        </div>
        <div className="dw-prototype__actions">
          <Btn variant="ghost" size="sm" icon="comment" onClick={() => { setCommentOpen(true); track('prototype_click', { control: 'comment' }); }}>Comment</Btn>
          <Btn variant="ghost" size="sm" icon="eye" onClick={toggleFull}>{full ? 'Exit full screen' : 'Full screen'}</Btn>
          {external ? <a className="dw-action" href={prototype.sourceUrl} target="_blank" rel="noreferrer" onClick={() => track('prototype_click', { control: 'open-original', href: prototype.sourceUrl })}>Open original ↗</a> : null}
        </div>
      </div>
      {external ? (
        <p className="dw-body-sm dw-secondary" style={{ margin: 0 }}>This link opens in an isolated frame. Dealwondr records frame open/load/focus; internal clicks are only available for uploaded HTML prototypes hosted here.</p>
      ) : (
        <p className="dw-body-sm dw-secondary" style={{ margin: 0 }}>This uploaded prototype is hosted in an isolated frame. Clicks, screen changes, scroll, and visibility events are recorded for replay.</p>
      )}
      <div className="dw-prototype__frame">
        {status === 'error' ? <div className="dw-empty"><Icon name="file" size="xl" /><div className="dw-empty__title">Prototype unavailable</div><div className="dw-empty__body">{error}</div></div> : null}
        {status === 'loading' ? <div className="dw-empty"><span className="dw-spinner"></span><div className="dw-empty__title">Loading prototype</div></div> : null}
        {status === 'ready' ? (
          <iframe
            title={prototype.title || doc.title}
            src={src}
            srcDoc={external ? undefined : srcDoc}
            sandbox={sandbox}
            referrerPolicy="no-referrer"
            onLoad={() => track(external ? 'prototype_load' : 'prototype_screen_view', { kind: prototype.kind })}
            onFocus={() => track('prototype_focus', { kind: prototype.kind })}
          />
        ) : null}
      </div>
      {commentOpen ? (
        <div className="dw-prototype__composer">
          <Composer quote={anchor.quote} autoFocus onPost={postPrototypeComment} onCancel={() => setCommentOpen(false)} />
          {previewMode ? <p className="dw-hint" style={{ marginTop: 8 }}>Preview comments are disabled because preview mode is untracked.</p> : null}
        </div>
      ) : null}
    </div>
  );
}

function ReaderDoc({ docRef, renderPara, cue, coach, isMobile, dismissCue, focus, onExitFocus,
                     unlocked, setUnlocked, docs, activeDoc, postQuestionnaire, postDone, onStartPostQ, roomId, replayTracker, previewMode, onPrototypeComment, onHtmlDocumentSelect, onHtmlDocumentClearSelection }) {
  const sentinel = useRef(null);
  const rows = docs || [];
  const visibleRows = previewMode ? rows : rows.slice(0, unlocked);

  // reveal the next doc / questionnaire when the reader reaches the end
  useEffect(() => {
    if (previewMode) return undefined;
    const root = docRef.current; const mark = sentinel.current;
    if (!root || !mark) return;
    const io = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && root.scrollTop > 24 && unlocked < rows.length) setUnlocked((n) => Math.min(rows.length, n + 1));
    }, { root, threshold: 0.6 });
    io.observe(mark);
    return () => io.disconnect();
  }, [previewMode, unlocked, rows.length]);

  const allDocsRead = previewMode || unlocked >= rows.length;
  const hasPrototypeDoc = rows.some((doc) => doc && doc.renderMode === 'prototype');
  const hasWideDoc = hasPrototypeDoc || rows.some((doc) => doc && getDocSections(doc).some((sec) => sec.htmlDocument || sec.htmlDocumentPath));

  return (
    <div className={'dw-reader-doc' + (hasWideDoc ? ' dw-reader-doc--wide' : '') + (hasPrototypeDoc ? ' dw-reader-doc--prototype' : '') + (focus ? ' is-focus' : '')} style={{ position: 'relative' }}>
      <div className={'dw-docpage' + (hasWideDoc ? ' dw-docpage--wide' : '') + (hasPrototypeDoc ? ' dw-docpage--prototype' : '')}>
        <Eyebrow>{window.DWDisplay.preparedForLabel()}</Eyebrow>
        {visibleRows.map((d, di) => (
          <div key={d.id} data-doc={d.id}>
            {di > 0 ? <DocSeparator eyebrow={'Document ' + (di + 1) + ' of ' + rows.length} title={d.title} /> : null}
            {d.renderMode === 'prototype' ? <PrototypeDocument doc={d} roomId={roomId} replayTracker={replayTracker} previewMode={previewMode} onPrototypeComment={onPrototypeComment} /> : getDocSections(d).map((sec, si) => (
              <div key={sec.id} data-sec={sec.id} data-seclabel={sec.label} style={di === 0 && si === 0 ? { position: 'relative' } : null}>
                {sec.htmlDocument || sec.htmlDocumentPath ? null : di === 0 && si === 0 ? <h2 className="dw-mt-2">{sec.heading}</h2> : <h2 className="dw-h3" style={{ marginTop: 28, marginBottom: 12 }}>{sec.heading}</h2>}
                {di === 0 && si === 0 && cue && !coach && !isMobile ? <HighlightCue onDismiss={dismissCue} /> : null}
                {sec.htmlDocument || sec.htmlDocumentPath ? <HtmlDocumentFrame section={sec} title={d.title} replayTracker={replayTracker} onHtmlDocumentSelect={onHtmlDocumentSelect} onHtmlDocumentClearSelection={onHtmlDocumentClearSelection} /> : sec.html ? <div className="dw-html-doc-section" dangerouslySetInnerHTML={{ __html: sec.html }} /> : sec.paras.map((para, pi) => <p key={pi} className="dw-body">{renderPara(para, sec.id)}</p>)}
              </div>
            ))}
          </div>
        ))}

        {/* sentinel: when this scrolls into view, unlock the next doc */}
        {!allDocsRead ? (
          <div ref={sentinel} style={{ height: 1 }}></div>
        ) : null}
        {!allDocsRead ? (
          <DocSeparator eyebrow="Keep reading" title={'Up next · ' + rows[unlocked].title}
            onContinue={() => setUnlocked((n) => Math.min(rows.length, n + 1))} cta={'Continue to ' + rows[unlocked].title} />
        ) : null}

        {/* post-reading questionnaire, after the final document */}
        {allDocsRead && postQuestionnaire ? (
          postDone
            ? <DocSeparator eyebrow="All done" title="Thanks — your answers are in." />
            : <DocSeparator eyebrow="One last thing" title={postQuestionnaire.title}
                onContinue={onStartPostQ} cta="Answer two questions" />
        ) : null}
        <div style={{ height: focus ? 80 : 40 }}></div>
      </div>
    </div>
  );
}

/* the post-reading questionnaire, shown inline as a sheet/modal */
function PostQuestionnaire({ open, questionnaire, onClose, onDone }) {
  const q = questionnaire;
  const store = useStore();
  const [ans, setAns] = useState({});
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');
  if (!open || !q) return null;
  const missingRequired = q.fields.some((f) => (f.required || f.req) && (ans[f.id] === undefined || ans[f.id] === null || ans[f.id] === '' || (Array.isArray(ans[f.id]) && !ans[f.id].length)));
  const submit = async () => {
    if (missingRequired || saving) return;
    setSaving(true);
    setErr('');
    try {
      await store.submitQuestionnaire(q.id, ans, true);
      onDone();
    } catch (error) {
      setErr(error.message || 'Could not submit answers');
    } finally {
      setSaving(false);
    }
  };
  return (
    <Modal open title={q.title} sub={'This goes straight to ' + window.DWDisplay.orgName() + ' — it shapes your call.'} onClose={onClose}
      footer={<React.Fragment><Btn variant="ghost" size="sm" disabled={saving} onClick={onClose}>Not now</Btn><Btn variant="pine" size="sm" loading={saving} disabled={missingRequired || saving} onClick={submit}>Submit</Btn></React.Fragment>}>
      {q.fields.map((f) => <QField key={f.id} q={{ ...f, opts: f.options || f.opts, req: f.required || f.req }} value={ans[f.id]} onChange={(v) => setAns((a) => ({ ...a, [f.id]: v }))} />)}
      {err ? <div className="dw-error dw-mt-3"><b>Could not submit answers.</b><br />{err}</div> : null}
    </Modal>
  );
}

Object.assign(window, { ReaderDoc, DocSeparator, PrototypeDocument, PostQuestionnaire, getDocSections });


/* ---- app/replay-tracking.js ---- */
/* ============================================================
   DEALWONDR APP — reader replay capture
   Records only explicit room engagement: session open, section
   dwell, scroll milestones, clicks on room controls, highlights,
   and comments. No keystrokes, mouse movement, screen, location,
   camera, or off-room activity is captured.
   ============================================================ */
(function () {
  const FLUSH_MS = 5000;
  const SCROLL_MS = 1200;
  const MAX_BATCH = 40;

  function nowSec(startedAt) {
    return Math.max(0, Math.round((Date.now() - startedAt) / 1000));
  }

  function textLabel(node) {
    const text = ((node && (node.getAttribute && (node.getAttribute("aria-label") || node.getAttribute("title"))) || node.textContent) || "")
      .replace(/\s+/g, " ")
      .trim();
    return text.slice(0, 80) || (node && node.tagName ? node.tagName.toLowerCase() : "control");
  }

  function activeSection(container) {
    if (!container) return { sectionId: null, label: null };
    const sections = Array.from(container.querySelectorAll("[data-sec]"));
    if (!sections.length) return { sectionId: null, label: null };
    const top = container.getBoundingClientRect().top + 72;
    let best = sections[0];
    let bestDistance = Infinity;
    sections.forEach((section) => {
      const distance = Math.abs(section.getBoundingClientRect().top - top);
      if (distance < bestDistance) {
        best = section;
        bestDistance = distance;
      }
    });
    return { sectionId: best.getAttribute("data-sec"), label: best.getAttribute("data-seclabel") || best.getAttribute("data-sec") };
  }

  function createTracker(input) {
    const startedAt = Date.now();
    const state = {
      roomId: input.roomId,
      versionId: input.versionId,
      docRef: input.docRef,
      sessionId: null,
      recording: false,
      stopped: false,
      queue: [],
      lastScrollAt: 0,
      lastScrollBucket: -1,
      pendingScrollTimer: null,
      active: null,
      activeSince: Date.now(),
      flushTimer: null
    };

    function enqueue(type, details) {
      if (state.stopped) return;
      const event = Object.assign({ type, atSec: nowSec(startedAt) }, details || {});
      state.queue.push(event);
      if (state.queue.length >= MAX_BATCH) flush();
    }

    async function flush() {
      if (!state.recording || !state.sessionId || !state.queue.length) return;
      const batch = state.queue.splice(0, MAX_BATCH);
      try {
        const result = await window.DWApi.recordSessionEvents(state.sessionId, batch);
        if (result && result.recording === false) {
          state.recording = false;
          state.queue = [];
        }
      } catch (error) {
        state.queue = batch.concat(state.queue).slice(0, MAX_BATCH * 2);
      }
    }

    function closeDwell() {
      if (!state.active) return;
      const durationMs = Math.max(0, Date.now() - state.activeSince);
      if (durationMs >= 800) enqueue("section_dwell", Object.assign({}, state.active, { durationMs }));
      state.activeSince = Date.now();
    }

    function setActive(section) {
      const key = (section.sectionId || "") + "|" + (section.label || "");
      const activeKey = state.active ? (state.active.sectionId || "") + "|" + (state.active.label || "") : "";
      if (key === activeKey) return;
      closeDwell();
      state.active = section;
      state.activeSince = Date.now();
    }

    function recordScroll(el, force) {
      const t = Date.now();
      if (!force && t - state.lastScrollAt < SCROLL_MS) {
        if (!state.pendingScrollTimer) {
          state.pendingScrollTimer = setTimeout(() => {
            state.pendingScrollTimer = null;
            recordScroll(el, true);
          }, SCROLL_MS);
        }
        return;
      }
      state.lastScrollAt = t;
      setActive(activeSection(el));
      const max = Math.max(0, el.scrollHeight - el.clientHeight);
      const pct = max > 0 ? Math.min(100, Math.round((el.scrollTop / max) * 100)) : 0;
      const bucket = Math.floor(pct / 10) * 10;
      if (force || bucket !== state.lastScrollBucket) {
        state.lastScrollBucket = bucket;
        enqueue("scroll_progress", Object.assign({}, state.active || {}, { payload: { percent: pct } }));
      }
    }
    function trackScroll(el) {
      recordScroll(el, false);
    }

    function track(type, details) {
      if (type === "highlight" && details) setActive({ sectionId: details.sectionId || null, label: details.label || null });
      enqueue(type, details || {});
    }

    function viewportPayload() {
      const root = state.docRef && state.docRef.current;
      return {
        viewport: {
          width: root ? root.clientWidth : window.innerWidth,
          height: root ? root.clientHeight : window.innerHeight,
          windowWidth: window.innerWidth,
          windowHeight: window.innerHeight
        }
      };
    }

    function onClick(event) {
      const target = event.target && event.target.closest ? event.target.closest("button,a,[role='button']") : null;
      if (!target) return;
      const root = state.docRef && state.docRef.current;
      if (!root && !document.body.contains(target)) return;
      enqueue("click", Object.assign({}, activeSection(root), { label: textLabel(target), payload: { control: textLabel(target) } }));
    }

    async function start() {
      try {
        const pages = state.docRef && state.docRef.current ? state.docRef.current.querySelectorAll(".dw-docpage,[data-doc]").length : 0;
        const session = await window.DWApi.startSession(state.roomId, { versionId: state.versionId, pages });
        if (!session || session.recording === false || !session.sessionId) return;
        state.sessionId = session.sessionId;
        state.recording = true;
        document.addEventListener("click", onClick, true);
        state.flushTimer = setInterval(flush, FLUSH_MS);
        state.active = activeSection(state.docRef && state.docRef.current);
        enqueue("open", Object.assign({}, state.active || {}, { payload: viewportPayload() }));
      } catch (error) {}
    }

    async function stop() {
      if (state.stopped) return;
      closeDwell();
      state.stopped = true;
      document.removeEventListener("click", onClick, true);
      if (state.flushTimer) clearInterval(state.flushTimer);
      if (state.pendingScrollTimer) {
        clearTimeout(state.pendingScrollTimer);
        state.pendingScrollTimer = null;
        if (state.docRef && state.docRef.current) recordScroll(state.docRef.current, true);
      }
      await flush();
      if (state.recording && state.sessionId) {
        try {
          const pages = state.docRef && state.docRef.current ? state.docRef.current.querySelectorAll(".dw-docpage,[data-doc]").length : 0;
          await window.DWApi.finishSession(state.sessionId, { durationSec: nowSec(startedAt), pages });
        } catch (error) {}
      }
    }

    start();
    return { track, trackScroll, flush, stop };
  }

  window.DWReplayTracking = { start: createTracker };
})();


/* ---- app/reader.jsx ---- */
/* ============================================================
   DEALWONDR APP — reading room
   The core loop: read → select a sentence → "Comment on this" →
   composer → comment appears in the panel. Uses ClientGate (gate.jsx)
   and CommentCard/Composer (comment.jsx).
   ============================================================ */

function Reader({ onAdmin, onSignOut, previewMode }) {
  const store = useStore();
  const isMobile = useIsMobile();
  const [toast, toastNode] = useToast();
  const [sel, setSel] = useState(null);          // {quote, sectionId, section, x, y}
  const [composing, setComposing] = useState(false);
  const [tab, setTab] = useState('activity');
  const [filter, setFilter] = useState('all');   // all | email
  const [active, setActive] = useState(null);
  const [panelOpen, setPanelOpen] = useState(false);
  const [coach, setCoach] = useState(() => { if (previewMode) return false; try { return !localStorage.getItem('dw-coach-done'); } catch (e) { return true; } });
  const [trust, setTrust] = useState(false);
  const [version, setVersion] = useState(() => window.DWDisplay.readerVersionId());
  const [vdiff, setVdiff] = useState(null);
  const [versionBusy, setVersionBusy] = useState(false);
  const [banner, setBanner] = useState(() => { try { return !localStorage.getItem('dw-trust-seen'); } catch (e) { return true; } });
  const [cue, setCue] = useState(() => { try { return !localStorage.getItem('dw-cue-seen'); } catch (e) { return true; } });
  const [focus, setFocus] = useState(false);
  const [unlocked, setUnlocked] = useState(1);
  const [activeDoc, setActiveDoc] = useState('d1');
  const [postQ, setPostQ] = useState(false);
  const [postDone, setPostDone] = useState(false);
  const [progress, setProgress] = useState(() => { try { return parseInt(localStorage.getItem('dw-read-pct'), 10) || 0; } catch (e) { return 0; } });
  const readerModel = window.DWAdapters.readerRoomModel();
  const docs = readerModel.docs;
  const hasPrototypeDoc = docs.some((doc) => doc && doc.renderMode === 'prototype');
  const hasWideDoc = hasPrototypeDoc || docs.some((doc) => doc && (doc.sections || []).some((sec) => sec && (sec.htmlDocument || sec.htmlDocumentPath)));
  const room = readerModel.room;
  const readers = readerModel.readers;
  const postQuestionnaire = readerModel.postQuestionnaire;
  const selectedVersionId = store.get().selectedVersionId;
  const visibleDocCount = previewMode ? docs.length : unlocked;
  const loadingPanel = useBriefLoad(600);
  const dismissBanner = () => { setBanner(false); try { localStorage.setItem('dw-trust-seen', '1'); } catch (e) {} };
  const dismissCue = () => { setCue(false); try { localStorage.setItem('dw-cue-seen', '1'); } catch (e) {} };
  const closeCoach = () => { setCoach(false); try { localStorage.setItem('dw-coach-done', '1'); } catch (e) {} };
  const comments = store.comments();
  const activity = store.activity();
  const me = store.get().clientEmail;
  const docRef = useRef(null);
  const replayTracker = useRef(null);
  useEffect(() => {
    setVersion(window.DWDisplay.readerVersionId());
  }, [room.id, room.version, selectedVersionId]);
  useEffect(() => {
    if (!sel || composing) return undefined;
    const clearSelection = (event) => {
      if (event.target && event.target.closest && event.target.closest('.dw-seltool,.dw-bubble')) return;
      setSel(null);
    };
    window.addEventListener('mousedown', clearSelection, true);
    return () => window.removeEventListener('mousedown', clearSelection, true);
  }, [sel, composing]);
  useEffect(() => {
    if (!window.DWReplayTracking || !store.hasReaderApiSession()) return undefined;
    const session = store.activeSession();
    if (!session || session.kind !== 'reader') return undefined;
    const tracker = window.DWReplayTracking.start({ roomId: room.id, versionId: version, docRef });
    replayTracker.current = tracker;
    const onPageHide = () => { if (replayTracker.current) replayTracker.current.stop(); };
    window.addEventListener('pagehide', onPageHide);
    return () => {
      window.removeEventListener('pagehide', onPageHide);
      const activeTracker = replayTracker.current;
      replayTracker.current = null;
      if (activeTracker) activeTracker.stop();
    };
  }, [room.id, version]);

  function onMouseUp(event) {
    if (event && event.target && event.target.closest && event.target.closest('.dw-seltool')) return;
    if (previewMode) return;
    if (isMobile) return; // handled by touch path below
    if (composing) return; // don't disturb the open composer
    const s = window.getSelection();
    const txt = (s.toString() || '').trim();
    if (!txt || txt.length < 4) { setSel(null); return; }
    const range = s.getRangeAt(0);
    const secEl = range.startContainer.parentElement.closest('[data-sec]');
    const wrapRect = docRef.current.getBoundingClientRect();
    const r = range.getBoundingClientRect();
    const selection = { quote: txt, sectionId: secEl ? secEl.getAttribute('data-sec') : 's1', section: secEl ? secEl.getAttribute('data-seclabel') : '§01',
      x: r.left - wrapRect.left + docRef.current.scrollLeft, y: r.top - wrapRect.top + docRef.current.scrollTop - 44 };
    setSel(selection);
    if (replayTracker.current) replayTracker.current.track('highlight', { sectionId: selection.sectionId, label: selection.section, payload: { length: txt.length } });
  }
  function startCompose() { setComposing(true); }
  async function postAnchoredComment(anchor, text, needsReply, meta) {
    if (previewMode) {
      toast('Preview mode is untracked. Open the client room link to leave comments.');
      return;
    }
    if (!anchor) throw new Error('Comment anchor is required.');
    try {
      const c = await store.addComment(anchor.sectionId, anchor.section, anchor.quote, text, needsReply);
      if (replayTracker.current) replayTracker.current.track('comment', {
        sectionId: anchor.sectionId,
        label: anchor.section,
        payload: Object.assign({ commentId: c.id, needsReply: !!needsReply }, meta || {})
      });
      setComposing(false); setSel(null); if (window.getSelection) window.getSelection().removeAllRanges();
      setActive(c.id); setTab('comments'); setPanelOpen(true);
      toast(needsReply ? 'Comment posted — ' + window.DWDisplay.orgName() + ' will reply' : 'Comment posted', true);
      return c;
    } catch (error) {
      toast(error.message || 'Could not post comment');
      throw error;
    }
  }
  async function post(text, needsReply) {
    return postAnchoredComment(sel, text, needsReply);
  }
  async function postPrototypeComment(anchor, text, needsReply, prototype) {
    return postAnchoredComment(anchor, text, needsReply, {
      prototypeId: prototype && prototype.id,
      prototypeKind: prototype && prototype.kind
    });
  }
  function selectHtmlDocumentText(anchor, point) {
    if (previewMode) return;
    if (!anchor || !anchor.quote || anchor.quote.length < 4 || !docRef.current) return;
    const wrapRect = docRef.current.getBoundingClientRect();
    setSel({
      quote: anchor.quote,
      sectionId: anchor.sectionId || 'html-document',
      section: anchor.section || 'HTML document',
      x: Number(point && point.clientX || 0) - wrapRect.left + docRef.current.scrollLeft,
      y: Number(point && point.clientY || 0) - wrapRect.top + docRef.current.scrollTop - 44
    });
    setComposing(false);
  }
  function clearHtmlDocumentSelection() {
    if (!composing) setSel(null);
  }
  function jump(c) { setActive(c.id); setTab('comments'); setPanelOpen(true);
    const el = docRef.current.querySelector('[data-cid="' + c.id + '"]') || (c.sectionId && docRef.current.querySelector('[data-sec="' + c.sectionId + '"]'));
    if (el) el.scrollIntoView({ block: 'center' });
  }
  async function switchVersion(nextVersion) {
    if (nextVersion === version || versionBusy) return;
    const prev = version;
    setVersion(nextVersion);
    setVersionBusy(true);
    try {
      const loaded = await store.selectReaderVersion(room.apiId || room.id, nextVersion);
      setVdiff({ from: prev, to: nextVersion });
      setSel(null);
      setComposing(false);
      setActive(null);
      setFilter('all');
      setUnlocked(1);
      setActiveDoc(loaded.docs && loaded.docs[0] ? loaded.docs[0].id : 'd1');
      if (docRef.current) docRef.current.scrollTop = 0;
    } catch (error) {
      setVersion(prev);
      toast(error.message || 'Could not load this version');
    } finally {
      setVersionBusy(false);
    }
  }

  /* real read progress — furthest point reached, persisted across reloads */
  function onScroll(e) {
    const el = e.currentTarget; const max = el.scrollHeight - el.clientHeight;
    const p = max > 0 ? Math.min(100, Math.round((el.scrollTop / max) * 100)) : 0;
    if (replayTracker.current) replayTracker.current.trackScroll(el);
    setProgress((prev) => { const np = p > prev ? p : prev; if (np !== prev) { try { localStorage.setItem('dw-read-pct', String(np)); } catch (er) {} } return np; });
  }

  const shown = comments.filter((c) => filter === 'all' || c.author === filter);
  const unread = store.activityUnreadCount();
  const taggedActivity = activity.tagged || [];
  const replyActivity = activity.replies || [];
  const roomActivity = activity.around || [];
  const hasActivity = taggedActivity.length || replyActivity.length || roomActivity.length;

  /* render a paragraph, wrapping any comment quote as a highlight */
  function renderPara(text, secId) {
    const hits = comments.filter((c) => c.sectionId === secId && text.indexOf(c.quote) !== -1);
    if (!hits.length) return text;
    const c = hits[0];
    const i = text.indexOf(c.quote);
    return [
      text.slice(0, i),
      <span key="h" className={'dw-hl' + (active === c.id ? ' is-active' : '')} data-cid={c.id} onClick={() => jump(c)}>{c.quote}<span className="dw-hl__chip">{hits.length}</span></span>,
      text.slice(i + c.quote.length),
    ];
  }

  const panel = (
    <aside className="dw-panel" style={isMobile ? { width: '100%' } : { width: 340 }}>
      <div className="dw-panel__tabs">
        <button className={'dw-panel__tab' + (tab === 'activity' ? ' is-on' : '')} onClick={() => setTab('activity')}>Activity {unread ? <span className="dw-tabs__cnt is-hot">{unread}</span> : null}</button>
        <button className={'dw-panel__tab' + (tab === 'comments' ? ' is-on' : '')} onClick={() => setTab('comments')}>Comments <span className="dw-tabs__cnt">{comments.length}</span></button>
      </div>
      {banner ? <TrustBanner onDetails={() => { dismissBanner(); setTrust(true); }} onDismiss={dismissBanner} /> : null}
      {tab === 'comments' ? (
        <React.Fragment>
          <div className="dw-filterbar" style={{ padding: '12px 16px', borderBottom: '1px solid var(--dw-border-subtle)' }}>
            <button className={'dw-chip' + (filter === 'all' ? ' is-on' : '')} onClick={() => setFilter('all')}>All readers</button>
            {readers.map((e) => <button key={e} className={'dw-chip' + (filter === e ? ' is-on' : '')} onClick={() => setFilter(e)}>{window.DWAdapters.person(e).name}</button>)}
          </div>
          <div className="dw-panel__scroll">
            {loadingPanel ? <SkeletonList rows={3} /> : (
              <React.Fragment>
                {shown.map((c) => <CommentCard key={c.id} c={c} active={active === c.id} onJump={jump}
                  onResolve={async (c2, v) => { await store.setResolved(c2.id, v); toast(v ? 'Marked resolved' : 'Reopened'); }}
                  onReply={async (c2, t) => { await store.addReply(c2.id, t); toast('Reply posted', true); }} />)}
                {!shown.length ? <div className="dw-empty"><Icon name="comment" size="xl" /><div className="dw-empty__title">{filter === 'all' ? 'No questions yet' : 'Nothing from ' + window.DWAdapters.person(filter).name}</div><div className="dw-empty__body">{filter === 'all' ? 'Highlight any sentence in the proposal to ask the first question — it’ll appear right here.' : 'They haven’t commented yet. Switch to “All readers” to see every thread.'}</div>{filter === 'all' ? null : <button className="dw-jump dw-mt-2" onClick={() => setFilter('all')}>← All readers</button>}</div> : null}
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ) : (
        <div className="dw-panel__scroll">
          {loadingPanel ? <SkeletonList rows={3} /> : (
            <React.Fragment>
              {taggedActivity.length ? <React.Fragment><div className="dw-panel__sec">You were tagged</div>{taggedActivity.map((a, i) => <div key={i} className={'dw-activity' + (a.unread ? ' is-unread' : '')}><Avatar email={a.email} size="sm" /><div><div className="dw-activity__body"><b>{a.who}</b> tagged you: <em>“{a.body}”</em></div><div className="dw-activity__when">{a.when}</div></div></div>)}</React.Fragment> : null}
              {replyActivity.length ? <React.Fragment><div className="dw-panel__sec">Replies to your threads</div>{replyActivity.map((a, i) => <div key={i} className={'dw-activity' + (a.unread ? ' is-unread' : '')}><Avatar email={a.email} size="sm" /><div><div className="dw-activity__body"><b>{a.who}</b> {a.body}</div><div className="dw-activity__when">{a.when}</div></div></div>)}</React.Fragment> : null}
              {roomActivity.length ? <React.Fragment><div className="dw-panel__sec">Around the room</div>{roomActivity.map((a, i) => <div key={i} className="dw-activity"><Avatar email={a.email} size="sm" /><div><div className="dw-activity__body"><b>{a.who}</b> {a.body}</div><div className="dw-activity__when">{a.when}</div></div></div>)}</React.Fragment> : null}
              {!hasActivity ? <div className="dw-empty"><Icon name="bell" size="xl" /><div className="dw-empty__title">No room activity yet</div><div className="dw-empty__body">Mentions, replies, and reader updates will appear here when they happen.</div></div> : null}
            </React.Fragment>
          )}
        </div>
      )}
    </aside>
  );

  return (
    <div className="dw-app">
      {isMobile ? (
        <div className="dw-appbar">
          <button className="dw-appbar__btn" onClick={onAdmin}><Icon name="grid" /></button>
          <span className="dw-appbar__title">{room.title.split(' — ')[1] || room.title}</span>
          <button className="dw-appbar__btn" style={{ position: 'relative' }} onClick={() => { setTab('activity'); setPanelOpen(true); }}><Icon name="bell" />{unread ? <span className="dw-bell__dot" style={{ top: 6, right: 6 }}>{unread}</span> : null}</button>
          <button className="dw-appbar__btn" aria-label="What's shared" title="What's shared" onClick={() => setTrust(true)}><Icon name="shield" /></button>
        </div>
      ) : (
        <div className="dw-topbar" style={{ flexWrap: 'nowrap', gap: 'var(--dw-space-3)', height: 56 }}>
          <Lockup />
          <span className="dw-topbar__divider" style={{ flex: 'none' }}></span>
          <span className="dw-doc-chip" style={{ minWidth: 0, display: 'inline-flex', alignItems: 'baseline', overflow: 'hidden' }}><span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{room.title}</span></span>
          <span style={{ flex: 'none', position: 'relative' }}><VersionSwitcher version={version} onChange={switchVersion} />{vdiff ? <VersionDiff from={vdiff.from} to={vdiff.to} onClose={() => setVdiff(null)} /> : null}</span>
          <span className="dw-topbar__spacer"></span>
          <span className="dw-meter" style={{ flex: 'none', whiteSpace: 'nowrap' }}>Read {progress}%<span className="dw-progress" style={{ width: 90, height: 3 }}><i style={{ width: progress + '%' }}></i></span></span>
          <button className={'dw-focusbtn' + (focus ? ' is-on' : '')} onClick={() => setFocus(!focus)} title="Focus mode — dim everything but the document"><Icon name="eye" size="sm" /> Focus</button>
          <span className="dw-trustchip" onClick={() => setTrust(true)} style={{ cursor: 'pointer', flex: 'none', whiteSpace: 'nowrap' }}><Icon name="shield" size="sm" /> What's shared</span>
          <button className="dw-bell" style={{ flex: 'none' }} onClick={() => { setTab('activity'); }}><Icon name="bell" size="sm" />{unread ? <span className="dw-bell__dot">{unread}</span> : null}</button>
          <span style={{ flex: 'none' }}><AvatarMenu email={me} onCoach={() => setCoach(true)} onTrust={() => setTrust(true)} onAdmin={onAdmin} onSignOut={onSignOut} /></span>
        </div>
      )}

      {previewMode ? (
        <div className="dw-previewbar" role="status">
          <Icon name="eye" size="sm" />
          <strong>Preview reader mode</strong>
          <span>Untracked. No replay, analytics, or reader session events are recorded.</span>
          <span className="dw-grow"></span>
          <Btn variant="ghost" size="sm" icon="grid" onClick={onAdmin}>Back to dashboard</Btn>
        </div>
      ) : null}

      {!isMobile ? (
        <div className="dw-doctabs">
          {docs.map((d, di) => {
            const locked = di >= visibleDocCount;
            const done = !previewMode && (di < unlocked - 1 || (di === docs.length - 1 && postDone));
            return (
              <button key={d.id} className={'dw-doctab' + (activeDoc === d.id ? ' is-on' : '') + (locked ? ' is-locked' : '') + (done ? ' is-done' : '')}
                onClick={() => { if (locked) return; if (replayTracker.current) replayTracker.current.track('click', { label: d.title, payload: { control: 'document-tab', documentId: d.id } }); setActiveDoc(d.id); const el = docRef.current.querySelector('[data-doc="' + d.id + '"]'); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }}>
                <span className="dw-doctab__n">{done ? '✓' : di + 1}</span>{d.title}{locked ? <Icon name="lock" size="sm" /> : null}
              </button>
            );
          })}
          {postQuestionnaire ? <button className={'dw-doctab' + (unlocked < docs.length ? ' is-locked' : '') + (postDone ? ' is-done' : '')} onClick={() => unlocked >= docs.length && setPostQ(true)}><span className="dw-doctab__n">{postDone ? '✓' : '?'}</span>Questions{unlocked < docs.length ? <Icon name="lock" size="sm" /> : null}</button> : null}
        </div>
      ) : null}

      <div style={{ flex: 1, display: 'flex', minHeight: 0, position: 'relative' }}>
        <div className={'dw-docwrap' + (hasWideDoc ? ' dw-docwrap--wide' : '') + (hasPrototypeDoc ? ' dw-docwrap--prototype' : '')} ref={docRef} style={{ flex: 1, overflowY: 'auto', position: 'relative' }} onMouseUp={onMouseUp} onScroll={onScroll}>
          <ReaderDoc docRef={docRef} renderPara={renderPara} cue={cue} coach={coach} isMobile={isMobile} dismissCue={dismissCue}
            focus={focus} onExitFocus={() => setFocus(false)} unlocked={visibleDocCount} setUnlocked={setUnlocked}
            docs={docs} activeDoc={activeDoc} postQuestionnaire={postQuestionnaire} postDone={postDone} onStartPostQ={() => setPostQ(true)}
            roomId={room.id} replayTracker={replayTracker} previewMode={previewMode} onPrototypeComment={postPrototypeComment} onHtmlDocumentSelect={selectHtmlDocumentText} onHtmlDocumentClearSelection={clearHtmlDocumentSelection} />
          {sel && !composing && !isMobile ? (
            <div className="dw-seltool" style={{ position: 'absolute', top: sel.y, left: Math.max(8, sel.x), zIndex: 75 }}>
              <button onClick={startCompose}><Icon name="comment" size="sm" /> Comment on this</button>
            </div>
          ) : null}
          {composing && !isMobile && sel ? (
            <div className="dw-bubble" style={{ position: 'absolute', top: Math.max(8, sel.y + 4), left: Math.min(sel.x, 360), zIndex: 80 }}>
              <Composer quote={sel.quote} autoFocus onPost={post} onCancel={() => { setComposing(false); setSel(null); }} />
            </div>
          ) : null}
        </div>
        {focus ? <div className="dw-focus-scrim"></div> : null}
        {focus ? <button className="dw-focus-exit" onClick={() => setFocus(false)}><Icon name="x" size="sm" /> Exit focus</button> : null}
        {!isMobile && !focus ? panel : null}
      </div>

      {/* mobile: tab bar + panel sheet + selection/compose sheets */}
      {isMobile ? (
        <React.Fragment>
          <div className="dw-tabbar">
            <button className={'dw-tabbar__tab is-on'}><Icon name="file" />Room</button>
            <button className="dw-tabbar__tab" onClick={() => { setTab('comments'); setPanelOpen(true); }}><Icon name="comment" />Threads</button>
            <button className="dw-tabbar__tab" onClick={() => { setTab('activity'); setPanelOpen(true); }}><Icon name="bell" />Activity</button>
          </div>
          <Sheet open={panelOpen} title={tab === 'comments' ? 'Comments' : 'Activity'} onClose={() => setPanelOpen(false)}>
            <div style={{ margin: '-16px' }}>{panel}</div>
          </Sheet>
          <Sheet open={!!sel && !composing} action onClose={() => setSel(null)}>
            <Btn variant="pine" onClick={startCompose}><Icon name="comment" /> Comment on this</Btn>
          </Sheet>
          <Sheet open={composing} title="Comment on this" onClose={() => { setComposing(false); setSel(null); }}>
            {sel ? <Composer quote={sel.quote} autoFocus onPost={post} onCancel={() => { setComposing(false); setSel(null); }} /> : null}
          </Sheet>
          <MobileSelect docRef={docRef} onSelect={setSel} comments={comments} />
        </React.Fragment>
      ) : null}
      {toastNode}
      <Coach open={coach} onClose={closeCoach} />
      <TrustDrawer open={trust} onClose={() => setTrust(false)} />
      <PostQuestionnaire open={postQ} questionnaire={postQuestionnaire} onClose={() => setPostQ(false)} onDone={() => { setPostQ(false); setPostDone(true); toast('Sent to ' + window.DWDisplay.orgName() + ' — thank you', true); }} />
      {!isMobile ? (
        <div className="dw-appfoot">
          <Logo />
          <span className="dw-appfoot__line"></span>
          <span className="dw-appfoot__text">Powered by Dealwondr</span>
          <span className="dw-appfoot__line"></span>
          <span className="dw-appfoot__text">Intent Pop</span>
        </div>
      ) : null}
    </div>
  );
}

/* mobile: listen to selectionchange to surface the action sheet */
function MobileSelect({ docRef, onSelect }) {
  useEffect(() => {
    let t;
    const fn = () => {
      clearTimeout(t);
      t = setTimeout(() => {
        const s = window.getSelection();
        const txt = (s.toString() || '').trim();
        if (!txt || txt.length < 4 || !docRef.current) return;
        try {
          const range = s.getRangeAt(0);
          if (!docRef.current.contains(range.startContainer)) return;
          const secEl = range.startContainer.parentElement.closest('[data-sec]');
          onSelect({ quote: txt, sectionId: secEl ? secEl.getAttribute('data-sec') : 's1', section: secEl ? secEl.getAttribute('data-seclabel') : '§01' });
        } catch (e) {}
      }, 400);
    };
    document.addEventListener('selectionchange', fn);
    return () => document.removeEventListener('selectionchange', fn);
  }, []);
  return null;
}

Object.assign(window, { Reader, MobileSelect });


/* ---- app/reader-extras.jsx ---- */
/* ============================================================
   DEALWONDR APP — reader extras
   Onboarding coach · trust drawer · avatar menu · version switcher.
   ============================================================ */

/* Onboarding coach — first-time tutorial with a try-it box */
function Coach({ open, onClose }) {
  const [tried, setTried] = useState(false);
  if (!open) return null;
  const steps = [
    ['Read it like a document', 'Scroll section by section — everything is interactive.'],
    ['Highlight anything to ask', 'Select any text — a “Comment on this” button appears right there.'],
    ['Everyone reads every thread', 'Your questions and our answers stay in the room, in context.'],
  ];
  return (
    <div className="dw-modal-scrim" style={{ position: 'fixed' }} onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="dw-coach">
        <Eyebrow>First time here</Eyebrow>
        <div className="dw-coach__title">This proposal answers back.</div>
        {steps.map((s, i) => (
          <div className="dw-coach__step" key={i}><span className="dw-coach__num">{i + 1}</span><div><div className="dw-coach__st">{s[0]}</div><div className="dw-coach__sd">{s[1]}</div></div></div>
        ))}
        <div className="dw-mt-4" style={{ border: '1.5px dashed var(--dw-accent-press)', borderRadius: 9, padding: '12px 15px', background: 'var(--dw-surface-input)', fontSize: 'var(--dw-text-sm)' }}
          onMouseUp={() => { if ((window.getSelection().toString() || '').trim().length > 3) setTried(true); }}>
          {tried ? <span><b>✓ That’s it — you’ve got it.</b> In the document, a Comment button opens right where you select.</span>
            : <span>Try it now — <b>highlight a few words of this sentence</b> with your cursor.</span>}
        </div>
        <div className="dw-row dw-mt-5"><button className="dw-action" onClick={onClose}>Skip</button><Btn variant="accent" size="sm" onClick={onClose}>Got it</Btn></div>
      </div>
    </div>
  );
}

/* "What's shared in this room" trust drawer */
function TrustDrawer({ open, onClose }) {
  const store = useStore();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const summary = store.readerTracking && store.readerTracking();
  useEffect(() => {
    if (!open || !store.refreshReaderTracking) return;
    let alive = true;
    setError('');
    store.refreshReaderTracking().catch((err) => { if (alive) setError(err.message || 'Could not load sharing details'); });
    return () => { alive = false; };
  }, [open]);
  const setPaused = async () => {
    if (!store.setReaderTrackingPaused || !summary) return;
    setBusy(true);
    setError('');
    try {
      await store.setReaderTrackingPaused(!summary.paused);
    } catch (err) {
      setError(err.message || 'Could not update sharing settings');
    } finally {
      setBusy(false);
    }
  };
  const recorded = summary && summary.recorded ? summary.recorded : [];
  const neverRecorded = summary && summary.neverRecorded ? summary.neverRecorded : [];
  const value = summary && summary.value ? summary.value : [];
  return (
    <Drawer open={open} title="What's shared in this room" sub="Reciprocal by design — you see what they see." onClose={onClose}
      footer={<React.Fragment>{summary ? <Btn variant={summary.paused ? 'pine' : 'ghost'} size="sm" loading={busy} disabled={busy} onClick={setPaused}>{summary.paused ? 'Resume sharing' : 'Pause sharing'}</Btn> : null}<Btn variant="pine" size="sm" disabled={busy} onClick={onClose}>Got it</Btn></React.Fragment>}>
      {summary && summary.paused ? <div className="dw-card dw-card--pad-sm" style={{ borderLeft: '3px solid var(--dw-accent)' }}><strong className="dw-body-sm">Sharing is paused</strong><div className="dw-body-sm dw-secondary dw-mt-2">New reading sessions are not recorded while paused. Comments you post still appear in the room.</div></div> : null}
      {error ? <p className="dw-error">{error}</p> : null}
      {!summary && !error ? <p className="dw-body-sm dw-muted">Loading sharing details for this room.</p> : null}
      {summary ? <React.Fragment>
        <SectionRule hint="your current room activity">The sender can see</SectionRule>
        {recorded.map((row, i) => (
          <div className="dw-checkitem is-on" key={i}><span className="dw-checkitem__box is-on"></span><span><strong>{row.k}</strong><span className="dw-muted"> · {row.v}</span></span></div>
        ))}
        <SectionRule>You can see</SectionRule>
        {value.map((t, i) => (
          <div className="dw-checkitem is-on" key={i}><span className="dw-checkitem__box is-on"></span> {t}</div>
        ))}
        <SectionRule>Never recorded</SectionRule>
        {neverRecorded.map((t, i) => (
          <div className="dw-checkitem" key={i}><span className="dw-checkitem__box"></span> {t}</div>
        ))}
        <p className="dw-drawer__note">Dealwondr never sells or shares your activity. It stays between you and the people invited to this room.</p>
      </React.Fragment> : null}
    </Drawer>
  );
}

/* Account / avatar menu */
function AvatarMenu({ email, onCoach, onTrust, onAdmin, onSignOut }) {
  const [open, setOpen] = useState(false);
  const [theme, setTheme] = useTheme();
  useEffect(() => { if (!open) return; const fn = () => setOpen(false); window.addEventListener('click', fn); return () => window.removeEventListener('click', fn); }, [open]);
  return (
    <span style={{ position: 'relative' }} onClick={(e) => e.stopPropagation()}>
      <span style={{ cursor: 'pointer' }} onClick={() => setOpen(!open)}><Avatar email={email} size="sm" /></span>
      {open ? (
        <div className="dw-dropdown" style={{ position: 'absolute', right: 0, top: 'calc(100% + 8px)', zIndex: 600, minWidth: 230 }}>
          <div className="dw-dropdown__head">{email}</div>
          <div style={{ padding: '6px 12px 9px' }}>
            <div className="dw-mono-xs dw-muted" style={{ marginBottom: 6 }}>Appearance</div>
            <div className="dw-seg" style={{ width: '100%' }}>
              <button className={'dw-seg__opt' + (theme === 'light' ? ' is-on' : '')} style={{ flex: 1 }} onClick={() => setTheme('light')}>☀ Light</button>
              <button className={'dw-seg__opt' + (theme === 'dark' ? ' is-on' : '')} style={{ flex: 1 }} onClick={() => setTheme('dark')}>☾ Dark</button>
            </div>
          </div>
          <div className="dw-dropdown__sep"></div>
          <button className="dw-dropdown__item" onClick={() => { setOpen(false); onTrust(); }}><Icon name="shield" size="sm" /> What’s shared in this room</button>
          <button className="dw-dropdown__item" onClick={() => { setOpen(false); onCoach(); }}><Icon name="refresh" size="sm" /> Replay the tutorial</button>
          <button className="dw-dropdown__item" onClick={() => { setOpen(false); onAdmin(); }}><Icon name="settings" size="sm" /> Switch to admin console</button>
          {window.DWDisplay.enableReaderReset() ? <React.Fragment><div className="dw-dropdown__sep"></div><button className="dw-dropdown__item" onClick={() => { window.DWStore.reset(); setOpen(false); }}><Icon name="refresh" size="sm" /> Reset local data</button></React.Fragment> : null}
          <button className="dw-dropdown__item dw-dropdown__item--danger" onClick={() => { setOpen(false); onSignOut(); }}><Icon name="x" size="sm" /> Sign out</button>
        </div>
      ) : null}
    </span>
  );
}

/* Version switcher chip + menu */
function VersionSwitcher({ version, onChange }) {
  const [open, setOpen] = useState(false);
  const versions = window.DWAdapters.readerVersions();
  const versionKey = String(version || '').toLowerCase();
  const cur = versions.find((v) => String(v.id || '').toLowerCase() === versionKey || String(v.label || '').toLowerCase() === versionKey) || versions.find((v) => v.latest) || versions[0];
  const canSwitch = versions.length > 1;
  useEffect(() => { if (!open) return; const fn = () => setOpen(false); window.addEventListener('click', fn); return () => window.removeEventListener('click', fn); }, [open]);
  if (!cur) return null;
  return (
    <span style={{ position: 'relative' }} onClick={(e) => e.stopPropagation()}>
      <button type="button" className={'dw-verchip' + (canSwitch ? ' is-switchable' : '')} style={{ whiteSpace: 'nowrap' }} aria-haspopup={canSwitch ? 'menu' : undefined} aria-expanded={canSwitch ? open : undefined} disabled={!canSwitch} onClick={() => canSwitch && setOpen(!open)}>
        {cur.label} {cur.latest ? <i>· latest</i> : <i className="old">· {cur.issued}</i>}{canSwitch ? <React.Fragment> <i>· {versions.length} versions</i> ▾</React.Fragment> : null}
      </button>
      {open && canSwitch ? (
        <div className="dw-vermenu" style={{ position: 'absolute', top: 'calc(100% + 8px)', left: 0, zIndex: 600 }}>
          <div className="dw-vermenu__head">Versions of this proposal · {versions.length} total</div>
          {versions.map((v) => (
            <button key={v.id} role="menuitem" className={'dw-vermenu__item' + (v.id === cur.id ? ' is-on' : '')} onClick={() => { setOpen(false); onChange(v.id); }}>
              <strong>{v.label}</strong>{v.latest ? <span className="tag">latest</span> : null}<span className="vd">{v.issued}{v.note ? ' · ' + v.note : ''}</span>
            </button>
          ))}
        </div>
      ) : null}
    </span>
  );
}

Object.assign(window, { Coach, TrustDrawer, AvatarMenu, VersionSwitcher });


/* ---- app/insights.jsx ---- */
/* ============================================================
   DEALWONDR APP — room insights (deep)
   Sub-tabs: Overview · Actions · Engagement · Sections · Journeys
   · Pre-call.  Objection orbit + evidence drawer + pre-call brief.
   ============================================================ */

const DW_EVIDENCE = {
  'Pricing & terms': { confidence: 0, confidenceLabel: 'Waiting for signals' },
  'Security review': { confidence: 0, confidenceLabel: 'Waiting for signals' },
  'Timeline': { confidence: 0, confidenceLabel: 'Waiting for signals' },
};

const DW_NOTE = {
  label: 'Warm', temperature: 76,
  parts: [
    { title: 'Where the deal stands', body: 'Reader engagement, unanswered questions, and quiet stakeholders will appear here after a pre-call note is generated.' },
    { title: 'Open questions', items: ['Clarify the highest-friction topic', 'Confirm the next-step owner', 'Resolve any unanswered reader comments'] },
    { title: 'Biggest risk', body: 'The strongest objection or stalled stakeholder will appear here when enough room activity exists.' },
    { title: 'Suggested open', body: 'Lead with the most recent reader signal and the next decision needed from the buyer.' },
  ],
};

/* ---- Objection orbit (bubble chart) ---- */
function ObjectionOrbit({ objections, onPick }) {
  const W = 360, H = 280, cx = W / 2, cy = H / 2;
  const shown = objections.slice(0, 6);
  const coreTop = window.DWDisplay.clientName();
  const coreBottom = window.DWDisplay.roomTitle().replace(/\s+Proposal$/i, '') || 'room';
  return (
    <div className="dw-orbit" style={{ width: W, height: H, margin: '0 auto' }}>
      <svg className="dw-orbit__links" width={W} height={H} aria-hidden="true">
        {shown.map((o, i) => { const a = (i / shown.length) * 2 * Math.PI - Math.PI / 2; const r = Math.max(78, 150 - o.score * 0.6); return <line key={o.cat} x1={cx} y1={cy} x2={cx + Math.cos(a) * r} y2={cy + Math.sin(a) * r} />; })}
      </svg>
      <div className="dw-orbit__core">{coreTop}<br />{coreBottom}</div>
      {shown.map((o, i) => {
        const a = (i / shown.length) * 2 * Math.PI - Math.PI / 2; const r = Math.max(78, 150 - o.score * 0.6);
        const x = cx + Math.cos(a) * r, y = cy + Math.sin(a) * r; const size = 40 + Math.round(o.score / 100 * 38);
        const conf = (DW_EVIDENCE[o.cat] || {}).confidence || 60; const bw = conf > 75 ? 3 : conf >= 55 ? 2 : 1.5;
        return <button key={o.cat} className={'dw-orbit__b sev-' + o.sev} style={{ left: x, top: y, width: size, height: size, borderWidth: bw }} onClick={() => onPick(o)} title={o.cat + ' · ' + o.sevLabel}><span className="l">{o.cat.split(' ')[0]}</span><span className="n">{o.ev}</span></button>;
      })}
    </div>
  );
}

/* ---- Past pre-call notes (archived per version) ---- */
function PastPreCalls() {
  const [view, setView] = useState(null);
  const rows = window.DWAdapters.roomInsights().pastNotes || [];
  if (!rows.length) return <div className="dw-empty"><Icon name="file" size="xl" /><div className="dw-empty__title">No earlier notes yet</div><div className="dw-empty__body">Every pre-call note you generate is archived here, pinned to the version it was written on.</div></div>;
  return (
    <React.Fragment>
      <div className="dw-pastlist">
        {rows.map((p) => (
          <button key={p.id} className="dw-pastrow" onClick={() => setView(p)}>
            <span className="dw-verpill">{p.version}</span>
            <span className="dw-pastrow__main"><span className="dw-pastrow__sum">{p.summary}</span><span className="dw-pastrow__meta">{p.date} · by {p.by}</span></span>
            <span className={'dw-temp dw-temp--' + p.tone}>{p.label} · {p.temperature}</span>
            <a className="dw-jump">View →</a>
          </button>
        ))}
      </div>
      <Drawer open={!!view} title={view ? 'Pre-call note · ' + view.version : ''} sub={view ? view.date + ' · archived snapshot' : ''} onClose={() => setView(null)}>
        {view ? (
          <div className="dw-note__doc" style={{ border: 'none', padding: 0 }}>
            <div className="dw-note__head"><Eyebrow>Pre-call note · {view.version}</Eyebrow><span className={'dw-temp dw-temp--' + view.tone}>{view.label} · {view.temperature}</span></div>
            {view.parts.map((p, i) => (
              <div className="dw-note__part" key={i}><div className="dw-note__ph"><span className="dw-note__pn">{i + 1}</span>{p.title}</div>{p.items ? <ul className="dw-note__list">{p.items.map((it, j) => <li key={j}>{it}</li>)}</ul> : <p className="dw-note__pb">{p.body}</p>}</div>
            ))}
            <p className="dw-note__foot">Archived snapshot — read-only. Generate a fresh note above for the current state of the room.</p>
          </div>
        ) : null}
      </Drawer>
    </React.Fragment>
  );
}

/* ---- Evidence drawer ---- */
function EvidenceDrawer({ obj, onClose, onResolve, onDismiss }) {
  const seed = obj ? DW_EVIDENCE[obj.cat] : null;
  const ex = obj ? {
    confidence: obj.confidence || (seed && seed.confidence) || 0,
    confidenceLabel: obj.confidenceLabel || (seed && seed.confidenceLabel) || 'Waiting for signals',
    evidence: obj.evidence || [],
    readers: obj.readers || [],
    clarifications: obj.clarifications || []
  } : null;
  return (
    <Drawer open={!!obj} title={obj ? obj.cat : ''} sub={obj && ex ? obj.sevLabel + ' · ' + ex.confidence + '% confidence · ' + ex.confidenceLabel : ''} onClose={onClose}
      footer={obj ? <React.Fragment><Btn variant="ghost" size="sm" onClick={() => onDismiss(obj)}>Dismiss</Btn><span className="dw-grow"></span><Btn variant="pine" size="sm" onClick={() => onResolve(obj)}>Mark resolved</Btn></React.Fragment> : null}>
      {obj && ex ? (
        <React.Fragment>
          <div className="dw-stats" style={{ marginTop: 2 }}>
            <div className="dw-stat"><span className="dw-stat__k">Score</span><div className="dw-stat__v">{obj.score}</div><span className="dw-stat__d">/ 100</span></div>
            <div className="dw-stat"><span className="dw-stat__k">Severity</span><div className="dw-stat__v" style={{ fontSize: 19 }}>{obj.sevLabel}</div><span className="dw-stat__d">{obj.ev} signals</span></div>
            <div className="dw-stat"><span className="dw-stat__k">Confidence</span><div className="dw-stat__v">{ex.confidence}%</div><span className="dw-stat__d">{ex.confidenceLabel}</span></div>
          </div>
          <SectionRule hint="why this surfaced">Evidence</SectionRule>
          {ex.evidence.length ? ex.evidence.map((e, i) => (
            <div className="dw-evrow" key={i}><span className={'dw-evtag t-' + e.type}>{e.type}</span><div className="dw-evrow__b"><p>{e.text}</p>{(e.reader || e.section) ? <span className="dw-evrow__m">{e.reader ? window.DWAdapters.person(e.reader).name : ''}{e.reader && e.section ? ' · ' : ''}{e.section || ''}</span> : null}</div></div>
          )) : <div className="dw-empty"><Icon name="file" size="xl" /><div className="dw-empty__title">No evidence attached yet</div><div className="dw-empty__body">This objection has no evidence rows yet. Regenerate insights after more reader activity.</div></div>}
          {ex.readers.length ? <React.Fragment><SectionRule>Readers involved</SectionRule><div className="dw-evchips">{ex.readers.map((e) => <span key={e} className="dw-evchip"><Avatar email={e} size="sm" />{window.DWAdapters.person(e).name}</span>)}</div></React.Fragment> : null}
          {ex.clarifications.length ? <React.Fragment><SectionRule>Suggested clarifications</SectionRule><ul className="dw-note__list">{ex.clarifications.map((c, i) => <li key={i}>{c}</li>)}</ul></React.Fragment> : null}
        </React.Fragment>
      ) : null}
    </Drawer>
  );
}

/* ---- Pre-call note ---- */
function PreCallNote({ toast }) {
  const store = useStore();
  const [note, setNote] = useState(null);
  const [busy, setBusy] = useState('');
  const createNote = async () => {
    setBusy('generate');
    try {
      const generated = await store.generatePrecallNote();
      setNote(generated);
      toast('Pre-call note generated', true);
    } catch (error) {
      toast(error.message || 'Could not generate pre-call note');
    } finally {
      setBusy('');
    }
  };
  const copyNote = async () => {
    try {
      if (!note || !note.markdown) throw new Error('Generated note did not include Markdown.');
      await window.DWShare.copyText(note.markdown);
      toast('Pre-call note copied', true);
    } catch (error) {
      toast(error.message || 'Could not copy pre-call note');
    }
  };
  const exportNote = async () => {
    setBusy('export');
    try {
      const artifact = await store.exportRoomArtifact('precall', { versionId: note && note.versionId });
      const filename = window.DWDownload.artifact(artifact);
      toast(filename + ' downloaded', true);
    } catch (error) {
      toast(error.message || 'Could not export pre-call note');
    } finally {
      setBusy('');
    }
  };
  if (!note) {
    return (
      <div className="dw-note-cta">
        <div><div className="dw-note-cta__h">Generate a pre-call note</div><p>One evidence-cited brief — engagement, questions, concerns, temperature and open items — assembled from everything in this room. You review and edit before the call.</p></div>
        <span className="dw-grow"></span>
        <Btn variant="pine" size="sm" loading={busy === 'generate'} disabled={!!busy} onClick={createNote}>Generate note →</Btn>
      </div>
    );
  }
  return (
    <div className="dw-note">
      <div className="dw-note__bar"><span className="dw-note__tag">Draft · review before your call</span><span className="dw-grow"></span><button className="dw-action" disabled={!!busy} onClick={createNote}>{busy === 'generate' ? 'Generating...' : '↻ Regenerate'}</button><button className="dw-action" disabled={!!busy} onClick={copyNote}>Copy</button><button className="dw-action" disabled={!!busy} onClick={exportNote}>{busy === 'export' ? 'Exporting...' : 'Export .md'}</button></div>
      <div className="dw-note__doc">
        <div className="dw-note__head"><Eyebrow>Pre-call note · {note.version || 'current version'}</Eyebrow><span className={'dw-temp dw-temp--' + (note.tone || 'warm')}>{note.label} · {note.temperature}</span></div>
        {(note.parts || []).map((p, i) => (
          <div className="dw-note__part" key={i}><div className="dw-note__ph"><span className="dw-note__pn">{i + 1}</span>{p.title}</div>
            {p.items ? <ul className="dw-note__list">{p.items.map((it, j) => <li key={j}>{it}</li>)}</ul> : <p className="dw-note__pb">{p.body}</p>}</div>
        ))}
        <p className="dw-note__foot">Facts are drawn from this room’s activity; lines marked “possible” are inference, not certainty. Edit freely — this never replaces your activity list.</p>
      </div>
    </div>
  );
}

/* ---- Engagement (columns + heatmap) ---- */
function Engagement() {
  const cols = [['§01 Answer', 88, true], ['§02 How', 54, false], ['§03 Pricing', 72, false]];
  const heat = [3, 4, 2, 1, 4, 3, 2, 2, 3, 4, 1, 2, 2, 3, 4, 2];
  return (
    <React.Fragment>
      <SectionRule hint="time spent per section">Section engagement</SectionRule>
      <div className="dw-ins-card">
        <div style={{ maxWidth: 460 }}><div className="dw-columns">{cols.map((c, i) => <div key={i} className={'dw-columns__col' + (c[2] ? ' is-hot' : '')}><span className="dw-columns__v">{c[1]}</span><div className="dw-columns__bar" style={{ height: c[1] + '%' }}></div></div>)}</div>
          <div className="dw-columns__labels">{cols.map((c, i) => <span key={i}>{c[0]}</span>)}</div></div>
      </div>
      <SectionRule hint="section × reader">Attention heatmap</SectionRule>
      <div className="dw-ins-card"><div style={{ maxWidth: 280 }}><div className="dw-heat" style={{ gridTemplateColumns: 'repeat(4,1fr)' }}>{heat.map((l, i) => <div key={i} className={'dw-heat__cell' + (l ? ' l' + l : '')}></div>)}</div>
        <div className="dw-heat-scale" style={{ marginTop: 10 }}>Less <i className="dw-heat__cell"></i><i className="dw-heat__cell l1"></i><i className="dw-heat__cell l2"></i><i className="dw-heat__cell l3"></i><i className="dw-heat__cell l4"></i> More</div></div></div>
    </React.Fragment>
  );
}

Object.assign(window, { ObjectionOrbit, EvidenceDrawer, PreCallNote, PastPreCalls, Engagement, DW_EVIDENCE, DW_NOTE });


/* ---- app/analytics.jsx ---- */
/* ============================================================
   DEALWONDR APP — analytics tabs (DS-driven)
   Engagement · Sections · Journeys — faithful to the original
   Reading Room analytics, rendered entirely on the design system.
   ============================================================ */

/* ---- reader filter pills ---- */
function ReaderFilter({ readers, value, onChange }) {
  return (
    <div className="dw-cluster-2" style={{ overflowX: 'auto', flexWrap: 'nowrap' }}>
      <button className={'dw-chip' + (value === 'all' ? ' is-on' : '')} onClick={() => onChange('all')}>All readers</button>
      {readers.map((e) => <button key={e} className={'dw-chip' + (value === e ? ' is-on' : '')} onClick={() => onChange(e)}>{window.DWAdapters.person(e).name}</button>)}
    </div>
  );
}

/* ---- signal card ---- */
function Signal({ tone, k, children }) {
  const border = tone === 'hot' ? 'var(--dw-accent)' : tone === 'warn' ? 'var(--dw-status-warn)' : 'var(--dw-border-default)';
  return (
    <div className="dw-card dw-card--pad-sm" style={{ borderLeft: '3px solid ' + border }}>
      <span className="dw-overline" style={{ color: tone === 'hot' ? 'var(--dw-accent-text)' : tone === 'warn' ? 'var(--dw-status-warn)' : 'var(--dw-text-secondary)' }}>{k}</span>
      <div className="dw-body-sm dw-mt-2" style={{ lineHeight: 1.5 }}>{children}</div>
    </div>
  );
}

/* ---- status pill mapping ---- */
function statusBadge(status) {
  const map = { Finished: 'pine', Reading: 'outline', Stalled: 'warn', 'Never opened': 'bad' };
  return <Badge variant={map[status] || 'outline'}>{status}</Badge>;
}

function analyticsForVersion(version) {
  return window.DWAdapters.analyticsForVersion(version);
}

function questionnaireStats() {
  return window.DWAdapters.questionnaireStats();
}

function uniqueSessionReaders(sessions) {
  const seen = {};
  return (sessions || []).map((s) => s.reader).filter((email) => {
    if (!email || seen[email]) return false;
    seen[email] = true;
    return true;
  });
}

function sessionLabel(session, index) {
  const count = (session.events || []).length;
  return (session.when || 'Recorded session') + ' · ' + (session.duration || '0s') + ' · ' + count + ' event' + (count === 1 ? '' : 's');
}

function selectedJourneyStats(sessions, reader, session) {
  const readerSessions = sessions.filter((s) => s.reader === reader);
  const allEvents = readerSessions.reduce((n, s) => n + ((s.events || []).length), 0);
  const selectedEvents = (session && session.events) || [];
  const selectedSections = {};
  selectedEvents.forEach((event) => {
    if (event.kind === 'section' || event.kind === 'scroll') selectedSections[event.sectionId || event.section || event.label] = true;
  });
  return {
    readerSessions,
    allEvents,
    selectedEvents,
    selectedSections: Object.keys(selectedSections).length
  };
}

/* ============================================================
   ENGAGEMENT
   ============================================================ */
function EngagementView({ version, onReplay }) {
  const [who, setWho] = useState('all');
  const a = analyticsForVersion(version);
  const readers = Object.keys(a.perReader || {});
  const r = who !== 'all' ? a.perReader[who] : null;

  const roster = (a.readers || []).map((rr) => {
    const pr = (a.perReader || {})[rr.email] || {};
    const comp = parseInt(pr.completion) || 0;
    return { email: rr.email, time: rr.time, last: rr.last, completion: pr.completion || '—', comp, comments: pr.comments || 0, status: comp >= 90 ? 'Finished' : comp >= 50 ? 'Reading' : 'Stalled' };
  });
  (a.neverOpened || []).forEach((s) => {
    const em = s.split(' (')[0];
    if (roster.some((x) => x.email === em)) return;
    roster.push({ email: em, time: '—', last: s.indexOf('(') !== -1 ? s.slice(s.indexOf('(') + 1, -1) : 'invited', completion: '0%', comp: 0, comments: 0, status: 'Never opened' });
  });
  const champion = roster.filter((x) => x.comp).sort((x, y) => y.comp - x.comp)[0];
  const cold = roster.find((x) => x.status === 'Stalled') || roster.find((x) => x.status === 'Never opened');

  return (
    <React.Fragment>
      <div className="dw-cluster dw-mt-4" style={{ justifyContent: 'flex-end' }}>
        <ReaderFilter readers={readers} value={who} onChange={setWho} />
      </div>

      {r ? (
        <div className="dw-stats dw-mt-4">
          <div className="dw-stat"><span className="dw-stat__k">Time on {version.toUpperCase()}</span><div className="dw-stat__v">{r.time}</div><span className="dw-stat__d">last seen {r.last}</span></div>
          <div className="dw-stat"><span className="dw-stat__k">Completion</span><div className="dw-stat__v">{r.completion}</div><span className="dw-stat__d">of this version</span></div>
          <div className="dw-stat"><span className="dw-stat__k">Comments</span><div className="dw-stat__v">{r.comments}</div><span className="dw-stat__d">on {version.toUpperCase()}</span></div>
        </div>
      ) : (
        <div className="dw-stats dw-mt-4">
          <div className="dw-stat"><span className="dw-stat__k">Read time · {version.toUpperCase()}</span><div className="dw-stat__v">{a.totalReadTime}</div><span className="dw-stat__d">{a.delta}</span></div>
          <div className="dw-stat"><span className="dw-stat__k">Readers opened</span><div className="dw-stat__v">{a.readersOpened}</div><span className="dw-stat__d">this version</span></div>
          <div className="dw-stat"><span className="dw-stat__k">Median completion</span><div className="dw-stat__v">{a.completion}</div><span className="dw-stat__d">deepest: {a.deepest}</span></div>
        </div>
      )}

      {r ? (
        <React.Fragment>
          <SectionRule hint={window.DWAdapters.person(who).name + ' only'}>Time per section · {version.toUpperCase()}</SectionRule>
          {r.sectionTime.map((b) => (
            <div className={'dw-barrow' + (b.hot ? ' dw-barrow--hot' : '')} key={b.label}><span className="dw-barrow__l">{b.label}</span><span className="dw-barrow__track"><i style={{ width: b.pct + '%' }}></i></span><span className="dw-barrow__v">{b.time}</span></div>
          ))}
          <p className="dw-body-sm dw-secondary dw-mt-3">{r.insight}</p>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <SectionRule hint="what to act on before the next call">Reading signals</SectionRule>
          <div className="dw-grid-auto">
            <Signal tone="hot" k="Decision point · re-reads">{a.insight}</Signal>
            <Signal k="Most highlighted"><span className="dw-serif">{a.mostHighlighted}</span></Signal>
            <Signal k="Read depth">Median completion <strong>{a.completion}</strong> · deepest reach was <strong>{a.deepest}</strong>.</Signal>
            <Signal k="Momentum"><strong>{a.totalReadTime}</strong> total on {version.toUpperCase()} · {a.delta}.</Signal>
            {champion ? <Signal k="Most engaged"><strong>{window.DWAdapters.person(champion.email).name}</strong> leads — {champion.time}, {champion.completion} read.</Signal> : null}
            <Signal tone={cold ? 'warn' : null} k={cold ? 'Needs a nudge' : 'All engaged'}>{cold ? <React.Fragment><strong>{window.DWAdapters.person(cold.email).name}</strong> is at {cold.completion} — {cold.status === 'Never opened' ? 'hasn’t opened this version yet.' : 'stalled before the close.'}</React.Fragment> : 'Everyone invited has opened and read deeply.'}</Signal>
          </div>

          <SectionRule hint="who’s engaged · who’s gone quiet">Readers</SectionRule>
          <div className="dw-table-scroll"><table className="dw-table">
            <thead><tr><th>Reader</th><th>Status</th><th>Time</th><th style={{ width: 140 }}>Completion</th><th>Comments</th><th>Last seen</th><th></th></tr></thead>
            <tbody>{roster.map((x) => (
              <tr key={x.email} style={{ cursor: x.comp ? 'pointer' : 'default' }} onClick={() => x.comp && setWho(x.email)}>
                <td className="lead"><div className="dw-person"><Avatar email={x.email} size="sm" /><div><div className="dw-person__nm">{window.DWAdapters.person(x.email).name}</div><div className="dw-person__em">{x.email}</div></div></div></td>
                <td>{statusBadge(x.status)}</td>
                <td className="num">{x.time}</td>
                <td><div className="dw-barrow__track" style={{ width: 90, display: 'inline-block', verticalAlign: 'middle' }}><i style={{ width: Math.max(x.comp, 2) + '%', background: x.comp < 50 ? 'var(--dw-status-warn)' : 'var(--dw-pine-500)' }}></i></div> <span className="dw-mono-xs dw-muted">{x.completion}</span></td>
                <td className="num">{x.comments}</td>
                <td className="num dw-muted">{x.last}</td>
                <td style={{ textAlign: 'right' }}>{x.comp ? <button type="button" className="dw-action" onClick={(e) => { e.stopPropagation(); if (onReplay) onReplay(x.email); }}>▶ Replay</button> : null}</td>
              </tr>
            ))}</tbody>
          </table></div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

/* ============================================================
   SECTIONS
   ============================================================ */
function SectionsView({ version }) {
  const a = analyticsForVersion(version);
  const stats = a.sectionStats || [];
  const top = stats.slice().sort((x, y) => (y.hot ? 1 : 0) - (x.hot ? 1 : 0) || y.revisits - x.revisits)[0];
  const skipped = stats.slice().sort((x, y) => y.skips - x.skips)[0];
  const revisited = stats.slice().sort((x, y) => y.revisits - x.revisits)[0];
  const questioned = stats.slice().sort((x, y) => y.questions - x.questions)[0];
  const q = questionnaireStats();
  if (!stats.length) {
    return (
      <React.Fragment>
        <SectionRule hint="active reading time only">Section heat · {version.toUpperCase()}</SectionRule>
        <div className="dw-empty dw-mt-4"><Icon name="chart" size="xl" /><div className="dw-empty__title">No section analytics yet</div><div className="dw-empty__body">Section heat appears once readers spend time in this version.</div></div>
        <SectionRule hint="started · in progress · completed">Questionnaire</SectionRule>
        <div className="dw-stats">
          <div className="dw-stat"><span className="dw-stat__k">Invited</span><div className="dw-stat__v">{q.invited}</div><span className="dw-stat__d">can answer</span></div>
          <div className="dw-stat"><span className="dw-stat__k">Started</span><div className="dw-stat__v">{q.started}</div><span className="dw-stat__d">opened the form</span></div>
          <div className="dw-stat"><span className="dw-stat__k">Completed</span><div className="dw-stat__v">{q.completed}</div><span className="dw-stat__d">submitted</span></div>
          <div className="dw-stat"><span className="dw-stat__k">Avg progress</span><div className="dw-stat__v">{q.avg}%</div><span className="dw-stat__d">{q.inProgress} in progress</span></div>
        </div>
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      <SectionRule hint="active reading time only">Section heat · {version.toUpperCase()}</SectionRule>
      <div className="dw-grid-auto">
        <Signal tone="hot" k="Top attention"><strong>{top.label}</strong> — {top.avg} avg · {top.revisits} revisits.</Signal>
        {skipped && skipped.skips ? <Signal tone="warn" k="Most skipped"><strong>{skipped.label}</strong> — likely skipped by {skipped.skips} reader{skipped.skips === 1 ? '' : 's'}.</Signal> : null}
        <Signal k="Most revisited"><strong>{revisited.label}</strong> — {revisited.revisits} returns.</Signal>
        {questioned && questioned.questions ? <Signal k="Most questioned"><strong>{questioned.label}</strong> — {questioned.questions} question{questioned.questions === 1 ? '' : 's'} attached.</Signal> : null}
      </div>

      <SectionRule>Every section</SectionRule>
      <div className="dw-table-scroll"><table className="dw-table">
        <thead><tr><th>Section</th><th>Readers</th><th>Avg time</th><th>Revisits</th><th>Qs</th><th>Highlights</th><th>Insight</th></tr></thead>
        <tbody>{stats.map((s) => (
          <tr key={s.label}>
            <td className="lead">{s.label}{s.hot ? <span className="dw-dot dw-dot--accent" style={{ marginLeft: 7, display: 'inline-block', verticalAlign: 'middle' }}></span> : null}{s.skips >= 5 ? <Badge variant="warn">likely skipped</Badge> : null}</td>
            <td className="num">{s.readers}</td><td className="num">{s.avg}</td><td className="num">{s.revisits}</td><td className="num">{s.questions}</td><td className="num">{s.highlights}</td>
            <td style={{ color: 'var(--dw-text-secondary)', fontSize: 'var(--dw-text-sm)' }}>{s.insight}</td>
          </tr>
        ))}</tbody>
      </table></div>

      <SectionRule hint="started · in progress · completed">Questionnaire</SectionRule>
      <div className="dw-stats">
        <div className="dw-stat"><span className="dw-stat__k">Invited</span><div className="dw-stat__v">{q.invited}</div><span className="dw-stat__d">can answer</span></div>
        <div className="dw-stat"><span className="dw-stat__k">Started</span><div className="dw-stat__v">{q.started}</div><span className="dw-stat__d">opened the form</span></div>
        <div className="dw-stat"><span className="dw-stat__k">Completed</span><div className="dw-stat__v">{q.completed}</div><span className="dw-stat__d">submitted</span></div>
        <div className="dw-stat"><span className="dw-stat__k">Avg progress</span><div className="dw-stat__v">{q.avg}%</div><span className="dw-stat__d">{q.inProgress} in progress</span></div>
      </div>
    </React.Fragment>
  );
}

/* ============================================================
   JOURNEYS (replay)
   ============================================================ */
function JourneysView({ version, focusReader }) {
  const sessions = window.DWAdapters.sessionsForVersion(version);
  const readers = uniqueSessionReaders(sessions);
  const [reader, setReader] = useState(() => readers.indexOf(focusReader) !== -1 ? focusReader : readers[0]);
  const readerSessions = sessions.filter((s) => s.reader === reader);
  const [sel, setSel] = useState(() => {
    const focused = sessions.find((s) => s.reader === focusReader);
    return focused ? focused.id : (readerSessions[0] && readerSessions[0].id) || (sessions[0] && sessions[0].id);
  });
  const session = sessions.find((s) => s.id === sel) || sessions[0];
  const scopedSessions = sessions.filter((s) => s.reader === reader);
  const scopedSession = scopedSessions.find((s) => s.id === sel) || scopedSessions[0] || session;
  const stats = selectedJourneyStats(sessions, reader, scopedSession);
  useEffect(() => {
    if (!sessions.length) return;
    const nextReader = readers.indexOf(focusReader) !== -1 ? focusReader : (readers.indexOf(reader) !== -1 ? reader : readers[0]);
    const nextSessions = sessions.filter((s) => s.reader === nextReader);
    const currentStillValid = nextSessions.some((s) => s.id === sel);
    setReader(nextReader);
    if (!currentStillValid && nextSessions[0]) setSel(nextSessions[0].id);
  }, [focusReader, version, sessions.length]);
  if (!sessions.length) return <div className="dw-empty dw-mt-4"><Icon name="play" size="xl" /><div className="dw-empty__title">No recorded sessions on {version.toUpperCase()}</div><div className="dw-empty__body">Reader journeys appear here once someone opens this version.</div></div>;
  if (!scopedSession) return <div className="dw-empty dw-mt-4"><Icon name="play" size="xl" /><div className="dw-empty__title">Loading session replay</div><div className="dw-empty__body">Preparing the selected reader journey.</div></div>;
  const replaySessions = scopedSessions.length ? scopedSessions : [scopedSession];
  function chooseReader(nextReader) {
    const nextSessions = sessions.filter((s) => s.reader === nextReader);
    setReader(nextReader);
    if (nextSessions[0]) setSel(nextSessions[0].id);
  }
  return (
    <React.Fragment>
      <div className="dw-journey-controls dw-mt-4">
        <Field label="Reader">
          <select className="dw-select" value={reader || ''} onChange={(e) => chooseReader(e.target.value)}>
            {readers.map((email) => <option key={email} value={email}>{window.DWAdapters.person(email).name} · {email}</option>)}
          </select>
        </Field>
        <Field label="Session">
          <select className="dw-select" value={scopedSession ? scopedSession.id : ''} onChange={(e) => setSel(e.target.value)}>
            {scopedSessions.map((s, index) => <option key={s.id} value={s.id}>{sessionLabel(s, index)}</option>)}
          </select>
        </Field>
      </div>
      <div className="dw-journey-summary">
        <div><span className="dw-stat__k">Selected reader</span><strong>{window.DWAdapters.person(reader).name}</strong><em>{stats.readerSessions.length} session{stats.readerSessions.length === 1 ? '' : 's'} · {stats.allEvents} event{stats.allEvents === 1 ? '' : 's'}</em></div>
        <div><span className="dw-stat__k">Selected session</span><strong>{scopedSession.duration || '0s'}</strong><em>{scopedSession.when || 'Recorded'} · {stats.selectedEvents.length} event{stats.selectedEvents.length === 1 ? '' : 's'}</em></div>
        <div><span className="dw-stat__k">Replay coverage</span><strong>{stats.selectedSections || '—'}</strong><em>section{stats.selectedSections === 1 ? '' : 's'} touched in this session</em></div>
      </div>
      <SectionRule hint={scopedSession ? 'press play — watch how ' + window.DWAdapters.person(scopedSession.reader).name + ' moved through the room' : ''}>Session replay</SectionRule>
      <Replay sessions={replaySessions} selId={scopedSession.id} onSelect={setSel} version={version} />
    </React.Fragment>
  );
}

Object.assign(window, { EngagementView, SectionsView, JourneysView, ReaderFilter, analyticsForVersion });


/* ---- app/replay-frame.jsx ---- */
/* ============================================================
   DEALWONDR APP — hosted replay frame
   Renders the same hosted HTML document/prototype used by readers
   and drives its internal scroll via postMessage during replay.
   ============================================================ */

function injectReplayFrameController(html) {
  const controller = `<script>
(function(){
  function maxScroll(){
    var htmlHeight = document.documentElement && document.documentElement.scrollHeight || 0;
    var bodyHeight = document.body && document.body.scrollHeight || 0;
    return Math.max(
      0,
      Math.max(htmlHeight, bodyHeight) - window.innerHeight
    );
  }
  function scrollToPercent(percent){
    var pct = Math.max(0, Math.min(100, Number(percent) || 0));
    var top = Math.round(maxScroll() * (pct / 100));
    window.scrollTo({ top: top, left: 0, behavior: "auto" });
    if (document.documentElement) document.documentElement.scrollTop = top;
    if (document.body) document.body.scrollTop = top;
  }
  window.addEventListener("message", function(event){
    var data = event.data || {};
    if (typeof data === "string") {
      try { data = JSON.parse(data); } catch (error) { data = {}; }
    }
    if (!data || data.source !== "dealwondr-replay-player") return;
    if (data.type === "scroll_to_percent") {
      scrollToPercent(data.percent);
      requestAnimationFrame(function(){ scrollToPercent(data.percent); });
    }
  });
})();</script>`;
  if (/<\/body>/i.test(html || "")) return String(html).replace(/<\/body>/i, controller + "</body>");
  if (/<\/html>/i.test(html || "")) return String(html).replace(/<\/html>/i, controller + "</html>");
  return String(html || "") + controller;
}

function replayFrameViewport(viewport) {
  return {
    width: Math.max(320, Math.min(1920, Number(viewport && viewport.width) || 1280)),
    height: Math.max(520, Math.min(2200, Number(viewport && viewport.height) || 900))
  };
}

function ReplayFrame({ target, currentEvent, viewport }) {
  const store = useStore();
  const shellRef = useRef(null);
  const frameRef = useRef(null);
  const currentEventRef = useRef(null);
  const [srcDoc, setSrcDoc] = useState("");
  const [status, setStatus] = useState(target ? "loading" : "idle");
  const [error, setError] = useState("");
  const [scale, setScale] = useState(1);
  const frameViewport = replayFrameViewport(viewport);
  currentEventRef.current = currentEvent;

  useEffect(() => {
    const shell = shellRef.current;
    if (!shell) return undefined;
    function measure() {
      const rect = shell.getBoundingClientRect();
      const nextScale = Math.min(
        rect.width / frameViewport.width,
        rect.height / frameViewport.height
      );
      setScale(Math.max(0.12, Math.min(1, Number.isFinite(nextScale) ? nextScale : 1)));
    }
    measure();
    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", measure);
      return () => window.removeEventListener("resize", measure);
    }
    const observer = new ResizeObserver(measure);
    observer.observe(shell);
    return () => observer.disconnect();
  }, [frameViewport.width, frameViewport.height]);

  useEffect(() => {
    let cancelled = false;
    if (!target) {
      setStatus("idle");
      setSrcDoc("");
      return undefined;
    }
    setStatus("loading");
    setError("");
    setSrcDoc("");
    const request = target.kind === "prototype_html"
      ? store.prototypeFrameHtml(target.roomId, target.prototypeId)
      : store.documentFrameHtml(target.roomId, target.documentId, target.versionId);
    request.then((html) => {
      if (cancelled) return;
      setSrcDoc(injectReplayFrameController(html));
      setStatus("ready");
    }).catch((err) => {
      if (cancelled) return;
      setError(err.message || "Replay frame content is unavailable.");
      setStatus("error");
    });
    return () => { cancelled = true; };
  }, [
    target && target.kind,
    target && target.roomId,
    target && target.documentId,
    target && target.versionId,
    target && target.prototypeId
  ]);

  function postScroll() {
    const event = currentEventRef.current;
    if (!frameRef.current || !frameRef.current.contentWindow || !event) return;
    if (event.scrollPercent === null || event.scrollPercent === undefined) return;
    const message = {
      source: "dealwondr-replay-player",
      type: "scroll_to_percent",
      percent: event.scrollPercent
    };
    try {
      frameRef.current.contentWindow.postMessage(message, "*");
      frameRef.current.contentWindow.postMessage(JSON.stringify(message), "*");
      frameRef.current.setAttribute("data-replay-posted", String(event.scrollPercent));
    } catch (error) {
      frameRef.current.setAttribute("data-replay-posted", "error");
    }
  }

  useEffect(() => {
    if (status !== "ready") return undefined;
    const timer = setInterval(postScroll, 250);
    return () => clearInterval(timer);
  }, [status]);

  useEffect(() => {
    postScroll();
    if (status !== "ready" || !currentEvent || currentEvent.scrollPercent === null || currentEvent.scrollPercent === undefined) return undefined;
    const timers = [80, 240].map((ms) => setTimeout(postScroll, ms));
    return () => timers.forEach(clearTimeout);
  }, [currentEvent && currentEvent.sec, currentEvent && currentEvent.scrollPercent, status]);

  if (!target) return null;
  if (status === "error") {
    return (
      <div ref={shellRef} className="dw-replay-frame-shell">
        <div className="dw-replay-frame--empty">
          <Icon name="file" size="xl" />
          <div className="dw-empty__title">Replay frame unavailable</div>
          <div className="dw-empty__body">{error}</div>
        </div>
      </div>
    );
  }
  if (status === "loading") {
    return (
      <div ref={shellRef} className="dw-replay-frame-shell">
        <div className="dw-replay-frame--empty">
          <span className="dw-spinner"></span>
          <div className="dw-empty__title">Loading replay frame</div>
        </div>
      </div>
    );
  }
  return (
    <div ref={shellRef} className="dw-replay-frame-shell">
      <div
        className="dw-replay-frame-scale"
        style={{
          width: frameViewport.width,
          height: frameViewport.height,
          transform: 'scale(' + scale + ')'
        }}
      >
        <iframe
          ref={frameRef}
          className="dw-replay-frame"
          title={target.title || "Replay frame"}
          sandbox="allow-scripts allow-forms allow-popups allow-downloads"
          srcDoc={srcDoc}
          width={frameViewport.width}
          height={frameViewport.height}
          data-replay-scroll={currentEvent && currentEvent.scrollPercent !== null && currentEvent.scrollPercent !== undefined ? currentEvent.scrollPercent : ""}
          onLoad={postScroll}
        />
      </div>
    </div>
  );
}

Object.assign(window, { ReplayFrame });


/* ---- app/replay.jsx ---- */
/* ============================================================
   DEALWONDR APP — Session Replay (parity with the original app)
   A working session-replay player: a captured viewport on the LEFT
   that renders the REAL document scrolling under a live cursor,
   a synced, auto-scrolling event log on the RIGHT. Drives per-
   reader journey playback from DW_ANALYTICS.sessions.
   Transport: prev/next section · play · speed 1/2/4/8× · skip-idle
   · autoplay-to-next. Stats header + revisited summary on top.
   ============================================================ */

/* seconds → "M:SS" */
function tlFmt(s) { const m = Math.floor(s / 60), ss = Math.floor(s % 60); return m + ':' + (ss < 10 ? '0' : '') + ss; }
/* "52m 10s" / "44m" → seconds */
function durToSec(d) { if (!d) return 0; const mm = /(\d+)\s*m/.exec(d), ss = /(\d+)\s*s/.exec(d); return (mm ? +mm[1] : 0) * 60 + (ss ? +ss[1] : 0); }
function ordinal(n) { const s = ['th', 'st', 'nd', 'rd'], v = n % 100; return n + (s[(v - 20) % 10] || s[v] || s[0]); }
function replayViewport(events) {
  const row = (events || []).find((event) => event && event.payload && event.payload.viewport);
  const viewport = row && row.payload && row.payload.viewport;
  const width = Math.max(320, Math.min(1920, Number(viewport && viewport.width) || 1280));
  const height = Math.max(520, Math.min(2200, Number(viewport && viewport.height) || 900));
  return { width, height, aspect: width + ' / ' + height };
}

/* colours keyed by event kind — bright for the dark scrubber, deep for the light log */
const KIND_SCRUB = { section: 'color-mix(in srgb, var(--dw-cream-100) 55%, transparent)', scroll: 'var(--dw-pine-500)', highlight: 'var(--dw-poppy-500)', comment: 'var(--dw-accent)', click: 'var(--dw-pine-400, var(--dw-pine-500))', prototype: 'var(--dw-accent)', idle: 'color-mix(in srgb, var(--dw-cream-100) 26%, transparent)' };
const KIND_DOT = { section: 'var(--dw-warm-grey)', scroll: 'var(--dw-pine-500)', highlight: 'var(--dw-poppy-600)', comment: 'var(--dw-accent)', click: 'var(--dw-pine-500)', prototype: 'var(--dw-accent)', idle: 'var(--dw-border-strong)' };
const POP_LABEL = { comment: 'Asked a question', highlight: 'Highlighted', idle: 'Idle' };

function Replay({ sessions, selId, onSelect, version }) {
  const session = sessions.find((s) => s.id === selId) || sessions[0];
  if (!session) return <div className="dw-empty"><Icon name="play" size="xl" /><div className="dw-empty__title">No replay session selected</div><div className="dw-empty__body">Choose a reader and session to play the journey.</div></div>;
  const replayDocs = window.DWAdapters.replayDocs();
  const replayDoc = window.DWAdapters.replayDocSections(replayDocs, window.DWDisplay.roomTitle());
  const replayLabels = window.DWAdapters.replaySectionLabels(replayDoc);

  const events = window.DWAdapters.mapReplayEvents(session.events);
  const replayFrameTarget = window.DWAdapters.replayFrameTarget(events, replayDocs, version);
  const hasScrollEvents = events.some((e) => e.scrollPercent !== null && e.scrollPercent !== undefined);
  const replayFrameViewport = replayViewport(events);
  const stageStyle = { '--dw-replay-aspect': replayFrameViewport.aspect };
  const total = durToSec(session.duration) || ((events[events.length - 1] ? events[events.length - 1].sec : 0) + 30);

  const [pos, setPos] = useState(0);          // seconds into the session
  const [playing, setPlaying] = useState(true);
  const [speed, setSpeed] = useState(4);
  const [skipIdle, setSkipIdle] = useState(true);
  const [autoplay, setAutoplay] = useState(true);
  const [scrollY, setScrollY] = useState(0);
  const [full, setFull] = useState(false);
  const timer = useRef(null);
  const secRefs = useRef({});
  const pageRef = useRef(null);
  const stageRef = useRef(null);
  const logRef = useRef(null);

  /* reset transport when the selected session changes */
  useEffect(() => { setPos(0); setPlaying(true); }, [session.id]);

  useEffect(() => {
    if (!full) return undefined;
    const onKey = (event) => { if (event.key === 'Escape') setFull(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [full]);

  /* playback loop — setInterval + wall-clock dt so timer throttling can't stall it */
  useEffect(() => {
    if (!playing) return;
    let prev = Date.now();
    timer.current = setInterval(() => {
      const now = Date.now();
      const dt = (now - prev) / 1000; prev = now;
      setPos((p) => {
        let np = p + dt * speed * 14;          // compressed wall-clock — watchable
        if (skipIdle) {
          const idle = events.find((e) => e.kind === 'idle' && p < e.sec && np >= e.sec);
          if (idle) { const after = events.find((e) => e.sec > idle.sec); if (after) np = after.sec; }
        }
        if (np >= total) {
          if (autoplay) {
            const idx = sessions.findIndex((s) => s.id === session.id);
            const nxt = sessions[idx + 1];
            if (nxt) { setTimeout(() => onSelect(nxt.id), 650); return total; }
          }
          setPlaying(false); return total;
        }
        return np;
      });
    }, 200);
    return () => clearInterval(timer.current);
  }, [playing, speed, skipIdle, autoplay, session.id, total]);

  const curIdx = (() => { let i = 0; for (let j = 0; j < events.length; j++) if (events[j].sec <= pos) i = j; return i; })();
  const cur = events[curIdx];
  const activeSection = cur ? cur.section : 's1';
  const pct = Math.min(100, (pos / total) * 100);

  /* scroll the real page so the active section rides near the top of the stage */
  useEffect(() => {
    const el = secRefs.current[activeSection]; const page = pageRef.current; const stage = stageRef.current;
    if (replayFrameTarget) {
      setScrollY(0);
      return;
    }
    if (!page || !stage) return;
    const max = Math.max(0, page.offsetHeight - stage.clientHeight + 20);
    if (cur && cur.scrollPercent !== null && cur.scrollPercent !== undefined) {
      setScrollY(Math.min(max, Math.max(0, Math.round(max * (cur.scrollPercent / 100)))));
      return;
    }
    if (!el || !page || !stage) return;
    setScrollY(Math.min(max, Math.max(0, el.offsetTop - 16)));
  }, [activeSection, curIdx, session.id, replayFrameTarget && replayFrameTarget.kind]);

  /* keep the live log row centred (manual scroll — never scrollIntoView) */
  useEffect(() => {
    const log = logRef.current; if (!log) return;
    const row = log.querySelector('.dw-tl-event.is-now');
    if (row) log.scrollTop = Math.max(0, row.offsetTop - log.clientHeight / 2 + row.clientHeight / 2);
  }, [curIdx, session.id]);

  /* cursor lands inside the active section, offset by event kind */
  const secEl = secRefs.current[activeSection];
  const stageH = stageRef.current ? stageRef.current.clientHeight : 440;
  const cursorTop = secEl ? Math.min(stageH - 26, Math.max(18, (secEl.offsetTop - scrollY) + 44)) : 60;
  const cursorLeft = cur && cur.kind === 'highlight' ? '64%' : cur && cur.kind === 'comment' ? '72%' : '34%';
  const showPop = cur && (cur.kind === 'comment' || cur.kind === 'highlight' || cur.kind === 'idle') && (pos - cur.sec) < 3 && playing;

  /* derived journey stats */
  const sectionEvents = events.filter((e) => e.kind === 'section' || e.kind === 'scroll');
  const visitCounts = {}; sectionEvents.forEach((e) => { visitCounts[e.section] = (visitCounts[e.section] || 0) + 1; });
  const sectionsSeen = Object.keys(visitCounts).length;
  const revisited = Object.keys(visitCounts).filter((k) => visitCounts[k] > 1);
  const hlN = events.filter((e) => e.kind === 'highlight').length;
  const cmN = events.filter((e) => e.kind === 'comment').length;
  const qRow = (window.DWAdapters.questionnaireStats().rows || []).find((r) => r.email === session.reader);
  const qStat = qRow ? qRow.status : '—';
  const person = window.DWAdapters.person(session.reader);
  const a = window.DWAdapters.analyticsForVersion(version);
  const focusInsight = (a.perReader[session.reader] || {}).insight || '';
  const role = (person.dealRole ? person.dealRole[0].toUpperCase() + person.dealRole.slice(1) : 'Reader');

  /* running visit annotations for the log ("· 2nd visit") */
  const seenSoFar = {}; const logAnno = events.map((e) => { if (e.kind !== 'section') return ''; seenSoFar[e.section] = (seenSoFar[e.section] || 0) + 1; return seenSoFar[e.section] > 1 ? '· ' + ordinal(seenSoFar[e.section]) + ' visit' : ''; });

  /* transport actions */
  function toggle() { if (pos >= total) setPos(0); setPlaying((p) => !p); }
  function seekTo(sec) { setPos(sec); }
  function seekSection(dir) {
    const target = dir > 0 ? sectionEvents.find((e) => e.sec > pos + 0.5) : sectionEvents.slice().reverse().find((e) => e.sec < pos - 1.5);
    if (target) setPos(target.sec);
  }
  function scrub(e) { const r = e.currentTarget.getBoundingClientRect(); setPos(Math.max(0, Math.min(total, ((e.clientX - r.left) / r.width) * total))); }

  return (
    <div className="dw-journey">
      {/* ── stats header ── */}
      <div className="dw-jhead">
        <Avatar email={session.reader} size="lg" />
        <div className="dw-jhead__id"><span className="dw-jhead__nm">{person.name}</span><span className="dw-jhead__sub">{role} · {session.when}</span></div>
        <span className="dw-grow"></span>
        <div className="dw-jstats">
          <span><b>{session.duration}</b>active</span>
          <span><b>{sectionsSeen}</b>sections</span>
          <span><b>{revisited.length}</b>revisited</span>
          <span><b>{hlN}</b>highlights</span>
          <span><b>{cmN}</b>comments</span>
          <span><b style={{ textTransform: 'capitalize' }}>{qStat}</b>questionnaire</span>
        </div>
      </div>
      {revisited.length ? (
        <div className="dw-jsummary">Revisited <strong>{revisited.map((k) => (replayLabels[k] || k).replace(/^§\d+\s*·?\s*/, '')).slice(0, 3).join(', ')}</strong> — returned to re-read the parts that matter most.</div>
      ) : null}

      <div className={'dw-replay' + (full ? ' is-fullscreen' : '')}>
        {full ? (
          <div className="dw-replay__fullbar">
            <span><strong>Session replay</strong><em>{person.name} · {session.when}</em></span>
            <Btn variant="ghost" size="sm" icon="x" onClick={() => setFull(false)}>Exit full screen</Btn>
          </div>
        ) : null}
        {/* ── LEFT — captured viewport player ── */}
        <div className="dw-replay__main">
          <div className="dw-jstage" ref={stageRef} style={stageStyle}>
            <span className="dw-jlive">{replayFrameTarget ? 'Active replay · hosted page' : 'Active replay · parsed page'}</span>
            {replayFrameTarget ? (
              <ReplayFrame target={replayFrameTarget} currentEvent={cur} viewport={replayFrameViewport} />
            ) : (
              <div className="dw-jpage" ref={pageRef} style={{ transform: 'translateY(' + (-scrollY) + 'px)' }}>
                {replayDoc.map((s) => {
                  const active = s.id === activeSection;
                  const hot = active && cur && cur.kind === 'highlight';
                  return (
                    <div key={s.id} ref={(el) => { secRefs.current[s.id] = el; }} className={'dw-jsec' + (active ? ' is-active' : '')}>
                      <div className="dw-jsec__eyebrow">{s.eyebrow}</div>
                      <div className="dw-jsec__h">{s.h}</div>
                      {s.paras.map((p, i) => <p key={i} className={'dw-jsec__p' + (hot && i === 1 ? ' is-hl' : '')}>{p}</p>)}
                    </div>
                  );
                })}
                {hasScrollEvents ? <div aria-hidden="true" style={{ height: 520 }}></div> : null}
              </div>
            )}
            {(playing || pos > 0) ? <div className="dw-jcursor" style={{ left: cursorLeft, top: cursorTop }}></div> : null}
            {showPop ? <div key={curIdx} className={'dw-poster__pop k-' + cur.kind} style={{ left: cursorLeft, top: cursorTop }}>{POP_LABEL[cur.kind]}</div> : null}
          </div>

          {/* transport */}
          <div className="dw-player">
            <div className="dw-player__scrub">
              <div className="dw-player__line" style={{ cursor: 'pointer' }} onClick={scrub}>
                <i style={{ width: pct + '%' }}></i>
                {events.map((e, i) => <span key={i} title={e.label} style={{ position: 'absolute', left: (e.sec / total * 100) + '%', top: -3, width: 3, height: 12, background: KIND_SCRUB[e.kind], borderRadius: 2, transform: 'translateX(-1px)' }}></span>)}
                <span className="dw-player__head" style={{ left: pct + '%' }}></span>
              </div>
              <div className="dw-player__meta"><span>{tlFmt(pos)} / {tlFmt(total)}</span><span style={{ cursor: 'pointer' }} onClick={() => setAutoplay((v) => !v)}>autoplay · {autoplay ? 'on' : 'off'}</span></div>
            </div>
            <div className="dw-player__transport">
              <button className="dw-skipbtn" onClick={() => seekSection(-1)} title="Previous section">⏮</button>
              <button className={'dw-playbtn' + (playing ? ' is-playing' : '')} onClick={toggle} aria-label={playing ? 'Pause' : 'Play'}></button>
              <button className="dw-skipbtn" onClick={() => seekSection(1)} title="Next section">⏭</button>
              <span className="dw-grow"></span>
              {[1, 2, 4, 8].map((s) => <button key={s} className={'dw-speed' + (speed === s ? ' is-on' : '')} onClick={() => setSpeed(s)}>{s}×</button>)}
              <button className={'dw-speed dw-speed--dash' + (skipIdle ? ' is-on' : '')} onClick={() => setSkipIdle((v) => !v)} title="Skip idle gaps">skip idle</button>
              {!full ? <button className="dw-speed dw-speed--dash" onClick={() => setFull(true)} title="Open replay full screen">full screen</button> : null}
            </div>
          </div>
          {focusInsight ? <p className="dw-body-sm dw-secondary" style={{ margin: '2px 2px 0' }}>{focusInsight}</p> : null}
        </div>

        {/* ── RIGHT — synced event log ── */}
        <div className="dw-timeline">
          <div className="dw-timeline__head"><span>Reading journey · synced</span><span>{curIdx + 1} / {events.length}</span></div>
          <div className="dw-timeline__scroll" ref={logRef} style={{ maxHeight: 472 }}>
            {events.map((e, i) => (
              <div key={i} className={'dw-tl-event' + (i === curIdx ? ' is-now' : i < curIdx ? ' is-past' : '')} onClick={() => seekTo(e.sec)}>
                <span className="dw-tl-event__t">{e.t}</span>
                <span className="dw-tl-event__rail"><span className="dw-tl-event__dot" style={{ background: KIND_DOT[e.kind] }}></span></span>
                <span><span className="dw-tl-event__b">{e.label}{logAnno[i] ? <em className="dw-tl-event__visit"> {logAnno[i]}</em> : null}</span><div className="dw-tl-event__k">{e.kind}</div></span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

Object.assign(window, { Replay });


/* ---- app/builder.jsx ---- */
/* ============================================================
   DEALWONDR APP — gap-fill screens
   Questionnaire builder · Content>Questionnaires view ·
   Super console · Export drawer · Invite-teammate modal +
   member kebab menu.
   ============================================================ */

/* ===================== QUESTIONNAIRE BUILDER ===================== */
function QuestionnaireBuilder({ seed, onClose, toast, onSave }) {
  const isMobile = useIsMobile();
  const baseFields = seed && seed.fields && seed.fields.length ? seed.fields : (seed && seed.schema ? window.DWAdapters.schemaFields(seed.schema) : []);
  const [title, setTitle] = useState(seed && (seed.title || seed.name) ? (seed.title || seed.name) : 'Untitled questionnaire');
  const [fields, setFields] = useState(baseFields.map((f) => ({ ...f })));
  const [sel, setSel] = useState(0);
  const [placement, setPlacement] = useState(seed && seed.placement ? seed.placement : 'post');
  const [preview, setPreview] = useState(false);
  const [drag, setDrag] = useState(null);
  const [saving, setSaving] = useState(false);

  const addField = (type) => {
    const meta = window.DWAdapters.fieldTypes().find((t) => t.type === type);
    const nf = { id: 'f' + Date.now(), type, label: meta.label + ' question', required: false };
    if (['single', 'multi', 'yesno', 'ranking'].indexOf(type) > -1) nf.options = type === 'yesno' ? ['Yes', 'No'] : ['Option 1', 'Option 2'];
    setFields((f) => [...f, nf]); setSel(fields.length);
  };
  const update = (i, patch) => setFields((f) => f.map((x, j) => j === i ? { ...x, ...patch } : x));
  const remove = (i) => { setFields((f) => f.filter((_, j) => j !== i)); setSel(Math.max(0, i - 1)); };
  const onDrop = (i) => { if (drag === null || drag === i) return; setFields((f) => { const a = [...f]; const [m] = a.splice(drag, 1); a.splice(i, 0, m); return a; }); setDrag(null); };
  const toSchema = () => ({
    steps: [{
      id: 'step_1',
      title: title.trim() || 'Questionnaire',
      questions: fields.map((field, index) => ({
        id: field.id || 'q' + (index + 1),
        type: field.type === 'long' ? 'long_text' : field.type === 'short' ? 'short_text' : field.type === 'single' ? 'single_select' : field.type === 'multi' ? 'multi_select' : field.type,
        label: field.label,
        help: field.help || '',
        required: !!field.required,
        options: field.options || []
      }))
    }]
  });
  const save = async () => {
    setSaving(true);
    try {
      const payload = {
        id: seed && seed.id,
        name: title.trim() || 'Untitled questionnaire',
        title: title.trim() || 'Untitled questionnaire',
        fields: fields,
        schema: toSchema(),
        placement: placement,
        mode: fields.length > 6 ? 'multi' : 'single',
        status: seed && seed.status ? seed.status : 'draft',
        introText: seed && seed.introText ? seed.introText : '',
        outroText: seed && seed.outroText ? seed.outroText : ''
      };
      if (!onSave) throw new Error('Questionnaire save handler is not configured.');
      await onSave(payload);
      onClose();
    } catch (error) {
      toast(error.message || 'Could not save questionnaire');
    } finally {
      setSaving(false);
    }
  };

  const cur = fields[sel];
  const placements = window.DWAdapters.questionnairePlacements();

  if (preview) {
    return (
      <Modal open wide title={title} sub="Preview — this is what your client fills in" onClose={() => setPreview(false)}
        footer={<Btn variant="ghost" size="sm" onClick={() => setPreview(false)}>← Back to editor</Btn>}>
        {fields.map((q) => <QField key={q.id} q={{ ...q, opts: q.options, req: q.required }} value={undefined} onChange={() => {}} />)}
      </Modal>
    );
  }

  return (
    <Modal open wide title="Questionnaire builder" sub="Drag to reorder · click a field to edit · 14 field types" onClose={onClose}
      footer={<React.Fragment><Btn variant="ghost" size="sm" onClick={() => setPreview(true)}>Preview</Btn><span className="dw-grow"></span><Btn variant="ghost" size="sm" disabled={saving} onClick={onClose}>Cancel</Btn><Btn variant="pine" size="sm" loading={saving} disabled={saving || !title.trim()} onClick={save}>Save questionnaire</Btn></React.Fragment>}>
      <Field label="Title"><input className="dw-input" value={title} onChange={(e) => setTitle(e.target.value)} /></Field>
      <div className="dw-mt-3">
        <label className="dw-label">Placement</label>
        <div className="dw-seg dw-mt-2">{Object.keys(placements).map((key) => <button key={key} className={'dw-seg__opt' + (placement === key ? ' is-on' : '')} onClick={() => setPlacement(key)}>{placements[key][0]}</button>)}</div>
        <div className="dw-hint">{(placements[placement] || placements.post)[1]}</div>
      </div>
      <div className="dw-grid-2 dw-mt-4" style={{ gridTemplateColumns: isMobile ? '1fr' : '1.3fr 1fr', alignItems: 'start', gap: 18 }}>
        {/* canvas */}
        <div>
          <SectionRule hint={fields.length + ' fields'}>Fields</SectionRule>
          {fields.map((f, i) => (
            <div key={f.id} draggable onDragStart={() => setDrag(i)} onDragOver={(e) => e.preventDefault()} onDrop={() => onDrop(i)}
              onClick={() => setSel(i)}
              className="dw-card dw-card--pad-sm dw-mt-2" style={{ cursor: 'pointer', borderColor: sel === i ? 'var(--dw-border-strong)' : 'var(--dw-border-default)', boxShadow: sel === i ? 'inset 3px 0 0 var(--dw-accent)' : 'none', opacity: drag === i ? 0.5 : 1 }}>
              <div className="dw-row">
                <div className="dw-cluster-2" style={{ minWidth: 0 }}><span style={{ color: 'var(--dw-text-faint)', cursor: 'grab' }}>⠿</span><span className="dw-body-sm" style={{ fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.label}</span></div>
                <div className="dw-cluster-2" style={{ flex: 'none' }}><span className="dw-verpill">{f.type}</span>{f.required ? <span className="dw-req" style={{ marginLeft: 0 }}>required</span> : null}<button className="dw-kebab" onClick={(e) => { e.stopPropagation(); remove(i); }}><Icon name="trash" size="sm" /></button></div>
              </div>
            </div>
          ))}
          <SectionRule>Add a field</SectionRule>
          <div className="dw-cluster-2">{window.DWAdapters.fieldTypes().map((t) => <button key={t.type} className="dw-chip" onClick={() => addField(t.type)}><Icon name={t.icon} size="sm" /> {t.label}</button>)}</div>
        </div>
        {/* inspector */}
        <div className="dw-card dw-card--sunken" style={{ position: 'sticky', top: 0 }}>
          <SectionRule>Edit field</SectionRule>
          {cur ? (
            <React.Fragment>
              <Field label="Question"><input className="dw-input dw-input--sm" value={cur.label} onChange={(e) => update(sel, { label: e.target.value })} /></Field>
              <div className="dw-mt-3"><Field label="Help text" optional><input className="dw-input dw-input--sm" value={cur.help || ''} onChange={(e) => update(sel, { help: e.target.value })} placeholder="Shown under the question" /></Field></div>
              {cur.options ? (
                <div className="dw-mt-3"><label className="dw-label">Options</label>
                  {cur.options.map((o, oi) => (
                    <div key={oi} className="dw-cluster-2 dw-mt-2"><input className="dw-input dw-input--sm" value={o} onChange={(e) => update(sel, { options: cur.options.map((x, j) => j === oi ? e.target.value : x) })} /><button className="dw-kebab" onClick={() => update(sel, { options: cur.options.filter((_, j) => j !== oi) })}><Icon name="x" size="sm" /></button></div>
                  ))}
                  <button className="dw-jump dw-mt-2" onClick={() => update(sel, { options: [...cur.options, 'Option ' + (cur.options.length + 1)] })}>+ Add option</button>
                </div>
              ) : null}
              <label className="dw-choice dw-mt-4"><input type="checkbox" className="dw-switch" checked={!!cur.required} onChange={() => update(sel, { required: !cur.required })} /> Required</label>
            </React.Fragment>
          ) : <div className="dw-body-sm dw-muted">Add a field to begin.</div>}
        </div>
      </div>
    </Modal>
  );
}

/* ===================== CONTENT > QUESTIONNAIRES ===================== */
/* % of fields a response actually answered */
function qCompletion(resp, fields) {
  const n = fields.filter((f) => { const v = resp.answers && resp.answers[f.id]; return v != null && v !== '' && !(Array.isArray(v) && v.length === 0); }).length;
  return Math.round(n / fields.length * 100);
}
function QBar({ label, count, pct, suffix }) {
  return <div className="dw-barrow"><span className="dw-barrow__l">{label}</span><span className="dw-barrow__track"><i style={{ width: Math.max(pct, 1.5) + '%' }}></i></span><span className="dw-barrow__v">{count}{suffix || ''} · {pct}%</span></div>;
}
function qAnswerText(value) {
  if (Array.isArray(value)) return value.join(' → ');
  if (value && typeof value === 'object') {
    if (value.fileName) return value.fileName + (value.bytes ? ' · ' + Math.ceil(value.bytes / 1024) + ' KB' : '');
    return JSON.stringify(value);
  }
  return String(value);
}
function qResponseAnswerText(field, value) {
  if (value == null || value === '' || (Array.isArray(value) && value.length === 0)) return null;
  if (field.type === 'rating') return value + ' / 5';
  if (field.type === 'consent') return 'Agreed';
  if (field.type === 'yesno') return value === 'yes' ? 'Yes' : value === 'no' ? 'No' : qAnswerText(value);
  return qAnswerText(value);
}
function QResponseAnswer({ questionnaireId, field, value }) {
  const store = useStore();
  const text = qResponseAnswerText(field, value);
  if (!text) return <span className="sa empty">— not answered</span>;
  if (field.type === 'file' && value && value.key) {
    return (
      <button type="button" className="dw-action sa" style={{ textAlign: 'left', justifyContent: 'flex-start' }} onClick={async () => {
        const artifact = await store.downloadQuestionnaireAttachment(questionnaireId, value);
        window.DWDownload.artifact(artifact);
      }}>
        <Icon name="download" size="sm" /> {text}
      </button>
    );
  }
  return <span className="sa">{text}</span>;
}
/* one result card — aggregates a single question across completed responses */
function QResultCard({ field, responses, questionnaireId }) {
  const store = useStore();
  const N = responses.length;
  const vals = responses.map((r) => r.answers[field.id]).filter((v) => v != null && v !== '' && !(Array.isArray(v) && v.length === 0));
  const answered = vals.length;
  let body;
  if (field.type === 'single' || field.type === 'yesno' || field.type === 'consent') {
    const opts = field.options || (field.type === 'yesno' ? ['Yes', 'No'] : ['Agreed']);
    const norm = (v) => field.type === 'consent' ? 'Agreed' : (v === 'yes' ? 'Yes' : v === 'no' ? 'No' : v);
    const counts = {}; opts.forEach((o) => (counts[o] = 0)); vals.forEach((v) => { const k = norm(v); if (k in counts) counts[k]++; });
    body = opts.map((o) => <QBar key={o} label={o} count={counts[o]} pct={answered ? Math.round(counts[o] / answered * 100) : 0} />);
  } else if (field.type === 'multi') {
    const opts = field.options || [];
    const counts = {}; opts.forEach((o) => (counts[o] = 0)); vals.forEach((arr) => (arr || []).forEach((v) => { if (v in counts) counts[v]++; }));
    body = opts.map((o) => <QBar key={o} label={o} count={counts[o]} pct={answered ? Math.round(counts[o] / answered * 100) : 0} />);
  } else if (field.type === 'rating') {
    const nums = vals.map(Number).filter((n) => !isNaN(n));
    const avg = nums.length ? nums.reduce((a, b) => a + b, 0) / nums.length : 0;
    const dist = [1, 2, 3, 4, 5].map((s) => nums.filter((n) => n === s).length);
    body = (
      <React.Fragment>
        <div className="dw-cluster-2" style={{ alignItems: 'baseline', marginBottom: 8 }}><span className="dw-stat__v" style={{ fontSize: 'var(--dw-text-2xl)' }}>{avg.toFixed(1)}</span><span className="dw-mono-xs dw-muted">avg · 1 = exploring · 5 = need it now</span></div>
        {[5, 4, 3, 2, 1].map((s) => <QBar key={s} label={s + ' ★'} count={dist[s - 1]} pct={answered ? Math.round(dist[s - 1] / answered * 100) : 0} />)}
      </React.Fragment>
    );
  } else if (field.type === 'file') {
    body = answered ? (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {vals.slice(0, 6).map((v, i) => (
          <button key={i} type="button" className="dw-action" style={{ textAlign: 'left' }} onClick={async () => {
            if (!v || !v.key) return;
            const artifact = await store.downloadQuestionnaireAttachment(questionnaireId, v);
            window.DWDownload.artifact(artifact);
          }}>
            <Icon name="download" size="sm" /> {qAnswerText(v)}
          </button>
        ))}
      </div>
    ) : <span className="dw-body-sm dw-muted">No files yet</span>;
  } else {
    body = answered ? <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>{vals.slice(0, 6).map((v, i) => <div key={i} style={{ paddingLeft: 12, borderLeft: '2px solid var(--dw-border-strong)' }}><span className="dw-serif dw-body-sm" style={{ color: 'var(--dw-text-secondary)' }}>“{qAnswerText(v)}”</span></div>)}</div> : <span className="dw-body-sm dw-muted">No answers yet</span>;
  }
  return (
    <div className="dw-card dw-card--pad-sm dw-mt-2">
      <div className="dw-row" style={{ alignItems: 'baseline' }}><div className="dw-body" style={{ fontWeight: 600 }}>{field.label}</div><span className="dw-mono-xs dw-muted" style={{ flex: 'none' }}>{answered}/{N} answered</span></div>
      <div className="dw-mt-3">{body}</div>
    </div>
  );
}
function QResults({ q }) {
  const completed = q.responses.filter((r) => r.status === 'Completed');
  const N = completed.length;
  return (
    <React.Fragment>
      <SectionRule hint={'aggregated from ' + N + ' completed response' + (N === 1 ? '' : 's')}>Results by question</SectionRule>
      {q.fields.map((f) => <QResultCard key={f.id} field={f} responses={completed} questionnaireId={q.id} />)}
    </React.Fragment>
  );
}
function QSubmissions({ q, onView }) {
  return (
    <React.Fragment>
      <SectionRule hint={q.responses.length + ' people · partial saves included'}>Submissions</SectionRule>
      <div className="dw-table-scroll"><table className="dw-table dw-mt-2">
        <thead><tr><th>Reader</th><th>Status</th><th style={{ width: 150 }}>Completion</th><th>Time</th><th>Submitted</th><th></th></tr></thead>
        <tbody>{q.responses.map((r, i) => {
          const comp = qCompletion(r, q.fields);
          return (
            <tr key={i} style={{ cursor: 'pointer' }} onClick={() => onView(r)}>
              <td className="lead"><div className="dw-person"><Avatar email={r.email} size="sm" /><div><div className="dw-person__nm">{window.DWAdapters.person(r.email).name}</div><div className="dw-person__em">{r.email}</div></div></div></td>
              <td><Badge variant={r.status === 'Completed' ? 'pine' : 'outline'}>{r.status}</Badge></td>
              <td><div className="dw-barrow__track" style={{ width: 90, display: 'inline-block', verticalAlign: 'middle' }}><i style={{ width: Math.max(comp, 2) + '%', background: comp < 50 ? 'var(--dw-status-warn)' : 'var(--dw-pine-500)' }}></i></div> <span className="dw-mono-xs dw-muted">{comp}%</span></td>
              <td className="num dw-muted">{r.dur || '—'}</td>
              <td className="num dw-muted">{r.status === 'Completed' ? r.when : '—'}</td>
              <td style={{ textAlign: 'right' }}><a className="dw-jump">View →</a></td>
            </tr>
          );
        })}</tbody>
      </table></div>
    </React.Fragment>
  );
}
function NewQDrawer({ open, onClose, onPick, templates, busy }) {
  const [mode, setMode] = useState('choose');
  const [prompt, setPrompt] = useState('');
  useEffect(() => { if (open) { setMode('choose'); setPrompt(''); } }, [open]);
  const opt = (icon, t, d, fn) => <button className="dw-card dw-card--pad-sm dw-mt-2" style={{ width: '100%', textAlign: 'left', cursor: 'pointer', display: 'flex', gap: 12, alignItems: 'center' }} onClick={fn}><span className="dw-channel__ic"><Icon name={icon} size="sm" /></span><span style={{ flex: 1 }}><span className="dw-body-sm" style={{ fontWeight: 600, display: 'block' }}>{t}</span><span className="dw-body-sm dw-muted">{d}</span></span><span className="dw-jump">→</span></button>;
  return (
    <Drawer open={open} title={mode === 'ai' ? 'Generate a questionnaire' : mode === 'tpl' ? 'Start from a template' : 'New questionnaire'} sub={mode === 'ai' ? 'Describe what you need to learn — you review every question.' : mode === 'tpl' ? 'Reuse one of your saved templates.' : 'Three ways to start — all editable before you publish.'} onClose={onClose}
      footer={mode === 'ai' ? <React.Fragment><Btn variant="ghost" size="sm" disabled={busy} onClick={() => setMode('choose')}>Back</Btn><Btn variant="pine" size="sm" loading={busy} disabled={!prompt.trim() || busy} onClick={() => onPick('ai', { prompt })}>Generate draft →</Btn></React.Fragment> : mode === 'tpl' ? <Btn variant="ghost" size="sm" disabled={busy} onClick={() => setMode('choose')}>Back</Btn> : null}>
      {mode === 'choose' ? <React.Fragment>
        {opt('edit', 'Build manually', 'Start blank and add your own questions.', () => onPick('blank'))}
        {opt('sparkle', 'Generate from a prompt', 'Describe what you need; we draft it, you edit.', () => setMode('ai'))}
        {opt('layers', 'From a template', 'Reuse one of your saved questionnaires.', () => setMode('tpl'))}
      </React.Fragment> : null}
      {mode === 'ai' ? <React.Fragment><label className="dw-label">What should it cover?</label><textarea className="dw-textarea dw-mt-2" placeholder="e.g. Qualify budget, timeline and decision process for a scale-up evaluating a growth retainer" value={prompt} onChange={(e) => setPrompt(e.target.value)} autoFocus></textarea></React.Fragment> : null}
      {mode === 'tpl' ? <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 4 }}>{(templates || []).map((t) => <button key={t.id} className="dw-card dw-card--pad-sm" disabled={busy} style={{ textAlign: 'left', cursor: 'pointer' }} onClick={() => onPick('tpl', { templateId: t.id })}><span className="dw-body-sm" style={{ fontWeight: 600, display: 'block' }}>{t.name}</span><span className="dw-mono-xs dw-muted">{t.questions}q · {t.steps}s · used {t.usage}×</span></button>)}</div> : null}
    </Drawer>
  );
}

function QuestionnairesView({ toast }) {
  const store = useStore();
  const list = store.questionnaires();
  const templates = store.questionnaireTemplates();
  const [sel, setSel] = useState(null);
  const [start, setStart] = useState(false);
  const [build, setBuild] = useState(null);
  const [busy, setBusy] = useState('');
  const [loadError, setLoadError] = useState('');
  const roomId = window.DWShare.roomId(window.DWAdapters.roomContext());
  const selQ = list.find((q) => q.id === sel);
  useEffect(() => {
    let alive = true;
    if (!store.refreshQuestionnaires || !store.hasTeamApiSession()) return undefined;
    setLoadError('');
    store.refreshQuestionnaires(roomId).catch((error) => {
      if (!alive) return;
      const message = error.message || 'Could not load questionnaires';
      setLoadError(message);
      toast(message);
    });
    return () => { alive = false; };
  }, [roomId]);
  const saveQuestionnaire = async (payload) => {
    await store.saveQuestionnaire(roomId, payload);
    toast('Questionnaire saved', true);
  };
  const publishQuestionnaire = async (questionnaireId) => {
    setBusy('publish:' + questionnaireId);
    try {
      await store.publishQuestionnaire(roomId, questionnaireId);
      toast('Questionnaire published', true);
    } catch (error) {
      toast(error.message || 'Could not publish questionnaire');
    } finally {
      setBusy('');
    }
  };
  const archiveQuestionnaire = async (questionnaireId) => {
    setBusy('archive:' + questionnaireId);
    try {
      await store.archiveQuestionnaire(roomId, questionnaireId);
      if (sel === questionnaireId) setSel(null);
      toast('Questionnaire archived');
    } catch (error) {
      toast(error.message || 'Could not archive questionnaire');
    } finally {
      setBusy('');
    }
  };
  if (selQ) return <QuestionnaireDetail q={selQ} onBack={() => setSel(null)} toast={toast} onSave={saveQuestionnaire} onPublish={publishQuestionnaire} onArchive={archiveQuestionnaire} busy={busy} />;
  const startBuild = async (how, meta) => {
    setBusy(how);
    try {
      if (how === 'ai') {
        const draft = await store.generateQuestionnaire(roomId, meta && meta.prompt);
        setStart(false);
        setBuild(draft);
        toast('Draft generated — review before publishing', true);
      } else if (how === 'tpl') {
        await store.useQuestionnaireTemplate(roomId, meta && meta.templateId);
        setStart(false);
        toast('Template loaded as a draft', true);
      } else {
        setStart(false);
        setBuild({ placement: 'post', status: 'draft', fields: [] });
        toast('New questionnaire — add your questions', true);
      }
    } catch (error) {
      toast(error.message || 'Could not start questionnaire');
    } finally {
      setBusy('');
    }
  };
  return (
    <React.Fragment>
      <div className="dw-row"><SectionRule hint="attached to this room, or standalone">Questionnaires</SectionRule><Btn variant="pine" size="sm" icon="plus" disabled={!!busy} onClick={() => setStart(true)}>New questionnaire</Btn></div>
      {loadError ? <p className="dw-error">{loadError}</p> : null}
      <div className="dw-table-scroll"><table className="dw-table dw-mt-2">
        <thead><tr><th>Questionnaire</th><th>Placement</th><th>Status</th><th>Responses</th><th>Last activity</th><th></th></tr></thead>
        <tbody>{list.map((q) => { const pl = window.DWAdapters.questionnairePlacements()[q.placement] || ['—', '']; return (
          <tr key={q.id} style={{ cursor: 'pointer' }} onClick={() => setSel(q.id)}>
            <td className="lead">{q.title}<div className="dw-mono-xs dw-muted">{q.fields.length} question{q.fields.length === 1 ? '' : 's'} · {q.mode === 'multi' ? 'Multi-step' : 'Single page'}</div></td>
            <td><Badge variant="outline">{pl[0]}</Badge></td>
            <td>{q.status === 'live' ? <span className="dw-status-text dw-status-text--ok">Active</span> : <Badge variant="outline">Draft</Badge>}</td>
            <td className="num">{q.status === 'live' ? (q.completed + ' / ' + q.sent) : '—'}</td>
            <td className="num dw-muted">{q.lastActivity}</td>
            <td style={{ textAlign: 'right' }}>
              <span className="dw-cluster-2" style={{ justifyContent: 'flex-end', flexWrap: 'nowrap' }}>
                <a className="dw-jump">{q.status === 'live' ? 'Results →' : 'Edit →'}</a>
                <RowMenu items={[{ label: 'Archive questionnaire', icon: 'trash', danger: true, onClick: () => archiveQuestionnaire(q.id) }]} />
              </span>
            </td>
          </tr>
        ); })}</tbody>
      </table></div>
      <p className="dw-body-sm dw-muted dw-mt-2">A room can hold several questionnaires — an <strong>intro</strong> sent with the invite, a <strong>post-read</strong> CTA, or a <strong>standalone</strong> form with its own link. Each collects and reports independently.</p>
      <NewQDrawer open={start} onClose={() => setStart(false)} onPick={startBuild} templates={templates} busy={!!busy} />
      {build ? <QuestionnaireBuilder seed={build} onSave={saveQuestionnaire} onClose={() => setBuild(null)} toast={toast} /> : null}
    </React.Fragment>
  );
}

function QuestionnaireDetail({ q, onBack, toast, onSave, onPublish, onArchive, busy }) {
  const [build, setBuild] = useState(false);
  const [resp, setResp] = useState(null);
  const [view, setView] = useState(q.status === 'live' ? 'Results' : 'Submissions');
  const pl = window.DWAdapters.questionnairePlacements()[q.placement] || ['—', ''];
  const pct = q.sent ? Math.round((q.completed / q.sent) * 100) : 0;
  const completedR = q.responses.filter((r) => r.status === 'Completed');
  const avgSec = completedR.length ? Math.round(completedR.reduce((a, r) => a + durToSec(r.dur || '0m'), 0) / completedR.length) : 0;
  const avgTime = avgSec ? Math.floor(avgSec / 60) + 'm ' + String(avgSec % 60).padStart(2, '0') + 's' : '—';
  const empty = !q.responses.length;
  const copyStandaloneLink = async () => {
    try {
      await window.DWShare.copyQuestionnaireLink(q, window.DWAdapters.roomContext());
      toast('Form link copied', true);
    } catch (error) {
      toast(error.message || 'Could not copy form link');
    }
  };
  return (
    <React.Fragment>
      <div className="dw-row dw-mt-2"><button className="dw-action" onClick={onBack}>← All questionnaires</button><span className="dw-grow"></span>{q.status === 'live' && q.placement === 'standalone' ? <Btn variant="ghost" size="sm" icon="link" disabled={!!busy} onClick={copyStandaloneLink}>Copy form link</Btn> : null}{q.status !== 'live' ? <Btn variant="pine" size="sm" loading={busy === 'publish:' + q.id} disabled={!!busy} onClick={() => onPublish(q.id)}>Publish questionnaire</Btn> : null}<Btn variant="ghost" size="sm" icon="trash" loading={busy === 'archive:' + q.id} disabled={!!busy} onClick={() => onArchive(q.id)}>Archive</Btn><Btn variant="pine" size="sm" icon="edit" disabled={!!busy} onClick={() => setBuild(true)}>Edit questionnaire</Btn></div>
      <div className="dw-card dw-mt-2">
        <div className="dw-row"><div><div className="dw-cluster-2" style={{ alignItems: 'baseline' }}><div className="dw-h4">{q.title}</div>{q.status === 'live' ? <span className="dw-status-text dw-status-text--ok">Active</span> : <Badge variant="outline">Draft</Badge>}</div><div className="dw-body-sm dw-muted dw-mt-2 dw-cluster-2" style={{ alignItems: 'center' }}>{q.fields.length} questions · {q.mode === 'multi' ? 'Multi-step' : 'Single page'} · <Badge variant="outline">{pl[0]}</Badge></div><p className="dw-body-sm dw-secondary dw-mt-2">{pl[1]}</p></div><Btn variant="ghost" size="sm" onClick={() => setBuild(true)}>Preview</Btn></div>
        {q.status === 'live' ? (<React.Fragment>
          <div className="dw-stats dw-mt-4" style={{ borderBottom: 'none' }}>
            <div className="dw-stat"><span className="dw-stat__k">Sent</span><div className="dw-stat__v">{q.sent}</div></div>
            <div className="dw-stat"><span className="dw-stat__k">Completed</span><div className="dw-stat__v">{q.completed}</div><span className="dw-stat__d">{pct}%</span></div>
            <div className="dw-stat"><span className="dw-stat__k">In progress</span><div className="dw-stat__v">{q.inProgress}</div></div>
            <div className="dw-stat"><span className="dw-stat__k">Avg time</span><div className="dw-stat__v">{avgTime}</div><span className="dw-stat__d">to complete</span></div>
          </div>
          <div className="dw-progress dw-mt-2"><i style={{ width: pct + '%' }}></i></div>
        </React.Fragment>) : <p className="dw-body-sm dw-secondary dw-mt-3">This questionnaire is a draft — publish it from the builder to start collecting responses.</p>}
      </div>
      {q.status === 'live' ? (<React.Fragment>
        <div className="dw-pilltabs dw-mt-4">{['Results', 'Submissions'].map((v) => <button key={v} className={'dw-pilltabs__tab' + (v === view ? ' is-on' : '')} onClick={() => setView(v)}>{v}</button>)}</div>
        {empty ? <div className="dw-empty dw-mt-3"><Icon name="quote" size="xl" /><div className="dw-empty__title">No responses yet</div><div className="dw-empty__body">They’ll appear here the moment a client answers — partial saves included.</div></div> : (view === 'Results' ? <QResults q={q} /> : <QSubmissions q={q} onView={setResp} />)}
      </React.Fragment>) : null}
      {build ? <QuestionnaireBuilder seed={q} onSave={onSave} onClose={() => setBuild(false)} toast={toast} /> : null}
      <ResponseDrawer q={q} resp={resp} onClose={() => setResp(null)} />
    </React.Fragment>
  );
}

function ResponseDrawer({ q, resp, onClose }) {
  return (
    <Drawer open={!!resp} title={resp ? window.DWAdapters.person(resp.email).name + '’s answers' : ''} sub={resp ? resp.when : ''} onClose={onClose}
      footer={<Btn variant="pine" size="sm" onClick={onClose}>Done</Btn>}>
      {resp ? q.fields.map((f) => {
        const a = resp.answers[f.id];
        return <div className="dw-subrow" key={f.id} style={{ gridTemplateColumns: '1fr' }}><span className="sq">{f.label}</span><QResponseAnswer questionnaireId={q.id} field={f} value={a} /></div>;
      }) : null}
    </Drawer>
  );
}

/* ===================== EXPORT DRAWER ===================== */
function ExportDrawer({ open, onClose, toast }) {
  const store = useStore();
  const [busy, setBusy] = useState(null);
  const [last, setLast] = useState(null);
  const supported = [
    { kind: 'comments', icon: 'grid', name: 'Comments & questions (CSV)', meta: 'Every thread, status and reply', format: 'csv' },
    { kind: 'submissions', icon: 'quote', name: 'Questionnaire submissions (.md)', meta: 'All captured answers for this room' },
    { kind: 'objections', icon: 'alert', name: 'Objection summary (.md)', meta: 'Evidence, severity and confidence' },
    { kind: 'precall', icon: 'sparkle', name: 'Pre-call note (.md)', meta: 'The latest synthesised brief' },
    { kind: 'analytics', icon: 'chart', name: 'Engagement analytics (.json)', meta: 'Version-pinned analytics payload' },
    { kind: 'proposal-pdf', icon: 'file', name: 'Proposal PDF', meta: 'Current version as a generated PDF' },
    { kind: 'all-versions', icon: 'layers', name: 'All versions (.zip)', meta: 'Every version with documents, comments and analytics' }
  ];

  async function run(option) {
    setBusy(option.kind);
    setLast(null);
    try {
      const artifact = await store.exportRoomArtifact(option.kind, { format: option.format });
      const filename = window.DWDownload.artifact(artifact);
      setLast(filename);
      toast(filename + ' downloaded', true);
    } catch (error) {
      toast(error.message || 'Could not export this room');
    } finally {
      setBusy(null);
    }
  }

  const opt = (option) => (
    <button className="dw-card dw-card--pad-sm dw-mt-2" disabled={!!busy} style={{ width: '100%', textAlign: 'left', cursor: busy ? 'wait' : 'pointer', display: 'flex', gap: 12, alignItems: 'center' }} onClick={() => run(option)}>
      <span className="dw-channel__ic"><Icon name={option.icon} size="sm" /></span>
      <span style={{ flex: 1 }}><span className="dw-body-sm" style={{ fontWeight: 600, display: 'block' }}>{option.name}</span><span className="dw-body-sm dw-muted">{busy === option.kind ? 'Generating export...' : option.meta}</span></span>
      <Icon name={busy === option.kind ? 'refresh' : 'download'} size="sm" />
    </button>
  );
  return (
    <Drawer open={open} title="Export this room" sub="A snapshot for your records or your CRM." onClose={onClose}>
      <SectionRule>Available exports</SectionRule>
      {supported.map((option) => <React.Fragment key={option.kind}>{opt(option)}</React.Fragment>)}
      {last ? <p className="dw-drawer__note">Downloaded {last}.</p> : <p className="dw-drawer__note">Exports are generated on demand and recorded in the workspace usage ledger.</p>}
    </Drawer>
  );
}

/* ===================== INVITE / EDIT TEAMMATE DRAWER ===================== */
const DW_TEAM_ROLES = [
  ['Admin', 'Manage the team, billing and every room.'],
  ['Editor', 'Create, edit and publish rooms. No team or billing.'],
  ['Viewer', 'See rooms and insights, but can’t change them.'],
];
function InviteTeammateDrawer({ drawer, onClose, onInvite, onSaveRole, busy }) {
  const edit = drawer && drawer.mode === 'edit';
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('Editor');
  useEffect(() => { if (!drawer) return; setEmail(edit ? drawer.m[1] : ''); setRole(edit ? drawer.m[4] : 'Editor'); }, [drawer]);
  return (
    <Drawer open={!!drawer}
      title={edit ? 'Edit ' + drawer.m[0] : 'Invite a teammate'}
      sub={edit ? drawer.m[1] : 'They sign in with a magic link — no password to set.'}
      onClose={onClose}
      footer={edit
        ? <React.Fragment><Btn variant="ghost" size="sm" disabled={busy} onClick={onClose}>Cancel</Btn><Btn variant="pine" size="sm" loading={busy} disabled={busy} onClick={() => onSaveRole(role)}>Save changes</Btn></React.Fragment>
        : <React.Fragment><Btn variant="ghost" size="sm" disabled={busy} onClick={onClose}>Cancel</Btn><Btn variant="pine" size="sm" loading={busy} disabled={!email.trim() || busy} onClick={() => onInvite(email, role)}>Send invite</Btn></React.Fragment>}>
      {!edit ? <Field label="Work email"><input className="dw-input" placeholder={window.DWDisplay.workspaceEmailExample()} value={email} onChange={(e) => setEmail(e.target.value)} autoFocus onKeyDown={(e) => { if (e.key === 'Enter' && email.trim() && !busy) onInvite(email, role); }} /></Field> : null}
      <label className="dw-label dw-mt-4">Role</label>
      <div className="dw-roleradio dw-mt-2">
        {DW_TEAM_ROLES.map((r) => (
          <label key={r[0]} className={'dw-roleopt' + (role === r[0] ? ' is-on' : '')} onClick={() => setRole(r[0])}><span className="dw-roleopt__top"><span className="dot"></span><span className={'dw-role dw-role--' + r[0].toLowerCase()}>{r[0]}</span></span><span className="dw-roleopt__desc">{r[1]}</span></label>
        ))}
      </div>
    </Drawer>
  );
}

/* member row kebab menu */
function MemberMenu({ onEdit, onRemove }) {
  const [open, setOpen] = useState(false);
  useEffect(() => { if (!open) return; const fn = () => setOpen(false); window.addEventListener('click', fn); return () => window.removeEventListener('click', fn); }, [open]);
  return (
    <span style={{ position: 'relative' }} onClick={(e) => e.stopPropagation()}>
      <button className={'dw-kebab' + (open ? ' is-on' : '')} onClick={() => setOpen(!open)} aria-label="Member actions"><Icon name="more" /></button>
      {open ? (
        <div className="dw-dropdown" style={{ position: 'absolute', right: 0, top: 'calc(100% + 6px)', zIndex: 600, minWidth: 180 }}>
          <button className="dw-dropdown__item" onClick={() => { setOpen(false); onEdit(); }}><Icon name="user" size="sm" /> Edit role</button>
          <div className="dw-dropdown__sep"></div>
          <button className="dw-dropdown__item dw-dropdown__item--danger" onClick={() => { setOpen(false); onRemove(); }}><Icon name="trash" size="sm" /> Remove from team</button>
        </div>
      ) : null}
    </span>
  );
}

/* generic row overflow menu — used by the Super console workspace rows */
function RowMenu({ items }) {
  const [open, setOpen] = useState(false);
  useEffect(() => { if (!open) return; const fn = () => setOpen(false); window.addEventListener('click', fn); return () => window.removeEventListener('click', fn); }, [open]);
  return (
    <span style={{ position: 'relative' }} onClick={(e) => e.stopPropagation()}>
      <button className={'dw-kebab' + (open ? ' is-on' : '')} onClick={() => setOpen(!open)} aria-label="Row actions"><Icon name="more" /></button>
      {open ? (
        <div className="dw-dropdown" style={{ position: 'absolute', right: 0, top: 'calc(100% + 6px)', zIndex: 600, minWidth: 190 }}>
          {items.map((it, i) => it.sep ? <div key={i} className="dw-dropdown__sep"></div> : <button key={i} className={'dw-dropdown__item' + (it.danger ? ' dw-dropdown__item--danger' : '')} onClick={() => { setOpen(false); it.onClick(); }}>{it.icon ? <Icon name={it.icon} size="sm" /> : null} {it.label}</button>)}
        </div>
      ) : null}
    </span>
  );
}

/* ===================== SUPER CONSOLE ===================== */
function SuperConsole({ onExit }) {
  const store = useStore();
  const [toast, toastNode] = useToast();
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [planTarget, setPlanTarget] = useState(null);
  const [busy, setBusy] = useState('');
  const overview = store.platformOverview();
  useEffect(() => {
    let alive = true;
    store.loadPlatformOverview().catch((error) => { if (alive) toast(error.message || 'Could not load platform overview'); });
    return () => { alive = false; };
  }, []);
  const deleteWorkspace = async () => {
    if (!deleteTarget) return;
    setBusy('delete:' + deleteTarget.id);
    try {
      const result = await store.deletePlatformWorkspace(deleteTarget.id);
      setDeleteTarget(null);
      toast('Workspace deleted · ' + (result.r2ObjectsDeleted || 0) + ' stored files removed', true);
    } catch (error) {
      toast(error.message || 'Could not delete workspace');
    } finally {
      setBusy('');
    }
  };
  const changePlan = async () => {
    if (!planTarget || !planTarget.plan) return;
    setBusy('plan:' + planTarget.row.id);
    try {
      await store.setPlatformWorkspacePlan(planTarget.row.id, planTarget.plan);
      toast(planTarget.row.name + ' is now on ' + planTarget.plan, true);
      setPlanTarget(null);
    } catch (error) {
      toast(error.message || 'Could not update workspace plan');
    } finally {
      setBusy('');
    }
  };
  const planMix = (overview && overview.planMix) || [];
  const workspaceRows = window.DWAdapters.platformWorkspaceRows(overview);
  const stats = overview ? [
    ['Workspaces', overview.workspaces, 'all-time'],
    ['Active rooms', overview.liveRooms, 'currently active'],
    ['Readers · 30d', overview.readers30, 'unique readers'],
    ['Plan types', planMix.length, 'active mix']
  ] : [];
  return (
    <div className="dw-app">
      <div className="dw-topbar" style={{ background: 'var(--dw-ink-800)', borderColor: 'transparent' }}>
        <span className="dw-logo dw-logo--reversed"><span style={{ color: 'var(--dw-cream-100)' }}>dealw</span><i className="dw-logo__mark"></i><span style={{ color: 'var(--dw-cream-100)' }}>ndr</span></span>
        <span className="dw-applabel" style={{ color: 'var(--dw-poppy-300)' }}>Super</span>
        <span className="dw-topbar__spacer"></span>
        <Btn variant="ghost" size="sm" onClick={onExit}>← Back to console</Btn>
      </div>
      <div className="dw-main__body" style={{ overflowY: 'auto' }}>
        <div className="dw-main__hrow" style={{ padding: 0, marginBottom: 16 }}><div><h2 className="dw-main__title">Platform overview</h2><span className="dw-main__sub">All workspaces · internal admin</span></div></div>
        {overview ? (
          <React.Fragment>
            <div className="dw-stats">
              {stats.map((s, i) => <div className="dw-stat" key={i}><span className="dw-stat__k">{s[0]}</span><div className="dw-stat__v">{s[1]}</div><span className="dw-stat__d">{s[2]}</span></div>)}
            </div>
            <SectionRule hint={planMix.length + ' plan buckets'}>Plan mix</SectionRule>
            <div className="dw-card dw-card--pad-sm dw-mt-2">
              {(() => {
                const total = planMix.reduce((sum, row) => sum + Number(row.count || row.n || 0), 0) || 1;
                return planMix.map((row) => {
                  const count = Number(row.count || row.n || 0);
                  const label = row.plan || 'Unknown';
                  return (
                    <div className="dw-barrow" key={label}>
                      <span className="dw-barrow__l">{label}</span>
                      <span className="dw-barrow__track"><i style={{ width: Math.max(2, Math.round(count / total * 100)) + '%', background: /past/i.test(label) ? 'var(--dw-status-warn)' : 'var(--dw-pine-500)' }}></i></span>
                      <span className="dw-barrow__v">{count}</span>
                    </div>
                  );
                });
              })()}
            </div>
            <SectionRule hint={workspaceRows.length + ' workspace rows'}>Workspaces</SectionRule>
            {workspaceRows.length ? (
              <div className="dw-table-scroll"><table className="dw-table dw-mt-2">
                <thead><tr><th>Workspace</th><th>Plan</th><th>Seats</th><th>Rooms</th><th>Status</th><th>Created</th><th></th></tr></thead>
                <tbody>{workspaceRows.map((row) => (
                  <tr key={row.id}>
                    <td className="lead">{row.name}</td>
                    <td>{row.plan}</td>
                    <td className="num">{row.seats}</td>
                    <td className="num">{row.rooms}</td>
                    <td><Badge variant={/past|due|fail/i.test(row.status) ? 'bad' : /trial|pending/i.test(row.status) ? 'outline' : 'pine'}>{row.status}</Badge></td>
                    <td className="num dw-muted">{row.created}</td>
                    <td style={{ textAlign: 'right' }}><RowMenu items={[
                      { label: 'Open workspace', icon: 'arrowright', onClick: () => toast('Workspace drill-down is not enabled in this milestone') },
                      { label: 'View usage', icon: 'chart', onClick: () => toast('Usage opens from the workspace settings tab') },
                      { sep: true },
                      { label: 'Set Trial plan', icon: 'settings', onClick: () => setPlanTarget({ row, plan: 'Trial' }) },
                      { label: 'Set Studio plan', icon: 'settings', onClick: () => setPlanTarget({ row, plan: 'Studio' }) },
                      { label: 'Set Agency plan', icon: 'shield', onClick: () => setPlanTarget({ row, plan: 'Agency' }) },
                      { sep: true },
                      { label: 'Delete workspace', icon: 'trash', danger: true, onClick: () => setDeleteTarget(row) }
                    ]} /></td>
                  </tr>
                ))}</tbody>
              </table></div>
            ) : <div className="dw-empty dw-mt-3"><Icon name="grid" size="xl" /><div className="dw-empty__title">No workspace rows returned</div><div className="dw-empty__body">The platform overview route must include workspaceRows for row-level administration.</div></div>}
          </React.Fragment>
        ) : <div className="dw-empty"><Icon name="refresh" size="xl" /><div className="dw-empty__title">Loading platform overview</div><div className="dw-empty__body">Fetching aggregate platform metrics.</div></div>}
      </div>
      {deleteTarget ? (
        <div className="dw-modal-scrim" style={{ position: 'fixed' }} onMouseDown={(e) => { if (e.target === e.currentTarget && !busy) setDeleteTarget(null); }}>
          <div className="dw-confirm" role="dialog" aria-modal="true" aria-label={'Delete ' + deleteTarget.name}>
            <div className="dw-confirm__title">Delete “{deleteTarget.name}”?</div>
            <p className="dw-confirm__body">This permanently deletes the workspace, rooms, documents, reader access, comments, replay, questionnaires, notifications, usage ledger rows, and stored files. This can’t be undone.</p>
            <div className="dw-confirm__acts"><Btn variant="ghost" size="sm" disabled={!!busy} onClick={() => setDeleteTarget(null)}>Cancel</Btn><Btn variant="danger" size="sm" loading={busy === 'delete:' + deleteTarget.id} disabled={!!busy} onClick={deleteWorkspace}>Delete workspace</Btn></div>
          </div>
        </div>
      ) : null}
      {planTarget ? (
        <div className="dw-modal-scrim" style={{ position: 'fixed' }} onMouseDown={(e) => { if (e.target === e.currentTarget && !busy) setPlanTarget(null); }}>
          <div className="dw-confirm" role="dialog" aria-modal="true" aria-label={'Set ' + planTarget.row.name + ' plan'}>
            <div className="dw-confirm__title">Set “{planTarget.row.name}” to {planTarget.plan}?</div>
            <p className="dw-confirm__body">{planTarget.plan === 'Agency' ? 'This enables the workspace admin to configure custom proposal domains and custom email sending after DNS verification.' : 'This changes the static product tier. Billing and subscriptions remain disabled in this milestone.'}</p>
            <div className="dw-confirm__acts"><Btn variant="ghost" size="sm" disabled={!!busy} onClick={() => setPlanTarget(null)}>Cancel</Btn><Btn variant="pine" size="sm" loading={busy === 'plan:' + planTarget.row.id} disabled={!!busy || planTarget.row.plan === planTarget.plan} onClick={changePlan}>Set {planTarget.plan}</Btn></div>
          </div>
        </div>
      ) : null}
      {toastNode}
    </div>
  );
}

Object.assign(window, { QuestionnaireBuilder, QuestionnairesView, ExportDrawer, InviteTeammateDrawer, MemberMenu, SuperConsole });


/* ---- app/rooms.jsx ---- */
/* ============================================================
   DEALWONDR APP — Rooms home + New-room upload wizard
   Full parity with the original: rooms listing table (status,
   temperature, readers, comments, read time, delete) and the
   3-step Start → Review → Publish create flow.
   ============================================================ */

/* ---------- Rooms home ---------- */
function RoomsHome({ onOpenRoom, onUpload }) {
  const store = useStore();
  const [toast, toastNode] = useToast();
  const [confirm, setConfirm] = useState(null);
  const [busy, setBusy] = useState('');
  const rooms = store.rooms();
  const statusVariant = { live: 'pine', draft: 'outline', archived: 'resolved', quest: 'outline' };
  const tempVariant = (s) => s >= 75 ? 'hot' : s >= 50 ? 'warm' : s > 0 ? 'steady' : null;
  const openRoom = async (room) => {
    if (!room || !room.canOpen) return;
    const roomId = room.apiId || room.id;
    setBusy('open:' + room.id);
    window.DW_API_ROOM_ID = roomId;
    onOpenRoom(room);
    try {
      await store.selectRoom(roomId);
    } catch (error) {
      toast(error.message || 'Could not open room');
    } finally {
      setBusy('');
    }
  };
  const deleteRoom = async () => {
    if (!confirm) return;
    setBusy('delete:' + confirm.id);
    try {
      await store.deleteRoom(confirm.apiId || confirm.id);
      setConfirm(null);
      toast('Room deleted');
    } catch (error) {
      toast(error.message || 'Could not delete room');
    } finally {
      setBusy('');
    }
  };
  const restoreRoom = async (room, event) => {
    if (event) event.stopPropagation();
    if (!room || room.status !== 'archived') return;
    setBusy('restore:' + room.id);
    try {
      await store.unarchiveRoom(room.apiId || room.id);
      toast('Room restored', true);
    } catch (error) {
      toast(error.message || 'Could not restore room');
    } finally {
      setBusy('');
    }
  };
  return (
    <React.Fragment>
      <PageHead title="Rooms" sub={'Every proposal ' + window.DWDisplay.orgName() + ' has opened — active · draft · archived'}
        primary={{ label: 'New room', icon: 'plus', onClick: onUpload }} />
      <div className="dw-main__body">
        <div className="dw-table-scroll"><table className="dw-table" style={{ minWidth: 860 }}>
          <thead><tr><th style={{ width: 260 }}>Room</th><th>Status</th><th>Temperature</th><th>Readers</th><th>Comments</th><th>Read time</th><th>Last activity</th><th></th></tr></thead>
          <tbody>{rooms.map((r) => (
            <tr key={r.id} style={{ cursor: r.canOpen ? 'pointer' : 'default' }} onClick={() => openRoom(r)}>
              <td className="lead" style={{ paddingRight: 16, whiteSpace: 'normal' }}>{r.title}{r.version ? <span className="dw-verpill" style={{ marginLeft: 8 }}>{r.version}</span> : null}</td>
              <td><Badge variant={statusVariant[r.status]}>{window.DWAdapters.statusLabel(r.status)}</Badge></td>
              <td>{r.tempScore ? <span className={'dw-temp dw-temp--' + tempVariant(r.tempScore)}>{r.temp} · {r.tempScore}</span> : <span className="dw-muted">—</span>}</td>
              <td className="num">{r.readers}</td><td className="num">{r.comments}</td><td className="num">{r.readTime}</td><td className="num dw-muted">{r.last}</td>
              <td style={{ textAlign: 'right' }} onClick={(e) => e.stopPropagation()}>
                {r.status === 'archived'
                  ? <button className="dw-action" disabled={!!busy} onClick={(e) => restoreRoom(r, e)}>Restore</button>
                  : <button className="dw-action dw-action--danger" disabled={!!busy} onClick={() => setConfirm(r)}>Delete</button>}
              </td>
            </tr>
          ))}</tbody>
        </table></div>
        <p className="dw-body-sm dw-muted dw-mt-3">Open any room to manage content, access, comments, insights, and analytics.</p>
      </div>
      {confirm ? (
        <div className="dw-modal-scrim" style={{ position: 'fixed' }} onMouseDown={(e) => { if (e.target === e.currentTarget) setConfirm(null); }}>
          <div className="dw-confirm">
            <div className="dw-confirm__title">Delete “{confirm.title}”?</div>
            <p className="dw-confirm__body">Clients can no longer open this room and its analytics, comments and replay history are removed. This can’t be undone.</p>
            <div className="dw-confirm__acts"><Btn variant="ghost" size="sm" disabled={!!busy} onClick={() => setConfirm(null)}>Cancel</Btn><Btn variant="danger" size="sm" loading={busy === 'delete:' + confirm.id} disabled={!!busy} onClick={deleteRoom}>Delete room</Btn></div>
          </div>
        </div>
      ) : null}
      {toastNode}
    </React.Fragment>
  );
}

/* ---------- New-room wizard ---------- */
function UploadWizard({ onPublish, onCancel }) {
  const store = useStore();
  const [toast, toastNode] = useToast();
  const [step, setStep] = useState(1);
  const [parsing, setParsing] = useState(false);
  const [parseStep, setParseStep] = useState(0);
  const [rows, setRows] = useState(null);
  const [info, setInfo] = useState(null);
  const [sourceKind, setSourceKind] = useState('file');
  const [sourceLabel, setSourceLabel] = useState('');
  const [over, setOver] = useState(false);
  const [link, setLink] = useState('');
  const [published, setPublished] = useState(false);
  const [draft, setDraft] = useState(null);
  const [error, setError] = useState('');
  const fileInput = useRef(null);
  const htmlInput = useRef(null);

  const formats = window.DWAdapters.importFormats();

  async function runUpload(file) {
    if (!file) return;
    const steps = ['Reading file in browser', 'Creating draft room', 'Creating first version', 'Uploading file to storage', 'Saving reader preview sections', 'Queueing backend validation'];
    setSourceKind('file'); setSourceLabel(file.name); setParsing(true); setParseStep(0); setInfo({ file: file.name, steps: steps }); setStep(2); setRows(null); setError('');
    try {
      var interval = window.setInterval(function () { setParseStep(function (n) { return Math.min(n + 1, steps.length - 1); }); }, 420);
      var preview = await window.DWClientAnalyzers.analyzeFile(file);
      if (!preview.sections || !preview.sections.length) throw new Error('Client preview did not find any readable sections.');
      var result = await store.createUploadedRoom({ file: file, preview: preview });
      window.clearInterval(interval);
      setParseStep(steps.length);
      setDraft(result);
      setInfo({ file: file.name, title: result.room.title, steps: steps, stored: result.upload && result.upload.stored, preview: preview, previewPersisted: result.preview });
      setRows(preview.sections);
      setParsing(false);
    } catch (uploadError) {
      if (interval) window.clearInterval(interval);
      setParsing(false);
      setError(uploadError.message || 'Could not upload this proposal.');
      toast(uploadError.message || 'Could not upload this proposal.');
    }
  }
  async function runPrototypeUpload(file) {
    const steps = ['Reading standalone HTML', 'Creating prototype room', 'Uploading HTML to storage', 'Preparing sandboxed replay bridge'];
    setSourceKind('prototype-html'); setSourceLabel(file.name); setParsing(true); setParseStep(0); setInfo({ file: file.name, steps: steps }); setStep(2); setRows(null); setError('');
    try {
      var interval = window.setInterval(function () { setParseStep(function (n) { return Math.min(n + 1, steps.length - 1); }); }, 420);
      var result = await store.createUploadedPrototypeRoom({ file: file });
      window.clearInterval(interval);
      setParseStep(steps.length);
      setDraft(result);
      setInfo({ file: file.name, title: result.room.title, steps: steps, stored: result.stored, prototype: result.prototype });
      setRows([
        { page: '—', label: result.prototype.title || result.room.title, src: 'prototype', on: true },
        { page: '—', label: 'Sandboxed iframe with click, state, scroll, and screen-view replay', src: 'prototype', on: true }
      ]);
      setParsing(false);
    } catch (prototypeError) {
      if (interval) window.clearInterval(interval);
      setParsing(false);
      setError(prototypeError.message || 'Could not upload this prototype.');
      toast(prototypeError.message || 'Could not upload this prototype.');
    }
  }
  function openFilePicker() { if (fileInput.current) fileInput.current.click(); }
  function openHtmlPicker() { if (htmlInput.current) htmlInput.current.click(); }
  function onFiles(files) { if (files && files[0]) runUpload(files[0]); }
  async function runLinkImport() {
    if (!link.trim()) return;
    const steps = ['Fetching link', 'Creating draft room', 'Storing imported content', 'Queueing document parser'];
    setSourceKind('link'); setSourceLabel(link.trim()); setStep(2); setParsing(true); setParseStep(0); setRows(null); setError(''); setInfo({ file: link.trim(), steps: steps });
    try {
      var interval = window.setInterval(function () { setParseStep(function (n) { return Math.min(n + 1, steps.length - 1); }); }, 420);
      var result = await store.createLinkedRoom({ url: link.trim() });
      window.clearInterval(interval);
      setParseStep(steps.length);
      setDraft(result);
      setInfo({ file: (result.import && result.import.fileName) || link.trim(), title: result.room.title, steps: steps, imported: result.import });
      setRows([
        { page: '—', label: 'Parser queued for ' + ((result.import && result.import.fileName) || link.trim()), src: 'queue', on: true },
        { page: '—', label: 'Sections will appear after parsing finishes', src: 'queue', on: true }
      ]);
      setParsing(false);
    } catch (linkError) {
      window.clearInterval(interval);
      setParsing(false);
      setError(linkError.message || 'Could not import this link.');
      toast(linkError.message || 'Could not import this link.');
    }
  }
  async function runPrototypeLink() {
    if (!link.trim()) return;
    const steps = ['Validating prototype link', 'Creating prototype room', 'Preparing iframe embed'];
    setSourceKind('prototype-link'); setSourceLabel(link.trim()); setStep(2); setParsing(true); setParseStep(0); setRows(null); setError(''); setInfo({ file: link.trim(), steps: steps });
    try {
      var interval = window.setInterval(function () { setParseStep(function (n) { return Math.min(n + 1, steps.length - 1); }); }, 420);
      var result = await store.createPrototypeLinkRoom({ url: link.trim() });
      window.clearInterval(interval);
      setParseStep(steps.length);
      setDraft(result);
      setInfo({ file: result.prototype.sourceUrl || link.trim(), title: result.room.title, steps: steps, prototype: result.prototype });
      setRows([
        { page: '—', label: result.prototype.title || result.room.title, src: 'prototype', on: true },
        { page: '—', label: 'Frame open/load/focus tracked; internal clicks require uploaded HTML or instrumented source', src: 'prototype', on: true }
      ]);
      setParsing(false);
    } catch (linkError) {
      if (interval) window.clearInterval(interval);
      setParsing(false);
      setError(linkError.message || 'Could not create this prototype room.');
      toast(linkError.message || 'Could not create this prototype room.');
    }
  }
  async function publishDraft() {
    if (!draft || !draft.room) return;
    try {
      await store.publishRoom(draft.room.id);
      setPublished(true);
    } catch (publishError) {
      setError(publishError.message || 'Could not publish this room.');
      toast(publishError.message || 'Could not publish this room.');
    }
  }
  const isPrototype = sourceKind === 'prototype-html' || sourceKind === 'prototype-link';
  const titles = { 1: 'New room', 2: parsing ? (isPrototype ? 'Creating prototype room…' : sourceKind === 'link' ? 'Importing link…' : 'Uploading your proposal…') : (isPrototype ? 'Review prototype' : 'Review parser status'), 3: 'Publish' };
  const subs = { 1: 'Import a proposal file, paste a link, or upload standalone HTML', 2: isPrototype ? 'A draft is saved as an interactive prototype document' : sourceKind === 'link' ? 'A draft is saved — imported content is queued for parsing' : 'A draft is saved with reader sections, then backend validation continues', 3: 'One last check before it becomes active' };
  const reviewCopy = isPrototype ? 'The prototype is stored as an interactive document and rendered in a sandboxed iframe. It stays as a draft until you publish.' : sourceKind === 'link' ? 'The imported URL is stored and the parser job is queued. Sections become reader content after parsing finishes.' : 'The upload is stored, browser-detected sections are persisted for readers, and the backend parser validates them from the stored file.';
  const reviewHint = isPrototype ? 'interactive prototype document' : sourceKind === 'file' ? 'reader preview saved plus backend validation' : 'storage and parser queue status';
  const hasPersistedPreview = sourceKind === 'file' && info && info.previewPersisted && info.previewPersisted.sections && info.previewPersisted.sections.length;
  const parserStatus = isPrototype ? 'not required · prototype iframe' : hasPersistedPreview ? 'preview saved · backend validating' : 'queued';
  const readerContentStatus = isPrototype ? (sourceKind === 'prototype-html' ? 'hosted iframe ready with replay bridge' : 'external iframe ready; frame events tracked') : hasPersistedPreview ? 'reader content ready from browser preview' : 'available after parse worker persists sections';

  return (
    <React.Fragment>
      <PageHead title={titles[step]} sub={subs[step]}
        secondary={step === 1 ? { label: 'Cancel', onClick: onCancel } : null}
        primary={step === 2 && rows && !parsing ? { label: 'Continue → Publish', onClick: () => setStep(3) } : null} />
      <div className="dw-main__body">
        <div className="dw-stepper">
          {['Start', 'Review', 'Publish'].map((s, i) => (
            <div key={s} className={'dw-stepper__step' + (step === i + 1 ? ' is-on' : step > i + 1 ? ' is-done' : '')}><span className="dw-stepper__n">{step > i + 1 ? '✓' : i + 1}</span> {s}</div>
          ))}
        </div>

        {step === 1 ? (
          <div className="dw-upload-start">
            <input ref={fileInput} data-testid="proposal-file-input" aria-label="Upload proposal file" type="file" className="dw-sr-only" tabIndex="-1" accept=".pdf,.docx,.pptx,.html,.htm,.md,.txt,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.presentationml.presentation,text/html,text/markdown,text/plain" onChange={(e) => onFiles(e.target.files)} />
            <input ref={htmlInput} data-testid="prototype-html-input" aria-label="Standalone HTML prototype file" type="file" className="dw-sr-only" tabIndex="-1" accept=".html,.htm,text/html,application/xhtml+xml" onChange={(e) => e.target.files && e.target.files[0] && runPrototypeUpload(e.target.files[0])} />
            <div className={'dw-dropzone dw-dropzone--hero dw-mt-5' + (over ? ' is-over' : '')}
              onDragOver={(e) => { e.preventDefault(); setOver(true); }} onDragLeave={() => setOver(false)} onDrop={(e) => { e.preventDefault(); setOver(false); onFiles(e.dataTransfer.files); }} onClick={openFilePicker}>
              <Icon name="upload" size="xl" />
              <div className="dw-dropzone__big">Drop your proposal — or click to browse</div>
              <div className="dw-dropzone__small">A draft room is saved when the file uploads. It stays inactive until you publish.</div>
              <div className="dw-import-format-list">{formats.map((f) => <button key={f.id} type="button" className="dw-chip" title={f.note} onClick={(e) => { e.stopPropagation(); openFilePicker(); }}><span className="dw-mono">{f.glyph}</span> {f.label}</button>)}</div>
            </div>
            <div className="dw-section-rule dw-mt-6">interactive prototype / iframe</div>
            <div className="dw-card dw-card--pad-sm dw-prototype-card">
              <div className="dw-prototype-card__head">
                <Btn variant="pine" icon="upload" onClick={openHtmlPicker}>Upload standalone HTML</Btn>
                <span className="dw-body-sm dw-secondary">Creates a hosted iframe content type with replay bridge.</span>
              </div>
              <div className="dw-prototype-card__url">
                <label className="dw-label" htmlFor="dw-prototype-url">Iframe or prototype URL</label>
                <input id="dw-prototype-url" className="dw-input" type="url" inputMode="url" placeholder="Website, Figma, app link…" value={link} onChange={(e) => setLink(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && link.trim() && runPrototypeLink()} aria-describedby="dw-prototype-url-hint" />
              </div>
              <div className="dw-prototype-card__actions">
                <Btn variant="pine" disabled={!link.trim()} onClick={runPrototypeLink}>Create iframe room</Btn>
                <Btn variant="ghost" disabled={!link.trim()} onClick={runLinkImport}>Import link as text</Btn>
              </div>
              <p id="dw-prototype-url-hint" className="dw-body-sm dw-muted dw-prototype-card__copy">Iframe rooms preserve the interactive experience. Text import parses the URL into reader sections.</p>
            </div>
            {error ? <p className="dw-error">{error}</p> : null}
          </div>
        ) : null}

        {step === 2 && parsing ? (
          <div style={{ maxWidth: 460, margin: '20px 0' }}>
            <div className="dw-cluster-2" style={{ marginBottom: 16 }}><Icon name="file" /><span className="dw-mono">{(info && info.file) || sourceLabel}</span></div>
            {(info ? info.steps : []).map((s, i) => (
              <div className="dw-checkitem" key={i}><span className={'dw-checkitem__box' + (i < parseStep ? ' is-on' : '')}>{i === parseStep ? <span className="dw-spinner" style={{ width: 12, height: 12, borderWidth: 1.5 }}></span> : null}</span> <span style={{ color: i <= parseStep ? 'var(--dw-text-primary)' : 'var(--dw-text-muted)' }}>{s}</span></div>
            ))}
          </div>
        ) : null}

        {step === 2 && rows && !parsing ? (
          <React.Fragment>
            <SectionRule hint={reviewHint}>Sections we found</SectionRule>
            <div className="dw-table-scroll"><table className="dw-table">
              <thead><tr><th style={{ width: 40 }}>Status</th><th style={{ width: 54 }}>Page</th><th>Section</th><th style={{ width: 110 }}>Detected via</th></tr></thead>
              <tbody>{rows.map((r, i) => (
                <tr key={i}>
                  <td><span className="dw-checkitem__box is-on" style={{ display: 'inline-block' }} title="Queued"></span></td>
                  <td className="num">{r.page}</td><td className="lead">{r.label}</td>
                  <td><span className={'dw-src' + (r.src === 'label' ? ' dw-src--label' : '')}>{r.src === 'prototype' ? 'prototype' : r.src === 'label' ? 'data-label' : r.src === 'h2' ? 'heading' : r.src === 'queue' ? 'queue' : 'inferred'}</span></td>
                </tr>
              ))}</tbody>
            </table></div>
            <p className="dw-body-sm dw-secondary dw-mt-3">{reviewCopy} It stays inactive until you publish.</p>
          </React.Fragment>
        ) : null}

        {step === 3 ? (
          <div style={{ maxWidth: 560 }}>
            <SectionRule>Ready to publish</SectionRule>
            <div className="dw-metarow"><span className="dw-metarow__k">Room</span><span>{(draft && draft.room && draft.room.title) || (info && info.title) || 'Uploaded proposal'}</span></div>
            <div className="dw-metarow"><span className="dw-metarow__k">Reference</span><span className="dw-mono">{(draft && draft.room && draft.room.ref) || 'draft'}</span></div>
            <div className="dw-metarow"><span className="dw-metarow__k">Parser</span><span className="dw-mono">{parserStatus}</span></div>
            <div className="dw-metarow"><span className="dw-metarow__k">Reader content</span><span>{readerContentStatus}</span></div>
            {!published ? (
              <div className="dw-cluster-2 dw-mt-5"><Btn variant="ghost" onClick={onCancel}>Keep as draft</Btn><Btn variant="pine" disabled={!draft} onClick={publishDraft}>Publish room →</Btn></div>
            ) : (
              <div className="dw-mt-5" style={{ borderLeft: '3px solid var(--dw-pine-500)', background: 'var(--dw-cream-50)', padding: '14px 16px', borderRadius: '0 8px 8px 0' }}>
                <p style={{ margin: '0 0 4px', fontWeight: 600 }}>The room is active — but nobody can open it yet.</p>
                <p className="dw-body-sm dw-secondary" style={{ margin: '0 0 12px' }}>Invite the client by email on the Access page — each reader enters their address and gets a one-time room link.</p>
                <Btn variant="pine" size="sm" onClick={onPublish}>Go to Access — invite the client →</Btn>
              </div>
            )}
          </div>
        ) : null}
      </div>
      {toastNode}
    </React.Fragment>
  );
}

Object.assign(window, { RoomsHome, UploadWizard });


/* ---- app/screens.jsx ---- */
/* ============================================================
   DEALWONDR APP — remaining screens
   Settings (Team/Brand/Billing) · Alerts + rules drawer ·
   Questionnaire fill · Replay player.
   ============================================================ */

/* ===================== SETTINGS ===================== */
function Settings() {
  const [tab, setTab] = useState('Team');
  const orgName = window.DWDisplay.orgName();
  return (
    <React.Fragment>
      <PageHead title="Settings" sub={orgName + ' · team, templates, brand, domains, usage & billing'}
        tabs={['Team', 'Templates', 'Brand', 'Domains', 'Usage', 'Plan & billing'].map((t) => <button key={t} className={'dw-tabs__tab' + (t === tab ? ' is-on' : '')} onClick={() => setTab(t)}>{t}</button>)} />
      <div className="dw-main__body">
        {tab === 'Team' && <TeamPanel />}
        {tab === 'Templates' && <TemplatesPanel />}
        {tab === 'Brand' && <BrandPanel />}
        {tab === 'Domains' && <DomainsPanel />}
        {tab === 'Usage' && <UsagePanel />}
        {tab === 'Plan & billing' && <BillingPanel />}
      </div>
    </React.Fragment>
  );
}

function shortRequestDate(value) {
  if (!value) return 'new';
  try { return new Date(value).toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); }
  catch (e) { return 'new'; }
}

function TeamPanel() {
  const store = useStore();
  const [toast, toastNode] = useToast();
  const [drawer, setDrawer] = useState(null);   // null | {mode:'invite'} | {mode:'edit', m, i}
  const [roles, setRoles] = useState(false);
  const [rejecting, setRejecting] = useState(null);
  const [rejectNote, setRejectNote] = useState('');
  const [busy, setBusy] = useState(false);
  const members = store.members();
  const requests = store.joinRequests().filter((request) => request.status === 'pending');
  const addMember = async (email, roleLabel) => {
    setBusy(true);
    try {
      await store.inviteMember(email, roleLabel);
      setDrawer(null); toast('Invited ' + email + ' as ' + roleLabel + ' — magic link sent', true);
    } catch (error) {
      toast(error.message || 'Could not invite teammate');
    } finally {
      setBusy(false);
    }
  };
  const saveRole = async (member, roleLabel) => {
    setBusy(true);
    try {
      await store.setMemberRole(member[1], roleLabel);
      setDrawer(null); toast(member[0] + ' is now ' + roleLabel);
    } catch (error) {
      toast(error.message || 'Could not update teammate role');
    } finally {
      setBusy(false);
    }
  };
  const remove = async (member) => {
    setBusy(true);
    try {
      await store.removeMember(member[1]);
      toast(member[0] + ' removed from the team');
    } catch (error) {
      toast(error.message || 'Could not remove teammate');
    } finally {
      setBusy(false);
    }
  };
  const approveRequest = async (request) => {
    setBusy('approve:' + request.id);
    try {
      const result = await store.approveJoinRequest(request.id);
      toast(request.name + ' approved as Viewer' + (result && result.emailQueued ? ' — magic link sent' : ''), true);
    } catch (error) {
      toast(error.message || 'Could not approve workspace request');
    } finally {
      setBusy(false);
    }
  };
  const rejectRequest = async () => {
    const request = rejecting;
    if (!request) return;
    setBusy('reject:' + request.id);
    try {
      await store.rejectJoinRequest(request.id, rejectNote.trim());
      setRejecting(null);
      setRejectNote('');
      toast(request.name + ' request rejected');
    } catch (error) {
      toast(error.message || 'Could not reject workspace request');
    } finally {
      setBusy(false);
    }
  };
  const sendEmailCheck = async () => {
    setBusy('email-smoke');
    try {
      const result = await store.sendEmailSmoke();
      toast('Email check queued to ' + ((result && result.to) || 'your account'), true);
    } catch (error) {
      toast(error.message || 'Could not send email check');
    } finally {
      setBusy(false);
    }
  };
  return (
    <React.Fragment>
      {requests.length ? (
        <React.Fragment>
          <div className="dw-row"><SectionRule hint={requests.length + ' pending'}>Workspace requests</SectionRule></div>
          <div className="dw-table-scroll"><table className="dw-table dw-mt-4"><thead><tr><th>Requester</th><th>Requested</th><th>Status</th><th></th></tr></thead><tbody>
            {requests.map((request) => (
              <tr key={request.id}>
                <td className="lead"><div className="dw-member"><span className="dw-ava dw-ava--sm">{request.initials}</span><span className="dw-member__nm"><span className="dw-member__name">{request.name}</span><em>{request.email}</em></span></div></td>
                <td className="num dw-muted">{shortRequestDate(request.requestedAt)}</td>
                <td><Badge variant="outline">Pending</Badge></td>
                <td style={{ textAlign: 'right' }}><span className="dw-cluster-2" style={{ justifyContent: 'flex-end', flexWrap: 'nowrap' }}><Btn variant="ghost" size="sm" disabled={!!busy} onClick={() => { setRejecting(request); setRejectNote(''); }}>Reject</Btn><Btn variant="pine" size="sm" loading={busy === 'approve:' + request.id} disabled={!!busy} onClick={() => approveRequest(request)}>Approve</Btn></span></td>
              </tr>
            ))}
          </tbody></table></div>
        </React.Fragment>
      ) : null}
      <div className="dw-row" style={{ marginTop: requests.length ? 28 : 0 }}><div className="dw-cluster-2"><SectionRule hint={members.length + ' people'}>Members</SectionRule><button className="dw-action" onClick={() => setRoles(true)}>ⓘ Understand roles</button></div><span className="dw-cluster-2"><Btn variant="ghost" size="sm" icon="mail" loading={busy === 'email-smoke'} disabled={!!busy} onClick={sendEmailCheck}>Send email check</Btn><Btn variant="pine" size="sm" icon="plus" disabled={!!busy} onClick={() => setDrawer({ mode: 'invite' })}>Invite teammate</Btn></span></div>
      <div className="dw-table-scroll"><table className="dw-table dw-mt-4"><thead><tr><th>Member</th><th>Role</th><th>Last active</th><th></th></tr></thead><tbody>
        {members.map((m, i) => (
          <tr key={m[1]}><td className="lead"><div className="dw-member"><span className="dw-ava dw-ava--sm">{m[2]}</span><span className="dw-member__nm"><span className="dw-member__name">{m[0]}{m[5] ? <span className="dw-you">you</span> : null}</span><em>{m[1]}</em></span></div></td><td><span className={'dw-role dw-role--' + m[3]}>{m[4]}</span></td><td className="num dw-muted">{m[5] ? 'now' : '2h ago'}</td><td style={{ textAlign: 'right' }}>{m[5] ? null : <MemberMenu onEdit={() => setDrawer({ mode: 'edit', m, i })} onRemove={() => remove(m)} />}</td></tr>
        ))}
      </tbody></table></div>
      <InviteTeammateDrawer drawer={drawer} onClose={() => setDrawer(null)} onInvite={addMember} onSaveRole={(role) => saveRole(drawer.m, role)} busy={busy} />
      <Modal open={!!rejecting} title={rejecting ? 'Reject ' + rejecting.name + '?' : 'Reject request?'} sub={rejecting ? rejecting.email : ''} onClose={() => { if (!busy) setRejecting(null); }} footer={<React.Fragment><Btn variant="ghost" size="sm" disabled={!!busy} onClick={() => setRejecting(null)}>Cancel</Btn><Btn variant="danger" size="sm" loading={rejecting && busy === 'reject:' + rejecting.id} disabled={!!busy} onClick={rejectRequest}>Reject request</Btn></React.Fragment>}>
        <Field label="Note" optional hint="Included in the rejection email if email sending is enabled."><textarea className="dw-textarea" value={rejectNote} onChange={(e) => setRejectNote(e.target.value)} placeholder="e.g. Please ask your workspace admin to invite you." /></Field>
      </Modal>
      <Modal open={roles} title="The three roles" sub="Kept deliberately simple — every teammate is one of these." onClose={() => setRoles(false)} footer={<Btn variant="pine" size="sm" onClick={() => setRoles(false)}>Got it</Btn>}>
        {DW_TEAM_ROLES.map((r) => (
          <div className="dw-card dw-card--pad-sm dw-mt-2" key={r[0]}><span className={'dw-role dw-role--' + r[0].toLowerCase()}>{r[0]}</span><p className="dw-body-sm dw-secondary dw-mt-2" style={{ margin: '8px 0 0' }}>{r[1]}</p></div>
        ))}
      </Modal>
      {toastNode}
    </React.Fragment>
  );
}

function templateBuilderSeed(template) {
  if (!template) return null;
  const steps = template.schema && Array.isArray(template.schema.steps) ? template.schema.steps : [];
  const fields = steps.flatMap((step) => (step.questions || []).map((q) => ({
    id: q.id,
    type: q.type === 'long_text' ? 'long' : q.type === 'short_text' ? 'short' : q.type === 'single_select' ? 'single' : q.type === 'multi_select' ? 'multi' : q.type,
    label: q.label,
    help: q.help || '',
    required: !!q.required,
    options: q.options || []
  })));
  return { id: template.id, title: template.name, fields: fields, tags: template.tags || [], schema: template.schema || {} };
}

function TemplatesPanel() {
  const store = useStore();
  const [toast, toastNode] = useToast();
  const rows = store.questionnaireTemplates();
  const [build, setBuild] = useState(null);
  const [renameT, setRenameT] = useState(null);
  const [renameVal, setRenameVal] = useState('');
  const [busy, setBusy] = useState(false);
  const dup = async (t) => {
    setBusy(true);
    try {
      await store.duplicateQuestionnaireTemplate(t.id);
      toast('Template duplicated');
    } catch (error) {
      toast(error.message || 'Could not duplicate template');
    } finally {
      setBusy(false);
    }
  };
  const archive = async (t) => {
    setBusy(true);
    try {
      await store.archiveQuestionnaireTemplate(t.id);
      toast(t.name + ' archived');
    } catch (error) {
      toast(error.message || 'Could not archive template');
    } finally {
      setBusy(false);
    }
  };
  const doRename = async () => {
    if (!renameVal.trim()) return;
    setBusy(true);
    try {
      await store.renameQuestionnaireTemplate(renameT.id, renameVal.trim());
      setRenameT(null);
      toast('Renamed');
    } catch (error) {
      toast(error.message || 'Could not rename template');
    } finally {
      setBusy(false);
    }
  };
  const saveTemplate = async (payload) => {
    setBusy(true);
    try {
      await store.saveQuestionnaireTemplate({
        ...(payload.id ? { id: payload.id } : {}),
        name: payload.name,
        tags: (build && build.tags) || ['Sales'],
        schema: payload.schema
      });
      setBuild(null);
      toast('Template saved', true);
    } catch (error) {
      toast(error.message || 'Could not save template');
      throw error;
    } finally {
      setBusy(false);
    }
  };
  return (
    <React.Fragment>
      <div className="dw-row"><SectionRule hint="reusable across rooms — build once, reuse everywhere">Questionnaire templates</SectionRule><Btn variant="pine" size="sm" icon="plus" disabled={busy} onClick={() => setBuild({})}>New template</Btn></div>
      <div className="dw-table-scroll"><table className="dw-table dw-mt-2">
        <thead><tr><th>Template</th><th>Tags</th><th>Size</th><th>Used</th><th>Last used</th><th></th></tr></thead>
        <tbody>{rows.map((t) => (
          <tr key={t.id}>
            <td className="lead">{t.name}<div className="dw-mono-xs dw-muted">v{t.version} · by {t.by}</div></td>
            <td><span className="dw-cluster-2">{t.tags.map((g) => <Badge key={g} variant="outline">{g}</Badge>)}</span></td>
            <td className="num dw-muted">{t.questions}q · {t.steps}s</td>
            <td className="num">{t.usage}×</td>
            <td className="num dw-muted">{t.lastUsed}</td>
            <td style={{ textAlign: 'right' }}><span className="dw-cluster-2" style={{ justifyContent: 'flex-end', flexWrap: 'nowrap' }}><a className="dw-action" onClick={() => setBuild(templateBuilderSeed(t))}>Edit</a><a className="dw-action" onClick={() => !busy && dup(t)}>Duplicate</a><a className="dw-action" onClick={() => { setRenameT(t); setRenameVal(t.name); }}>Rename</a><a className="dw-action" style={{ color: 'var(--dw-status-bad)' }} onClick={() => !busy && archive(t)}>Archive</a></span></td>
          </tr>
        ))}</tbody>
      </table></div>
      {!rows.length ? <div className="dw-empty dw-mt-3"><Icon name="layers" size="xl" /><div className="dw-empty__title">No templates yet</div><div className="dw-empty__body">Save any questionnaire as a template to reuse it across rooms.</div></div> : null}
      {build ? <QuestionnaireBuilder seed={build} onClose={() => setBuild(null)} onSave={saveTemplate} toast={toast} /> : null}
      <Drawer open={!!renameT} title="Rename template" sub={renameT ? renameT.name : ''} onClose={() => setRenameT(null)} footer={<React.Fragment><Btn variant="ghost" size="sm" disabled={busy} onClick={() => setRenameT(null)}>Cancel</Btn><Btn variant="pine" size="sm" loading={busy} disabled={!renameVal.trim() || busy} onClick={doRename}>Save</Btn></React.Fragment>}>
        <Field label="Template name"><input className="dw-input" autoFocus value={renameVal} onChange={(e) => setRenameVal(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') doRename(); }} /></Field>
      </Drawer>
      {toastNode}
    </React.Fragment>
  );
}

function BrandPanel() {
  const store = useStore();
  const [toast, toastNode] = useToast();
  const current = store.brand();
  const [primary, setPrimary] = useState(current.primary || '#123A33');
  const [accent, setAccent] = useState(current.secondary || '#FF4A1C');
  const [logoUrl, setLogoUrl] = useState(current.logo || '');
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const brand = store.brand();
    setPrimary(brand.primary || '#123A33');
    setAccent(brand.secondary || '#FF4A1C');
    setLogoUrl(brand.logo || '');
  }, [current.primary, current.secondary, current.logo, current.logoMode]);
  const reset = async () => {
    setBusy(true);
    try {
      const patch = { primary: '#123A33', secondary: '#FF4A1C', logo: '', logoMode: 'none' };
      await store.saveBrand(patch);
      setPrimary(patch.primary);
      setAccent(patch.secondary);
      setLogoUrl('');
      toast('Brand reset to defaults');
    } catch (error) {
      toast(error.message || 'Could not reset brand');
    } finally {
      setBusy(false);
    }
  };
  const save = async () => {
    setBusy(true);
    try {
      await store.saveBrand({
        primary: primary,
        secondary: accent,
        logo: logoUrl.trim(),
        logoMode: logoUrl.trim() ? 'image' : 'none'
      });
      toast('Brand saved — every client gate now uses it', true);
    } catch (error) {
      toast(error.message || 'Could not save brand');
    } finally {
      setBusy(false);
    }
  };
  const swatch = (val, set, opts) => (
    <div className="dw-swatchrow dw-mt-2"><label className="dw-swatch-chip" style={{ background: val }}><input type="color" value={val} onChange={(e) => set(e.target.value)} /></label>
      {opts.map((o) => <button key={o} className={'dw-swatch-opt' + (val.toLowerCase() === o.toLowerCase() ? ' is-on' : '')} style={{ background: o }} onClick={() => set(o)}></button>)}</div>
  );
  const orgName = window.DWDisplay.orgName();
  const exampleEmail = window.DWDisplay.clientEmailExample();
  return (
    <React.Fragment>
      <div className="dw-grid-2" style={{ alignItems: 'start' }}>
        <div>
          <label className="dw-label">Primary</label>{swatch(primary, setPrimary, ['#123A33', '#1A140E', '#0D2A25'])}
          <label className="dw-label dw-mt-5">Accent</label>{swatch(accent, setAccent, ['#FF4A1C', '#E9A53C', '#B23A1A'])}
          <SectionRule>Logo</SectionRule>
          <Field label="Logo URL"><input className="dw-input" placeholder="https://static.example.com/logo.svg" value={logoUrl} onChange={(e) => setLogoUrl(e.target.value)} /></Field>
          <div className={'dw-logodrop' + (logoUrl.trim() ? ' is-set' : '')}><span className="dw-logodrop__h">{logoUrl.trim() ? logoUrl.trim() : 'Add a hosted PNG or SVG URL, then save brand to persist it.'}</span></div>
        </div>
        <div>
          <label className="dw-label">Client-gate preview <span className="dw-mono-xs dw-muted" style={{ textTransform: 'none', letterSpacing: 0 }}>· exactly what readers see first</span></label>
          <div className="dw-gp dw-mt-2"><div className="dw-gp__brand" style={{ background: primary }}><span className="dw-gp__logo">{orgName}</span><h3>A proposal with a place to <span className="mk" style={{ background: accent, color: '#fff' }}>talk back.</span></h3></div>
            <div className="dw-gp__entry"><span className="dw-gp__lbl">Your work email</span><span className="dw-gp__field">{exampleEmail}</span><button className="dw-gp__cta" style={{ background: accent }}>Email me the room link →</button><span className="dw-gp__micro">If your email is on the invite list, we send a one-time magic link.</span></div></div>
        </div>
      </div>
      <div className="dw-row dw-mt-5" style={{ justifyContent: 'flex-end' }}><Btn variant="ghost" size="sm" disabled={busy} onClick={reset}>Reset</Btn><Btn variant="pine" size="sm" loading={busy} disabled={busy} onClick={save}>Save brand</Btn></div>
      {toastNode}
    </React.Fragment>
  );
}

function cleanOrganisationDomain(value) {
  return String(value || '').trim().replace(/^https?:\/\//i, '').replace(/^www\./i, '').replace(/\/.*$/, '').toLowerCase();
}

function emailDomain(email) {
  const parts = String(email || '').toLowerCase().split('@');
  return parts.length === 2 ? cleanOrganisationDomain(parts[1]) : '';
}

function defaultOrganisationDomain(store) {
  const members = store.members ? store.members() : [];
  const admin = members.find((member) => member[4] === 'Admin' && emailDomain(member[1]));
  const currentUserDomain = emailDomain((store.get().teamUser || {}).email);
  const workspaceDomain = emailDomain(window.DWDisplay.workspaceEmailExample());
  return (admin && emailDomain(admin[1])) || currentUserDomain || workspaceDomain;
}

function DomainsPanel() {
  const store = useStore();
  const [toast, toastNode] = useToast();
  const domains = store.workspaceDomains();
  const plan = window.DWAdapters.workspacePlan();
  const isTopTier = plan === 'Agency';
  const defaultDomain = defaultOrganisationDomain(store);
  const [baseDomain, setBaseDomain] = useState(defaultDomain);
  const [busy, setBusy] = useState('');
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [editingKind, setEditingKind] = useState('');
  useEffect(() => {
    if (!baseDomain && defaultDomain) setBaseDomain(defaultDomain);
  }, [baseDomain, defaultDomain]);
  const webDomain = domains.find((domain) => domain.kind === 'web');
  const emailDomain = domains.find((domain) => domain.kind === 'email');
  const proposalHost = cleanOrganisationDomain(baseDomain).indexOf('proposals.') === 0 ? cleanOrganisationDomain(baseDomain) : 'proposals.' + (cleanOrganisationDomain(baseDomain) || 'organisation-domain.com');
  const create = async (kind, replacingDomain) => {
    const organisationDomain = cleanOrganisationDomain(baseDomain);
    if (!organisationDomain) {
      toast('Enter the organisation domain first.');
      return;
    }
    setBusy((replacingDomain ? 'replace:' : 'create:') + kind);
    try {
      const result = await store.createWorkspaceDomain({ kind: kind, baseDomain: organisationDomain, senderLocalPart: 'proposals' });
      if (replacingDomain) await store.deleteWorkspaceDomain(replacingDomain.id);
      setEditingKind('');
      toast('DNS records ready for ' + result.hostname + '. Add them at the organisation DNS host, then validate.', true);
    } catch (error) {
      toast(error.message || 'Could not create domain setup');
    } finally {
      setBusy('');
    }
  };
  const verify = async (domain) => {
    setBusy('verify:' + domain.id);
    try {
      const result = await store.verifyWorkspaceDomain(domain.id);
      toast(result.status === 'active' ? result.hostname + ' is validated' : result.hostname + ' is still waiting on DNS', result.status === 'active');
    } catch (error) {
      toast(error.message || 'Could not verify domain');
    } finally {
      setBusy('');
    }
  };
  const remove = async () => {
    if (!confirmDelete) return;
    setBusy('delete:' + confirmDelete.id);
    try {
      await store.deleteWorkspaceDomain(confirmDelete.id);
      toast(confirmDelete.hostname + ' removed. This workspace is back on the default Dealwondr flow.', true);
      setConfirmDelete(null);
    } catch (error) {
      toast(error.message || 'Could not remove domain');
    } finally {
      setBusy('');
    }
  };
  const testEmail = async (domain) => {
    setBusy('test:' + domain.id);
    try {
      const result = await store.testWorkspaceDomainEmail(domain.id);
      toast('Test email queued from ' + result.from + ' to ' + result.to, true);
    } catch (error) {
      toast(error.message || 'Could not send test email');
    } finally {
      setBusy('');
    }
  };
  return (
    <React.Fragment>
      <div className="dw-card dw-row" style={{ alignItems: 'flex-start' }}>
        <div>
          <Eyebrow>Highest tier setup</Eyebrow>
          <div className="dw-h4 dw-mt-2">Organisation domains and email sending</div>
          <p className="dw-body-sm dw-secondary dw-mt-2" style={{ margin: 0 }}>Workspace-wide setup for this organisation. Dealwondr prepares the sending and link configuration, then shows DNS records the organisation owner adds wherever their DNS is hosted. Until validation passes, rooms and emails keep using the default Dealwondr flow.</p>
        </div>
        <Badge variant={isTopTier ? 'pine' : 'outline'}>{isTopTier ? 'Agency enabled' : plan + ' plan'}</Badge>
      </div>
      {!isTopTier ? (
        <div className="dw-empty dw-mt-3"><Icon name="shield" size="xl" /><div className="dw-empty__title">Custom domains are not enabled on this plan</div><div className="dw-empty__body">Upgrade workflow is disabled in this milestone. A platform admin can move the workspace to the highest tier when this is sold.</div></div>
      ) : (
        <React.Fragment>
          <DomainSetupCard kind="web" title="Proposal link domain" description="Use proposals for every room link in this organisation after DNS and TLS validate." empty="Proposal links use the default Dealwondr domain until this is validated." domain={webDomain} baseDomain={baseDomain} defaultDomain={defaultDomain} proposalHost={proposalHost} busy={busy} editing={editingKind === 'web'} onBaseDomain={setBaseDomain} onCreate={create} onVerify={verify} onRemove={setConfirmDelete} onEdit={() => setEditingKind('web')} onCancelEdit={() => setEditingKind('')} />
          <DomainSetupCard kind="email" title="Organisation email sender" description="Use proposals as the authenticated sender for workspace and client emails after DNS validates." empty="Emails use the default Dealwondr sender until this is validated." domain={emailDomain} baseDomain={baseDomain} defaultDomain={defaultDomain} proposalHost={proposalHost} busy={busy} editing={editingKind === 'email'} onBaseDomain={setBaseDomain} onCreate={create} onVerify={verify} onRemove={setConfirmDelete} onEdit={() => setEditingKind('email')} onCancelEdit={() => setEditingKind('')} onTest={testEmail} />
        </React.Fragment>
      )}
      <Modal open={!!confirmDelete} title="Delete domain settings?" sub={confirmDelete ? confirmDelete.hostname : ''} onClose={() => { if (!busy) setConfirmDelete(null); }} footer={<React.Fragment><Btn variant="ghost" size="sm" disabled={!!busy} onClick={() => setConfirmDelete(null)}>Cancel</Btn><Btn variant="danger" size="sm" loading={confirmDelete && busy === 'delete:' + confirmDelete.id} disabled={!!busy} onClick={remove}>Delete settings</Btn></React.Fragment>}>
        <p className="dw-body-sm dw-secondary">This removes the Dealwondr setup and returns this workspace to the default Dealwondr domain and email flow used by other plans. DNS records at the organisation DNS host must be removed separately.</p>
      </Modal>
      {toastNode}
    </React.Fragment>
  );
}

function DomainSetupCard({ kind, title, description, empty, domain, baseDomain, defaultDomain, proposalHost, busy, editing, onBaseDomain, onCreate, onVerify, onRemove, onEdit, onCancelEdit, onTest }) {
  const active = domain && domain.status === 'active';
  const setupBusy = busy === 'create:' + kind || busy === 'replace:' + kind;
  const icon = kind === 'email' ? 'mail' : 'link';
  if (!domain || editing) {
    return (
      <div className="dw-card dw-card--pad-sm dw-mt-3">
        <div className="dw-row">
          <div>
            <Eyebrow>{domain ? 'Edit setup' : 'Step 1 · choose organisation domain'}</Eyebrow>
            <div className="dw-h4 dw-mt-2">{title}</div>
            <p className="dw-body-sm dw-secondary dw-mt-1">{domain ? 'Generate a replacement setup. The existing setting remains active until the new DNS records are created.' : empty}</p>
          </div>
          <Badge variant="outline">Default Dealwondr flow</Badge>
        </div>
        <div className="dw-grid-2 dw-mt-3" style={{ alignItems: 'end' }}>
          <Field label="Organisation domain" hint={'DNS records will be created for ' + proposalHost}><input className="dw-input" placeholder={defaultDomain || 'organisation.com'} value={baseDomain} onChange={(e) => onBaseDomain(e.target.value)} /></Field>
          <div className="dw-cluster-2" style={{ justifyContent: 'flex-end' }}>
            {domain ? <Btn variant="ghost" size="sm" disabled={!!busy} onClick={onCancelEdit}>Cancel</Btn> : null}
            <Btn variant={kind === 'email' ? 'pine' : 'ghost'} size="sm" icon={icon} loading={setupBusy} disabled={!!busy || !cleanOrganisationDomain(baseDomain)} onClick={() => onCreate(kind, domain)}>{domain ? 'Generate replacement DNS records' : 'Generate DNS records'}</Btn>
          </div>
        </div>
        <p className="dw-body-sm dw-secondary dw-mt-2">{description}</p>
      </div>
    );
  }
  return (
    <div className="dw-card dw-card--pad-sm dw-mt-3">
      <div className="dw-row">
        <div>
          <Eyebrow>{active ? 'Step 3 · validated' : 'Step 2 · add DNS records'}</Eyebrow>
          <div className="dw-h4 dw-mt-2">{title}</div>
          <div className="dw-body-sm dw-muted dw-mt-1">{domain.hostname} · {domain.kind === 'email' ? (domain.senderLocalPart || 'proposals') + '@' + domain.hostname : 'https://' + domain.hostname}</div>
        </div>
        <span className="dw-cluster-2">
          <Badge variant={active ? 'pine' : domain.status === 'failed' ? 'bad' : 'outline'}>{window.DWAdapters.domainStatusLabel(domain.status)}</Badge>
          <Btn variant="ghost" size="sm" loading={busy === 'verify:' + domain.id} disabled={!!busy} onClick={() => onVerify(domain)}>{active ? 'Revalidate' : 'Validate'}</Btn>
          <Btn variant="ghost" size="sm" disabled={!!busy} onClick={onEdit}>Edit</Btn>
          {onTest ? <Btn variant="ghost" size="sm" icon="mail" loading={busy === 'test:' + domain.id} disabled={!!busy || !active} onClick={() => onTest(domain)}>Send test</Btn> : null}
          <Btn variant="ghost" size="sm" disabled={!!busy} onClick={() => onRemove(domain)}>Delete settings</Btn>
        </span>
      </div>
      {domain.errorMessage ? <p className="dw-body-sm" style={{ color: 'var(--dw-status-bad)' }}>{domain.errorMessage}</p> : null}
      <p className="dw-body-sm dw-secondary dw-mt-2">{active ? 'These records have validated. Revalidate after DNS changes, edit to generate a new setup, or delete settings to return to the default Dealwondr flow.' : 'Add these records where the organisation manages DNS, then click Validate. Dealwondr keeps using the default flow until validation passes.'}</p>
      <SectionRule hint={description}>{active ? 'Validated DNS entries' : 'DNS records to add at your DNS host'}</SectionRule>
      <div className="dw-table-scroll"><table className="dw-table dw-mt-3">
        <thead><tr><th>Record type</th><th>Host / name</th><th>Value / target</th><th>Why</th></tr></thead>
        <tbody>{domain.dnsRecords.map((record, index) => (
          <tr key={index}><td className="dw-mono">{record.type}</td><td className="dw-mono-xs">{record.name}</td><td className="dw-mono-xs">{record.value}</td><td className="dw-muted">{record.purpose || record.status || 'Verification'}</td></tr>
        ))}</tbody>
      </table></div>
      {!domain.dnsRecords.length ? <div className="dw-empty dw-mt-3"><Icon name="file" size="xl" /><div className="dw-empty__title">DNS records are not ready yet</div><div className="dw-empty__body">Click Validate again. If this stays empty, Dealwondr has not received records for this setup.</div></div> : null}
    </div>
  );
}

function UsagePanel() {
  const store = useStore();
  const costs = store.costs();
  const llmRuns = store.llmRuns();
  const usage = window.DWAdapters.usageSummary(costs, llmRuns);
  const tokenTotals = usage.tokenTotals;
  return (
    <React.Fragment>
      <div className="dw-stats">
        <div className="dw-stat"><span className="dw-stat__k">Ledger rows</span><div className="dw-stat__v">{usage.ledgerRows}</div><span className="dw-stat__d">workspace-scoped</span></div>
        <div className="dw-stat"><span className="dw-stat__k">Services</span><div className="dw-stat__v">{usage.serviceCount}</div><span className="dw-stat__d">tracked separately</span></div>
        <div className="dw-stat"><span className="dw-stat__k">LLM runs</span><div className="dw-stat__v">{usage.llmRunCount}</div><span className="dw-stat__d">Workers AI audit</span></div>
        <div className="dw-stat"><span className="dw-stat__k">Known cost</span><div className="dw-stat__v">{usage.knownCost}</div><span className="dw-stat__d">USD where priced</span></div>
      </div>
      <SectionRule hint="from /workspaces/:workspaceId/costs">Service usage ledger</SectionRule>
      {usage.services.length ? (
        <div className="dw-table-scroll"><table className="dw-table dw-mt-2">
          <thead><tr><th>Service</th><th>Rows</th><th>Quantity</th><th>Known cost</th></tr></thead>
          <tbody>{usage.services.map((row) => (
            <tr key={row.service}><td className="lead">{row.service}</td><td className="num">{row.entries}</td><td className="num">{row.quantity}</td><td className="num">{row.hasCost ? window.DWAdapters.formatUsageMoney(row.cost) : '—'}</td></tr>
          ))}</tbody>
        </table></div>
      ) : <div className="dw-empty dw-mt-3"><Icon name="chart" size="xl" /><div className="dw-empty__title">No usage rows yet</div><div className="dw-empty__body">Backend service usage will appear here after uploads, exports, queues, D1 operations, or AI runs.</div></div>}
      <SectionRule hint="separate Workers AI audit trail">LLM usage</SectionRule>
      <div className="dw-card dw-card--pad-sm dw-mt-2">
        <div className="dw-row"><div><div className="dw-h4">{usage.tokenTotal} tokens</div><div className="dw-body-sm dw-muted dw-mt-1">{tokenTotals.input} input · {tokenTotals.output} output</div></div><span className="dw-grow"></span><div className="dw-data">{tokenTotals.hasCost ? window.DWAdapters.formatUsageMoney(tokenTotals.cost) : '—'}</div></div>
      </div>
      {usage.llmRuns.length ? (
        <div className="dw-table-scroll"><table className="dw-table dw-mt-2">
          <thead><tr><th>Run</th><th>Room</th><th>Status</th><th>Model</th><th>Tokens</th><th>Cost</th><th>Created</th></tr></thead>
          <tbody>{usage.llmRuns.map((run) => (
            <tr key={run.id}>
              <td className="lead">{run.task}<div className="dw-mono-xs dw-muted">{run.promptVersion}</div></td>
              <td className="dw-mono dw-muted">{run.roomId}</td>
              <td><Badge variant={run.status === 'succeeded' ? 'pine' : run.status === 'failed' ? 'bad' : 'outline'}>{run.status || 'unknown'}</Badge></td>
              <td className="dw-mono dw-muted">{run.model}</td>
              <td className="num">{run.tokens}</td>
              <td className="num">{run.cost}</td>
              <td className="num dw-muted">{run.created}</td>
            </tr>
          ))}</tbody>
        </table></div>
      ) : <div className="dw-empty dw-mt-3"><Icon name="sparkle" size="xl" /><div className="dw-empty__title">No LLM runs yet</div><div className="dw-empty__body">Workers AI section analysis runs will appear separately from the general service ledger.</div></div>}
    </React.Fragment>
  );
}

function BillingPanel() {
  const plan = window.DWAdapters.workspacePlan();
  const tiers = [['Trial', 'Free', ['3 rooms', 'Core insights'], 'Downgrade', 'ghost'], ['Studio', '$49 / mo', ['Unlimited rooms', 'Full insights', 'Replay'], 'Current', 'current'], ['Agency', '$149 / mo', ['Everything in Studio', 'Team roles · SSO'], 'Upgrade', 'pine']];
  return (
    <React.Fragment>
      <div className="dw-card dw-row"><div><Eyebrow>Current plan</Eyebrow><div className="dw-h4 dw-mt-2">{plan} <span className="dw-planpill active">active</span></div><div className="dw-body-sm dw-secondary dw-mt-2">Static workspace plan. Subscription billing is not enabled in this milestone.</div></div><Btn variant="ghost" size="sm" disabled>Manage disabled</Btn></div>
      <SectionRule>Plans</SectionRule>
      <div className="dw-tiers">{tiers.map((t, i) => (
        <div key={i} className={'dw-tier' + (t[4] === 'current' ? ' is-current' : '')}>{t[4] === 'current' ? <span className="dw-tier__cur">Your plan</span> : null}
          <div className="dw-tier__name">{t[0]}</div><div className="dw-tier__price">{t[1]}</div><ul className="dw-tier__feat">{t[2].map((f, j) => <li key={j}>{f}</li>)}</ul>
          {t[4] === 'current' ? <Btn variant="ghost" size="sm" block disabled>Current</Btn> : <Btn variant={t[4] === 'pine' ? 'pine' : 'ghost'} size="sm" block disabled>{t[3]} disabled</Btn>}</div>
      ))}</div>
      <SectionRule>Billing</SectionRule>
      <div className="dw-billrow"><span className="dw-billrow__k">Payment method</span><span>Not configured</span></div>
      <div className="dw-billrow"><span className="dw-billrow__k">Next invoice</span><span>Not scheduled</span></div>
    </React.Fragment>
  );
}

/* ===================== ALERTS ===================== */
/* one actionable notification — one-tap act/snooze, with a done+undo state */
function NotifCard({ n, onAct, onUndo, onUnsnooze, busy }) {
  if (n.done) {
    return (
      <div className="dw-action-card is-done dw-mt-3"><span className="dw-action-card__rail"></span>
        <div className="dw-cluster-2" style={{ flex: 1, alignItems: 'center' }}><span className="dw-action-card__tick">✓</span><span className="dw-body-sm" style={{ color: 'var(--dw-text-secondary)' }}><strong style={{ color: 'var(--dw-text-primary)' }}>{n.done.label}</strong> · {n.title}</span><span className="dw-grow"></span><button className="dw-action" disabled={busy} onClick={() => onUndo(n)}>Undo</button></div></div>
    );
  }
  return (
    <div className={'dw-action-card t-' + n.temp + (n.hot ? ' is-lead' : '') + ' dw-mt-3'}><span className="dw-action-card__rail"></span>
      <div style={{ flex: 1 }}>
        <div className="dw-action-card__meta">
          <span className="dw-action-card__verb">{n.verb}</span>
          <span className={'dw-action-card__impact i-' + n.temp}>{n.tempLabel}</span>
          <span className="dw-overline">{n.room}</span>
          {n.snoozed ? <Badge variant="outline">snoozed</Badge> : null}
        </div>
        <div className="dw-action-card__title">{n.title}</div>
        {n.body ? <p className="dw-action-card__why">{n.body}</p> : null}
        <div className="dw-action-card__acts">
          {n.snoozed && onUnsnooze ? <Btn variant="ghost" size="sm" loading={busy === n.id + ':unsnooze'} disabled={!!busy} onClick={() => onUnsnooze(n)}>Unsnooze</Btn> : null}
          {n.actions.map((a) => <Btn key={a.id} variant={a.primary ? 'pine' : 'ghost'} size="sm" loading={busy === n.id + ':' + a.id} disabled={!!busy} onClick={() => onAct(n, a)}>{a.label}</Btn>)}
        </div>
      </div>
    </div>
  );
}

const DW_ALERT_FILTERS = [['all', 'All'], ['needs', 'Needs action'], ['hot', 'Hot'], ['snoozed', 'Snoozed'], ['done', 'Done']];

function Alerts({ onNav, onReader }) {
  const store = useStore();
  const [toast, toastNode] = useToast();
  const [rules, setRules] = useState(false);
  const [filter, setFilter] = useState('needs');
  const [busy, setBusy] = useState('');
  const notifs = store.notifications();
  const prefs = store.notificationPrefs();
  const act = async (n, a) => {
    setBusy(n.id + ':' + a.id);
    try {
      if (a.kind === 'snooze') {
        await store.snoozeNotification(n.id);
        toast('Snoozed — back tomorrow');
      } else {
        const result = await store.actOnNotification(n.id, a.id);
        if (onNav) await openNotificationNav(store, n, result, onNav, onReader);
        toast((result && result.toast) || a.toast || (a.doneLabel || a.label) + ' — done', !!a.primary);
      }
    } catch (error) {
      toast(error.message || 'Could not update alert');
    } finally {
      setBusy('');
    }
  };
  const undo = async (n) => {
    setBusy(n.id + ':undo');
    try {
      await store.undoNotification(n.id);
      toast('Action undone');
    } catch (error) {
      toast(error.message || 'Could not undo alert');
    } finally {
      setBusy('');
    }
  };
  const unsnooze = async (n) => {
    setBusy(n.id + ':unsnooze');
    try {
      await store.unsnoozeNotification(n.id);
      toast('Alert returned to Needs action', true);
    } catch (error) {
      toast(error.message || 'Could not unsnooze alert');
    } finally {
      setBusy('');
    }
  };
  const markAllRead = async () => {
    setBusy('read-all');
    try {
      await store.markAllNotificationsRead();
      toast('All alerts marked read');
    } catch (error) {
      toast(error.message || 'Could not mark alerts read');
    } finally {
      setBusy('');
    }
  };
  const savePrefs = async (patch) => {
    setBusy('rules');
    try {
      await store.saveNotificationPrefs(patch);
      toast('Alert rules saved', true);
    } catch (error) {
      toast(error.message || 'Could not save alert rules');
      throw error;
    } finally {
      setBusy('');
    }
  };
  const counts = {
    needs: notifs.filter((n) => n.actionable && !n.snoozed && !n.done).length,
    hot: notifs.filter((n) => n.hot && !n.snoozed && !n.done).length,
    unread: notifs.filter((n) => !n.read && !n.done).length,
  };
  const list = notifs.filter((n) => {
    if (filter === 'snoozed') return n.snoozed && !n.done;
    if (filter === 'done') return !!n.done;
    if (n.snoozed || n.done) return false;
    if (filter === 'needs') return n.actionable;
    if (filter === 'hot') return n.hot;
    return true;
  });
  const emptyCopy = { needs: ['Nothing needs you right now', 'When a reader re-reads the guarantee, an approver stays silent, or a question ages out — it lands here, ready to act on.'], hot: ['No hot signals', 'Re-reads and high-severity objections show up here first.'], snoozed: ['No snoozed alerts', 'Snooze an alert to revisit it tomorrow.'], done: ['No actioned alerts yet', 'Acted alerts move here with an Undo, so nothing is lost.'], all: ['All clear', 'Every alert has been actioned or snoozed.'] }[filter] || ['No alerts', ''];
  return (
    <React.Fragment>
      <PageHead title="Alerts" sub="The moment it matters — one tap to act"
        secondary={{ label: 'Alert rules ▾', onClick: () => setRules(true) }}>
        <span className="dw-status-text dw-status-text--ok" style={{ marginRight: 8 }}>Active</span>
      </PageHead>
      <div className="dw-main__body">
        <div className="dw-stats">
          <div className="dw-stat"><span className="dw-stat__k">Needs action</span><div className="dw-stat__v">{counts.needs}</div><span className="dw-stat__d">one tap each</span></div>
          <div className="dw-stat"><span className="dw-stat__k">Hot &amp; at-risk</span><div className="dw-stat__v">{counts.hot}</div><span className="dw-stat__d">act first</span></div>
          <div className="dw-stat"><span className="dw-stat__k">Unread</span><div className="dw-stat__v">{counts.unread}</div><span className="dw-stat__d">across your rooms</span></div>
        </div>
        <div className="dw-row dw-mt-5"><div className="dw-filterbar">{DW_ALERT_FILTERS.map((f) => <button key={f[0]} className={'dw-chip' + (filter === f[0] ? ' is-on' : '')} onClick={() => setFilter(f[0])}>{f[1]}{f[0] === 'needs' && counts.needs ? ' · ' + counts.needs : ''}</button>)}</div>{filter !== 'done' && filter !== 'snoozed' ? <button className="dw-action" disabled={!!busy} onClick={markAllRead}>Mark all read</button> : null}</div>
        <div className="dw-mt-4">
          {list.length ? list.map((n) => <NotifCard key={n.id} n={n} onAct={act} onUndo={undo} onUnsnooze={unsnooze} busy={busy} />) : <div className="dw-empty"><Icon name="bell" size="xl" /><div className="dw-empty__title">{emptyCopy[0]}</div><div className="dw-empty__body">{emptyCopy[1]}</div></div>}
        </div>
      </div>
      <AlertRulesDrawer open={rules} prefs={prefs} busy={busy === 'rules'} teamEmail={(store.get().teamUser || {}).email} onSave={savePrefs} onClose={() => setRules(false)} />
      {toastNode}
    </React.Fragment>
  );
}

function AlertRulesDrawer({ open, onClose, prefs, onSave, busy, teamEmail }) {
  const base = prefs || {};
  const [channels, setChannels] = useState(base.channels || {});
  const [rules, setRules] = useState(base.rules || []);
  const [digest, setDigest] = useState(base.digest && base.digest.on === false ? 'off' : (base.digest && base.digest.cadence) || 'daily');
  useEffect(() => {
    if (!open) return;
    setChannels((prefs && prefs.channels) || {});
    setRules((prefs && prefs.rules) || []);
    setDigest(prefs && prefs.digest && prefs.digest.on === false ? 'off' : (prefs && prefs.digest && prefs.digest.cadence) || 'daily');
  }, [open, prefs && prefs.updatedAt]);
  const toggleChannel = (key) => setChannels((value) => ({ ...value, [key]: !value[key] }));
  const toggleRule = (id) => setRules((rows) => rows.map((row) => row.id === id ? { ...row, on: !row.on } : row));
  const save = async () => {
    await onSave({ channels: channels, rules: rules, digest: { on: digest !== 'off', cadence: digest, time: (prefs && prefs.digest && prefs.digest.time) || '09:00' } });
    onClose();
  };
  const channel = (key, icon, name, meta) => (
    <div className="dw-channel"><span className="dw-channel__ic"><Icon name={icon} size="sm" /></span><div className="dw-channel__body"><div className="dw-channel__name">{name}</div><div className="dw-channel__meta">{meta}</div></div><input type="checkbox" className="dw-switch" checked={!!channels[key]} onChange={() => toggleChannel(key)} /></div>
  );
  const rule = (row) => (
    <div className={'dw-rule' + (row.on ? '' : ' is-off')}><div className="dw-rule__body"><div className="dw-rule__name">{row.name}</div><div className="dw-rule__desc">{row.desc}</div><div className="dw-rule__thresh"><span>Threshold</span><span className="dw-verpill">{row.threshold}</span></div></div><input type="checkbox" className="dw-switch" checked={!!row.on} onChange={() => toggleRule(row.id)} /></div>
  );
  return (
    <Drawer open={open} title="Alert rules" sub="Where alerts go, what fires them, and how often." onClose={onClose} footer={<React.Fragment><Btn variant="ghost" size="sm" disabled={busy} onClick={onClose}>Cancel</Btn><Btn variant="pine" size="sm" loading={busy} disabled={busy} onClick={save}>Save rules</Btn></React.Fragment>}>
      <SectionRule>Where alerts go</SectionRule>
      {channel('inApp', 'inbox', 'In-app', 'Always on')}
      {channel('email', 'mail', 'Email', teamEmail || 'Team email')}
      {channel('slack', 'bolt', 'Slack', channels.slack ? '#deals' : 'Not connected')}
      <SectionRule>What fires an alert</SectionRule>
      {rules.map((row) => <React.Fragment key={row.id}>{rule(row)}</React.Fragment>)}
      <SectionRule>Digest &amp; quiet hours</SectionRule>
      <label className="dw-label">Roll-up cadence</label>
      <div className="dw-seg dw-mt-2">{['off', 'daily', 'weekly'].map((c) => <button key={c} className={'dw-seg__opt' + (digest === c ? ' is-on' : '')} onClick={() => setDigest(c)}>{c}</button>)}</div>
      <p className="dw-drawer__note">A hot reader or an approver going silent always breaks through quiet hours — everything else waits for the digest. Dealwondr never messages your clients.</p>
    </Drawer>
  );
}

/* ===================== QUESTIONNAIRE (fill) ===================== */
function questionType(type) {
  return type === 'long_text' ? 'long' : type === 'short_text' ? 'short' : type === 'single_select' ? 'single' : type === 'multi_select' ? 'multi' : type;
}
function questionSteps(questionnaire) {
  const schema = questionnaire && questionnaire.schema ? questionnaire.schema : {};
  if (Array.isArray(schema.steps) && schema.steps.length) {
    return schema.steps.map((step, index) => ({
      step: step.title || 'Step ' + (index + 1),
      qs: (step.questions || []).map((q) => ({
        id: q.id,
        type: questionType(q.type),
        label: q.label,
        req: !!q.required,
        required: !!q.required,
        help: q.help || '',
        opts: q.options || q.opts || [],
        placeholder: q.placeholder || ''
      }))
    }));
  }
  return questionnaire && questionnaire.fields && questionnaire.fields.length ? [{ step: questionnaire.title, qs: questionnaire.fields }] : [];
}

function Questionnaire({ onDone, questionnaireId }) {
  const store = useStore();
  const [toast, toastNode] = useToast();
  const [loading, setLoading] = useState(!!questionnaireId);
  const [loadError, setLoadError] = useState('');
  useEffect(() => {
    if (!questionnaireId) return;
    let cancelled = false;
    setLoading(true);
    setLoadError('');
    store.loadQuestionnaire(questionnaireId)
      .catch((error) => { if (!cancelled) setLoadError(error.message || 'Could not load questionnaire.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [questionnaireId]);
  const questionnaire = store.activeQuestionnaire(questionnaireId);
  const steps = questionSteps(questionnaire);
  const [si, setSi] = useState(0);
  const [ans, setAns] = useState({});
  const [done, setDone] = useState(false);
  const [saving, setSaving] = useState(false);
  const step = steps[si] || steps[0];
  const pct = steps.length ? Math.round(((si + 1) / steps.length) * 100) : 0;
  const preparedFor = window.DWDisplay.preparedForLabel();
  const set = (id, v) => setAns((a) => ({ ...a, [id]: v }));
  const missingRequired = step ? step.qs.some((q) => q.req && (ans[q.id] === undefined || ans[q.id] === null || ans[q.id] === '' || (Array.isArray(ans[q.id]) && !ans[q.id].length))) : false;
  const uploadFile = (questionId, file) => store.uploadQuestionnaireAttachment(questionnaire.id, questionId, file);
  const advance = async () => {
    if (!questionnaire || !step || missingRequired) return;
    const final = si >= steps.length - 1;
    setSaving(true);
    try {
      await store.submitQuestionnaire(questionnaire.id, ans, final);
      if (final) setDone(true);
      else setSi(si + 1);
    } catch (error) {
      toast(error.message || 'Could not save answers');
    } finally {
      setSaving(false);
    }
  };
  if (loading) {
    return (
      <div className="dw-qframe"><div className="dw-qframe__top"><Logo /><span className="dw-grow"></span><span className="dw-qframe__sub">{preparedFor}</span></div>
        <div className="dw-qframe__body"><div className="dw-qframe__card thanks"><span className="dw-spinner" style={{ width: 24, height: 24 }}></span><h2>Loading questionnaire.</h2></div></div>{toastNode}</div>
    );
  }
  if (loadError) {
    return (
      <div className="dw-qframe"><div className="dw-qframe__top"><Logo /><span className="dw-grow"></span><span className="dw-qframe__sub">{preparedFor}</span><Btn variant="ghost" size="sm" onClick={onDone}>Back</Btn></div>
        <div className="dw-qframe__body"><div className="dw-qframe__card thanks"><h2>Questionnaire unavailable.</h2><p>{loadError}</p><Btn variant="ghost" size="sm" onClick={onDone}>Back to the proposal</Btn></div></div>{toastNode}</div>
    );
  }
  if (!questionnaire || !steps.length) {
    return (
      <div className="dw-qframe"><div className="dw-qframe__top"><Logo /><span className="dw-grow"></span><span className="dw-qframe__sub">{preparedFor}</span><Btn variant="ghost" size="sm" onClick={onDone}>Back</Btn></div>
        <div className="dw-qframe__body"><div className="dw-qframe__card thanks"><h2>No active questionnaire.</h2><p>This room does not have an active questionnaire attached right now.</p><Btn variant="ghost" size="sm" onClick={onDone}>Back to the proposal</Btn></div></div>{toastNode}</div>
    );
  }
  if (done) {
    return (
      <div className="dw-qframe"><div className="dw-qframe__top"><Logo /><span className="dw-grow"></span><span className="dw-qframe__sub">{preparedFor}</span></div>
        <div className="dw-qframe__body"><div className="dw-qframe__card thanks"><div className="dw-thanks-mark">✓</div><h2>Thank you.</h2><p>{questionnaire.outroText || 'Your answers are in — we’ll use them to prepare for our conversation.'}</p><Btn variant="ghost" size="sm" onClick={onDone}>Back to the proposal</Btn></div></div>
      </div>
    );
  }
  return (
    <div className="dw-qframe">
      <div className="dw-qframe__top"><Logo /><span className="dw-grow"></span><span className="dw-qframe__sub">{preparedFor}</span><Btn variant="ghost" size="sm" onClick={onDone}>← Back</Btn></div>
      <div className="dw-qframe__body"><div className="dw-qframe__card"><div className="dw-fill">
        <div className="dw-fill__head"><div style={{ flex: 1 }}><Eyebrow>{questionnaire.title}</Eyebrow><div className="dw-fill__prog"><span>Step {si + 1} of {steps.length} — {step.step}</span><span className="bar"><i style={{ width: pct + '%' }}></i></span></div></div></div>
        <div className="dw-fill__body">
          {si === 0 ? <p className="dw-fill__intro">{questionnaire.introText || 'About five minutes — your answers make our conversation sharper.'}</p> : null}
          {step.qs.map((q) => <QField key={q.id} q={q} value={ans[q.id]} onChange={(v) => set(q.id, v)} onFile={uploadFile} onError={(message) => toast(message)} />)}
        </div>
        <div className="dw-fill__foot">{si > 0 ? <Btn variant="ghost" size="sm" disabled={saving} onClick={() => setSi(si - 1)}>← Back</Btn> : <span />}
          <Btn variant="pine" size="sm" loading={saving} disabled={saving || missingRequired} onClick={advance}>{si < steps.length - 1 ? 'Continue →' : 'Submit answers'}</Btn></div>
      </div></div></div>
      {toastNode}
    </div>
  );
}

function QField({ q, value, onChange, onFile, onError }) {
  const [fileBusy, setFileBusy] = useState(false);
  const [fileError, setFileError] = useState('');
  const opts = q.opts || q.options || [];
  const moveRank = (index, direction) => {
    const arr = Array.isArray(value) && value.length ? value.slice() : opts.slice();
    const next = index + direction;
    if (next < 0 || next >= arr.length) return;
    const item = arr[index];
    arr.splice(index, 1);
    arr.splice(next, 0, item);
    onChange(arr);
  };
  const upload = async (file) => {
    if (!file) return;
    if (!onFile) {
      setFileError('File upload is available in active forms only.');
      return;
    }
    setFileBusy(true);
    setFileError('');
    try {
      const saved = await onFile(q.id, file);
      onChange({
        fileName: saved.fileName || file.name,
        contentType: saved.contentType || file.type || 'application/octet-stream',
        bytes: saved.bytes || file.size,
        key: saved.key
      });
    } catch (error) {
      const message = error.message || 'Could not upload file';
      setFileError(message);
      if (onError) onError(message);
    } finally {
      setFileBusy(false);
    }
  };
  let control;
  if (q.type === 'long') control = <textarea className="dw-textarea" value={value || ''} onChange={(e) => onChange(e.target.value)} placeholder="Your answer…" />;
  else if (q.type === 'short') control = <input className="dw-input" value={value || ''} onChange={(e) => onChange(e.target.value)} placeholder={q.placeholder || 'Your answer'} style={{ maxWidth: 320 }} />;
  else if (q.type === 'email') control = <input className="dw-input" type="email" value={value || ''} onChange={(e) => onChange(e.target.value)} placeholder={q.placeholder || 'name@company.com'} style={{ maxWidth: 360 }} />;
  else if (q.type === 'url') control = <input className="dw-input" type="url" value={value || ''} onChange={(e) => onChange(e.target.value)} placeholder={q.placeholder || 'https://example.com'} style={{ maxWidth: 420 }} />;
  else if (q.type === 'number') control = <input className="dw-input" type="number" value={value ?? ''} onChange={(e) => onChange(e.target.value === '' ? '' : Number(e.target.value))} placeholder={q.placeholder || '0'} style={{ maxWidth: 220 }} />;
  else if (q.type === 'currency') control = <label className="dw-field-affix" style={{ maxWidth: 240 }}><span className="dw-icon dw-mono-xs" style={{ color: 'var(--dw-text-muted)' }}>$</span><input className="dw-input" type="number" min="0" step="0.01" value={value ?? ''} onChange={(e) => onChange(e.target.value === '' ? '' : Number(e.target.value))} placeholder={q.placeholder || '0.00'} /></label>;
  else if (q.type === 'date') control = <input className="dw-input" type="date" value={value || ''} onChange={(e) => { onChange(e.target.value); e.currentTarget.blur(); }} style={{ maxWidth: 220 }} />;
  else if (q.type === 'single') control = <div className="dw-q-opts">{opts.map((o) => <button key={o} type="button" className={'dw-q-opt' + (value === o ? ' is-on' : '')} onClick={() => onChange(o)}>{o}</button>)}</div>;
  else if (q.type === 'multi') { const arr = value || []; control = <div className="dw-q-opts">{opts.map((o) => <button key={o} type="button" className={'dw-q-opt' + (arr.indexOf(o) > -1 ? ' is-on' : '')} onClick={() => onChange(arr.indexOf(o) > -1 ? arr.filter((x) => x !== o) : arr.concat(o))}>{o}</button>)}</div>; }
  else if (q.type === 'yesno') control = <div className="dw-q-opts">{['Yes', 'No'].map((o) => <button key={o} type="button" className={'dw-q-opt' + (String(value || '').toLowerCase() === o.toLowerCase() ? ' is-on' : '')} onClick={() => onChange(o.toLowerCase())}>{o}</button>)}</div>;
  else if (q.type === 'rating') control = <div className="dw-q-rate">{[1, 2, 3, 4, 5].map((n) => <button key={n} className={'dw-q-star' + (value >= n ? ' is-on' : '')} onClick={() => onChange(n)}>{n}</button>)}</div>;
  else if (q.type === 'ranking') {
    const arr = Array.isArray(value) && value.length ? value : opts;
    control = <div className="dw-q-rank">{arr.map((o, i) => <div key={o} className="dw-q-rankrow"><span className="rk">{i + 1}</span><span className="lb">{o}</span><span className="mv"><button type="button" disabled={i === 0} onClick={() => moveRank(i, -1)}>↑</button><button type="button" disabled={i === arr.length - 1} onClick={() => moveRank(i, 1)}>↓</button></span></div>)}</div>;
  }
  else if (q.type === 'file') {
    control = (
      <div>
        <label className={'dw-q-file' + (value && value.fileName ? ' done' : '')}>
          <Icon name="upload" size="sm" /> {fileBusy ? 'Uploading…' : value && value.fileName ? value.fileName : 'Choose file'}
          <input type="file" disabled={fileBusy || !onFile} onChange={(e) => upload(e.target.files && e.target.files[0])} style={{ display: 'none' }} />
        </label>
        {value && value.bytes ? <div className="dw-mono-xs dw-muted dw-mt-2">{Math.ceil(value.bytes / 1024)} KB uploaded</div> : null}
        {fileError ? <div className="dw-error">{fileError}</div> : null}
      </div>
    );
  }
  else if (q.type === 'consent') return <div className="dw-q"><label className="dw-q-consent"><input type="checkbox" className="dw-check" checked={value === 'yes'} onChange={() => onChange(value === 'yes' ? '' : 'yes')} /> {q.label}</label></div>;
  return <div className="dw-q"><label className="dw-q__label">{q.label}{q.req ? <span className="dw-req">*</span> : null}</label>{q.help ? <p className="dw-q__help">{q.help}</p> : null}{control}</div>;
}

/* ===================== REPLAY ===================== */
Object.assign(window, { Settings, Alerts, AlertRulesDrawer, Questionnaire });


/* ---- app/shell.jsx ---- */
/* ============================================================
   DEALWONDR APP — console shell
   Team magic-link gate · the room-centric shell (pine nav + dark
   top bar + footer) · shared side-rail section header.
   ============================================================ */

/* ---------- Team gate (magic link · sign in + create a workspace) ---------- */
const DW_FREEMAIL = ['gmail.com', 'outlook.com', 'hotmail.com', 'yahoo.com', 'icloud.com', 'proton.me', 'protonmail.com', 'aol.com', 'live.com', 'me.com'];
function TeamGate({ onDone, onBack }) {
  const isMobile = useIsMobile();
  const [mode, setMode] = useState('login');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [orgName, setOrgName] = useState('');
  const [orgTouched, setOrgTouched] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const [devToken, setDevToken] = useState('');
  const [sentMode, setSentMode] = useState('');
  const [sentStatus, setSentStatus] = useState('');

  const domain = (email.split('@')[1] || '').toLowerCase();
  const seg = domain.split('.')[0] || '';
  const suggestedOrg = seg ? seg.charAt(0).toUpperCase() + seg.slice(1) : '';
  const isEmail = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.trim());
  const isFree = DW_FREEMAIL.indexOf(domain) > -1;
  const errCopy = typeof err === 'string'
    ? ({ invalid: ['That does not look like an email address.', 'Check for typos and try again.'], freemail: ['Use your work email.', 'Workspaces are tied to professional domains, so personal inboxes cannot manage proposals.'], name: ['Add your name.', 'This becomes the first admin profile for the workspace.'] }[err] || [err, ''])
    : null;
  const renderErr = (copy) => copy ? <React.Fragment><b>{copy[0]}</b>{copy[1] ? <React.Fragment><br />{copy[1]}</React.Fragment> : null}</React.Fragment> : null;
  const emailErr = err === 'invalid' || err === 'freemail' ? errCopy : null;
  const nameErr = err === 'name' ? errCopy : null;
  const formErr = errCopy && !emailErr && !nameErr ? errCopy : null;
  const requestedOrg = (orgTouched && orgName.trim()) ? orgName.trim() : suggestedOrg;

  function switchMode(next) {
    setMode(next);
    setErr(null);
    setDevToken('');
    setSentStatus('');
  }
  const requestLink = async (nextMode) => {
    const selectedMode = nextMode || mode;
    if (!isEmail) { setErr('invalid'); return; }
    if (isFree) { setErr('freemail'); return; }
    if (selectedMode === 'register' && !name.trim()) { setErr('name'); return; }
    setBusy(true);
    setErr(null);
    try {
      const result = await window.DWStore.requestTeamMagicLink(email, selectedMode, selectedMode === 'register' ? { name: name.trim(), orgName: requestedOrg } : {});
      setDevToken(result.token || '');
      setSentMode(selectedMode);
      setSentStatus(result.status || 'magic_link_sent');
      setMode('sent');
    } catch (error) {
      setErr(error.message || 'Could not send a magic link.');
    } finally {
      setBusy(false);
    }
  };
  const complete = async () => {
    setBusy(true);
    setErr(null);
    try {
      if (!devToken) throw new Error('Check your email for the sign-in link.');
      await window.DWStore.completeTeamMagicLink(devToken);
      onDone();
    } catch (error) {
      setErr(error.message || 'Could not complete sign-in.');
    } finally {
      setBusy(false);
    }
  };

  const brand = (
    <div className="dw-gate__brand" style={{ position: 'relative', flex: isMobile ? 'none' : '1.05', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', top: 30, right: 26 }}><Stamp size={isMobile ? 76 : 100} /></div>
      <Lockup reversed />
      <h1 className="dw-gate__h1" style={isMobile ? { paddingRight: 86, margin: '22px 0 14px' } : null}>The console behind every <span className="dw-mark" style={{ whiteSpace: 'nowrap' }}>proposal.</span></h1>
      <p className="dw-gate__sub">Upload versions, manage client access, answer questions where they were asked, and watch every proposal get read — across your whole team.</p>
      <div style={{ marginTop: 'auto', paddingTop: 28, display: 'flex', alignItems: 'center', gap: 12 }}>
        <span style={{ fontFamily: 'var(--dw-font-mono)', fontSize: 'var(--dw-text-2xs)', letterSpacing: '0.12em', textTransform: 'uppercase', color: 'color-mix(in srgb, var(--dw-cream-100) 60%, transparent)' }}>Magic-link · no passwords</span>
        <span style={{ flex: 1, height: 1, background: 'color-mix(in srgb, var(--dw-cream-100) 16%, transparent)' }}></span>
        {onBack ? <button className="dw-action" style={{ color: 'var(--dw-poppy-300)', textTransform: 'uppercase', fontSize: 'var(--dw-text-2xs)', letterSpacing: '0.12em' }} onClick={onBack}>← Reader view</button> : null}
      </div>
    </div>
  );

  const entry = (
    <div className="dw-gate__entry" style={{ flex: isMobile ? 'none' : '1', overflowY: 'auto' }}>
      <div style={{ width: '100%', maxWidth: 380, margin: '0 auto' }}>
        {mode === 'sent' ? (
          <React.Fragment>
            <div className="dw-auth-sent__status">
              <span className="dw-auth-sent__icon"><Icon name="mail" size="sm" /></span>
              <Eyebrow>{sentStatus === 'pending_approval' ? 'Request sent' : 'Magic link sent'}</Eyebrow>
            </div>
            <h2 className="dw-auth-sent__title">{sentStatus === 'pending_approval' ? 'Workspace admin approval needed.' : 'Check your inbox.'}</h2>
            <p className="dw-auth-sent__body">{sentStatus === 'pending_approval' ? 'An admin for this workspace will review your request.' : <React.Fragment>We emailed a sign-in link to <b>{email}</b>. It expires in 15 minutes and works once.</React.Fragment>}</p>
            {sentMode === 'register' && sentStatus !== 'pending_approval' ? <p className="dw-auth-sent__note">Opening it creates the <b>{requestedOrg}</b> workspace on <span className="dw-mono">@{domain}</span>.</p> : null}
            {devToken ? (
              <div className="dw-card dw-card--sunken dw-mt-4" style={{ textAlign: 'center' }}>
                <div className="dw-mono-xs dw-muted">Local/dev shortcut</div>
                <div className="dw-mt-3"><Btn variant="pine" block loading={busy} onClick={complete}>Open the magic link →</Btn></div>
              </div>
            ) : null}
            {formErr ? <div className="dw-error" style={{ marginTop: 10 }}>{renderErr(formErr)}</div> : null}
            <div className="dw-auth-sent__action">Wrong address? <a className="dw-jump" onClick={() => switchMode(sentMode || 'login')}>Use a different email</a></div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div className="dw-seg" style={{ width: '100%' }}>
              <button className={'dw-seg__opt' + (mode === 'login' ? ' is-on' : '')} onClick={() => switchMode('login')}>Sign in</button>
              <button className={'dw-seg__opt' + (mode === 'register' ? ' is-on' : '')} onClick={() => switchMode('register')}>Create a workspace</button>
            </div>
            <h2 className="dw-h2 dw-mt-4">{mode === 'register' ? 'Start your workspace' : 'Sign in to your console'}</h2>
            <p className="dw-body-sm dw-secondary dw-mt-2">{mode === 'register' ? 'No passwords — we email a one-time link. Your domain becomes your team.' : 'No passwords — we email you a one-time sign-in link.'}</p>
            {mode === 'register' ? <div className="dw-mt-4"><Field label="Your name" error={renderErr(nameErr)}><input className={'dw-input' + (nameErr ? ' is-error' : '')} placeholder="Vid Mehta" value={name} onChange={(e) => { setName(e.target.value); setErr(null); }} /></Field></div> : null}
            <div className="dw-mt-3"><Field label="Work email" error={renderErr(emailErr)}><input className={'dw-input' + (emailErr ? ' is-error' : '')} placeholder="you@company.com" value={email} onChange={(e) => { setEmail(e.target.value); setErr(null); }} onKeyDown={(e) => e.key === 'Enter' && requestLink(mode)} autoFocus /></Field></div>
            {mode === 'register' ? (
              <React.Fragment>
                <div className="dw-mt-3"><Field label="Workspace name"><input className="dw-input" placeholder={suggestedOrg || 'Acme'} value={orgTouched ? orgName : suggestedOrg} onChange={(e) => { setOrgTouched(true); setOrgName(e.target.value); }} /></Field></div>
                {domain && !isFree ? <p className="dw-hint" style={{ marginTop: 8 }}><span className="dw-mono">@{domain}</span> becomes your organisation — teammates with that domain can request access.</p> : null}
              </React.Fragment>
            ) : null}
            {formErr ? <div className="dw-error" style={{ marginTop: 10 }}>{renderErr(formErr)}</div> : null}
            <div className="dw-mt-4"><Btn variant="accent" size="lg" block iconRight="arrowright" loading={busy} disabled={!email.trim() || (mode === 'register' && !name.trim()) || busy} onClick={() => requestLink(mode)}>{mode === 'register' ? 'Create workspace — email me a link' : 'Email me a magic link'}</Btn></div>
            <div className="dw-hint" style={{ marginTop: 14 }}>{mode === 'login' ? <span>Use the email attached to your Dealwondr workspace.</span> : <span>Register with a professional email to create or request a workspace.</span>}</div>
          </React.Fragment>
        )}
      </div>
    </div>
  );

  return (
    <div className="dw-app">
      <div className="dw-gate" style={{ flexDirection: isMobile ? 'column' : 'row', height: '100%' }}>
        {brand}
        {entry}
      </div>
    </div>
  );
}

/* a labelled section header in a side rail */
function SideSec({ children }) { return <div className="dw-panel__sec">{children}</div>; }

function shellAccount(store) {
  const state = store.get();
  const session = state.teamSession || (store.activeSession ? store.activeSession() : null) || {};
  return window.DWAdapters.shellAccount(state, session, store.members ? store.members() : []);
}
function shellOpenAlertCount(store) {
  return (store.notifications ? store.notifications() : []).filter((n) => !n.read && !n.done && !n.snoozed).length;
}
function shellInsightsView(value) {
  return value === 'Analytics' ? 'Overview' : value;
}
async function openNotificationNav(store, notification, result, onGo, onReader) {
  const nav = result && result.nav;
  if (!nav) return false;
  if (notification && notification.roomId && store.selectRoom) await store.selectRoom(notification.roomId);
  if (nav.reader) {
    if (!onReader) throw new Error('Reader route is not available from this view.');
    onReader();
    return true;
  }
  if (nav.tab === 'Activity') {
    onGo('room', { roomTab: 'Activity' });
    return true;
  }
  if (nav.tab === 'Content') {
    onGo('room', { roomTab: 'Content', contentView: nav.view });
    return true;
  }
  if (nav.tab === 'Insights') {
    onGo('room', { roomTab: 'Insights', insightsView: shellInsightsView(nav.view) });
    return true;
  }
  return false;
}

/* ---------- Topbar bell + quick triage panel ---------- */
function BellTriage({ store, onGo, onReader }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState('');
  const [toast, toastNode] = useToast();
  const notifs = store.notifications ? store.notifications() : [];
  const actionable = notifs.filter((n) => n.actionable && !n.snoozed && !n.done);
  const act = async (n, a) => {
    setBusy(n.id + ':' + a.id);
    try {
      if (a.kind === 'snooze') {
        await store.snoozeNotification(n.id);
        toast('Snoozed — back tomorrow');
      } else {
        const result = await store.actOnNotification(n.id, a.id);
        const opened = await openNotificationNav(store, n, result, onGo, onReader);
        toast((result && result.toast) || (a.doneLabel || a.label) + ' — done', !!a.primary);
        if (opened) setOpen(false);
      }
    } catch (error) {
      toast(error.message || 'Could not update alert');
    } finally {
      setBusy('');
    }
  };
  const undo = async (n) => {
    setBusy(n.id + ':undo');
    try {
      await store.undoNotification(n.id);
      toast('Alert restored');
    } catch (error) {
      toast(error.message || 'Could not restore alert');
    } finally {
      setBusy('');
    }
  };
  return (
    <span style={{ position: 'relative', flex: 'none' }} onClick={(e) => e.stopPropagation()}>
      <button className={'dw-bell' + (open ? ' is-on' : '')} style={{ background: 'transparent', borderColor: 'color-mix(in srgb, var(--dw-cream-100) 26%, transparent)', color: 'var(--dw-cream-100)' }} onClick={() => setOpen((o) => !o)} title="Alerts"><Icon name="bell" size="sm" />{actionable.length ? <span className="dw-bell__dot">{actionable.length}</span> : null}</button>
      <Drawer open={open} title="Needs you" sub="The moment it matters — act in one tap" onClose={() => setOpen(false)}
        footer={<Btn variant="ghost" size="sm" block onClick={() => { setOpen(false); onGo('alerts'); }}>Open all alerts →</Btn>}>
        {actionable.length ? actionable.map((n) => <NotifCard key={n.id} n={n} onAct={act} onUndo={undo} busy={busy} />) : <div className="dw-empty"><Icon name="check" size="xl" /><div className="dw-empty__title">All caught up</div><div className="dw-empty__body">Nothing needs you right now. New signals land here the moment they happen.</div></div>}
        {toastNode}
      </Drawer>
    </span>
  );
}

/* ---------- Console shell ---------- */
function Shell({ active, onNav, onReader, side, children }) {
  const store = useStore();
  const isMobile = useIsMobile();
  const [navOpen, setNavOpen] = useState(false);
  const [orgOpen, setOrgOpen] = useState(false);
  const [acctOpen, setAcctOpen] = useState(false);
  const [roomLoading, setRoomLoading] = useState(null);
  useEffect(() => { if (!orgOpen && !acctOpen) return; const fn = () => { setOrgOpen(false); setAcctOpen(false); }; window.addEventListener('click', fn); return () => window.removeEventListener('click', fn); }, [orgOpen, acctOpen]);
  const rooms = store.rooms();
  const orgModel = window.DWAdapters.shellOrgModel();
  const currentRoomId = orgModel.currentRoomId;
  const isSuper = window.DWStore.isSuper();
  const platformOverview = isSuper && store.platformOverview ? store.platformOverview() : null;
  const sessionOrgs = store.teamWorkspaces ? store.teamWorkspaces() : [];
  const orgs = sessionOrgs.length ? sessionOrgs : (platformOverview ? window.DWAdapters.platformWorkspaceRows(platformOverview) : orgModel.orgs);
  const account = shellAccount(store);
  const alertCount = shellOpenAlertCount(store);
  const switchOrg = async (org, current) => {
    setOrgOpen(false);
    if (!org || current) return;
    if (store.switchWorkspace && org.id) {
      try {
        await store.switchWorkspace(org.id);
        onNav('dash');
        return;
      } catch (error) {
        console.error(error);
      }
    }
    if (isSuper) location.hash = '#/super';
  };
  const openRoom = async (room) => {
    if (!room || !room.canOpen) return;
    const roomId = room.apiId || room.id;
    if (active === 'room' && roomId === currentRoomId) {
      setNavOpen(false);
      return;
    }
    setRoomLoading({ id: roomId, title: room.title || 'room' });
    window.DW_API_ROOM_ID = roomId;
    onNav('room');
    setNavOpen(false);
    try {
      await store.selectRoom(roomId);
    } catch (error) {
      console.error(error);
    } finally {
      setRoomLoading(null);
    }
  };
  const nav = (
    <nav className={'dw-nav' + (navOpen ? ' is-open' : '')}>
      <button className={'dw-nav__link' + (active === 'dash' ? ' is-on' : '')} onClick={() => { onNav('dash'); setNavOpen(false); }}><Icon name="grid" size="sm" /> Dashboard</button>
      <button className={'dw-nav__link' + (active === 'alerts' ? ' is-on' : '')} onClick={() => { onNav('alerts'); setNavOpen(false); }}><Icon name="bell" size="sm" /> Alerts {alertCount ? <span className="dw-nav__count">{alertCount}</span> : null}</button>
      <div className="dw-nav__sec">Rooms <a onClick={() => { onNav('rooms'); setNavOpen(false); }}>All</a></div>
      {rooms.map((r) => {
        const roomId = r.apiId || r.id;
        const isLoading = roomLoading && roomLoading.id === roomId;
        return <button key={r.id} className={'dw-navroom' + (active === 'room' && roomId === currentRoomId ? ' is-on' : '') + (isLoading ? ' is-loading' : '')} disabled={isLoading} aria-busy={isLoading ? 'true' : undefined} onClick={() => openRoom(r)}>{r.title}<span className="dw-navroom__sub">{isLoading ? 'Opening…' : r.sub}</span></button>;
      })}
      <button className="dw-navroom" style={{ color: 'var(--dw-poppy-300)' }} onClick={() => { onNav('upload'); setNavOpen(false); }}>+ New room</button>
      <div className="dw-nav__foot" style={{ borderTop: 'none', flexDirection: 'column', alignItems: 'stretch', gap: 2, paddingLeft: 0, paddingRight: 'var(--dw-space-5)' }}>
        <button className={'dw-nav__link' + (active === 'settings' ? ' is-on' : '')} onClick={() => { onNav('settings'); setNavOpen(false); }}><Icon name="settings" size="sm" /> Settings</button>
        {isSuper ? <button className="dw-nav__link" onClick={() => { location.hash = '#/super'; setNavOpen(false); }}><Icon name="shield" size="sm" /> Super console</button> : null}
      </div>
    </nav>
  );

  if (isMobile) {
    const roomSection = active === 'room' || active === 'rooms' || active === 'upload';
    const mobileTitle = active === 'dash' ? 'Dashboard' : active === 'rooms' ? 'Rooms' : active === 'upload' ? 'New room' : active === 'room' ? window.DWDisplay.roomShortTitle() : active === 'alerts' ? 'Alerts' : 'Settings';
    return (
      <div className="dw-app" style={{ position: 'relative' }}>
        <div className="dw-appbar">
          <button className="dw-appbar__btn" onClick={() => setNavOpen(true)}><Icon name="grid" /></button>
          <span className="dw-appbar__title">{mobileTitle}</span>
          <button className="dw-appbar__btn" onClick={onReader} title="Open reader"><Icon name="eye" /></button>
        </div>
        <div style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>{children}</div>
        {roomLoading ? <RoomRouteLoader title={roomLoading.title} /> : null}
        <div className="dw-tabbar">
          <button className={'dw-tabbar__tab' + (active === 'dash' ? ' is-on' : '')} onClick={() => onNav('dash')}><Icon name="grid" />Home</button>
          <button className={'dw-tabbar__tab' + (roomSection ? ' is-on' : '')} onClick={() => onNav('rooms')}><Icon name="file" />Rooms</button>
          <button className={'dw-tabbar__tab' + (active === 'alerts' ? ' is-on' : '')} onClick={() => onNav('alerts')}><Icon name="bell" />Alerts{alertCount ? <span className="dw-nav__count">{alertCount}</span> : null}</button>
          <button className={'dw-tabbar__tab' + (active === 'settings' ? ' is-on' : '')} onClick={() => onNav('settings')}><Icon name="user" />You</button>
        </div>
        {navOpen ? <div className="dw-drawer-scrim" style={{ position: 'absolute', justifyContent: 'flex-start' }} onMouseDown={(e) => { if (e.target === e.currentTarget) setNavOpen(false); }}>{nav}</div> : null}
      </div>
    );
  }
  return (
    <div className="dw-app">
      <div className="dw-topbar" style={{ paddingLeft: 0, background: 'var(--dw-pine-700)', borderBottom: 'none', height: 56 }}>
        <div style={{ width: 'var(--dw-nav)', flex: 'none', paddingLeft: 'var(--dw-space-4)', display: 'flex', alignItems: 'center' }}><Lockup reversed /></div>
        <span style={{ width: 1, height: 22, background: 'color-mix(in srgb, var(--dw-cream-100) 20%, transparent)' }}></span>
        <span style={{ position: 'relative' }} onClick={(e) => e.stopPropagation()}>
          <button className="dw-orgchip" style={{ color: 'var(--dw-cream-100)' }} onClick={() => { setOrgOpen((o) => !o); setAcctOpen(false); }}>{orgModel.orgName} <span className="cv" style={{ color: 'color-mix(in srgb, var(--dw-cream-100) 55%, transparent)' }}>▾</span></button>
          {orgOpen ? (
            <div className="dw-dropdown" style={{ position: 'absolute', left: 0, top: 'calc(100% + 8px)', zIndex: 700, minWidth: 240 }}>
              <div className="dw-dropdown__head">Workspaces</div>
              {orgs.map((o) => { const cur = orgModel.isCurrentOrg(o); return (
                <button key={o.id || o.name} className="dw-dropdown__item" onClick={() => switchOrg(o, cur)}><span style={{ flex: 1 }}>{o.name}</span>{cur ? <Icon name="check" size="sm" /> : <span className="dw-mono-xs dw-muted">{o.plan}</span>}</button>
              ); })}
              <div className="dw-dropdown__sep"></div>
              {isSuper ? <button className="dw-dropdown__item" onClick={() => { setOrgOpen(false); location.hash = '#/super'; }}><Icon name="shield" size="sm" /> Manage workspaces</button> : null}
            </div>
          ) : null}
        </span>
        <span className="dw-topbar__spacer"></span>
        <button className="dw-btn dw-btn--sm" style={{ background: 'color-mix(in srgb, var(--dw-cream-100) 12%, transparent)', color: 'var(--dw-cream-100)' }} onClick={onReader}><Icon name="eye" size="sm" /> Open reader</button>
        <BellTriage store={store} onGo={onNav} onReader={onReader} />
        <span style={{ position: 'relative' }} onClick={(e) => e.stopPropagation()}>
          <button className="dw-acct" style={{ background: 'none', border: 'none', cursor: 'pointer' }} onClick={() => { setAcctOpen((o) => !o); setOrgOpen(false); }}><Avatar email={account.email} size="sm" /><span className="dw-acct__name" style={{ color: 'var(--dw-cream-100)' }}>{account.name}</span><span className={'dw-role dw-role--' + account.role.value}>{account.role.label}</span></button>
          {acctOpen ? (
            <div className="dw-dropdown" style={{ position: 'absolute', right: 0, top: 'calc(100% + 8px)', zIndex: 700, minWidth: 210 }}>
              <div className="dw-dropdown__head">{account.email}</div>
              <button className="dw-dropdown__item" onClick={() => { setAcctOpen(false); onNav('settings'); }}><Icon name="settings" size="sm" /> Settings</button>
              {isSuper ? <button className="dw-dropdown__item" onClick={() => { setAcctOpen(false); location.hash = '#/super'; }}><Icon name="shield" size="sm" /> Super console</button> : null}
              <div className="dw-dropdown__sep"></div>
              <button className="dw-dropdown__item dw-dropdown__item--danger" onClick={async () => { setAcctOpen(false); await window.DWStore.signOutTeam(); location.hash = '#/admin'; }}><Icon name="arrowright" size="sm" /> Sign out</button>
            </div>
          ) : null}
        </span>
      </div>
      <div style={{ flex: 1, display: 'flex', minHeight: 0 }}>
        {nav}
        <div className="dw-main">
          {side ? (
            <div className="dw-main__row">
              <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', minHeight: 0 }}>{children}</div>
              <aside className="dw-panel" style={{ width: 312 }}><div className="dw-panel__scroll">{side}</div></aside>
            </div>
          ) : children}
          <div className="dw-appfoot">
            <Logo />
            <span className="dw-appfoot__line"></span>
            <span className="dw-appfoot__text">Dealwondr · by Intent Pop</span>
            <span className="dw-appfoot__line"></span>
            <span className="dw-appfoot__text">Confidential</span>
          </div>
          {roomLoading ? <RoomRouteLoader title={roomLoading.title} /> : null}
        </div>
      </div>
    </div>
  );
}

function RoomRouteLoader({ title }) {
  return (
    <div className="dw-route-loader" role="status" aria-live="polite">
      <span className="dw-route-loader__mark"></span>
      <span className="dw-route-loader__copy">
        <strong>Opening {title}</strong>
        <span>Loading room content…</span>
      </span>
    </div>
  );
}

Object.assign(window, { TeamGate, Shell, SideSec });


/* ---- app/dashboard.jsx ---- */
/* ============================================================
   DEALWONDR APP — dashboard
   Cross-room home: stats + activity feed, with a deal-temperature
   / needs-you side rail.
   ============================================================ */

function dashboardFeed(store) {
  const state = store.get();
  const notifications = store.notifications ? store.notifications() : [];
  return window.DWAdapters.dashboardFeed(notifications, state, window.DWDisplay.roomTitle());
}
function dashboardStats(store) {
  const rooms = store.rooms();
  const notifications = store.notifications ? store.notifications() : [];
  const questionnaires = window.DWAdapters.dashboardQuestionnaires(store.questionnaires ? store.questionnaires() : null);
  return window.DWAdapters.dashboardStats(rooms, notifications, questionnaires);
}

function Dashboard({ onNav }) {
  const store = useStore();
  const [toast, toastNode] = useToast();
  const feed = dashboardFeed(store);
  const orgName = window.DWDisplay.orgName();
  const notifications = store.notifications ? store.notifications() : [];
  const questionnaires = window.DWAdapters.dashboardQuestionnaires(store.questionnaires ? store.questionnaires() : null);
  const model = window.DWAdapters.dashboardSideModel(store.rooms(), notifications, questionnaires);
  const openFeedItem = async (item) => {
    try {
      if (item.roomId && store.selectRoom) await store.selectRoom(item.roomId);
      onNav('room', { roomTab: 'Activity' });
    } catch (error) {
      toast(error.message || 'Could not open activity');
    }
  };
  const openRoomArea = async (room, params, emptyMessage) => {
    if (!room) {
      toast(emptyMessage || 'Create a room before opening this workspace area.');
      return;
    }
    try {
      await store.selectRoom(room.apiId || room.id);
      onNav('room', params || {});
    } catch (error) {
      toast(error.message || 'Could not open room');
    }
  };
  const openStat = async (label) => {
    if (label === 'Active rooms') onNav('rooms');
    else if (label === 'Needs you') onNav('alerts');
    else if (label === 'Questionnaires') await openRoomArea(model.questionnaireRoom || model.liveRooms[0], { roomTab: 'Content', contentView: 'Questionnaires' }, 'Create a room before adding questionnaires.');
    else await openRoomArea(model.commentsRoom || model.liveRooms[0], { roomTab: 'Activity' }, 'Create a room before reviewing comments.');
  };
  return (
    <React.Fragment>
      <PageHead title="Dashboard" sub={orgName + ' · everything happening across your rooms'}
        secondary={{ label: 'All rooms', onClick: () => onNav('rooms') }}
        primary={{ label: 'New room', icon: 'plus', onClick: () => onNav('upload') }} />
      <div className="dw-main__body">
        <div className="dw-stats">
          {dashboardStats(store).map((s, i) => (
            <div className="dw-stat" key={i} style={{ cursor: 'pointer' }} onClick={() => openStat(s[0])}><span className="dw-stat__k">{s[0]}</span><div className="dw-stat__v">{s[1]}</div><span className="dw-stat__d">{s[2]}</span></div>
          ))}
        </div>
        <SectionRule>Activity across your rooms</SectionRule>
        {feed.length ? feed.map((f, i) => (
          <div className="dw-feedrow" key={i} style={{ cursor: 'pointer' }} onClick={() => openFeedItem(f)}>
            <span className="dw-ava dw-ava--sm">{f.initials}</span>
            <div className="dw-feedrow__body"><div className="dw-feedrow__line"><span className="who">{f.who}</span> {f.action} · <span className="room">{f.room}</span></div><p className="dw-feedrow__quote">“{f.quote}”</p></div>
            <div className="dw-feedrow__aside">{f.status ? <Badge variant={f.status === 'Completed' ? 'pine' : 'outline'}>{f.status}</Badge> : null}<a className="dw-jump" onClick={(e) => { e.stopPropagation(); openFeedItem(f); }}>Open →</a></div>
          </div>
        )) : <div className="dw-empty"><Icon name="bell" size="xl" /><div className="dw-empty__title">No activity yet</div><div className="dw-empty__body">Reader actions and alerts will appear here.</div></div>}
      </div>
      {toastNode}
    </React.Fragment>
  );
}

function DashboardSide({ onNav }) {
  const store = useStore();
  const [toast, toastNode] = useToast();
  const notifications = store.notifications ? store.notifications() : [];
  const questionnaires = window.DWAdapters.dashboardQuestionnaires(store.questionnaires ? store.questionnaires() : null);
  const model = window.DWAdapters.dashboardSideModel(store.rooms(), notifications, questionnaires);
  const liveRooms = model.liveRooms;
  const liveQuestionnaires = model.liveQuestionnaires;
  const completed = model.completed;
  const inProgress = model.inProgress;
  const needs = model.needs;
  const openRoomArea = async (room, params) => {
    if (!room) {
      toast('No room is available for this shortcut.');
      return;
    }
    try {
      await store.selectRoom(room.apiId || room.id);
      onNav('room', params || {});
    } catch (error) {
      toast(error.message || 'Could not open room');
    }
  };
  const questionnaireRoom = model.questionnaireRoom;
  const commentsRoom = model.commentsRoom;
  return (
    <React.Fragment>
      <SideSec>Deal temperature</SideSec>
      <div style={{ padding: '4px 16px 12px' }}>
        {liveRooms.length ? liveRooms.map((r) => {
          const score = parseInt(String(r.tempScore || '').replace(/[^\d]/g, ''), 10) || 0;
          const tone = score >= 75 ? 'hot' : score >= 50 ? 'warm' : score > 0 ? 'steady' : 'steady';
          return (
            <button key={r.id} className="dw-row" style={{ padding: '6px 0', width: '100%', border: 0, background: 'none', color: 'inherit', font: 'inherit', textAlign: 'left', cursor: 'pointer' }} onClick={() => openRoomArea(r, { roomTab: 'Insights' })}>
              <span className="dw-body-sm">{r.title}</span>
              <span className={'dw-temp dw-temp--' + tone}>{r.temp || 'No signal'}{score ? ' · ' + score : ''}</span>
            </button>
          );
        }) : <p className="dw-body-sm dw-muted">No active rooms yet.</p>}
      </div>
      <SideSec>Questionnaires</SideSec>
      <div style={{ padding: '4px 16px 12px' }}>
        <p className="dw-body-sm"><strong>{completed} completed</strong> · {inProgress} in progress across {liveQuestionnaires.length} active form{liveQuestionnaires.length === 1 ? '' : 's'}.</p>
        {questionnaireRoom ? <a className="dw-jump" onClick={() => openRoomArea(questionnaireRoom, { roomTab: 'Content', contentView: 'Questionnaires' })}>→ View questionnaires</a> : null}
      </div>
      <SideSec>Needs you</SideSec>
      {needs.length ? needs.slice(0, 2).map((n) => {
        const person = window.DWAdapters.dashboardPerson(n.reader, n.verb);
        return <div key={n.id} className="dw-activity is-unread"><Avatar email={n.reader || ''} size="sm" /><div><div className="dw-activity__body"><b>{person.name}</b> {n.title || n.verb}</div><div className="dw-activity__when">{n.room || window.DWDisplay.roomTitle()} · <a className="dw-jump" onClick={() => onNav('alerts')}>Open alert</a></div></div></div>;
      }) : <p className="dw-body-sm dw-muted" style={{ padding: '4px 16px 12px' }}>No open alerts.</p>}
      <div style={{ padding: '10px 16px' }}>{commentsRoom ? <a className="dw-jump" onClick={() => openRoomArea(commentsRoom, { roomTab: 'Activity' })}>→ Go to the comments desk</a> : null}</div>
      {toastNode}
    </React.Fragment>
  );
}

Object.assign(window, { Dashboard, DashboardSide });


/* ---- app/room-workspace.jsx ---- */
/* ============================================================
   DEALWONDR APP — room workspace
   One room, four tabs: Content · Activity · Insights · Access.
   Header carries the ref-meta + Export/Manage actions.
   ============================================================ */

function normalizeRoomTab(value) {
  return ['Activity', 'Content', 'Insights', 'Access'].indexOf(value) >= 0 ? value : null;
}
function normalizeContentView(value) {
  return ['Documents', 'Questionnaires'].indexOf(value) >= 0 ? value : null;
}
function normalizeInsightsView(value) {
  return ['Overview', 'Actions', 'Engagement', 'Sections', 'Journeys', 'Pre-call'].indexOf(value) >= 0 ? value : null;
}

function RoomWorkspace({ onReader, onPreviewReader, onNav, initialTab, initialContentView, initialInsightsView }) {
  const store = useStore();
  const [toast, toastNode] = useToast();
  const [tab, setTab] = useState(normalizeRoomTab(initialTab) || 'Activity');
  const [contentView, setContentView] = useState(normalizeContentView(initialContentView) || 'Documents');
  const [insightsView, setInsightsView] = useState(normalizeInsightsView(initialInsightsView) || 'Overview');
  const [exp, setExp] = useState(false);
  const [manage, setManage] = useState(false);
  const [confirm, setConfirm] = useState(null);   // 'archive' | 'delete'
  const [renameOpen, setRenameOpen] = useState(false);
  const [renameTitle, setRenameTitle] = useState('');
  const [busy, setBusy] = useState('');
  const [, refreshRoomHead] = useState(0);
  useEffect(() => { if (!manage) return; const fn = () => setManage(false); window.addEventListener('click', fn); return () => window.removeEventListener('click', fn); }, [manage]);
  const room = window.DWAdapters.roomContext();
  const activeRoomId = window.DW_API_ROOM_ID || room.apiId || room.id;
  const shareRoom = Object.assign({}, room, activeRoomId ? { id: activeRoomId, apiId: activeRoomId } : {});
  const openTab = (nextTab, options) => {
    const nextContentView = options && (options.contentView || options.view);
    const nextInsightsView = options && (options.insightsView || options.view);
    if (nextTab === 'Content' && normalizeContentView(nextContentView)) setContentView(nextContentView);
    if (nextTab === 'Insights' && normalizeInsightsView(nextInsightsView)) setInsightsView(nextInsightsView);
    setTab(nextTab);
  };
  useEffect(() => {
    const nextTab = normalizeRoomTab(initialTab);
    if (nextTab) setTab(nextTab);
  }, [initialTab]);
  useEffect(() => {
    const nextView = normalizeContentView(initialContentView);
    if (nextView) setContentView(nextView);
  }, [initialContentView]);
  useEffect(() => {
    const nextView = normalizeInsightsView(initialInsightsView);
    if (nextView) setInsightsView(nextView);
  }, [initialInsightsView]);
  const loadingRoom = !room || !room.title || (activeRoomId && room.id && room.id !== activeRoomId && room.apiId !== activeRoomId);
  if (loadingRoom) {
    return (
      <React.Fragment>
        <div className="dw-main__head">
          <div className="dw-roomhead">
            <div className="dw-roomhead__row">
              <div className="dw-roomhead__main">
                <h2 className="dw-roomhead__title">Opening room</h2>
                <div className="dw-roomhead__meta"><span className="dw-roomhead__metaitem"><span>Status</span><strong>Loading content…</strong></span></div>
              </div>
            </div>
          </div>
        </div>
        <div className="dw-main__body">
          <div className="dw-empty" role="status" aria-live="polite"><span className="dw-spinner"></span><div className="dw-empty__title">Loading room content…</div><div className="dw-empty__body">Opening the selected room and its current version.</div></div>
        </div>
      </React.Fragment>
    );
  }
  const roomLink = window.DWShare ? window.DWShare.roomUrl(shareRoom) : '';
  const roomStatus = room.status || 'live';
  const displayStatus = window.DWAdapters.statusLabel(roomStatus);
  const copyRoomLink = async () => {
    try {
      await window.DWShare.copyRoomLink(shareRoom);
      toast('Room link copied', true);
    } catch (error) {
      toast(error.message || 'Could not copy room link');
    }
  };
  const runRoomLifecycle = async () => {
    if (!confirm) return;
    const action = confirm;
    setBusy(action);
    try {
      if (action === 'delete') await store.deleteRoom(room.id);
      else if (action === 'restore') await store.unarchiveRoom(room.id);
      else await store.archiveRoom(room.id);
      setConfirm(null);
      toast(action === 'delete' ? 'Room deleted' : action === 'restore' ? 'Room restored' : 'Room archived', action !== 'delete');
      if (onNav) onNav('rooms');
    } catch (error) {
      toast(error.message || (action === 'delete' ? 'Could not delete room' : action === 'restore' ? 'Could not restore room' : 'Could not archive room'));
    } finally {
      setBusy('');
    }
  };
  const openRenameRoom = () => {
    setRenameTitle(room.title || '');
    setRenameOpen(true);
  };
  const runRenameRoom = async () => {
    const title = renameTitle.trim();
    if (!title || busy) return;
    setBusy('rename');
    try {
      await store.renameRoom(activeRoomId, title);
      setRenameOpen(false);
      toast('Room renamed', true);
      refreshRoomHead((n) => n + 1);
    } catch (error) {
      toast(error.message || 'Could not rename room');
    } finally {
      setBusy('');
    }
  };
  const head = (
    <div className="dw-main__head">
      <div className="dw-roomhead">
        <div className="dw-roomhead__row">
          <div className="dw-roomhead__main">
            <h2 className="dw-roomhead__title">{room.title}</h2>
            <div className="dw-roomhead__meta" aria-label="Room details">
              <span className="dw-roomhead__metaitem"><span>Ref</span><strong>{room.ref}</strong></span>
              <span className="dw-roomhead__metaitem"><span>Version</span><strong>{room.version} current</strong></span>
              <span className="dw-roomhead__metaitem"><span>Docs</span><strong>{room.documents} documents</strong></span>
              <span className="dw-roomhead__metaitem"><span>Status</span><strong className={roomStatus === 'live' ? 'dw-status-text dw-status-text--ok' : ''}>{displayStatus}</strong></span>
              <span className="dw-roomhead__metaitem"><span>Since</span><strong>{room.since}</strong></span>
            </div>
          </div>
          <div className="dw-roomhead__actions">
            <Btn variant="ghost" size="sm" onClick={() => setExp(true)}>Export ▾</Btn>
            <Btn variant="ghost" size="sm" onClick={onReader}>Open as reader ↗</Btn>
            <Btn variant="ghost" size="sm" icon="eye" onClick={onPreviewReader}>Preview reader</Btn>
            <span style={{ position: 'relative' }} onClick={(e) => e.stopPropagation()}>
              <Btn variant="pine" size="sm" onClick={() => setManage((o) => !o)}>Manage ▾</Btn>
              {manage ? (
                <div className="dw-dropdown" style={{ position: 'absolute', right: 0, top: 'calc(100% + 6px)', zIndex: 600, minWidth: 190 }}>
                  <button className="dw-dropdown__item" onClick={() => { setManage(false); copyRoomLink(); }}><Icon name="link" size="sm" /> Copy room link</button>
                  <button className="dw-dropdown__item" onClick={() => { setManage(false); openRenameRoom(); }}><Icon name="edit" size="sm" /> Rename room</button>
                  <button className="dw-dropdown__item" onClick={() => { setManage(false); openTab('Access'); }}><Icon name="users" size="sm" /> Manage access</button>
                  {roomStatus === 'archived'
                    ? <button className="dw-dropdown__item" onClick={() => { setManage(false); setConfirm('restore'); }}><Icon name="file" size="sm" /> Restore room</button>
                    : <button className="dw-dropdown__item" onClick={() => { setManage(false); setConfirm('archive'); }}><Icon name="file" size="sm" /> Archive room</button>}
                  <div className="dw-dropdown__sep"></div>
                  <button className="dw-dropdown__item dw-dropdown__item--danger" onClick={() => { setManage(false); setConfirm('delete'); }}><Icon name="trash" size="sm" /> Delete room</button>
                </div>
              ) : null}
            </span>
          </div>
        </div>
        <div className="dw-roomhead__tabrail">
          <div className="dw-tabs dw-tabs--primary">{['Activity', 'Content', 'Insights', 'Access'].map((t) => <button key={t} className={'dw-tabs__tab' + (t === tab ? ' is-on' : '')} onClick={() => openTab(t)}>{t}</button>)}</div>
        </div>
      </div>
    </div>
  );
  return (
    <React.Fragment>
      {head}
      <div className="dw-main__body">
        {tab === 'Content' && <ContentTab store={store} toast={toast} roomLink={roomLink} copyRoomLink={copyRoomLink} onPreviewReader={onPreviewReader} onTab={openTab} onRoomUpdated={() => refreshRoomHead((n) => n + 1)} view={contentView} onViewChange={setContentView} />}
        {tab === 'Activity' && <ActivityTab store={store} toast={toast} onTab={openTab} />}
        {tab === 'Insights' && <InsightsTab toast={toast} onTab={openTab} view={insightsView} onViewChange={setInsightsView} />}
        {tab === 'Access' && <AccessTab store={store} toast={toast} copyRoomLink={copyRoomLink} />}
      </div>
      <ExportDrawer open={exp} onClose={() => setExp(false)} toast={toast} />
      <Drawer open={renameOpen} title="Rename room" sub={room.title} onClose={() => setRenameOpen(false)}
        footer={<React.Fragment><Btn variant="ghost" size="sm" disabled={busy === 'rename'} onClick={() => setRenameOpen(false)}>Cancel</Btn><Btn variant="pine" size="sm" loading={busy === 'rename'} disabled={!renameTitle.trim() || busy === 'rename'} onClick={runRenameRoom}>Save</Btn></React.Fragment>}>
        <Field label="Room title"><input className="dw-input" autoFocus value={renameTitle} onChange={(e) => setRenameTitle(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') runRenameRoom(); }} /></Field>
      </Drawer>
      {confirm ? (
        <div className="dw-modal-scrim" style={{ position: 'fixed' }} onMouseDown={(e) => { if (e.target === e.currentTarget) setConfirm(null); }}>
          <div className="dw-confirm">
            <div className="dw-confirm__title">{confirm === 'delete' ? 'Delete “' + room.title + '”?' : confirm === 'restore' ? 'Restore “' + room.title + '”?' : 'Archive “' + room.title + '”?'}</div>
            <p className="dw-confirm__body">{confirm === 'delete' ? 'Clients can no longer open this room and its analytics, comments and replay history are removed. This can’t be undone.' : confirm === 'restore' ? 'The room becomes active again for teammates. Re-check access before sending the link to clients.' : 'The room moves to your archive. Clients lose access, but you can restore it anytime.'}</p>
            <div className="dw-confirm__acts"><Btn variant="ghost" size="sm" disabled={!!busy} onClick={() => setConfirm(null)}>Cancel</Btn><Btn variant={confirm === 'delete' ? 'danger' : 'pine'} size="sm" loading={busy === confirm} disabled={!!busy} onClick={runRoomLifecycle}>{confirm === 'delete' ? 'Delete room' : confirm === 'restore' ? 'Restore room' : 'Archive room'}</Btn></div>
          </div>
        </div>
      ) : null}
      {toastNode}
    </React.Fragment>
  );
}

/* ---- document row overflow menu ---- */
function DocMenu({ onReplace, onRename, onRemove }) {
  const [open, setOpen] = useState(false);
  useEffect(() => { if (!open) return; const fn = () => setOpen(false); window.addEventListener('click', fn); return () => window.removeEventListener('click', fn); }, [open]);
  return (
    <span style={{ position: 'relative' }} onClick={(e) => e.stopPropagation()}>
      <button className={'dw-kebab' + (open ? ' is-on' : '')} onClick={() => setOpen(!open)} aria-label="Document actions"><Icon name="more" /></button>
      {open ? (
        <div className="dw-dropdown" style={{ position: 'absolute', right: 0, top: 'calc(100% + 6px)', zIndex: 600, minWidth: 180 }}>
          {onReplace ? <button className="dw-dropdown__item" onClick={() => { setOpen(false); onReplace(); }}><Icon name="upload" size="sm" /> Replace file</button> : null}
          {onRename ? <button className="dw-dropdown__item" onClick={() => { setOpen(false); onRename(); }}><Icon name="edit" size="sm" /> Rename</button> : null}
          {onRemove ? <React.Fragment><div className="dw-dropdown__sep"></div><button className="dw-dropdown__item dw-dropdown__item--danger" onClick={() => { setOpen(false); onRemove(); }}><Icon name="trash" size="sm" /> Remove from proposal</button></React.Fragment> : null}
        </div>
      ) : null}
    </span>
  );
}

function ContentTab({ store, toast, roomLink, copyRoomLink, onPreviewReader, onTab, onRoomUpdated, view: activeView, onViewChange }) {
  const [localView, setLocalView] = useState('Documents');
  const view = activeView || localView;
  const setView = onViewChange || setLocalView;
  return (
    <React.Fragment>
      <div className="dw-pilltabs">{['Documents', 'Questionnaires'].map((v) => <button key={v} className={'dw-pilltabs__tab' + (v === view ? ' is-on' : '')} onClick={() => setView(v)}>{v}</button>)}</div>
      {view === 'Documents' ? <DocumentsView store={store} toast={toast} roomLink={roomLink} copyRoomLink={copyRoomLink} onPreviewReader={onPreviewReader} onTab={onTab} onRoomUpdated={onRoomUpdated} /> : <QuestionnairesView toast={toast} />}
    </React.Fragment>
  );
}

function DocumentsView({ store, toast, roomLink, copyRoomLink, onPreviewReader, onTab, onRoomUpdated }) {
  const roomId = window.DWShare.roomId(window.DWAdapters.roomContext());
  const readLiveDocs = () => {
    const raw = window.DWAdapters.roomDocuments();
    return raw.slice().sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0)).map(window.DWAdapters.mapContentDoc);
  };
  const readVersions = (liveDocs) => {
    const rawVersions = window.DWAdapters.roomVersions();
    return window.DWAdapters.mapContentVersions(rawVersions, liveDocs);
  };
  const initialDocs = readLiveDocs();
  const [docs, setDocs] = useState(initialDocs);
  const [published, setPublished] = useState(initialDocs);             // last live snapshot (for Discard)
  const [versions, setVersions] = useState(() => readVersions(initialDocs));
  const [changes, setChanges] = useState([]);                       // staged change labels → draft when non-empty
  const [busy, setBusy] = useState(false);
  const [addOpen, setAddOpen] = useState(false);
  const [protoOpen, setProtoOpen] = useState(false);
  const [protoMode, setProtoMode] = useState('upload');
  const [protoTitle, setProtoTitle] = useState('');
  const [protoUrl, setProtoUrl] = useState('');
  const [protoFile, setProtoFile] = useState(null);
  const [renameDoc, setRenameDoc] = useState(null);
  const [renameVal, setRenameVal] = useState('');
  const [pub, setPub] = useState(null);                             // null | 'form' | 'done'
  const [note, setNote] = useState('');
  const [keepOld, setKeepOld] = useState(true);
  const [justPub, setJustPub] = useState(null);
  const [info, setInfo] = useState(false);
  const [addTitle, setAddTitle] = useState('');
  const [addPages, setAddPages] = useState(4);
  const [addFile, setAddFile] = useState(null);
  const [replaceDoc, setReplaceDoc] = useState(null);
  const replaceInput = useRef(null);
  const replaceTarget = useRef(null);

  const draft = changes.length > 0;
  const totalPages = docs.reduce((n, d) => n + (d.pages || 0), 0);
  const latest = versions.find((v) => v.latest) || versions[0];
  const highestVersionNumber = versions.reduce((n, v) => Math.max(n, parseInt(String(v.label).replace(/\D/g, '')) || 0), 0);
  const nextLabel = 'V' + ((highestVersionNumber || versions.length) + 1);
  const applyDraft = (draftRow) => {
    if (!draftRow || !Array.isArray(draftRow.documents)) return;
    setDocs((draftRow.documents || []).map(window.DWAdapters.mapContentDoc));
    setChanges(draftRow.changes || []);
  };
  const ensureDraftDoc = async (doc) => {
    if (doc.draftDocumentId) return doc;
    const draftRow = await store.ensureContentDraft(roomId);
    applyDraft(draftRow);
    const found = (draftRow.documents || []).map(window.DWAdapters.mapContentDoc).find((candidate) =>
      candidate.sourceDocumentId === doc.id || candidate.id === doc.id || candidate.title === doc.title
    );
    if (!found || !found.draftDocumentId) throw new Error('Content draft did not include this document.');
    return found;
  };
  const runDraftAction = async (fn, message, success) => {
    setBusy(true);
    try {
      const draftRow = await fn();
      applyDraft(draftRow);
      if (message) toast(message, !!success);
      return draftRow;
    } catch (error) {
      toast(error.message || 'Content update failed');
      return null;
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => {
    let cancelled = false;
    if (!store || !store.hasTeamApiSession()) return undefined;
    store.contentDraft(roomId).then((draftRow) => {
      if (!cancelled && draftRow) applyDraft(draftRow);
    }).catch((error) => {
      if (!cancelled) toast(error.message || 'Could not load content draft');
    });
    return () => { cancelled = true; };
  }, [roomId]);

  const move = async (d, dir) => {
    await runDraftAction(async () => {
      const draftDoc = await ensureDraftDoc(d);
      return store.moveDraftDocument(roomId, draftDoc.draftDocumentId, dir);
    }, 'Reordered documents');
  };
  const removeDoc = async (d) => {
    await runDraftAction(async () => {
      const draftDoc = await ensureDraftDoc(d);
      return store.removeDraftDocument(roomId, draftDoc.draftDocumentId);
    }, 'Removed — staged for ' + nextLabel);
  };
  const openReplace = (d) => {
    replaceTarget.current = d;
    setReplaceDoc(d);
    if (replaceInput.current) {
      replaceInput.current.value = '';
      replaceInput.current.click();
    }
  };
  const uploadReplacement = async (file) => {
    const target = replaceTarget.current || replaceDoc;
    if (!file || !target) return;
    const saved = await runDraftAction(async () => {
      const draftDoc = await ensureDraftDoc(target);
      const result = await store.uploadExistingDraftDocument(roomId, draftDoc.draftDocumentId, {
        title: target.title,
        fileName: file.name,
        contentType: file.type || 'application/octet-stream',
        body: file
      });
      return result.draft;
    }, 'Replacement uploaded — parser will run when ' + nextLabel + ' publishes', true);
    if (saved) {
      replaceTarget.current = null;
      setReplaceDoc(null);
    }
  };
  const doRename = async () => {
    if (!renameVal.trim() || !renameDoc) return;
    const saved = await runDraftAction(async () => {
      const draftDoc = await ensureDraftDoc(renameDoc);
      return store.renameDraftDocument(roomId, draftDoc.draftDocumentId, renameVal.trim());
    }, 'Renamed', true);
    if (saved) setRenameDoc(null);
  };
  const discard = async () => {
    setBusy(true);
    try {
      await store.discardContentDraft(roomId);
      setDocs(published);
      setChanges([]);
      toast('Draft discarded — back to ' + latest.label);
    } catch (error) {
      toast(error.message || 'Could not discard draft');
    } finally {
      setBusy(false);
    }
  };

  const openAdd = () => { setAddOpen(true); setAddTitle(''); setAddPages(4); setAddFile(null); };
  const openPrototype = () => {
    setProtoOpen(true);
    setProtoMode('upload');
    setProtoTitle('');
    setProtoUrl('');
    setProtoFile(null);
  };
  const titleFromUrl = (value) => {
    try {
      const url = new URL(value);
      const last = url.pathname.split('/').filter(Boolean).pop() || url.hostname;
      return window.DWAdapters.titleFromFileName(last || url.hostname);
    } catch (error) {
      return 'Prototype';
    }
  };
  const confirmAdd = async () => {
    if (!addTitle.trim()) return;
    const saved = await runDraftAction(async () => {
      if (addFile) {
        const result = await store.uploadDraftDocument(roomId, {
          title: addTitle.trim(),
          role: 'appendix',
          fileName: addFile.name,
          contentType: addFile.type || 'application/octet-stream',
          body: addFile
        });
        return result.draft;
      }
      return store.addDraftDocument(roomId, { title: addTitle.trim(), role: 'appendix', pages: addPages });
    }, addFile ? 'File uploaded — parser will run when ' + nextLabel + ' publishes' : 'Document added — staged for ' + nextLabel, true);
    if (saved) setAddOpen(false);
  };
  const pickAddFile = (file) => {
    setAddFile(file || null);
    if (file && !addTitle.trim()) setAddTitle(window.DWAdapters.titleFromFileName(file.name));
  };
  const pickPrototypeFile = (file) => {
    setProtoFile(file || null);
    if (file && !protoTitle.trim()) setProtoTitle(window.DWAdapters.titleFromFileName(file.name));
  };
  const confirmPrototype = async () => {
    const title = protoTitle.trim() || (protoMode === 'link' ? titleFromUrl(protoUrl) : (protoFile ? window.DWAdapters.titleFromFileName(protoFile.name) : 'Prototype'));
    const saved = await runDraftAction(async () => {
      if (protoMode === 'link') {
        if (!protoUrl.trim()) throw new Error('Paste the prototype URL first.');
        const result = await store.addDraftPrototypeLink(roomId, { title: title, url: protoUrl.trim() });
        return result.draft || result;
      }
      if (!protoFile) throw new Error('Choose an HTML file first.');
      const result = await store.uploadDraftPrototypeHtml(roomId, {
        title: title,
        fileName: protoFile.name,
        contentType: protoFile.type || 'text/html',
        body: protoFile
      });
      return result.draft || result;
    }, 'Prototype added — staged for ' + nextLabel, true);
    if (saved) setProtoOpen(false);
  };

  const publish = async () => {
    setBusy(true);
    try {
      const result = await store.publishContentDraft(roomId, { note: note.trim(), keepOldVersions: keepOld });
      const draftDocs = (result.draft && result.draft.documents) || [];
      const liveDocs = (result.documents || []).map((document, index) => window.DWAdapters.mapContentDoc(Object.assign({}, document, {
        prototype: draftDocs[index] && draftDocs[index].prototype ? draftDocs[index].prototype : null
      })));
      const v = window.DWAdapters.mapContentVersion(result.version, liveDocs, note.trim() || (changes[0] || 'Updated the proposal'), keepOld);
      setVersions((vs) => [v].concat(vs.map((x) => ({ ...x, latest: false }))));
      setPublished(liveDocs);
      setDocs(liveDocs);
      setChanges([]);
      setJustPub(v);
      setPub('done');
      window.DWAdapters.syncPublishedContent(roomId, result, liveDocs, v);
      if (onRoomUpdated) onRoomUpdated();
      toast(v.label + ' is active — clients now open it by default', true);
    } catch (error) {
      toast(error.message || 'Could not publish content draft');
    } finally {
      setBusy(false);
    }
  };
  const toggleVis = async (v) => {
    setBusy(true);
    try {
      await store.setVersionVisible(roomId, v.id, !v.clientVisible);
      setVersions((vs) => vs.map((x) => x.id === v.id ? { ...x, clientVisible: !x.clientVisible } : x));
      toast(v.label + (v.clientVisible ? ' hidden from clients' : ' visible to clients again'));
    } catch (error) {
      toast(error.message || 'Could not update version visibility');
    } finally {
      setBusy(false);
    }
  };
  const uniqChanges = [...new Set(changes)];
  const copyUpdateEmail = async () => {
    try {
      await window.DWShare.copyUpdateEmail(window.DWAdapters.roomContext(), { versionLabel: justPub ? justPub.label : nextLabel });
      toast('Update email copied', true);
    } catch (error) {
      toast(error.message || 'Could not copy update email');
    }
  };
  const openVersionAnalytics = async (v) => {
    if (!onTab) return;
    setBusy(true);
    try {
      await store.selectVersionSignals(roomId, v.id);
      onTab('Insights', { view: 'Overview' });
      toast(v.label + ' analytics loaded', true);
    } catch (error) {
      toast(error.message || 'Could not load version analytics');
    } finally {
      setBusy(false);
    }
  };
  const openVersionPreview = async (v) => {
    if (!onPreviewReader) return;
    setBusy(true);
    try {
      const loaded = await store.selectPreviewVersion(roomId, v.id);
      onPreviewReader({ versionId: loaded.versionId || v.id });
    } catch (error) {
      toast(error.message || 'Could not preview this version');
    } finally {
      setBusy(false);
    }
  };

  return (
    <React.Fragment>
      {/* ── the anchor: what clients open right now / draft state ── */}
      <div className="dw-card dw-mt-2" style={{ borderLeft: draft ? '3px solid var(--dw-accent)' : '3px solid var(--dw-pine-500)' }}>
        <div className="dw-row" style={{ alignItems: 'flex-start', gap: 20 }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <Eyebrow>{draft ? 'Unpublished changes' : 'Active now — what clients open'}</Eyebrow>
            <div className="dw-cluster-2 dw-mt-2" style={{ alignItems: 'baseline' }}><span className="dw-verpill">{draft ? nextLabel + ' · draft' : latest.label}</span>{draft ? <Badge variant="outline">clients still see {latest.label}</Badge> : <span className="dw-status-text dw-status-text--ok">Active · default</span>}</div>
            <p className="dw-body-sm dw-secondary dw-mt-2">{draft ? 'Clients keep opening ' + latest.label + '. Publish to make these changes the new version — comments & analytics on older versions stay put.' : (latest.note ? '“' + latest.note + '”' : 'Your current published proposal.')}</p>
            <div className="dw-mono-xs dw-muted dw-mt-2">{docs.length} document{docs.length === 1 ? '' : 's'} · {totalPages} pages · {draft ? 'staged together' : 'issued ' + latest.issued + ' · published together'}</div>
            {draft ? <div className="dw-cluster-2 dw-mt-3">{uniqChanges.map((c, i) => <span key={i} className="dw-chip" style={{ cursor: 'default' }}>{c}</span>)}</div> : null}
          </div>
          <div style={{ flex: 'none', textAlign: 'right' }}>
            {draft ? (
              <div className="dw-cluster-2" style={{ justifyContent: 'flex-end' }}><Btn variant="ghost" size="sm" disabled={busy} onClick={discard}>Discard</Btn><Btn variant="pine" size="sm" disabled={busy} onClick={() => { setNote(''); setKeepOld(true); setPub('form'); }}>Publish {nextLabel} →</Btn></div>
            ) : (
              <React.Fragment>
                <div className="dw-mono-xs dw-muted">Room link · you send it</div>
                <div className="dw-cluster-2 dw-mt-2" style={{ justifyContent: 'flex-end' }}><span className="dw-mono-xs" style={{ background: 'var(--dw-surface-sunken)', padding: '4px 8px', borderRadius: 'var(--dw-radius-sm)', maxWidth: 260, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block', verticalAlign: 'bottom' }}>{roomLink}</span><Btn variant="ghost" size="sm" onClick={copyRoomLink}>Copy</Btn><Btn variant="ghost" size="sm" icon="eye" onClick={onPreviewReader}>Preview</Btn></div>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>

      {/* ── the editable document set ── */}
      <input
        ref={replaceInput}
        type="file"
        aria-label="Replacement file"
        style={{ display: 'none' }}
        accept=".pdf,.pptx,.docx,.html,.htm,.md,.markdown,text/markdown,text/html,application/pdf,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        onChange={(e) => uploadReplacement(e.target.files && e.target.files[0])}
      />
      <div className="dw-row dw-mt-5"><SectionRule hint="main documents, appendices, and prototypes publish together">Content in this proposal</SectionRule><span className="dw-cluster-2"><Btn variant="ghost" size="sm" icon="plus" disabled={busy} onClick={openPrototype}>Add prototype</Btn><Btn variant="ghost" size="sm" icon="plus" disabled={busy} onClick={openAdd}>Add document</Btn></span></div>
      <div className="dw-table-scroll"><table className="dw-table dw-mt-2">
        <thead><tr><th>Content</th><th>Role</th><th>Pages</th><th style={{ width: 190 }}></th></tr></thead>
        <tbody>{docs.map((d, i) => (
          <tr key={d.id}>
            <td className="lead">{d.title}</td>
            <td><Badge variant={d.prototype ? 'outline' : d.role === 'main' ? 'pine' : 'outline'}>{d.prototype ? 'Prototype' : d.role === 'main' ? 'Main' : 'Appendix'}</Badge></td>
            <td className="num">{d.prototype ? '—' : (d.pages || '—')}</td>
            <td><span className="dw-cluster-2" style={{ justifyContent: 'flex-end', flexWrap: 'nowrap' }}>
              {d.prototype ? <button className="dw-iconbtn" disabled={busy} onClick={onPreviewReader} aria-label="Preview prototype"><Icon name="eye" size="sm" /></button> : null}
              <button className="dw-iconbtn" disabled={busy || i === 0} onClick={() => move(d, -1)} aria-label="Move up">↑</button>
              <button className="dw-iconbtn" disabled={busy || i === docs.length - 1} onClick={() => move(d, 1)} aria-label="Move down">↓</button>
              <DocMenu onReplace={busy || d.prototype ? null : () => openReplace(d)} onRename={busy ? null : () => { setRenameDoc(d); setRenameVal(d.title); }} onRemove={!busy && d.role !== 'main' ? () => removeDoc(d) : null} />
            </span></td>
          </tr>
        ))}</tbody>
      </table></div>
      <p className="dw-body-sm dw-muted dw-mt-2">Add, replace, remove or reorder freely — changes are a <strong>draft</strong> until you publish. Documents and prototypes ride the same version and publish together.</p>

      {/* ── version history ── */}
      <div className="dw-row dw-mt-6"><SectionRule>Version history</SectionRule><button className="dw-action" onClick={() => setInfo(true)}>ⓘ How versions work</button></div>
      <div className="dw-table-scroll"><table className="dw-table dw-mt-2">
        <thead><tr><th>Version</th><th>Issued</th><th>Docs</th><th>What changed</th><th>Comments</th><th>Clients can view</th><th></th></tr></thead>
        <tbody>{versions.map((v) => (
          <tr key={v.id}>
            <td className="lead"><span className="dw-cluster-2" style={{ alignItems: 'baseline' }}><span className="dw-verpill">{v.label}</span>{v.latest ? <Badge variant="pine">Current</Badge> : null}</span></td>
            <td className="num dw-muted">{v.issued}</td>
            <td className="num">{v.docs}</td>
            <td style={{ color: 'var(--dw-text-secondary)' }}>{v.note || '—'}</td>
            <td className="num">{v.comments}</td>
            <td>{v.latest ? <span className="dw-mono-xs dw-muted">always · latest</span> : <input type="checkbox" className="dw-switch" checked={v.clientVisible} onChange={() => toggleVis(v)} />}</td>
            <td style={{ textAlign: 'right' }}>
              <span className="dw-cluster-2" style={{ justifyContent: 'flex-end', flexWrap: 'nowrap' }}>
                <Btn variant="ghost" size="sm" icon="eye" disabled={busy} onClick={() => openVersionPreview(v)}>Preview</Btn>
                <Btn variant="ghost" size="sm" disabled={busy} onClick={() => openVersionAnalytics(v)}>Analytics</Btn>
              </span>
            </td>
          </tr>
        ))}</tbody>
      </table></div>

      {/* ── add document drawer ── */}
      <Drawer open={addOpen} title="Add a document" sub="It joins this proposal and publishes with the next version — main and appendices ship together." onClose={() => setAddOpen(false)}
        footer={<React.Fragment><Btn variant="ghost" size="sm" disabled={busy} onClick={() => setAddOpen(false)}>Cancel</Btn><Btn variant="pine" size="sm" disabled={!addTitle.trim() || busy} onClick={confirmAdd}>Add document</Btn></React.Fragment>}>
        <label className="dw-label">Import a file</label>
        <div className="dw-cluster-2 dw-mt-2">{window.DWAdapters.importFormats().map((f) => <span key={f.id} className="dw-chip" style={{ cursor: 'default' }} title={f.note}><span style={{ fontFamily: 'var(--dw-font-mono)' }}>{f.glyph}</span> {f.label}</span>)}</div>
        <label className="dw-card dw-card--pad-sm dw-mt-3" style={{ display: 'block', cursor: 'pointer' }}>
          <span className="dw-body-sm" style={{ fontWeight: 700 }}>{addFile ? addFile.name : 'Choose PDF, PowerPoint, Word, HTML, or Markdown'}</span>
          <span className="dw-mono-xs dw-muted" style={{ display: 'block', marginTop: 4 }}>{addFile ? 'Uploaded to the content draft and parsed when published.' : 'Stored now and queued for parsing after this draft becomes a version.'}</span>
          <input
            type="file"
            accept=".pdf,.pptx,.docx,.html,.htm,.md,.markdown,text/markdown,text/html,application/pdf,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            style={{ position: 'absolute', opacity: 0, pointerEvents: 'none' }}
            onChange={(e) => pickAddFile(e.target.files && e.target.files[0])}
          />
        </label>
        <div className="dw-section-rule dw-mt-4">or name it yourself</div>
        <Field label="Document title"><input className="dw-input" autoFocus placeholder="e.g. Appendix C · Pricing detail" value={addTitle} onChange={(e) => setAddTitle(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter' && addTitle.trim()) confirmAdd(); }} /></Field>
        <p className="dw-drawer__note">Appendices ride the same version as the main document — they publish together.</p>
      </Drawer>

      {/* ── add prototype drawer ── */}
      <Drawer open={protoOpen} title="Add a prototype" sub="Host standalone HTML here, or embed an existing HTTPS prototype link. It publishes with the next version." onClose={() => setProtoOpen(false)}
        footer={<React.Fragment><Btn variant="ghost" size="sm" disabled={busy} onClick={() => setProtoOpen(false)}>Cancel</Btn><Btn variant="pine" size="sm" disabled={busy || (protoMode === 'upload' ? !protoFile : !protoUrl.trim())} onClick={confirmPrototype}>Add prototype</Btn></React.Fragment>}>
        <div className="dw-pilltabs">
          <button className={'dw-pilltabs__tab' + (protoMode === 'upload' ? ' is-on' : '')} onClick={() => setProtoMode('upload')}>Upload HTML</button>
          <button className={'dw-pilltabs__tab' + (protoMode === 'link' ? ' is-on' : '')} onClick={() => setProtoMode('link')}>Use URL</button>
        </div>
        {protoMode === 'upload' ? (
          <React.Fragment>
            <label className="dw-card dw-card--pad-sm dw-mt-3" style={{ display: 'block', cursor: 'pointer' }}>
              <span className="dw-body-sm" style={{ fontWeight: 700 }}>{protoFile ? protoFile.name : 'Choose standalone HTML'}</span>
              <span className="dw-mono-xs dw-muted" style={{ display: 'block', marginTop: 4 }}>{protoFile ? 'Stored by Dealwondr and rendered in the reader prototype frame.' : 'Best for exported clickable prototypes and single-file HTML demos.'}</span>
              <input
                type="file"
                accept=".html,.htm,text/html,application/xhtml+xml"
                style={{ position: 'absolute', opacity: 0, pointerEvents: 'none' }}
                onChange={(e) => pickPrototypeFile(e.target.files && e.target.files[0])}
              />
            </label>
          </React.Fragment>
        ) : (
          <Field label="Prototype URL" hint="Use the HTTPS URL where your prototype already lives.">
            <input className="dw-input" placeholder="https://prototype.example.com" value={protoUrl} onChange={(e) => { setProtoUrl(e.target.value); if (!protoTitle.trim()) setProtoTitle(titleFromUrl(e.target.value)); }} />
          </Field>
        )}
        <Field label="Prototype title">
          <input className="dw-input" placeholder="e.g. Pricing configurator" value={protoTitle} onChange={(e) => setProtoTitle(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter' && (protoMode === 'link' ? protoUrl.trim() : protoFile)) confirmPrototype(); }} />
        </Field>
        <p className="dw-drawer__note">Preview opens the reader frame without tracking. Sent room links still track reader sessions, full-screen state, clicks, scroll and comments.</p>
      </Drawer>

      {/* ── rename drawer ── */}
      <Drawer open={!!renameDoc} title="Rename document" sub={renameDoc ? renameDoc.title : ''} onClose={() => setRenameDoc(null)}
        footer={<React.Fragment><Btn variant="ghost" size="sm" disabled={busy} onClick={() => setRenameDoc(null)}>Cancel</Btn><Btn variant="pine" size="sm" disabled={!renameVal.trim() || busy} onClick={doRename}>Save</Btn></React.Fragment>}>
        <Field label="Document title"><input className="dw-input" autoFocus value={renameVal} onChange={(e) => setRenameVal(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') doRename(); }} /></Field>
      </Drawer>

      {/* ── publish drawer (form → done) ── */}
      <Drawer open={!!pub} title={pub === 'done' ? (justPub ? justPub.label : nextLabel) + ' is active' : 'Publish ' + nextLabel} sub={pub === 'done' ? 'Clients now open it by default' : 'Make your staged changes the new version'} onClose={() => { setPub(null); }}
        footer={pub === 'form' ? <React.Fragment><Btn variant="ghost" size="sm" disabled={busy} onClick={() => setPub(null)}>Cancel</Btn><Btn variant="pine" size="sm" disabled={busy} onClick={publish}>Publish {nextLabel} → clients see it now</Btn></React.Fragment> : <Btn variant="pine" size="sm" onClick={() => setPub(null)}>Done</Btn>}>
        {pub === 'form' ? (
          <React.Fragment>
            <SectionRule hint={uniqChanges.length + ' change' + (uniqChanges.length === 1 ? '' : 's') + ' staged'}>What’s in {nextLabel}</SectionRule>
            <ul className="dw-note__list dw-mt-2">{uniqChanges.length ? uniqChanges.map((c, i) => <li key={i}>{c}</li>) : <li>Updated the proposal</li>}</ul>
            <Field label="What changed?" hint="Clients see this next to the version.">
              <input className="dw-input" placeholder="e.g. Reworked pricing after Friday’s call" value={note} onChange={(e) => setNote(e.target.value)} autoFocus />
            </Field>
            <label className="dw-choice dw-mt-4" style={{ cursor: 'pointer', display: 'flex', gap: 10, alignItems: 'flex-start' }}><input type="checkbox" className="dw-switch" checked={keepOld} onChange={() => setKeepOld(!keepOld)} /><span><strong className="dw-body-sm">Let clients open older versions</strong><div className="dw-body-sm dw-secondary">{keepOld ? 'Clients get a version switcher for ' + versions.map((v) => v.label).join(', ') + '.' : 'Clients will only ever see ' + nextLabel + '. Older versions stay in your console.'}</div></span></label>
            <p className="dw-drawer__note">Publishing re-publishes every document together. Comments & analytics on older versions are never merged or moved.</p>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div className="dw-cluster-2" style={{ alignItems: 'center', marginBottom: 10 }}><span className="dw-action-card__tick">✓</span><strong>{justPub ? justPub.label : nextLabel} is active</strong></div>
            <p className="dw-body-sm dw-secondary">Every client now opens {justPub ? justPub.label : nextLabel} by default. Older versions keep their comments and analytics exactly where they are.</p>
            <SectionRule hint="optional · you reach out — we never email clients">Let clients know</SectionRule>
            <div className="dw-cluster-2 dw-mt-2"><Btn variant="pine" size="sm" onClick={copyRoomLink}>Copy link</Btn><Btn variant="ghost" size="sm" onClick={copyUpdateEmail}>Copy update email</Btn></div>
            <p className="dw-drawer__note">The room link is unchanged — clients already inside see the new version next time they open it.</p>
          </React.Fragment>
        )}
      </Drawer>

      {/* ── how versions work ── */}
      <Drawer open={info} title="How versions work" sub="One room, many versions — kept clean" onClose={() => setInfo(false)} footer={<Btn variant="pine" size="sm" onClick={() => setInfo(false)}>Got it</Btn>}>
        <div className="dw-note__part"><div className="dw-note__ph"><span className="dw-note__pn">1</span>Clients always land on the newest version</div><p className="dw-note__pb">Older ones appear in their switcher only while you keep them visible.</p></div>
        <div className="dw-note__part"><div className="dw-note__ph"><span className="dw-note__pn">2</span>Comments are pinned</div><p className="dw-note__pb">A question asked on an older version stays on that version — with its exact quote — after the next version ships.</p></div>
        <div className="dw-note__part"><div className="dw-note__ph"><span className="dw-note__pn">3</span>Analytics never merge</div><p className="dw-note__pb">Each version is its own experiment: read time, completion and heat are per-version, so you can tell whether the new one actually lands better.</p></div>
      </Drawer>
    </React.Fragment>
  );
}

function ActivityTab({ store, toast, onTab }) {
  const [filter, setFilter] = useState('all');
  const [who, setWho] = useState('all');
  const comments = store.comments();
  const readers = store.access().map((a) => a.email);
  const versionSummary = window.DWDisplay.versionSummary();
  const byWho = (c) => who === 'all' || c.author === who;
  const counts = { all: comments.filter(byWho).length, needs: comments.filter((c) => byWho(c) && c.needsReply && !c.resolved).length, resolved: comments.filter((c) => byWho(c) && c.resolved).length };
  const shown = comments.filter((c) => byWho(c) && (filter === 'all' || (filter === 'needs' && c.needsReply && !c.resolved) || (filter === 'resolved' && c.resolved)));
  return (
    <React.Fragment>
      <div className="dw-row"><SectionRule>Comments across this room</SectionRule><Btn variant="pine" size="sm" onClick={() => onTab && onTab('Insights', { view: 'Pre-call' })}>✦ Generate pre-call note →</Btn></div>
      <div className="dw-cluster-2 dw-mt-4"><span className="dw-verchip" style={{ whiteSpace: 'nowrap' }}>{versionSummary}</span><span className="dw-filterbar__label" style={{ marginLeft: 4 }}>Readers</span><button className={'dw-chip' + (who === 'all' ? ' is-on' : '')} onClick={() => setWho('all')}>All</button>{readers.map((e) => <button key={e} className={'dw-chip' + (who === e ? ' is-on' : '')} onClick={() => setWho(e)}>{window.DWAdapters.person(e).name}</button>)}</div>
      <div className="dw-filterbar dw-mt-4" style={{ paddingBottom: 14, borderBottom: '1px solid var(--dw-border-default)' }}>
        <button className={'dw-chip' + (filter === 'all' ? ' is-on' : '')} onClick={() => setFilter('all')}>All · {counts.all}</button>
        <button className={'dw-chip' + (filter === 'needs' ? ' is-on' : '')} onClick={() => setFilter('needs')}>Needs reply · {counts.needs}</button>
        <button className={'dw-chip' + (filter === 'resolved' ? ' is-on' : '')} onClick={() => setFilter('resolved')}>Resolved · {counts.resolved}</button>
      </div>
      <div className="dw-mt-4">
        {shown.map((c) => <CommentCard key={c.id} c={c} onResolve={async (c2, v) => { await store.setResolved(c2.id, v); toast(v ? 'Marked resolved' : 'Reopened'); }} onReply={async (c2, t) => { await store.addReply(c2.id, t); toast('Reply posted', true); }} />)}
        {!shown.length ? <div className="dw-empty"><Icon name="comment" size="xl" /><div className="dw-empty__title">Nothing here yet</div><div className="dw-empty__body">{who === 'all' ? 'No comments match this filter.' : window.DWAdapters.person(who).name + ' hasn’t commented on this version yet.'}</div></div> : null}
      </div>
    </React.Fragment>
  );
}

function InsightsTab({ toast, onTab, view: activeView, onViewChange }) {
  const store = useStore();
  const [localView, setLocalView] = useState('Overview');
  const view = activeView || localView;
  const setView = onViewChange || setLocalView;
  const [replayReader, setReplayReader] = useState(null);
  const [pick, setPick] = useState(null);
  const [actionBusy, setActionBusy] = useState('');
  const ins = window.DWAdapters.roomInsights();
  // live: resolved comments cool the deal (lower friction) and auto-resolve matching objections
  const liveComments = store.comments();
  const resolvedCount = liveComments.filter((c) => c.resolved).length;
  const openNeedsReply = liveComments.filter((c) => c.needsReply && !c.resolved).length;
  const t = ins.temperature;
  const friction = Math.max(8, t.interest && t.friction - resolvedCount * 8);
  const temp = Math.round(0.75 * t.interest + 0.25 * (100 - friction));
  const tempLabel = temp >= 80 ? 'Hot' : temp >= 60 ? 'Warm' : temp >= 45 ? 'Steady' : 'Cooling';
  const nextActions = ins.actions || [];
  const versionId = window.DWDisplay.versionId();
  const versionSummary = window.DWDisplay.versionSummary();
  useEffect(() => {
    let cancelled = false;
    const roomId = window.DWAdapters.currentRoomId();
    if (!roomId || !versionId || !store.hasTeamApiSession()) return undefined;
    const loadInsights = view === 'Overview' || view === 'Actions' || view === 'Pre-call';
    if (loadInsights && !(window.DWAdapters.insightsLoadedFromApi && window.DWAdapters.insightsLoadedFromApi())) {
      store.refreshInsightOverview(roomId, versionId).catch((error) => {
        if (!cancelled) toast(error.message || 'Could not load insights');
      });
    }
    if ((view === 'Engagement' || view === 'Sections') && store.refreshAnalyticsSummary) {
      store.refreshAnalyticsSummary(roomId, versionId).catch((error) => {
        if (!cancelled) toast(error.message || 'Could not load analytics');
      });
    }
    if (view === 'Journeys') {
      store.refreshReplaySessions(roomId, versionId).catch((error) => {
        if (!cancelled) toast(error.message || 'Could not load replay events');
      });
    }
    if (view === 'Engagement' || view === 'Journeys') {
      store.refreshQuestionnaireStats(roomId, versionId).catch((error) => {
        if (!cancelled) toast(error.message || 'Could not load questionnaire analytics');
      });
    }
    return () => { cancelled = true; };
  }, [view, versionId]);
  const sectionResolved = (cat) => {
    const objection = (ins.objections || []).find((o) => o.cat === cat);
    if (objection && objection.status && objection.status !== 'open') return objection.status;
    // a critical pricing objection auto-resolves once the pricing thread is resolved
    if (/pricing/i.test(cat) && liveComments.some((c) => /fees|pricing|measurement/i.test(c.quote + c.body) && c.resolved)) return 'resolved';
    return null;
  };
  const objs = ins.objections.filter((o) => sectionResolved(o.cat) !== 'dismissed');
  const hasInsightSignals = !!(
    t.interest ||
    t.friction ||
    (ins.lifting && ins.lifting.length) ||
    (ins.holding && ins.holding.length) ||
    objs.length ||
    nextActions.length ||
    liveComments.length
  );
  const doneLabel = (a) => {
    const actionId = a.done && a.done.action;
    const option = (a.actions || []).find((item) => item.id === actionId);
    return option ? option.label : (actionId ? actionId.replace(/\b\w/g, (c) => c.toUpperCase()) : 'Done');
  };
  const act = async (a, option) => {
    setActionBusy(a.id + ':' + option.id);
    try {
      const result = await store.actOnNextAction(a, option.id);
      toast((result && result.toast) || option.label + ' — done', !!option.primary);
      if (result && result.nav && result.nav.tab === 'Activity' && onTab) onTab('Activity');
    } catch (error) {
      toast(error.message || 'Could not update next action');
    } finally {
      setActionBusy('');
    }
  };
  const undoAction = async (a) => {
    setActionBusy(a.id + ':undo');
    try {
      await store.undoNextAction(a);
      toast('Action undone');
    } catch (error) {
      toast(error.message || 'Could not undo next action');
    } finally {
      setActionBusy('');
    }
  };
  return (
    <React.Fragment>
      <div className="dw-pilltabs">{['Overview', 'Actions', 'Engagement', 'Sections', 'Journeys', 'Pre-call'].map((v) => <button key={v} className={'dw-pilltabs__tab' + (v === view ? ' is-on' : '')} onClick={() => setView(v)}>{v}</button>)}</div>
      <div className="dw-cluster dw-mt-4" style={{ justifyContent: 'space-between' }}>
        <div className="dw-cluster-2" style={{ flexWrap: 'nowrap' }}><span className="dw-verchip" style={{ whiteSpace: 'nowrap' }}>{versionSummary}</span><span className="dw-ins-note" style={{ whiteSpace: 'nowrap' }}>Active · {openNeedsReply} open · updates as you resolve</span></div>
      </div>

      {view === 'Overview' && !hasInsightSignals ? (
        <div className="dw-empty dw-mt-4">
          <Icon name="chart" size="xl" />
          <div className="dw-empty__title">No insight signals yet</div>
          <div className="dw-empty__body">Deal temperature, objections, and recommendations appear after readers open this version or leave comments.</div>
        </div>
      ) : null}

      {view === 'Overview' && hasInsightSignals ? (
        <React.Fragment>
          <SectionRule hint={'active · interest vs friction · ' + t.confidence + ' confidence'}>Deal temperature</SectionRule>
          <div className="dw-ins-card dw-cluster-4" style={{ alignItems: 'center', gap: 32 }}>
            <Pulse interest={t.interest} friction={friction} label={tempLabel} temp={temp} />
            <div style={{ flex: 1, minWidth: 220 }}>
              <span className="dw-overline" style={{ color: 'var(--dw-status-ok)' }}>What’s lifting it</span>
              <ul className="dw-note__list dw-mt-2">{ins.lifting.map((x, i) => <li key={i}>{x}</li>)}{resolvedCount ? <li><strong>{resolvedCount} question{resolvedCount === 1 ? '' : 's'} answered</strong> — friction easing.</li> : null}</ul>
              <span className="dw-overline dw-mt-4" style={{ color: 'var(--dw-status-warn)', display: 'block' }}>What’s holding it back</span>
              <ul className="dw-note__list dw-mt-2">{openNeedsReply ? <li><strong>{openNeedsReply} open question{openNeedsReply === 1 ? '' : 's'}</strong> awaiting your reply.</li> : <li>Nothing open — every question is answered.</li>}{ins.holding.slice(0, 1).map((x, i) => <li key={i}>{x}</li>)}</ul>
            </div>
          </div>
          <p className="dw-body-sm dw-muted dw-mt-2" style={{ lineHeight: 1.6 }}>A deal can be engaged <em>and</em> risky — so interest and friction are scored separately, then combined. <span className="dw-mono-xs" style={{ color: 'var(--dw-text-muted)' }}>0.75 × interest + 0.25 × (100 − friction)</span></p>
          <SectionRule hint="resolve a comment in Activity — watch this update">Objection map</SectionRule>
          <div className="dw-ins-card" style={{ display: 'flex', gap: 24, flexWrap: 'wrap', alignItems: 'center' }}>
            {objs.length ? (
              <React.Fragment>
                <ObjectionOrbit objections={objs} onPick={setPick} />
                <div style={{ flex: 1, minWidth: 280 }}>
                  {objs.map((o, i) => (
                    <div className="dw-objrow" key={i} onClick={() => setPick(o)} style={{ cursor: 'pointer', opacity: sectionResolved(o.cat) === 'resolved' ? 0.6 : 1 }}><span className={'dw-sevdot dw-sevdot--' + o.sev}></span><span className="dw-objrow__cat">{o.cat}{sectionResolved(o.cat) === 'resolved' ? <Badge variant="resolved">resolved</Badge> : null}</span><span className={'dw-sev dw-sev--' + o.sev}>{o.sevLabel}</span><span className="dw-objrow__score">{o.score}</span><span className="dw-mono-xs dw-muted" style={{ flex: 'none' }}>{o.ev} signal{o.ev === 1 ? '' : 's'}</span><a className="dw-jump">Evidence →</a></div>
                  ))}
                </div>
              </React.Fragment>
            ) : (
              <div className="dw-empty dw-objection-empty">
                <Icon name="check" size="xl" />
                <div className="dw-empty__title">No open objections</div>
                <div className="dw-empty__body">Resolved and dismissed objections stay out of this map. New pricing, security, timeline, or stakeholder-risk signals will appear here with evidence links.</div>
              </div>
            )}
          </div>
          {objs.length ? <p className="dw-body-sm dw-muted dw-mt-2" style={{ lineHeight: 1.6 }}>Bubble <strong>size</strong> = score · <strong>colour</strong> = severity · <strong>border</strong> = confidence · <strong>number</strong> = evidence count. Click any bubble for the evidence behind it.</p> : null}
        </React.Fragment>
      ) : null}

      {view === 'Actions' ? (
        <React.Fragment>
          <SectionRule hint="ranked by deal impact · one tap each">Next best actions</SectionRule>
          {nextActions.map((a) => a.done ? (
            <div key={a.id} className="dw-action-card is-done dw-mt-3"><span className="dw-action-card__rail"></span>
              <div className="dw-cluster-2" style={{ flex: 1, alignItems: 'center' }}><span className="dw-action-card__tick">✓</span><span className="dw-body-sm" style={{ color: 'var(--dw-text-secondary)' }}><strong style={{ color: 'var(--dw-text-primary)' }}>{doneLabel(a)}</strong> · {a.title}</span><span className="dw-grow"></span><button className="dw-action" disabled={!!actionBusy} onClick={() => undoAction(a)}>{actionBusy === a.id + ':undo' ? 'Undoing...' : 'Undo'}</button></div></div>
          ) : (
            <div key={a.id} className={'dw-action-card t-' + a.temp + (a.best ? ' is-lead' : '') + ' dw-mt-3'}><span className="dw-action-card__rail"></span>
              <div style={{ flex: 1 }}><div className="dw-action-card__meta"><span className="dw-action-card__verb">{a.verb}</span><span className={'dw-action-card__impact i-' + a.temp}>{a.impact}</span>{a.best ? <span className="dw-action-card__best">Top move now</span> : null}</div>
                <div className="dw-action-card__title">{a.title}</div><p className="dw-action-card__why">{a.why}</p>
                <div className="dw-action-card__acts">
                  {(a.actions || []).length ? (a.actions || []).map((option) => <Btn key={option.id} variant={option.primary ? 'pine' : 'ghost'} size="sm" loading={actionBusy === a.id + ':' + option.id} disabled={!!actionBusy} onClick={() => act(a, option)}>{option.label}</Btn>) : <Btn variant="ghost" size="sm" disabled>No action available</Btn>}
                  <span className="dw-grow"></span>
                </div></div></div>
          ))}
          {nextActions.length && nextActions.every((a) => a.done) ? <div className="dw-empty dw-mt-3"><Icon name="check" size="xl" /><div className="dw-empty__title">Every play is made</div><div className="dw-empty__body">You’ve actioned every recommended move on this version. New signals will surface fresh actions here.</div></div> : null}
        </React.Fragment>
      ) : null}

      {view === 'Engagement' ? <EngagementView version={versionId} onReplay={(reader) => { setReplayReader(reader); setView('Journeys'); }} /> : null}
      {view === 'Sections' ? <SectionsView version={versionId} /> : null}
      {view === 'Journeys' ? <JourneysView version={versionId} focusReader={replayReader} /> : null}

      {view === 'Pre-call' ? (
        <React.Fragment>
          <SectionRule hint="one evidence-cited note for your call">The brief</SectionRule>
          <PreCallNote toast={toast} />
          <SectionRule hint="every note you’ve generated — archived to its version">Past pre-call notes</SectionRule>
          <PastPreCalls />
        </React.Fragment>
      ) : null}

      <EvidenceDrawer obj={pick}
        onClose={() => setPick(null)}
        onResolve={async (o) => {
          try {
            await store.setObjectionStatus(o, 'resolved');
            setPick(null);
            toast(o.cat + ' marked resolved', true);
          } catch (error) {
            toast(error.message || 'Could not update objection');
          }
        }}
        onDismiss={async (o) => {
          try {
            await store.setObjectionStatus(o, 'dismissed');
            setPick(null);
            toast(o.cat + ' dismissed');
          } catch (error) {
            toast(error.message || 'Could not update objection');
          }
        }} />
    </React.Fragment>
  );
}

function Pulse({ interest, friction, label, temp }) {
  const R1 = 58, R2 = 41, c1 = 2 * Math.PI * R1, c2 = 2 * Math.PI * R2;
  return (
    <div className="dw-pulse"><svg viewBox="0 0 140 140" width="150" height="150">
      <g transform="rotate(-90 70 70)">
        <circle className="trk" cx="70" cy="70" r={R1} /><circle className="ring int" cx="70" cy="70" r={R1} strokeDasharray={(interest / 100 * c1).toFixed(1) + ' ' + c1.toFixed(1)} />
        <circle className="trk" cx="70" cy="70" r={R2} /><circle className="ring fri" cx="70" cy="70" r={R2} strokeDasharray={(friction / 100 * c2).toFixed(1) + ' ' + c2.toFixed(1)} />
      </g>
      <text className="pn" x="70" y="66" style={{ fontSize: 26 }}>{temp}</text><text className="pl" x="70" y="84">{label}</text>
    </svg>
      <div className="dw-pulse__legend"><span><i className="dot int"></i>Interest <b>{interest}</b></span><span><i className="dot fri"></i>Friction <b>{friction}</b></span></div>
    </div>
  );
}

/* deal-role options — shared by the invite + edit drawer */
const DW_DEAL_ROLES = [
  ['Final approver', 'Signs off the deal. Their attention — and silence — weigh heaviest.'],
  ['Champion', 'Selling internally for you. Engagement here is a strong positive.'],
  ['Senior', 'Influential evaluator weighing the decision.'],
];

/* row overflow menu — Edit · Copy link · Remove (parity with the original Access tab) */
function AccessRowMenu({ onEdit, onCopy, onRemove }) {
  const [open, setOpen] = useState(false);
  useEffect(() => { if (!open) return; const fn = () => setOpen(false); window.addEventListener('click', fn); return () => window.removeEventListener('click', fn); }, [open]);
  return (
    <span style={{ position: 'relative' }} onClick={(e) => e.stopPropagation()}>
      <button className={'dw-kebab' + (open ? ' is-on' : '')} onClick={() => setOpen(!open)} aria-label="Row actions"><Icon name="more" /></button>
      {open ? (
        <div className="dw-dropdown" style={{ position: 'absolute', right: 0, top: 'calc(100% + 6px)', zIndex: 600, minWidth: 190 }}>
          <button className="dw-dropdown__item" onClick={() => { setOpen(false); onEdit(); }}><Icon name="user" size="sm" /> Edit deal role</button>
          <button className="dw-dropdown__item" onClick={() => { setOpen(false); onCopy(); }}><Icon name="link" size="sm" /> Copy room link</button>
          <div className="dw-dropdown__sep"></div>
          <button className="dw-dropdown__item dw-dropdown__item--danger" onClick={() => { setOpen(false); onRemove(); }}><Icon name="trash" size="sm" /> Remove access</button>
        </div>
      ) : null}
    </span>
  );
}

function TrackingSetting({ title, desc, checked, disabled, busy, onChange }) {
  return (
    <div className={'dw-rule' + (checked ? '' : ' is-off')}>
      <div className="dw-rule__body"><div className="dw-rule__name">{title}</div><div className="dw-rule__desc">{desc}</div></div>
      <input type="checkbox" className="dw-switch" aria-label={title} checked={!!checked} disabled={disabled || busy} onChange={(e) => onChange(e.target.checked)} />
    </div>
  );
}

function AccessTab({ store, toast, copyRoomLink }) {
  const [drawer, setDrawer] = useState(null);     // null | {mode:'invite'} | {mode:'edit', a}
  const [confirm, setConfirm] = useState(null);   // access row pending removal
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('Final approver');
  const [trackingBusy, setTrackingBusy] = useState('');
  const [trackingError, setTrackingError] = useState('');
  const rows = store.access();
  const tracking = store.roomTracking ? store.roomTracking() : null;
  const edit = drawer && drawer.mode === 'edit';
  const sessionEmail = (store.get().teamSession && store.get().teamSession.email) || '';
  const sender = store.members().find((m) => m[1] && m[1].toLowerCase() === sessionEmail.toLowerCase()) || store.members().find((m) => m[5]) || null;
  const senderName = sender ? sender[0] : (sessionEmail ? window.DWAdapters.person(sessionEmail).name : 'Team');
  const orgName = window.DWDisplay.orgName();
  const roomTitle = window.DWDisplay.roomTitle();
  const exampleEmail = window.DWDisplay.clientEmailExample();

  useEffect(() => {
    if (!drawer) return;
    setEmail(edit ? drawer.a.email : '');
    setRole(edit ? drawer.a.role : 'Final approver');
  }, [drawer]);

  useEffect(() => {
    if (!store.loadRoomTracking) return;
    let alive = true;
    setTrackingError('');
    store.loadRoomTracking().catch((error) => { if (alive) setTrackingError(error.message || 'Could not load tracking settings'); });
    return () => { alive = false; };
  }, []);

  const openInvite = () => setDrawer({ mode: 'invite' });
  const openEdit = (a) => setDrawer({ mode: 'edit', a });
  const updateTracking = async (key, value) => {
    if (!store.setRoomTracking) return;
    setTrackingBusy(key);
    setTrackingError('');
    try {
      const patch = {};
      patch[key] = value;
      await store.setRoomTracking(patch);
      toast('Room tracking settings saved', true);
    } catch (error) {
      setTrackingError(error.message || 'Could not update tracking settings');
      toast(error.message || 'Could not update tracking settings');
    } finally {
      setTrackingBusy('');
    }
  };
  const send = async () => {
    if (!email.trim()) return;
    try {
      await store.invite(email, role);
      setDrawer(null);
      toast(role + ' added — copy the link or email to reach out yourself', true);
    } catch (error) {
      toast(error.message || 'Could not add client access');
    }
  };
  const saveEdit = async () => {
    try {
      await store.setAccessRole(drawer.a.email, role);
      setDrawer(null);
      toast(window.DWAdapters.person(drawer.a.email).name + ' is now ' + role);
    } catch (error) {
      toast(error.message || 'Could not update access role');
    }
  };
  const copyInviteEmail = async () => {
    try {
      await window.DWShare.copyInviteEmail(email, window.DWAdapters.roomContext());
      toast('Invite email copied', true);
    } catch (error) {
      toast(error.message || 'Could not copy invite email');
    }
  };

  return (
    <React.Fragment>
      <div className="dw-row"><SectionRule hint="role feeds Insights">Who can open this room</SectionRule><Btn variant="pine" size="sm" icon="plus" onClick={openInvite}>Invite client</Btn></div>
      <div className="dw-table-scroll"><table className="dw-table dw-mt-4">
        <thead><tr><th>Email</th><th>Access</th><th>Deal role</th><th>First opened</th><th>Time in room</th><th></th></tr></thead>
        <tbody>{rows.map((a, i) => (
          <tr key={a.email + i}><td className="lead">{a.email}</td>
            <td><span className="dw-cluster-2"><span className={'dw-dot' + (a.access === 'opened' ? ' dw-dot--ok' : '')}></span>{a.access === 'opened' ? 'Opened' : 'Invited'}</span></td>
            <td><Badge variant="outline">{a.role}</Badge></td><td className="num dw-muted">{a.opened}</td><td className="num dw-muted">{a.time}</td>
            <td style={{ textAlign: 'right' }}><AccessRowMenu onEdit={() => openEdit(a)} onCopy={copyRoomLink} onRemove={() => setConfirm(a)} /></td></tr>
        ))}</tbody>
      </table></div>

      <div className="dw-row dw-mt-6"><SectionRule hint="stored per room">Room tracking controls</SectionRule>{tracking && tracking.updatedAt ? <span className="dw-mono-xs dw-muted">Updated {new Date(tracking.updatedAt).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}</span> : null}</div>
      {trackingError ? <p className="dw-error">{trackingError}</p> : null}
      <div className="dw-card dw-card--pad-sm dw-mt-3">
        <TrackingSetting
          title="Record reader engagement"
          desc="Capture opens, section dwell, scroll progress, clicks, highlights, comments, and replay events for this room."
          checked={!tracking || tracking.recordEngagement !== false}
          disabled={!tracking}
          busy={!!trackingBusy}
          onChange={(checked) => updateTracking('recordEngagement', checked)}
        />
        <TrackingSetting
          title="Show readers what is shared"
          desc="Keep the reader trust drawer available so every buyer can inspect the activity footprint."
          checked={!!(tracking && tracking.readerCanSee)}
          disabled={!tracking || tracking.recordEngagement === false}
          busy={!!trackingBusy}
          onChange={(checked) => updateTracking('readerCanSee', checked)}
        />
        <TrackingSetting
          title="Show reader their own activity"
          desc="Let readers see their own room activity summary and pause or resume engagement sharing."
          checked={!!(tracking && tracking.showReaderOwnData)}
          disabled={!tracking || tracking.recordEngagement === false}
          busy={!!trackingBusy}
          onChange={(checked) => updateTracking('showReaderOwnData', checked)}
        />
      </div>

      <Drawer open={!!drawer}
        title={edit ? 'Edit ' + window.DWAdapters.person(drawer.a.email).name : 'Invite a client'}
        sub={edit ? drawer.a.email : 'They enter this email, then get a one-time room link — no account, no password.'}
        onClose={() => setDrawer(null)}
        footer={edit
          ? <React.Fragment><Btn variant="ghost" size="sm" onClick={() => setDrawer(null)}>Cancel</Btn><Btn variant="pine" size="sm" onClick={saveEdit}>Save changes</Btn></React.Fragment>
          : <React.Fragment><Btn variant="ghost" size="sm" onClick={() => setDrawer(null)}>Cancel</Btn><Btn variant="pine" size="sm" disabled={!email.trim()} onClick={send}>Add client</Btn></React.Fragment>}>
        {!edit ? <Field label="Client email" hint="One person per invite — the room opens for this exact address."><input className="dw-input" placeholder={exampleEmail} value={email} onChange={(e) => setEmail(e.target.value)} autoFocus onKeyDown={(e) => { if (e.key === 'Enter' && email.trim()) send(); }} /></Field> : null}
        <label className="dw-label dw-mt-5">Deal role <span className="dw-mono-xs dw-muted" style={{ textTransform: 'none', letterSpacing: 0 }}>· weights how Insights reads their signals</span></label>
        <div className="dw-roleradio dw-mt-2">
          {DW_DEAL_ROLES.map((r) => (
            <label key={r[0]} className={'dw-roleopt' + (role === r[0] ? ' is-on' : '')} onClick={() => setRole(r[0])}><span className="dw-roleopt__top"><span className="dot"></span><Badge variant="outline">{r[0]}</Badge></span><span className="dw-roleopt__desc">{r[1]}</span></label>
          ))}
        </div>
        {!edit ? (
          <React.Fragment>
            <div className="dw-section-rule dw-mt-5">How they get in <span style={{ textTransform: 'none', letterSpacing: '.02em', color: 'var(--dw-text-muted)' }}>· you send it</span></div>
            <p className="dw-drawer__note" style={{ marginTop: 0, marginBottom: 12 }}>Add the client to register their address, then send them the room link. Dealwondr emails the one-time access link only after they enter their address.</p>
            <div className="dw-emailframe" style={{ margin: 0, boxShadow: 'none' }}><div className="dw-emailframe__meta">FROM&nbsp;&nbsp;{senderName} · {orgName}<br/>TO&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{email || exampleEmail}<br/>SUBJ&nbsp;&nbsp;A proposal with a place to talk back</div><div className="dw-emailframe__body"><p className="dw-body-sm dw-secondary" style={{ margin: 0 }}>Here’s the {roomTitle} as a private room. Highlight anything to ask and I’ll answer in context.</p></div></div>
            <div className="dw-cluster-2 dw-mt-3"><Btn variant="pine" size="sm" onClick={copyInviteEmail}>Copy invite email</Btn><Btn variant="ghost" size="sm" onClick={copyRoomLink}>Copy room link</Btn></div>
          </React.Fragment>
        ) : null}
      </Drawer>

      {confirm ? (
        <div className="dw-modal-scrim" style={{ position: 'fixed' }} onMouseDown={(e) => { if (e.target === e.currentTarget) setConfirm(null); }}>
          <div className="dw-confirm">
            <div className="dw-confirm__title">Remove {window.DWAdapters.person(confirm.email).name}?</div>
            <p className="dw-confirm__body">{confirm.email} loses access to this room. Their comments and answers are kept — you can re-invite them anytime.</p>
            <div className="dw-confirm__acts"><Btn variant="ghost" size="sm" onClick={() => setConfirm(null)}>Cancel</Btn><Btn variant="danger" size="sm" onClick={async () => { try { await store.removeAccess(confirm.email); setConfirm(null); toast('Access removed'); } catch (error) { toast(error.message || 'Could not remove access'); } }}>Remove access</Btn></div>
          </div>
        </div>
      ) : null}
    </React.Fragment>
  );
}

Object.assign(window, { RoomWorkspace, ContentTab, ActivityTab, InsightsTab, Pulse, AccessTab });


/* ---- app/app.jsx ---- */
/* ============================================================
   DEALWONDR APP — router + mount
   Hash routes:  #/ gate · #/room reader · #/team team auth ·
   #/admin dashboard · #/admin/room workspace · #/admin/alerts ·
   #/admin/settings
   ============================================================ */
function App() {
  if (window.DWShare) window.DWShare.applyRoomIdFromLocation();
  const [route, setRoute] = useState(location.hash || '#/');
  const [booting, setBooting] = useState(true);
  const [routeHydrating, setRouteHydrating] = useState(false);
  const storeApi = useStore();
  const store = storeApi.get();
  const replaceAtAppRoot = (hash) => {
    history.replaceState(null, '', '/' + hash);
    setRoute(hash);
  };
  const hydrateReaderRouteSession = () => {
    const nextRoute = location.hash || '#/';
    if (!nextRoute.startsWith('#/room')) return;
    if (window.DWShare) window.DWShare.applyRoomIdFromLocation();
    const targetRoomId = window.DW_API_ROOM_ID;
    const current = window.DWStore.get().readerSession;
    const saved = targetRoomId && window.DWApi.getReaderSession ? window.DWApi.getReaderSession(targetRoomId) : null;
    if (!targetRoomId || !current || current.roomId === targetRoomId || !saved) return;
    setRouteHydrating(true);
    window.DWStore.restoreSession()
      .catch((error) => console.error(error))
      .finally(() => setRouteHydrating(false));
  };
  useEffect(() => {
    const fn = () => {
      if (window.DWShare) window.DWShare.applyRoomIdFromLocation();
      setRoute(location.hash || '#/');
      hydrateReaderRouteSession();
    };
    window.addEventListener('hashchange', fn);
    return () => window.removeEventListener('hashchange', fn);
  }, []);
  useEffect(() => {
    let cancelled = false;
    const done = () => { if (!cancelled) setBooting(false); };
    const token = new URLSearchParams(location.search).get('token');
    if (!token) {
      window.DWStore.restoreSession().catch((error) => console.error(error)).finally(done);
      return () => { cancelled = true; };
    }
    const isReaderLink = location.pathname.indexOf('/auth/reader-magic-link') > -1;
    const complete = isReaderLink ? window.DWStore.completeReaderMagicLink(token) : window.DWStore.completeTeamMagicLink(token);
    complete
      .then((result) => {
        if (isReaderLink) replaceAtAppRoot('#/room?roomId=' + encodeURIComponent(result.roomId));
        else replaceAtAppRoot('#/admin');
      })
      .catch((error) => {
        console.error(error);
        replaceAtAppRoot(isReaderLink ? '#/room' : '#/team');
      })
      .finally(done);
    return () => { cancelled = true; };
  }, []);
  useEffect(() => {
    if (booting || !route.startsWith('#/room')) return undefined;
    const targetRoomId = window.DW_API_ROOM_ID;
    const reader = store.readerSession;
    if (!targetRoomId || !reader || reader.roomId === targetRoomId) return undefined;
    const saved = window.DWApi.getReaderSession && window.DWApi.getReaderSession(targetRoomId);
    if (!saved) return undefined;
    let cancelled = false;
    setRouteHydrating(true);
    window.DWStore.restoreSession()
      .catch((error) => console.error(error))
      .finally(() => { if (!cancelled) setRouteHydrating(false); });
    return () => { cancelled = true; };
  }, [route, booting, store.readerSession && store.readerSession.roomId]);
  useEffect(() => {
    if (booting || !route.startsWith('#/admin/room') || !store.teamUser || hasRoomContext()) return undefined;
    const firstRoom = (store.rooms || []).find((room) => room && (room.apiId || room.id));
    if (!firstRoom) return undefined;
    let cancelled = false;
    setRouteHydrating(true);
    window.DWStore.selectRoom(firstRoom.apiId || firstRoom.id)
      .catch((error) => console.error(error))
      .finally(() => { if (!cancelled) setRouteHydrating(false); });
    return () => { cancelled = true; };
  }, [route, booting, !!store.teamUser, (store.rooms || []).length]);
  const go = (h) => { location.hash = h; };
  const adminHash = (section, params) => {
    const path = section === 'dash' ? '#/admin' : '#/admin/' + section;
    const query = new URLSearchParams();
    Object.keys(params || {}).forEach((key) => {
      if (params[key]) query.set(key, params[key]);
    });
    const text = query.toString();
    return text ? path + '?' + text : path;
  };
  const hashParam = (name) => {
    const hash = route || '';
    const queryStart = hash.indexOf('?');
    if (queryStart < 0) return null;
    return new URLSearchParams(hash.slice(queryStart + 1)).get(name);
  };
  const seed = () => window.DW_SEED || {};
  const seedRoom = () => seed().room || {};
  const routeRoomId = () => hashParam('roomId') || window.DW_API_ROOM_ID || seedRoom().apiId || seedRoom().id || '';
  const loadedRoomId = () => seedRoom().apiId || seedRoom().id || '';
  const hasLoadedReaderContent = () => {
    const versions = window.DWAdapters.readerVersions();
    const docs = seed().docs || [];
    return versions.length > 0 && docs.length > 0;
  };
  const activeRoomRef = () => {
    if (window.DW_API_ROOM_ID) return { id: window.DW_API_ROOM_ID, apiId: window.DW_API_ROOM_ID };
    try {
      if (storeApi.apiRoomId) {
        const id = storeApi.apiRoomId();
        if (id) return { id: id, apiId: id };
      }
    } catch (error) {}
    return window.DWAdapters.roomContext();
  };
  const readerHash = (options) => window.DWShare ? window.DWShare.readerHash(activeRoomRef(), options) : '#/room';
  const hasRoomContext = () => window.DWAdapters.hasRoomContext();
  const apiPathMatchesRoomRoute = () => {
    if (store.apiErrorStatus !== 404 || !store.apiErrorPath) return false;
    const roomId = routeRoomId();
    if (!roomId) return false;
    const encoded = encodeURIComponent(roomId);
    return store.apiErrorPath === '/rooms/' + encoded || store.apiErrorPath.indexOf('/rooms/' + encoded + '/') === 0;
  };
  const roomNotFound = apiPathMatchesRoomRoute() && (route.startsWith('#/room') || route.startsWith('#/form') || route.indexOf('/room') > -1);
  useEffect(() => {
    if (booting || !route.startsWith('#/room') || hashParam('preview') !== '1' || !store.teamUser) return undefined;
    const targetRoomId = routeRoomId();
    const targetVersionId = hashParam('versionId');
    if (!targetRoomId) return undefined;
    if (targetVersionId && store.selectedVersionId === targetVersionId && loadedRoomId() === targetRoomId && hasLoadedReaderContent()) return undefined;
    if (!targetVersionId && !store.selectedVersionId && loadedRoomId() === targetRoomId && hasLoadedReaderContent()) return undefined;
    let cancelled = false;
    setRouteHydrating(true);
    window.DW_API_ROOM_ID = targetRoomId;
    const load = targetVersionId
      ? window.DWStore.selectPreviewVersion(targetRoomId, targetVersionId)
      : (window.DWStore.clearSelectedVersion && window.DWStore.clearSelectedVersion(), window.DWStore.refreshRoom());
    load
      .catch((error) => console.error(error))
      .finally(() => { if (!cancelled) setRouteHydrating(false); });
    return () => { cancelled = true; };
  }, [route, booting, !!store.teamUser, store.selectedVersionId]);
  if (booting || routeHydrating) return <AppBootScreen />;

  // ---- admin console ----
  if (route.startsWith('#/admin')) {
    if (roomNotFound) return <NotFoundPage kind="room" detail="This room is no longer available in this workspace. It may have been deleted, unpublished, or moved." onPrimary={() => go('#/admin/rooms')} primaryLabel="Back to rooms" onSecondary={() => go('#/admin')} secondaryLabel="Dashboard" />;
    if (!store.teamUser) return <TeamGate onDone={() => go('#/admin')} onBack={() => go(readerHash())} />;
    const active = route.indexOf('/upload') > -1 ? 'upload' : route.indexOf('/rooms') > -1 ? 'rooms' : route.indexOf('/room') > -1 ? 'room' : route.indexOf('/alerts') > -1 ? 'alerts' : route.indexOf('/settings') > -1 ? 'settings' : 'dash';
    const onNav = (p, params) => go(adminHash(p, params));
    const onReader = () => {
      if (window.DWStore.clearApiError) window.DWStore.clearApiError();
      if (window.DWStore.clearSelectedVersion) window.DWStore.clearSelectedVersion();
      go(readerHash());
    };
    const onPreviewReader = (options) => {
      if (window.DWStore.clearApiError) window.DWStore.clearApiError();
      if (!(options && options.versionId) && window.DWStore.clearSelectedVersion) window.DWStore.clearSelectedVersion();
      go(readerHash(Object.assign({ preview: true }, options || {})));
    };
    const roomTarget = {
      tab: hashParam('roomTab'),
      contentView: hashParam('contentView'),
      insightsView: hashParam('insightsView')
    };
    if (active === 'room' && !hasRoomContext()) {
      return <NotFoundPage kind="room" detail="No active room is available in this workspace." onPrimary={() => go('#/admin/rooms')} primaryLabel="Back to rooms" onSecondary={() => go('#/admin')} secondaryLabel="Dashboard" />;
    }
    return (
      <Shell active={active} onNav={onNav} onReader={onReader} side={active === 'dash' ? <DashboardSide onNav={onNav} /> : null}>
        {active === 'dash' && <Dashboard onNav={onNav} />}
        {active === 'rooms' && <RoomsHome onOpenRoom={() => go('#/admin/room')} onUpload={() => go('#/admin/upload')} />}
        {active === 'upload' && <UploadWizard onPublish={() => go(adminHash('room', { roomTab: 'Access' }))} onCancel={() => go('#/admin/rooms')} />}
        {active === 'room' && <RoomWorkspace onReader={onReader} onPreviewReader={onPreviewReader} onNav={onNav} initialTab={roomTarget.tab} initialContentView={roomTarget.contentView} initialInsightsView={roomTarget.insightsView} />}
        {active === 'alerts' && <Alerts onNav={onNav} onReader={onReader} />}
        {active === 'settings' && <Settings />}
      </Shell>
    );
  }
  // ---- super console ----
  if (route.startsWith('#/super')) {
    if (!store.teamUser) return <TeamGate onDone={() => go('#/super')} onBack={() => go(readerHash())} />;
    if (!(store.teamSession && store.teamSession.role === 'super')) {
      return (
        <Shell active="settings" onNav={(p) => go(p === 'dash' ? '#/admin' : '#/admin/' + p)} onReader={() => go(readerHash())}>
          <div className="dw-main__body">
            <div className="dw-empty"><Icon name="shield" size="xl" /><div className="dw-empty__title">Platform access required</div><div className="dw-empty__body">This console is available only to platform staff sessions.</div></div>
          </div>
        </Shell>
      );
    }
    return <SuperConsole onExit={() => go('#/admin')} />;
  }
  // ---- team auth ----
  if (route.startsWith('#/team')) return <TeamGate onDone={() => go('#/admin')} onBack={() => go(readerHash())} />;
  // ---- questionnaire ----
  if (route.startsWith('#/form')) {
    if (roomNotFound) return <NotFoundPage kind="room" detail="This form link is no longer available. Ask the sender for a fresh link, or sign in if you manage this workspace." onPrimary={() => go('#/team')} primaryLabel="Team sign in" />;
    const questionnaireId = hashParam('questionnaireId');
    if (!store.clientEmail) return <ClientGate onEnter={() => go(route || '#/form')} onAdmin={() => go(store.teamUser ? '#/admin' : '#/team')} />;
    return <Questionnaire questionnaireId={questionnaireId} onDone={() => go(readerHash())} />;
  }
  // ---- reader ----
  if (route.startsWith('#/room')) {
    if (roomNotFound) return <NotFoundPage kind="room" detail="This private room link is no longer available. Ask the sender for a fresh link, or sign in if you manage this workspace." onPrimary={() => { window.DW_API_ROOM_ID = null; go('#/'); }} primaryLabel="Go home" onSecondary={() => go(store.teamUser ? '#/admin' : '#/team')} secondaryLabel={store.teamUser ? 'Dashboard' : 'Team sign in'} />;
    const previewMode = hashParam('preview') === '1';
    if (!store.clientEmail && !(previewMode && store.teamUser)) return <ClientGate onEnter={() => go(readerHash())} onAdmin={() => go(store.teamUser ? '#/admin' : '#/team')} />;
    return <Reader previewMode={previewMode && !!store.teamUser && !store.clientEmail} onAdmin={() => go(store.teamUser ? '#/admin' : '#/team')} onSignOut={async () => { await window.DWStore.signOutClient(); go('#/'); }} />;
  }
  // ---- public root: production team entry. Reader gates require room links. ----
  if (store.teamUser) {
    const onNav = (p, params) => go(adminHash(p, params));
    return <Shell active="dash" onNav={onNav} onReader={() => go(readerHash())} side={<DashboardSide onNav={onNav} />}><Dashboard onNav={onNav} /></Shell>;
  }
  if (hasRoomContext()) return <ClientGate onEnter={() => go(readerHash())} onAdmin={() => go('#/team')} />;
  if (!route || route === '#/' || route === '#') return <TeamGate onDone={() => go('#/admin')} />;
  return <NotFoundPage kind="route" detail="This address is not part of the current Dealwondr workspace." onPrimary={() => go('#/')} primaryLabel="Go home" onSecondary={() => go(store.teamUser ? '#/admin' : '#/team')} secondaryLabel={store.teamUser ? 'Dashboard' : 'Team sign in'} />;
}

function AppBootScreen() {
  return (
    <div className="dw-app">
      <div className="dw-empty" role="status" aria-live="polite" style={{ minHeight: '100%', justifyContent: 'center' }}>
        <span className="dw-spinner"></span>
        <div className="dw-empty__title">Loading Dealwondr</div>
        <div className="dw-empty__body">Checking your session and opening the right workspace.</div>
      </div>
    </div>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(<App />);

